//#region \0rolldown/runtime.js
var e = Object.defineProperty, t = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), n = (t, n) => {
	let r = {};
	for (var i in t) e(r, i, {
		get: t[i],
		enumerable: !0
	});
	return n || e(r, Symbol.toStringTag, { value: "Module" }), r;
}, r = /* @__PURE__ */ t(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), i = /* @__PURE__ */ t(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var S = Array.isArray;
	function C() {}
	var w = {
		H: null,
		A: null,
		T: null,
		S: null
	}, T = Object.prototype.hasOwnProperty;
	function E(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function D(e, t) {
		return E(e.type, t, e.props);
	}
	function O(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function k(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var A = /\/+/g;
	function j(e, t) {
		return typeof e == "object" && e && e.key != null ? k("" + e.key) : t.toString(36);
	}
	function M(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(C, C) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function N(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, N(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + j(e, 0) : a, S(o) ? (i = "", c != null && (i = c.replace(A, "$&/") + "/"), N(o, r, i, "", function(e) {
			return e;
		})) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(A, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return N(M(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function P(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return N(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function F(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var I = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, L = {
		map: P,
		forEach: function(e, t, n) {
			P(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return P(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return P(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!O(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = L, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return w.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !T.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return E(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) T.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return E(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = O, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: F
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = w.T, n = {};
		w.T = n;
		try {
			var r = e(), i = w.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(C, I);
		} catch (e) {
			I(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), w.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return w.H.useCacheRefresh();
	}, e.use = function(e) {
		return w.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return w.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return w.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return w.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return w.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return w.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return w.H.useEffectEvent(e);
	}, e.useId = function() {
		return w.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return w.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return w.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return w.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return w.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return w.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return w.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return w.H.useRef(e);
	}, e.useState = function(e) {
		return w.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return w.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return w.H.useTransition();
	}, e.version = "19.2.4";
})), a = /* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV !== "production" && (function() {
		function n(e, t) {
			Object.defineProperty(a.prototype, e, { get: function() {
				console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
			} });
		}
		function r(e) {
			return typeof e != "object" || !e ? null : (e = oe && e[oe] || e["@@iterator"], typeof e == "function" ? e : null);
		}
		function i(e, t) {
			e = (e = e.constructor) && (e.displayName || e.name) || "ReactClass";
			var n = e + "." + t;
			H[n] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, e), H[n] = !0);
		}
		function a(e, t, n) {
			this.props = e, this.context = t, this.refs = G, this.updater = n || U;
		}
		function o() {}
		function s(e, t, n) {
			this.props = e, this.context = t, this.refs = G, this.updater = n || U;
		}
		function c() {}
		function l(e) {
			return "" + e;
		}
		function u(e) {
			try {
				l(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var n = t.error, r = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return n.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", r), l(e);
			}
		}
		function d(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === ce ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case L: return "Fragment";
				case ee: return "Profiler";
				case R: return "StrictMode";
				case re: return "Suspense";
				case ie: return "SuspenseList";
				case ae: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case I: return "Portal";
				case te: return e.displayName || "Context";
				case z: return (e._context.displayName || "Context") + ".Consumer";
				case ne:
					var t = e.render;
					return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case B: return t = e.displayName || null, t === null ? d(e.type) || "Memo" : t;
				case V:
					t = e._payload, e = e._init;
					try {
						return d(e(t));
					} catch {}
			}
			return null;
		}
		function f(e) {
			if (e === L) return "<>";
			if (typeof e == "object" && e && e.$$typeof === V) return "<...>";
			try {
				var t = d(e);
				return t ? "<" + t + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function p() {
			var e = q.A;
			return e === null ? null : e.getOwner();
		}
		function m() {
			return Error("react-stack-top-frame");
		}
		function h(e) {
			if (J.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function g(e, t) {
			function n() {
				ue || (ue = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function _() {
			var e = d(this.type);
			return fe[e] || (fe[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function v(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: F,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: _
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function y(e, t) {
			return t = v(e.type, t, e.props, e._owner, e._debugStack, e._debugTask), e._store && (t._store.validated = e._store.validated), t;
		}
		function b(e) {
			x(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === V && (e._payload.status === "fulfilled" ? x(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function x(e) {
			return typeof e == "object" && !!e && e.$$typeof === F;
		}
		function S(e) {
			var t = {
				"=": "=0",
				":": "=2"
			};
			return "$" + e.replace(/[=:]/g, function(e) {
				return t[e];
			});
		}
		function C(e, t) {
			return typeof e == "object" && e && e.key != null ? (u(e.key), S("" + e.key)) : t.toString(36);
		}
		function w(e) {
			switch (e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
				default: switch (typeof e.status == "string" ? e.then(c, c) : (e.status = "pending", e.then(function(t) {
					e.status === "pending" && (e.status = "fulfilled", e.value = t);
				}, function(t) {
					e.status === "pending" && (e.status = "rejected", e.reason = t);
				})), e.status) {
					case "fulfilled": return e.value;
					case "rejected": throw e.reason;
				}
			}
			throw e;
		}
		function T(e, t, n, i, a) {
			var o = typeof e;
			(o === "undefined" || o === "boolean") && (e = null);
			var s = !1;
			if (e === null) s = !0;
			else switch (o) {
				case "bigint":
				case "string":
				case "number":
					s = !0;
					break;
				case "object": switch (e.$$typeof) {
					case F:
					case I:
						s = !0;
						break;
					case V: return s = e._init, T(s(e._payload), t, n, i, a);
				}
			}
			if (s) {
				s = e, a = a(s);
				var c = i === "" ? "." + C(s, 0) : i;
				return se(a) ? (n = "", c != null && (n = c.replace(ge, "$&/") + "/"), T(a, t, n, "", function(e) {
					return e;
				})) : a != null && (x(a) && (a.key != null && (s && s.key === a.key || u(a.key)), n = y(a, n + (a.key == null || s && s.key === a.key ? "" : ("" + a.key).replace(ge, "$&/") + "/") + c), i !== "" && s != null && x(s) && s.key == null && s._store && !s._store.validated && (n._store.validated = 2), a = n), t.push(a)), 1;
			}
			if (s = 0, c = i === "" ? "." : i + ":", se(e)) for (var l = 0; l < e.length; l++) i = e[l], o = c + C(i, l), s += T(i, t, n, o, a);
			else if (l = r(e), typeof l == "function") for (l === e.entries && (he || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), he = !0), e = l.call(e), l = 0; !(i = e.next()).done;) i = i.value, o = c + C(i, l++), s += T(i, t, n, o, a);
			else if (o === "object") {
				if (typeof e.then == "function") return T(w(e), t, n, i, a);
				throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
			}
			return s;
		}
		function E(e, t, n) {
			if (e == null) return e;
			var r = [], i = 0;
			return T(e, r, "", "", function(e) {
				return t.call(n, e, i++);
			}), r;
		}
		function D(e) {
			if (e._status === -1) {
				var t = e._ioInfo;
				t != null && (t.start = t.end = performance.now()), t = e._result;
				var n = t();
				if (n.then(function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 1, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "fulfilled", n.value = t);
					}
				}, function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 2, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "rejected", n.reason = t);
					}
				}), t = e._ioInfo, t != null) {
					t.value = n;
					var r = n.displayName;
					typeof r == "string" && (t.name = r);
				}
				e._status === -1 && (e._status = 0, e._result = n);
			}
			if (e._status === 1) return t = e._result, t === void 0 && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", t), "default" in t || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t), t.default;
			throw e._result;
		}
		function O() {
			var e = q.H;
			return e === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
		}
		function k() {
			q.asyncTransitions--;
		}
		function A(e) {
			if (Y === null) try {
				var n = ("require" + Math.random()).slice(0, 7);
				Y = (t && t[n]).call(t, "timers").setImmediate;
			} catch {
				Y = function(e) {
					!1 === ve && (ve = !0, typeof MessageChannel > "u" && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
					var t = new MessageChannel();
					t.port1.onmessage = e, t.port2.postMessage(void 0);
				};
			}
			return Y(e);
		}
		function j(e) {
			return 1 < e.length && typeof AggregateError == "function" ? AggregateError(e) : e[0];
		}
		function M(e, t) {
			t !== X - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), X = t;
		}
		function N(e, t, n) {
			var r = q.actQueue;
			if (r !== null) if (r.length !== 0) try {
				P(r), A(function() {
					return N(e, t, n);
				});
				return;
			} catch (e) {
				q.thrownErrors.push(e);
			}
			else q.actQueue = null;
			0 < q.thrownErrors.length ? (r = j(q.thrownErrors), q.thrownErrors.length = 0, n(r)) : t(e);
		}
		function P(e) {
			if (!Q) {
				Q = !0;
				var t = 0;
				try {
					for (; t < e.length; t++) {
						var n = e[t];
						do {
							q.didUsePromise = !1;
							var r = n(!1);
							if (r !== null) {
								if (q.didUsePromise) {
									e[t] = n, e.splice(0, t);
									return;
								}
								n = r;
							} else break;
						} while (1);
					}
					e.length = 0;
				} catch (n) {
					e.splice(0, t + 1), q.thrownErrors.push(n);
				} finally {
					Q = !1;
				}
			}
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var F = Symbol.for("react.transitional.element"), I = Symbol.for("react.portal"), L = Symbol.for("react.fragment"), R = Symbol.for("react.strict_mode"), ee = Symbol.for("react.profiler"), z = Symbol.for("react.consumer"), te = Symbol.for("react.context"), ne = Symbol.for("react.forward_ref"), re = Symbol.for("react.suspense"), ie = Symbol.for("react.suspense_list"), B = Symbol.for("react.memo"), V = Symbol.for("react.lazy"), ae = Symbol.for("react.activity"), oe = Symbol.iterator, H = {}, U = {
			isMounted: function() {
				return !1;
			},
			enqueueForceUpdate: function(e) {
				i(e, "forceUpdate");
			},
			enqueueReplaceState: function(e) {
				i(e, "replaceState");
			},
			enqueueSetState: function(e) {
				i(e, "setState");
			}
		}, W = Object.assign, G = {};
		Object.freeze(G), a.prototype.isReactComponent = {}, a.prototype.setState = function(e, t) {
			if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, e, t, "setState");
		}, a.prototype.forceUpdate = function(e) {
			this.updater.enqueueForceUpdate(this, e, "forceUpdate");
		};
		var K = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		for ($ in K) K.hasOwnProperty($) && n($, K[$]);
		o.prototype = a.prototype, K = s.prototype = new o(), K.constructor = s, W(K, a.prototype), K.isPureReactComponent = !0;
		var se = Array.isArray, ce = Symbol.for("react.client.reference"), q = {
			H: null,
			A: null,
			T: null,
			S: null,
			actQueue: null,
			asyncTransitions: 0,
			isBatchingLegacy: !1,
			didScheduleLegacyUpdate: !1,
			didUsePromise: !1,
			thrownErrors: [],
			getCurrentStack: null,
			recentlyCreatedOwnerStacks: 0
		}, J = Object.prototype.hasOwnProperty, le = console.createTask ? console.createTask : function() {
			return null;
		};
		K = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var ue, de, fe = {}, pe = K.react_stack_bottom_frame.bind(K, m)(), me = le(f(m)), he = !1, ge = /\/+/g, _e = typeof reportError == "function" ? reportError : function(e) {
			if (typeof window == "object" && typeof window.ErrorEvent == "function") {
				var t = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
					error: e
				});
				if (!window.dispatchEvent(t)) return;
			} else if (typeof process == "object" && typeof process.emit == "function") {
				process.emit("uncaughtException", e);
				return;
			}
			console.error(e);
		}, ve = !1, Y = null, X = 0, Z = !1, Q = !1, ye = typeof queueMicrotask == "function" ? function(e) {
			queueMicrotask(function() {
				return queueMicrotask(e);
			});
		} : A;
		K = Object.freeze({
			__proto__: null,
			c: function(e) {
				return O().useMemoCache(e);
			}
		});
		var $ = {
			map: E,
			forEach: function(e, t, n) {
				E(e, function() {
					t.apply(this, arguments);
				}, n);
			},
			count: function(e) {
				var t = 0;
				return E(e, function() {
					t++;
				}), t;
			},
			toArray: function(e) {
				return E(e, function(e) {
					return e;
				}) || [];
			},
			only: function(e) {
				if (!x(e)) throw Error("React.Children.only expected to receive a single React element child.");
				return e;
			}
		};
		e.Activity = ae, e.Children = $, e.Component = a, e.Fragment = L, e.Profiler = ee, e.PureComponent = s, e.StrictMode = R, e.Suspense = re, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = q, e.__COMPILER_RUNTIME = K, e.act = function(e) {
			var t = q.actQueue, n = X;
			X++;
			var r = q.actQueue = t === null ? [] : t, i = !1;
			try {
				var a = e();
			} catch (e) {
				q.thrownErrors.push(e);
			}
			if (0 < q.thrownErrors.length) throw M(t, n), e = j(q.thrownErrors), q.thrownErrors.length = 0, e;
			if (typeof a == "object" && a && typeof a.then == "function") {
				var o = a;
				return ye(function() {
					i || Z || (Z = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
				}), { then: function(e, a) {
					i = !0, o.then(function(i) {
						if (M(t, n), n === 0) {
							try {
								P(r), A(function() {
									return N(i, e, a);
								});
							} catch (e) {
								q.thrownErrors.push(e);
							}
							if (0 < q.thrownErrors.length) {
								var o = j(q.thrownErrors);
								q.thrownErrors.length = 0, a(o);
							}
						} else e(i);
					}, function(e) {
						M(t, n), 0 < q.thrownErrors.length ? (e = j(q.thrownErrors), q.thrownErrors.length = 0, a(e)) : a(e);
					});
				} };
			}
			var s = a;
			if (M(t, n), n === 0 && (P(r), r.length !== 0 && ye(function() {
				i || Z || (Z = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
			}), q.actQueue = null), 0 < q.thrownErrors.length) throw e = j(q.thrownErrors), q.thrownErrors.length = 0, e;
			return { then: function(e, t) {
				i = !0, n === 0 ? (q.actQueue = r, A(function() {
					return N(s, e, t);
				})) : e(s);
			} };
		}, e.cache = function(e) {
			return function() {
				return e.apply(null, arguments);
			};
		}, e.cacheSignal = function() {
			return null;
		}, e.captureOwnerStack = function() {
			var e = q.getCurrentStack;
			return e === null ? null : e();
		}, e.cloneElement = function(e, t, n) {
			if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
			var r = W({}, e.props), i = e.key, a = e._owner;
			if (t != null) {
				var o;
				a: {
					if (J.call(t, "ref") && (o = Object.getOwnPropertyDescriptor(t, "ref").get) && o.isReactWarning) {
						o = !1;
						break a;
					}
					o = t.ref !== void 0;
				}
				for (s in o && (a = p()), h(t) && (u(t.key), i = "" + t.key), t) !J.call(t, s) || s === "key" || s === "__self" || s === "__source" || s === "ref" && t.ref === void 0 || (r[s] = t[s]);
			}
			var s = arguments.length - 2;
			if (s === 1) r.children = n;
			else if (1 < s) {
				o = Array(s);
				for (var c = 0; c < s; c++) o[c] = arguments[c + 2];
				r.children = o;
			}
			for (r = v(e.type, i, r, a, e._debugStack, e._debugTask), i = 2; i < arguments.length; i++) b(arguments[i]);
			return r;
		}, e.createContext = function(e) {
			return e = {
				$$typeof: te,
				_currentValue: e,
				_currentValue2: e,
				_threadCount: 0,
				Provider: null,
				Consumer: null
			}, e.Provider = e, e.Consumer = {
				$$typeof: z,
				_context: e
			}, e._currentRenderer = null, e._currentRenderer2 = null, e;
		}, e.createElement = function(e, t, n) {
			for (var r = 2; r < arguments.length; r++) b(arguments[r]);
			r = {};
			var i = null;
			if (t != null) for (c in de || !("__self" in t) || "key" in t || (de = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), h(t) && (u(t.key), i = "" + t.key), t) J.call(t, c) && c !== "key" && c !== "__self" && c !== "__source" && (r[c] = t[c]);
			var a = arguments.length - 2;
			if (a === 1) r.children = n;
			else if (1 < a) {
				for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
				Object.freeze && Object.freeze(o), r.children = o;
			}
			if (e && e.defaultProps) for (c in a = e.defaultProps, a) r[c] === void 0 && (r[c] = a[c]);
			i && g(r, typeof e == "function" ? e.displayName || e.name || "Unknown" : e);
			var c = 1e4 > q.recentlyCreatedOwnerStacks++;
			return v(e, i, r, p(), c ? Error("react-stack-top-frame") : pe, c ? le(f(e)) : me);
		}, e.createRef = function() {
			var e = { current: null };
			return Object.seal(e), e;
		}, e.forwardRef = function(e) {
			e != null && e.$$typeof === B ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e == "function" ? e.length !== 0 && e.length !== 2 && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.") : console.error("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e), e != null && e.defaultProps != null && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
			var t = {
				$$typeof: ne,
				render: e
			}, n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.isValidElement = x, e.lazy = function(e) {
			e = {
				_status: -1,
				_result: e
			};
			var t = {
				$$typeof: V,
				_payload: e,
				_init: D
			}, n = {
				name: "lazy",
				start: -1,
				end: -1,
				value: null,
				owner: null,
				debugStack: Error("react-stack-top-frame"),
				debugTask: console.createTask ? console.createTask("lazy()") : null
			};
			return e._ioInfo = n, t._debugInfo = [{ awaited: n }], t;
		}, e.memo = function(e, t) {
			e ?? console.error("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), t = {
				$$typeof: B,
				type: e,
				compare: t === void 0 ? null : t
			};
			var n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.startTransition = function(e) {
			var t = q.T, n = {};
			n._updatedFibers = /* @__PURE__ */ new Set(), q.T = n;
			try {
				var r = e(), i = q.S;
				i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && (q.asyncTransitions++, r.then(k, k), r.then(c, _e));
			} catch (e) {
				_e(e);
			} finally {
				t === null && n._updatedFibers && (e = n._updatedFibers.size, n._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), t !== null && n.types !== null && (t.types !== null && t.types !== n.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), t.types = n.types), q.T = t;
			}
		}, e.unstable_useCacheRefresh = function() {
			return O().useCacheRefresh();
		}, e.use = function(e) {
			return O().use(e);
		}, e.useActionState = function(e, t, n) {
			return O().useActionState(e, t, n);
		}, e.useCallback = function(e, t) {
			return O().useCallback(e, t);
		}, e.useContext = function(e) {
			var t = O();
			return e.$$typeof === z && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"), t.useContext(e);
		}, e.useDebugValue = function(e, t) {
			return O().useDebugValue(e, t);
		}, e.useDeferredValue = function(e, t) {
			return O().useDeferredValue(e, t);
		}, e.useEffect = function(e, t) {
			return e ?? console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useEffect(e, t);
		}, e.useEffectEvent = function(e) {
			return O().useEffectEvent(e);
		}, e.useId = function() {
			return O().useId();
		}, e.useImperativeHandle = function(e, t, n) {
			return O().useImperativeHandle(e, t, n);
		}, e.useInsertionEffect = function(e, t) {
			return e ?? console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useInsertionEffect(e, t);
		}, e.useLayoutEffect = function(e, t) {
			return e ?? console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"), O().useLayoutEffect(e, t);
		}, e.useMemo = function(e, t) {
			return O().useMemo(e, t);
		}, e.useOptimistic = function(e, t) {
			return O().useOptimistic(e, t);
		}, e.useReducer = function(e, t, n) {
			return O().useReducer(e, t, n);
		}, e.useRef = function(e) {
			return O().useRef(e);
		}, e.useState = function(e) {
			return O().useState(e);
		}, e.useSyncExternalStore = function(e, t, n) {
			return O().useSyncExternalStore(e, t, n);
		}, e.useTransition = function() {
			return O().useTransition();
		}, e.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), o = /* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = i() : t.exports = a();
})), s = /* @__PURE__ */ t(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === k ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case v: return "Fragment";
				case b: return "Profiler";
				case y: return "StrictMode";
				case w: return "Suspense";
				case T: return "SuspenseList";
				case O: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case _: return "Portal";
				case S: return e.displayName || "Context";
				case x: return (e._context.displayName || "Context") + ".Consumer";
				case C:
					var n = e.render;
					return e = e.displayName, e ||= (e = n.displayName || n.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case E: return n = e.displayName || null, n === null ? t(e.type) || "Memo" : n;
				case D:
					n = e._payload, e = e._init;
					try {
						return t(e(n));
					} catch {}
			}
			return null;
		}
		function n(e) {
			return "" + e;
		}
		function r(e) {
			try {
				n(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var r = t.error, i = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return r.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", i), n(e);
			}
		}
		function i(e) {
			if (e === v) return "<>";
			if (typeof e == "object" && e && e.$$typeof === D) return "<...>";
			try {
				var n = t(e);
				return n ? "<" + n + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function a() {
			var e = A.A;
			return e === null ? null : e.getOwner();
		}
		function s() {
			return Error("react-stack-top-frame");
		}
		function c(e) {
			if (j.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function l(e, t) {
			function n() {
				P || (P = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function u() {
			var e = t(this.type);
			return F[e] || (F[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function d(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: g,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: u
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function f(e, n, i, o, s, u) {
			var f = n.children;
			if (f !== void 0) if (o) if (M(f)) {
				for (o = 0; o < f.length; o++) p(f[o]);
				Object.freeze && Object.freeze(f);
			} else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
			else p(f);
			if (j.call(n, "key")) {
				f = t(e);
				var m = Object.keys(n).filter(function(e) {
					return e !== "key";
				});
				o = 0 < m.length ? "{key: someKey, " + m.join(": ..., ") + ": ...}" : "{key: someKey}", R[f + o] || (m = 0 < m.length ? "{" + m.join(": ..., ") + ": ...}" : "{}", console.error("A props object containing a \"key\" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />", o, f, m, f), R[f + o] = !0);
			}
			if (f = null, i !== void 0 && (r(i), f = "" + i), c(n) && (r(n.key), f = "" + n.key), "key" in n) for (var h in i = {}, n) h !== "key" && (i[h] = n[h]);
			else i = n;
			return f && l(i, typeof e == "function" ? e.displayName || e.name || "Unknown" : e), d(e, f, i, a(), s, u);
		}
		function p(e) {
			m(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === D && (e._payload.status === "fulfilled" ? m(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function m(e) {
			return typeof e == "object" && !!e && e.$$typeof === g;
		}
		var h = o(), g = Symbol.for("react.transitional.element"), _ = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), x = Symbol.for("react.consumer"), S = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), T = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), O = Symbol.for("react.activity"), k = Symbol.for("react.client.reference"), A = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, j = Object.prototype.hasOwnProperty, M = Array.isArray, N = console.createTask ? console.createTask : function() {
			return null;
		};
		h = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var P, F = {}, I = h.react_stack_bottom_frame.bind(h, s)(), L = N(i(s)), R = {};
		e.Fragment = v, e.jsx = function(e, t, n) {
			var r = 1e4 > A.recentlyCreatedOwnerStacks++;
			return f(e, t, n, !1, r ? Error("react-stack-top-frame") : I, r ? N(i(e)) : L);
		}, e.jsxs = function(e, t, n) {
			var r = 1e4 > A.recentlyCreatedOwnerStacks++;
			return f(e, t, n, !0, r ? Error("react-stack-top-frame") : I, r ? N(i(e)) : L);
		};
	})();
})), c = (/* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = r() : t.exports = s();
})))(), l = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "AddLocation-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#AddLocation-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12 20.9402C11.8052 20.9402 11.6103 20.9067 11.4155 20.8395C11.2205 20.7722 11.0442 20.668 10.8865 20.527C9.98916 19.7 9.14941 18.8483 8.36725 17.972C7.58525 17.0958 6.9055 16.2199 6.328 15.3443C5.75033 14.4686 5.29325 13.6007 4.95675 12.7405C4.62025 11.8802 4.452 11.0493 4.452 10.248C4.452 8.64683 4.85808 7.19975 5.67025 5.90675C6.48241 4.61375 7.62566 3.66667 9.1 3.0655C9.5525 2.86933 10.0285 2.72767 10.528 2.6405C11.0273 2.55333 11.5321 2.50142 12.0422 2.48475C12.2547 2.48475 12.4329 2.55375 12.5767 2.69175C12.7204 2.82975 12.7922 3.00533 12.7922 3.2185C12.7922 3.43183 12.7204 3.61542 12.5767 3.76925C12.4329 3.92308 12.2547 4 12.0422 4C11.6247 4 11.2159 4.03433 10.8157 4.103C10.4156 4.1715 10.0142 4.28717 9.6115 4.45C8.432 4.93967 7.52716 5.71275 6.897 6.76925C6.267 7.82558 5.952 8.98517 5.952 10.248C5.952 11.457 6.47091 12.8657 7.50875 14.474C8.54658 16.0823 10.0437 17.7622 12 19.5135C12.9718 18.6443 13.8312 17.7921 14.578 16.9568C15.3247 16.1214 15.9544 15.3108 16.4672 14.525C16.8582 13.9187 17.1868 13.3158 17.453 12.7163C17.719 12.1169 17.8987 11.5256 17.9922 10.9423C18.0397 10.6551 18.1472 10.4542 18.3145 10.3395C18.4817 10.2247 18.6582 10.1808 18.8442 10.2078C19.0301 10.2346 19.1912 10.3105 19.3277 10.4355C19.4644 10.5605 19.5192 10.7294 19.4922 10.9423C19.3781 11.9116 19.0967 12.8437 18.648 13.7387C18.1992 14.6339 17.6729 15.4922 17.0692 16.3135C16.3846 17.225 15.6791 18.0436 14.9527 18.7693C14.2266 19.4949 13.6167 20.0776 13.123 20.5173C12.9677 20.6583 12.7911 20.764 12.5932 20.8345C12.3956 20.905 12.1978 20.9402 12 20.9402ZM12.0017 11.8652C12.4992 11.8652 12.9246 11.6881 13.2777 11.3338C13.6311 10.9794 13.8077 10.5535 13.8077 10.056C13.8077 9.5585 13.6306 9.13308 13.2762 8.77975C12.9219 8.42658 12.4959 8.25 11.9982 8.25C11.5007 8.25 11.0754 8.42717 10.7222 8.7815C10.3689 9.13583 10.1922 9.56183 10.1922 10.0595C10.1922 10.557 10.3694 10.9823 10.7237 11.3355C11.0781 11.6887 11.5041 11.8652 12.0017 11.8652ZM18 5V7.25C18 7.4625 18.0719 7.64067 18.2157 7.7845C18.3596 7.92817 18.5377 8 18.7502 8C18.9629 8 19.141 7.92817 19.2845 7.7845C19.4282 7.64067 19.5 7.4625 19.5 7.25V5H21.75C21.9625 5 22.1406 4.92808 22.2842 4.78425C22.4281 4.64042 22.5 4.46225 22.5 4.24975C22.5 4.03708 22.4281 3.859 22.2842 3.7155C22.1406 3.57183 21.9625 3.5 21.75 3.5H19.5V1.25C19.5 1.0375 19.4281 0.859417 19.2842 0.71575C19.1404 0.571917 18.9622 0.5 18.7497 0.5C18.5371 0.5 18.359 0.571917 18.2155 0.71575C18.0718 0.859417 18 1.0375 18 1.25V3.5H15.75C15.5375 3.5 15.3593 3.57192 15.2155 3.71575C15.0718 3.85958 15 4.03775 15 4.25025C15 4.46292 15.0718 4.641 15.2155 4.7845C15.3593 4.92817 15.5375 5 15.75 5H18Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), u = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Albatross-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Albatross-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M23.9616 22.4575C23.6878 21.5663 23.4938 20.8433 23.0594 20.0139C22.6441 19.2214 22.3138 18.3889 21.8074 17.6382C21.4286 17.0769 21.1644 16.4384 20.8484 15.8347C20.6782 15.5092 20.5203 15.1747 20.1366 15.0367C19.801 14.916 19.4657 14.7943 19.1308 14.6719C18.971 14.5982 18.8054 14.5377 18.6358 14.4909L18.2598 14.3535C17.5882 14.1083 16.941 13.8101 16.3537 13.4003C15.9791 13.1388 15.6275 12.8447 15.2638 12.5673C15.108 12.4485 15.0469 12.3162 15.1147 12.1122C15.1625 11.9689 15.1454 11.8048 15.1625 11.6505C15.1826 11.4685 15.1947 11.2836 15.2385 11.1069C15.2563 11.0348 15.3372 10.9589 15.4085 10.923C15.584 10.8351 15.7743 10.7771 15.9521 10.6928C16.2439 10.5543 16.3712 10.5699 16.6216 10.7809C16.6749 10.8257 16.7699 10.8836 16.8151 10.8642C17.0003 10.7842 17.0404 10.6081 17.0432 10.4242C17.0434 10.4157 17.0421 10.4082 17.0418 10.4001C17.0506 10.3081 17.0205 10.2127 16.9512 10.1437L16.8379 10.0303C16.7866 9.97895 16.721 9.94965 16.653 9.94132C16.6011 9.92154 16.5491 9.90262 16.4958 9.89777C16.4583 9.89427 16.4208 9.88982 16.3835 9.88442L16.3262 9.86188C16.2889 9.84713 16.2505 9.8433 16.2124 9.8473C16.2043 9.84487 16.1959 9.84245 16.1879 9.83985C16.1652 9.82757 16.141 9.81808 16.116 9.81158C15.9873 9.754 15.8788 9.6601 15.8021 9.50153C15.7567 9.4075 15.6628 9.30961 15.5679 9.2713C15.0651 9.06879 14.555 9.05944 14.0822 9.34482C13.8375 9.49247 13.6254 9.69723 13.4088 9.88774C13.0111 10.2372 12.5942 10.3053 12.2367 10.0362C11.9384 9.81192 11.6244 9.59053 11.3849 9.31012C11.0012 8.86059 10.6266 8.39023 10.3323 7.88014C9.85363 7.05027 9.44432 6.18056 9.00156 5.32985C8.95057 5.232 8.89138 5.12024 8.80428 5.06215C8.38337 4.78073 7.96765 4.48424 7.5197 4.25189C6.88174 3.92104 6.1959 3.67916 5.56938 3.32957C4.87521 2.942 4.12065 2.74558 3.37825 2.5065C2.91031 2.35588 2.41515 2.28337 1.95746 2.10953C1.34846 1.87824 0.764127 1.58244 0.169164 1.31436H0C0.0274285 1.36922 0.0505194 1.42663 0.0831359 1.47817C0.169036 1.61386 0.263398 1.74416 0.346152 1.88156C0.40322 1.9763 0.442258 2.08176 0.497795 2.17753C0.529731 2.23251 0.584886 2.27381 0.619246 2.32777C0.819622 2.64267 1.00286 2.97079 1.33736 3.17303C1.37308 3.19455 1.38473 3.25251 1.41629 3.28462C1.61216 3.4838 1.81168 3.6795 2.00793 3.87852C2.0886 3.96025 2.15022 4.06869 2.24407 4.12801C2.47898 4.27655 2.72503 4.40821 2.97121 4.53782C3.05711 4.58294 3.23078 4.59055 3.23771 4.63516C3.27534 4.87496 3.51684 4.84945 3.63017 4.89091C3.99486 5.02431 4.30436 5.28545 4.72076 5.31513C4.99802 5.33491 5.26852 5.47248 5.53779 5.56913C5.62679 5.60103 5.7061 5.66473 5.78435 5.72129C5.99446 5.87344 6.18723 6.05804 6.41486 6.17515C6.5927 6.26658 6.66712 6.40071 6.73358 6.56188C6.79086 6.70068 6.84742 6.83965 6.90517 6.97811C6.9286 7.03416 6.95552 7.08884 6.97891 7.14485C7.02037 7.2441 7.04882 7.35079 7.10363 7.44188C7.16768 7.54824 7.27178 7.63222 7.32765 7.74151C7.47445 8.02953 7.59573 8.33074 7.74389 8.61803C7.76281 8.65448 7.78292 8.69037 7.80253 8.72647C7.86359 8.9203 7.96251 9.09516 8.09663 9.24021C8.12964 9.29697 8.16209 9.35406 8.19397 9.41146C8.28765 9.58113 8.33035 9.80358 8.46634 9.91997C8.72191 10.1383 8.70023 10.5328 9.02848 10.7049C9.127 10.7566 9.13364 10.9721 9.19887 11.1045C9.22817 11.1642 9.29795 11.204 9.34928 11.253C9.3654 11.3187 9.40499 11.3727 9.4388 11.4302C9.51236 11.5549 9.59201 11.6774 9.65185 11.8086C9.69922 11.9127 9.70959 12.0336 9.75697 12.1379C9.81233 12.2595 9.76203 12.7028 9.68948 12.8173C9.49063 13.131 9.27031 13.4377 9.12109 13.7749C8.72502 14.6705 8.22514 15.4567 7.26378 15.8401C7.21275 15.8604 7.15326 15.9579 7.16091 16.0099C7.19038 16.2093 7.24575 16.405 7.29172 16.6038C7.06915 16.7365 6.85329 16.8652 6.63935 16.9929C6.87426 17.4774 6.87426 17.4774 7.11597 17.3596L7.4602 17.7147C7.61721 17.6235 7.80112 17.5522 7.93835 17.4288C7.95694 17.4121 7.97582 17.397 7.99474 17.3826C8.08967 17.3413 8.18218 17.2946 8.27183 17.2428C8.40753 17.2013 8.55101 17.1876 8.69916 17.1786C8.91498 17.1654 9.106 17.1155 9.20159 16.8765C9.33555 16.542 9.5642 16.2856 9.91626 16.1681C10.2969 16.0411 10.6765 15.9065 11.0652 15.8093C11.5373 15.6913 11.9891 15.5339 12.3557 15.2088C12.5383 15.0469 12.7323 15.0778 12.9089 15.1321C13.5028 15.315 14.0862 15.5315 14.6768 15.7251C15.0065 15.8332 15.3448 15.9142 15.675 16.0206C16.0804 16.1512 16.4807 16.2977 16.885 16.4321C17.0017 16.471 17.128 16.4825 17.2436 16.5239C17.4145 16.5853 17.5736 16.6918 17.7483 16.7271C18.1844 16.8152 18.6048 16.949 18.9954 17.1533C19.1516 17.235 19.294 17.3845 19.3869 17.537C19.598 17.8834 19.7774 18.2494 19.9643 18.6102C20.1475 18.9637 20.3187 19.3233 20.507 19.6742C20.5613 19.7751 20.6527 19.8575 20.7332 19.9429C20.8117 20.026 20.8989 20.1006 20.9801 20.1815C21.0986 20.2994 21.2135 20.4209 21.3332 20.5375C21.3728 20.576 21.4422 20.5949 21.4634 20.6393C21.5668 20.8567 21.6984 21.0269 21.9463 21.1042C22.0435 21.1343 22.1159 21.251 22.1939 21.3335C22.2663 21.4101 22.3213 21.5057 22.4013 21.5718C22.6891 21.8095 22.9843 22.0382 23.2683 22.2636C23.2664 22.2727 23.2738 22.236 23.2848 22.182C23.4081 22.4334 23.3847 22.1541 23.4468 22.1435C23.5032 22.3942 23.6211 22.5892 23.8695 22.678C24.04 22.7174 23.9932 22.5939 23.9968 22.5082C23.9851 22.4916 23.9674 22.4763 23.9616 22.4575Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), d = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "AltRoute-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#AltRoute-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M19.793 5.5H17.5029L17.4902 5.9873C17.4318 8.21992 16.991 9.67057 16.4248 10.7002C15.9989 11.4746 15.492 12.0322 14.9746 12.5234L14.4561 12.998C13.9278 13.4725 13.4174 13.9262 13.0586 14.5391C12.6894 15.1697 12.5 15.9284 12.5 17V21.5H11.5V17C11.5 16.0138 11.338 15.2906 11.0215 14.6885C10.795 14.2577 10.4995 13.9114 10.1758 13.5898L10.8799 12.8867C11.1352 13.1386 11.3745 13.4059 11.5889 13.7148L11.999 14.3047L12.4102 13.7158C12.8147 13.1367 13.2871 12.6881 13.7793 12.2549L13.7803 12.2559L13.7842 12.252C14.4118 11.6891 15.0846 11.0868 15.5957 10.1318C16.108 9.17456 16.4388 7.90473 16.4902 6.01367L16.5039 5.5H14.207L17 2.70703L19.793 5.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M8.20996 9.74121C8.45893 10.3037 8.76092 10.7546 9.08984 11.1426L8.375 11.8574C7.9518 11.368 7.55314 10.7736 7.23242 9.98828L8.20996 9.74121Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M9.79297 5.5H7.51172L7.52051 6.00781C7.5279 6.47365 7.55619 6.90904 7.59863 7.30273L6.625 7.54883C6.56848 7.07861 6.53357 6.55607 6.51953 5.9873L6.50781 5.5H4.20703L7 2.70703L9.79297 5.5Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), f = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ArrowBottom-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ArrowBottom-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.70711 13.2929C5.31658 12.9024 4.68342 12.9024 4.29289 13.2929C3.90237 13.6834 3.90237 14.3166 4.29289 14.7071L11.2929 21.7071C11.6834 22.0976 12.3166 22.0976 12.7071 21.7071L19.7071 14.7071C20.0976 14.3166 20.0976 13.6834 19.7071 13.2929C19.3166 12.9024 18.6834 12.9024 18.2929 13.2929L13 18.5858L13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V5V7L11 18.5858L5.70711 13.2929Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), p = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ArrowLeft-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ArrowLeft-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.7071 4.29289C11.0976 4.68342 11.0976 5.31658 10.7071 5.70711L5.41421 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H5.41421L10.7071 18.2929C11.0976 18.6834 11.0976 19.3166 10.7071 19.7071C10.3166 20.0976 9.68342 20.0976 9.29289 19.7071L2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929L9.29289 4.29289C9.68342 3.90237 10.3166 3.90237 10.7071 4.29289Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), m = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ArrowRight-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ArrowRight-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.2929 18.2929C12.9024 18.6834 12.9024 19.3166 13.2929 19.7071C13.6834 20.0976 14.3166 20.0976 14.7071 19.7071L21.7071 12.7071C22.0976 12.3166 22.0976 11.6834 21.7071 11.2929L14.7071 4.29289C14.3166 3.90237 13.6834 3.90237 13.2929 4.29289C12.9024 4.68342 12.9024 5.31658 13.2929 5.70711L18.5858 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H5H7H18.5858L13.2929 18.2929Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), h = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ArrowTop-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ArrowTop-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.2929 10.7071C18.6834 11.0976 19.3166 11.0976 19.7071 10.7071C20.0976 10.3166 20.0976 9.68342 19.7071 9.29289L12.7071 2.29289C12.3166 1.90237 11.6834 1.90237 11.2929 2.29289L4.29289 9.29289C3.90237 9.68342 3.90237 10.3166 4.29289 10.7071C4.68342 11.0976 5.31658 11.0976 5.70711 10.7071L11 5.41421V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V19V17V5.41421L18.2929 10.7071Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), g = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Ban-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Ban-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C11.6862 16.5 11.3799 16.4679 11.0843 16.4068L16.4068 11.0843C16.4679 11.3799 16.5 11.6862 16.5 12ZM8.91324 16.4564C8.69532 16.6744 8.72414 17.0371 8.99063 17.1919C9.87527 17.7057 10.9033 18 12 18C15.3137 18 18 15.3137 18 12C18 10.9033 17.7057 9.87527 17.1919 8.99063C17.0371 8.72414 16.6744 8.69532 16.4564 8.91324L8.91324 16.4564ZM14.9485 6.77321C15.2186 6.92594 15.2497 7.29157 15.0302 7.51101L7.51101 15.0302C7.29157 15.2497 6.92594 15.2186 6.77321 14.9485C6.28095 14.0777 6 13.0716 6 12C6 8.68629 8.68629 6 12 6C13.0716 6 14.0777 6.28095 14.9485 6.77321ZM7.63309 13.0907L13.0907 7.63309C12.7415 7.54615 12.3761 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 12.3761 7.54615 12.7415 7.63309 13.0907Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), _ = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Bell-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Bell-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 10C6 7.77641 7.20957 5.83534 9.00664 4.79886C9.11011 3.23579 10.4107 2 12 2C13.5893 2 14.8899 3.23579 14.9934 4.79886C16.7904 5.83534 18 7.77641 18 10V12.6972C18 12.8946 18.0584 13.0877 18.1679 13.2519L19.8321 15.7481C19.9416 15.9123 20 16.1054 20 16.3028V18C20 18.5523 19.5523 19 19 19H15.4646C15.2219 20.6961 13.7632 22 12 22C10.2368 22 8.77806 20.6961 8.53544 19H5C4.44772 19 4 18.5523 4 18V16.3028C4 16.1054 4.05844 15.9123 4.16795 15.7481L5.83205 13.2519C5.94156 13.0877 6 12.8946 6 12.6972V10ZM13.4966 4.89794L13.5496 5.69775L14.2439 6.09823C15.5956 6.87785 16.5 8.33421 16.5 10V12.6972C16.5 13.1908 16.6461 13.6733 16.9199 14.084L18.5 16.4542V17.5H5.5V16.4542L7.08013 14.084C7.3539 13.6733 7.5 13.1908 7.5 12.6972V10C7.5 8.33421 8.40435 6.87785 9.75606 6.09823L10.4504 5.69775L10.5034 4.89794C10.555 4.11785 11.206 3.5 12 3.5C12.794 3.5 13.445 4.11785 13.4966 4.89794ZM10.063 19C10.285 19.8626 11.0681 20.5 12 20.5C12.9319 20.5 13.715 19.8626 13.937 19H10.063Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), v = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Bill-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Bill-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M2.5 7.5V16.5H21.5V7.5H2.5ZM2 6C1.44772 6 1 6.44772 1 7V17C1 17.5523 1.44772 18 2 18H22C22.5523 18 23 17.5523 23 17V7C23 6.44772 22.5523 6 22 6H2Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6 10C6 10.5523 5.55228 11 5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9C5.55228 9 6 9.44772 6 10Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M20 14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), y = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "BlurLinear-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#BlurLinear-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M5.34625 17.3462C5.72825 17.3462 6.04808 17.2173 6.30575 16.9595C6.56342 16.7018 6.69225 16.382 6.69225 16C6.69225 15.618 6.56342 15.2982 6.30575 15.0405C6.04808 14.7827 5.72825 14.6538 5.34625 14.6538C4.96408 14.6538 4.64417 14.7827 4.3865 15.0405C4.12883 15.2982 4 15.618 4 16C4 16.382 4.12883 16.7018 4.3865 16.9595C4.64417 17.2173 4.96408 17.3462 5.34625 17.3462ZM9.34625 12.923C9.60775 12.923 9.82692 12.8346 10.0037 12.6578C10.1807 12.4808 10.2692 12.2615 10.2692 12C10.2692 11.7385 10.1807 11.5193 10.0037 11.3423C9.82692 11.1654 9.60775 11.077 9.34625 11.077C9.08458 11.077 8.86533 11.1654 8.6885 11.3423C8.5115 11.5193 8.423 11.7385 8.423 12C8.423 12.2615 8.5115 12.4808 8.6885 12.6578C8.86533 12.8346 9.08458 12.923 9.34625 12.923ZM9.34625 8.923C9.60775 8.923 9.82692 8.83458 10.0037 8.65775C10.1807 8.48075 10.2692 8.2615 10.2692 8C10.2692 7.7385 10.1807 7.51925 10.0037 7.34225C9.82692 7.16542 9.60775 7.077 9.34625 7.077C9.08458 7.077 8.86533 7.16542 8.6885 7.34225C8.5115 7.51925 8.423 7.7385 8.423 8C8.423 8.2615 8.5115 8.48075 8.6885 8.65775C8.86533 8.83458 9.08458 8.923 9.34625 8.923ZM19.75 20.5H4.25C4.0375 20.5 3.85942 20.4281 3.71575 20.2843C3.57192 20.1404 3.5 19.9623 3.5 19.7497C3.5 19.5371 3.57192 19.359 3.71575 19.2155C3.85942 19.0718 4.0375 19 4.25 19H19.75C19.9625 19 20.1406 19.0719 20.2843 19.2158C20.4281 19.3596 20.5 19.5378 20.5 19.7503C20.5 19.9629 20.4281 20.141 20.2843 20.2845C20.1406 20.4282 19.9625 20.5 19.75 20.5ZM5.34625 9.34625C5.72825 9.34625 6.04808 9.21733 6.30575 8.9595C6.56342 8.70183 6.69225 8.382 6.69225 8C6.69225 7.618 6.56342 7.29817 6.30575 7.0405C6.04808 6.78267 5.72825 6.65375 5.34625 6.65375C4.96408 6.65375 4.64417 6.78267 4.3865 7.0405C4.12883 7.29817 4 7.618 4 8C4 8.382 4.12883 8.70183 4.3865 8.9595C4.64417 9.21733 4.96408 9.34625 5.34625 9.34625ZM5.34625 13.3463C5.72825 13.3463 6.04808 13.2173 6.30575 12.9595C6.56342 12.7018 6.69225 12.382 6.69225 12C6.69225 11.618 6.56342 11.2982 6.30575 11.0405C6.04808 10.7827 5.72825 10.6538 5.34625 10.6538C4.96408 10.6538 4.64417 10.7827 4.3865 11.0405C4.12883 11.2982 4 11.618 4 12C4 12.382 4.12883 12.7018 4.3865 12.9595C4.64417 13.2173 4.96408 13.3463 5.34625 13.3463ZM9.34625 16.923C9.60775 16.923 9.82692 16.8346 10.0037 16.6578C10.1807 16.4808 10.2692 16.2615 10.2692 16C10.2692 15.7385 10.1807 15.5193 10.0037 15.3423C9.82692 15.1654 9.60775 15.077 9.34625 15.077C9.08458 15.077 8.86533 15.1654 8.6885 15.3423C8.5115 15.5193 8.423 15.7385 8.423 16C8.423 16.2615 8.5115 16.4808 8.6885 16.6578C8.86533 16.8346 9.08458 16.923 9.34625 16.923ZM17.3462 16.5C17.4962 16.5 17.6171 16.4542 17.7087 16.3625C17.8004 16.2708 17.8462 16.15 17.8462 16C17.8462 15.85 17.8004 15.7292 17.7087 15.6375C17.6171 15.5458 17.4962 15.5 17.3462 15.5C17.1962 15.5 17.0754 15.5458 16.9837 15.6375C16.8921 15.7292 16.8462 15.85 16.8462 16C16.8462 16.15 16.8921 16.2708 16.9837 16.3625C17.0754 16.4542 17.1962 16.5 17.3462 16.5ZM19.75 5H4.25C4.0375 5 3.85942 4.92808 3.71575 4.78425C3.57192 4.64042 3.5 4.46225 3.5 4.24975C3.5 4.03708 3.57192 3.859 3.71575 3.7155C3.85942 3.57183 4.0375 3.5 4.25 3.5H19.75C19.9625 3.5 20.1406 3.57192 20.2843 3.71575C20.4281 3.85958 20.5 4.03775 20.5 4.25025C20.5 4.46292 20.4281 4.641 20.2843 4.7845C20.1406 4.92817 19.9625 5 19.75 5ZM17.3462 8.5C17.4962 8.5 17.6171 8.45417 17.7087 8.3625C17.8004 8.27083 17.8462 8.15 17.8462 8C17.8462 7.85 17.8004 7.72917 17.7087 7.6375C17.6171 7.54583 17.4962 7.5 17.3462 7.5C17.1962 7.5 17.0754 7.54583 16.9837 7.6375C16.8921 7.72917 16.8462 7.85 16.8462 8C16.8462 8.15 16.8921 8.27083 16.9837 8.3625C17.0754 8.45417 17.1962 8.5 17.3462 8.5ZM17.3462 12.5C17.4962 12.5 17.6171 12.4542 17.7087 12.3625C17.8004 12.2708 17.8462 12.15 17.8462 12C17.8462 11.85 17.8004 11.7292 17.7087 11.6375C17.6171 11.5458 17.4962 11.5 17.3462 11.5C17.1962 11.5 17.0754 11.5458 16.9837 11.6375C16.8921 11.7292 16.8462 11.85 16.8462 12C16.8462 12.15 16.8921 12.2708 16.9837 12.3625C17.0754 12.4542 17.1962 12.5 17.3462 12.5ZM13.3462 8.923C13.6077 8.923 13.8269 8.83458 14.0038 8.65775C14.1808 8.48075 14.2693 8.2615 14.2693 8C14.2693 7.7385 14.1808 7.51925 14.0038 7.34225C13.8269 7.16542 13.6077 7.077 13.3462 7.077C13.0846 7.077 12.8653 7.16542 12.6885 7.34225C12.5115 7.51925 12.423 7.7385 12.423 8C12.423 8.2615 12.5115 8.48075 12.6885 8.65775C12.8653 8.83458 13.0846 8.923 13.3462 8.923ZM13.3462 12.923C13.6077 12.923 13.8269 12.8346 14.0038 12.6578C14.1808 12.4808 14.2693 12.2615 14.2693 12C14.2693 11.7385 14.1808 11.5193 14.0038 11.3423C13.8269 11.1654 13.6077 11.077 13.3462 11.077C13.0846 11.077 12.8653 11.1654 12.6885 11.3423C12.5115 11.5193 12.423 11.7385 12.423 12C12.423 12.2615 12.5115 12.4808 12.6885 12.6578C12.8653 12.8346 13.0846 12.923 13.3462 12.923ZM13.3462 16.923C13.6077 16.923 13.8269 16.8346 14.0038 16.6578C14.1808 16.4808 14.2693 16.2615 14.2693 16C14.2693 15.7385 14.1808 15.5193 14.0038 15.3423C13.8269 15.1654 13.6077 15.077 13.3462 15.077C13.0846 15.077 12.8653 15.1654 12.6885 15.3423C12.5115 15.5193 12.423 15.7385 12.423 16C12.423 16.2615 12.5115 16.4808 12.6885 16.6578C12.8653 16.8346 13.0846 16.923 13.3462 16.923Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), b = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Boost-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Boost-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M13.3107 12.8107C13.8964 12.2249 13.8964 11.2751 13.3107 10.6893C12.7249 10.1036 11.7751 10.1036 11.1893 10.6893L9.43934 12.4393C8.85355 13.0251 8.85355 13.9749 9.43934 14.5607C10.0251 15.1464 10.9749 15.1464 11.5607 14.5607L13.3107 12.8107Z" }), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.56906 7.712L2.5 10.757L5.14509 13.4095V18.3157C5.14158 18.4595 5.19712 18.5984 5.29877 18.7001C5.40041 18.8018 5.53927 18.8573 5.68297 18.8538H10.5682L13.2386 21.5L16.3076 18.4297C17.5875 17.1712 17.8118 15.1882 16.8455 13.6754C19.0346 10.9539 20.3101 7.61112 20.4904 4.12256C20.5244 3.95253 20.4668 3.77711 20.3385 3.66043C20.2205 3.53427 20.0464 3.477 19.8766 3.5085C16.3611 3.65594 12.992 4.95743 10.2897 7.21188C8.79853 6.23009 6.82163 6.43952 5.56906 7.712ZM15.6767 12.7352C17.4488 10.5322 18.5628 7.88149 18.9022 5.088C16.0944 5.4084 13.4327 6.54322 11.2507 8.36367L10.3953 9.07731L9.46486 8.46472C8.57195 7.87683 7.38824 8.00215 6.63805 8.76426L6.63183 8.77058L4.624 10.7627L6.64509 12.7894V17.3538H11.1855L13.2335 19.3833L15.2559 17.3601C16.0303 16.5986 16.1662 15.3984 15.5814 14.4829L15.0013 13.5748L15.6767 12.7352Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), x = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Bug-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Bug-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M12.75 13C12.75 12.5858 12.4142 12.25 12 12.25C11.5858 12.25 11.25 12.5858 11.25 13V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V13Z" }), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.21967 3.21967C7.51256 2.92678 7.98744 2.92678 8.28033 3.21967L9.75178 4.69112C10.3925 4.25495 11.1665 4 12 4C12.8335 4 13.6075 4.25495 14.2482 4.69112L15.7197 3.21967C16.0126 2.92678 16.4874 2.92678 16.7803 3.21967C17.0732 3.51256 17.0732 3.98744 16.7803 4.28033L15.3089 5.75178C15.745 6.39249 16 7.16647 16 8C16 8.24459 15.978 8.48406 15.936 8.71654C16.3055 9.09149 16.6352 9.51832 16.9169 9.9873L18.584 8.87592C18.9287 8.64616 19.3943 8.73929 19.6241 9.08393C19.8538 9.42858 19.7607 9.89423 19.4161 10.124L17.5593 11.3618C17.7663 11.955 17.9056 12.5887 17.966 13.25H20.25C20.6642 13.25 21 13.5858 21 14C21 14.4142 20.6642 14.75 20.25 14.75H17.966C17.9056 15.4113 17.7663 16.045 17.5593 16.6382L19.4161 17.876C19.7607 18.1058 19.8538 18.5714 19.6241 18.9161C19.3943 19.2607 18.9287 19.3538 18.584 19.1241L16.9169 18.0127C15.8319 19.819 14.0342 21 12 21C9.96584 21 8.1681 19.819 7.08306 18.0127L5.41598 19.1241C5.07134 19.3538 4.60568 19.2607 4.37592 18.9161C4.14616 18.5714 4.23929 18.1058 4.58393 17.876L6.44071 16.6382C6.2337 16.045 6.09441 15.4113 6.03404 14.75H3.75C3.33579 14.75 3 14.4142 3 14C3 13.5858 3.33579 13.25 3.75 13.25H6.03404C6.09441 12.5887 6.2337 11.955 6.44071 11.3618L4.58393 10.124C4.23929 9.89423 4.14616 9.42858 4.37592 9.08393C4.60568 8.73929 5.07134 8.64616 5.41598 8.87592L7.08306 9.9873C7.36477 9.51832 7.69453 9.09149 8.064 8.71654C8.02195 8.48406 8 8.24459 8 8C8 7.16647 8.25495 6.39249 8.69112 5.75178L7.21967 4.28033C6.92678 3.98744 6.92678 3.51256 7.21967 3.21967ZM12 5.5C13.2513 5.5 14.2879 6.41933 14.4712 7.61941C13.7176 7.22152 12.881 7 12 7C11.119 7 10.2824 7.22152 9.52878 7.61941C9.71209 6.41933 10.7487 5.5 12 5.5ZM16.5 14C16.5 17.2628 14.2767 19.5 12 19.5C9.72332 19.5 7.5 17.2628 7.5 14C7.5 10.7372 9.72332 8.5 12 8.5C14.2767 8.5 16.5 10.7372 16.5 14Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), S = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Bus-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Bus-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M7 14.5C7 13.9477 7.44772 13.5 8 13.5H9C9.55228 13.5 10 13.9477 10 14.5C10 15.0523 9.55228 15.5 9 15.5H8C7.44772 15.5 7 15.0523 7 14.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M15 13.5C14.4477 13.5 14 13.9477 14 14.5C14 15.0523 14.4477 15.5 15 15.5H16C16.5523 15.5 17 15.0523 17 14.5C17 13.9477 16.5523 13.5 16 13.5H15Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4 13H4.5V20C4.5 20.5523 4.94772 21 5.5 21H8.5C9.05228 21 9.5 20.5523 9.5 20V18H14.5V20C14.5 20.5523 14.9477 21 15.5 21H18.5C19.0523 21 19.5 20.5523 19.5 20V13H20C20.5523 13 21 12.5523 21 12V8C21 7.44772 20.5523 7 20 7H19.5C19.5 4.79086 17.7091 3 15.5 3H8.5C6.29086 3 4.5 4.79086 4.5 7H4C3.44772 7 3 7.44772 3 8V12C3 12.5523 3.44772 13 4 13ZM8.5 4.5H15.5C16.8807 4.5 18 5.61929 18 7V11H6V7C6 5.61929 7.11929 4.5 8.5 4.5ZM18 16.5V12.5H6V16.5H18ZM16 18V19.5H18V18H16ZM6 18H8V19.5H6V18Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), C = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "BusFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#BusFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.5 5H15.5C16.6046 5 17.5 5.89543 17.5 7V12H6.5V7C6.5 5.89543 7.39543 5 8.5 5ZM4 13H4.5V14V18V20C4.5 20.5523 4.94772 21 5.5 21H7.5C8.05228 21 8.5 20.5523 8.5 20V18H15.5V20C15.5 20.5523 15.9477 21 16.5 21H18.5C19.0523 21 19.5 20.5523 19.5 20V18V14V13H20C20.5523 13 21 12.5523 21 12V8C21 7.44772 20.5523 7 20 7H19.5C19.5 4.79086 17.7091 3 15.5 3H8.5C6.29086 3 4.5 4.79086 4.5 7H4C3.44772 7 3 7.44772 3 8V12C3 12.5523 3.44772 13 4 13ZM6 15C6 14.4477 6.44772 14 7 14H8C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16H7C6.44772 16 6 15.5523 6 15ZM16 14C15.4477 14 15 14.4477 15 15C15 15.5523 15.4477 16 16 16H17C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14H16Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), w = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Calendar-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Calendar-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M3 7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7ZM7 4.5H17C18.3807 4.5 19.5 5.61929 19.5 7V7.75H4.5V7C4.5 5.61929 5.61929 4.5 7 4.5ZM19.5 9.25V17C19.5 18.3807 18.3807 19.5 17 19.5H7C5.61929 19.5 4.5 18.3807 4.5 17V9.25H19.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M8.5 12C8.5 12.5523 8.05228 13 7.5 13C6.94772 13 6.5 12.5523 6.5 12C6.5 11.4477 6.94772 11 7.5 11C8.05228 11 8.5 11.4477 8.5 12Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M8.5 16C8.5 16.5523 8.05228 17 7.5 17C6.94772 17 6.5 16.5523 6.5 16C6.5 15.4477 6.94772 15 7.5 15C8.05228 15 8.5 15.4477 8.5 16Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M17.5 12C17.5 12.5523 17.0523 13 16.5 13C15.9477 13 15.5 12.5523 15.5 12C15.5 11.4477 15.9477 11 16.5 11C17.0523 11 17.5 11.4477 17.5 12Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), T = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CalendarTime-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#CalendarTime-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M17.0005 3C19.2095 3.00016 21.0005 4.79096 21.0005 7V11C21.0005 11.4141 20.6645 11.7498 20.2505 11.75C19.8363 11.75 19.5005 11.4142 19.5005 11V9.25H4.50049V17C4.50052 18.3807 5.6198 19.5 7.00049 19.5H11.0005C11.4146 19.5002 11.7505 19.8359 11.7505 20.25C11.7505 20.6641 11.4145 20.9998 11.0005 21H7.00049C4.79137 21 3.00052 19.2091 3.00049 17V7C3.00049 4.79086 4.79135 3 7.00049 3H17.0005ZM16.5005 12C18.9856 12.0002 21.0005 14.0148 21.0005 16.5C21.0005 18.9852 18.9856 20.9998 16.5005 21C14.0152 21 12.0005 18.9853 12.0005 16.5C12.0005 14.0147 14.0152 12 16.5005 12ZM16.5005 13.5C14.8436 13.5 13.5005 14.8431 13.5005 16.5C13.5005 18.1568 14.8437 19.5 16.5005 19.5C18.1572 19.4998 19.5005 18.1567 19.5005 16.5C19.5005 14.8432 18.1572 13.5002 16.5005 13.5ZM16.5005 14.25C16.9146 14.2502 17.2505 14.5859 17.2505 15V16.1895L17.5308 16.4697C17.8234 16.7626 17.8235 17.2374 17.5308 17.5303C17.2379 17.8231 16.7631 17.823 16.4702 17.5303L15.9702 17.0303C15.8296 16.8896 15.7505 16.6989 15.7505 16.5V15C15.7505 14.5858 16.0863 14.25 16.5005 14.25ZM7.50049 15C8.05263 15.0002 8.50049 15.4478 8.50049 16C8.50046 16.5522 8.05261 16.9998 7.50049 17C6.94822 17 6.50052 16.5523 6.50049 16C6.50049 15.4477 6.9482 15 7.50049 15ZM7.50049 11C8.05263 11.0002 8.50049 11.4478 8.50049 12C8.50046 12.5522 8.05261 12.9998 7.50049 13C6.94822 13 6.50052 12.5523 6.50049 12C6.50049 11.4477 6.9482 11 7.50049 11ZM12.0005 11C12.5526 11.0002 13.0005 11.4478 13.0005 12C13.0005 12.5522 12.5526 12.9998 12.0005 13C11.4482 13 11.0005 12.5523 11.0005 12C11.0005 11.4477 11.4482 11 12.0005 11ZM7.00049 4.5C5.61978 4.5 4.50049 5.61929 4.50049 7V7.75H19.5005V7C19.5005 5.61939 18.3811 4.50016 17.0005 4.5H7.00049Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), E = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Campaign-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Campaign-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M20.827 12.75H18.7115C18.4987 12.75 18.3205 12.6782 18.177 12.5345C18.0333 12.391 17.9615 12.2128 17.9615 12C17.9615 11.7872 18.0333 11.609 18.177 11.4655C18.3205 11.3218 18.4987 11.25 18.7115 11.25H20.827C21.0398 11.25 21.218 11.3218 21.3615 11.4655C21.5052 11.609 21.577 11.7872 21.577 12C21.577 12.2128 21.5052 12.391 21.3615 12.5345C21.218 12.6782 21.0398 12.75 20.827 12.75ZM16.6673 16.7135C16.7954 16.5378 16.9593 16.4365 17.1588 16.4095C17.3581 16.3827 17.5456 16.4333 17.7213 16.5615L19.4078 17.8288C19.5834 17.9571 19.6847 18.1209 19.7115 18.3203C19.7385 18.5196 19.6878 18.7071 19.5595 18.8828C19.4313 19.0583 19.2676 19.1595 19.0683 19.1865C18.8689 19.2135 18.6814 19.1628 18.5058 19.0345L16.8193 17.7673C16.6436 17.6391 16.5423 17.4753 16.5155 17.276C16.4885 17.0767 16.5391 16.8892 16.6673 16.7135ZM19.3693 6.13275L17.6828 7.4C17.5071 7.52817 17.3196 7.57884 17.1203 7.552C16.9209 7.525 16.7571 7.42367 16.6288 7.248C16.5006 7.0725 16.45 6.885 16.477 6.6855C16.5038 6.48617 16.6051 6.32242 16.7808 6.19425L18.4673 4.927C18.6429 4.79884 18.8304 4.74817 19.0298 4.775C19.2291 4.802 19.3929 4.90325 19.5213 5.07875C19.6494 5.25442 19.7 5.44192 19.673 5.64125C19.6462 5.84075 19.5449 6.00459 19.3693 6.13275ZM5.25 14.577H4.23075C3.73209 14.577 3.30617 14.4003 2.953 14.047C2.59967 13.6938 2.423 13.2679 2.423 12.7693V11.2308C2.423 10.7321 2.59967 10.3062 2.953 9.953C3.30617 9.59967 3.73209 9.423 4.23075 9.423H8.09625L11.2058 7.5635C11.5071 7.38267 11.8109 7.38109 12.1173 7.55875C12.4238 7.73625 12.577 7.99742 12.577 8.34225V15.6578C12.577 16.0026 12.4238 16.2638 12.1173 16.4413C11.8109 16.6189 11.5071 16.6173 11.2058 16.4365L8.09625 14.577H6.75V17.7308C6.75 17.9436 6.67817 18.1218 6.5345 18.2653C6.391 18.4089 6.21284 18.4808 6 18.4808C5.78717 18.4808 5.609 18.4089 5.4655 18.2653C5.32184 18.1218 5.25 17.9436 5.25 17.7308V14.577ZM11.077 14.5848V9.41525L8.5115 10.923H4.23075C4.15392 10.923 4.08342 10.9551 4.01925 11.0193C3.95509 11.0834 3.923 11.1539 3.923 11.2308V12.7693C3.923 12.8461 3.95509 12.9166 4.01925 12.9808C4.08342 13.0449 4.15392 13.077 4.23075 13.077H8.5115L11.077 14.5848ZM13.9615 15.1193V8.88075C14.3538 9.23592 14.6698 9.68334 14.9095 10.223C15.1493 10.7628 15.2693 11.3552 15.2693 12C15.2693 12.6448 15.1493 13.2372 14.9095 13.777C14.6698 14.3167 14.3538 14.7641 13.9615 15.1193Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), D = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CardMember-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#CardMember-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20 2.5C20.8339 2.5 21.5 3.16614 21.5 4V15C21.5 15.8339 20.8339 16.5 20 16.5H15.5V21.1904L12.2236 19.5527L12 19.4414L11.7764 19.5527L8.5 21.1904V16.5H4C3.16614 16.5 2.5 15.8339 2.5 15V4C2.5 3.16614 3.16614 2.5 4 2.5H20ZM3.5 12.5V15.5H20.5V12.5H3.5ZM3.5 3.5V10.5H20.5V3.5H3.5Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), O = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Charter-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Charter-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4.5 4.5H16.5V13C16.5 13.4142 16.8358 13.75 17.25 13.75C17.6642 13.75 18 13.4142 18 13V4C18 3.44772 17.5523 3 17 3H4C3.44772 3 3 3.44772 3 4V18C3 19.6569 4.34315 21 6 21H17.75C19.5449 21 21 19.5449 21 17.75V16C21 15.5858 20.6642 15.25 20.25 15.25H8.5C8.08579 15.25 7.75 15.5858 7.75 16V17.75C7.75 18.7165 6.9665 19.5 6 19.5C5.17157 19.5 4.5 18.8284 4.5 18V4.5ZM8.73909 19.5H17.75C18.7165 19.5 19.5 18.7165 19.5 17.75V16.75H9.25V17.75C9.25 18.3943 9.0625 18.9949 8.73909 19.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H13C13.4142 7.25 13.75 7.58579 13.75 8C13.75 8.41421 13.4142 8.75 13 8.75H8C7.58579 8.75 7.25 8.41421 7.25 8Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H13C13.4142 11.25 13.75 11.5858 13.75 12C13.75 12.4142 13.4142 12.75 13 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), k = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Check-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Check-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.7071 6.79289C20.0976 7.18342 20.0976 7.81658 19.7071 8.20711L10.7071 17.2071C10.3166 17.5976 9.68342 17.5976 9.29289 17.2071L4.29289 12.2071C3.90237 11.8166 3.90237 11.1834 4.29289 10.7929C4.68342 10.4024 5.31658 10.4024 5.70711 10.7929L10 15.0858L18.2929 6.79289C18.6834 6.40237 19.3166 6.40237 19.7071 6.79289Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), A = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CheckCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#CheckCircle-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.5303 8.21967C17.8232 8.51256 17.8232 8.98744 17.5303 9.28033L11.0303 15.7803C10.7374 16.0732 10.2626 16.0732 9.96967 15.7803L6.46967 12.2803C6.17678 11.9874 6.17678 11.5126 6.46967 11.2197C6.76256 10.9268 7.23744 10.9268 7.53033 11.2197L10.5 14.1893L16.4697 8.21967C16.7626 7.92678 17.2374 7.92678 17.5303 8.21967Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), j = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CheckCircleFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#CheckCircleFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.5303 9.28033C17.8232 8.98744 17.8232 8.51256 17.5303 8.21967C17.2374 7.92678 16.7626 7.92678 16.4697 8.21967L10.5 14.1893L7.53033 11.2197C7.23744 10.9268 6.76256 10.9268 6.46967 11.2197C6.17678 11.5126 6.17678 11.9874 6.46967 12.2803L9.96967 15.7803C10.2626 16.0732 10.7374 16.0732 11.0303 15.7803L17.5303 9.28033Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), M = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CheckboxFalse-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#CheckboxFalse-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.2 5H7.8C6.92692 5 6.39239 5.00156 5.99247 5.03423C5.80617 5.04945 5.69345 5.06857 5.625 5.08469C5.59244 5.09236 5.57241 5.09879 5.56158 5.10265C5.55118 5.10636 5.54601 5.10899 5.54601 5.10899C5.35785 5.20487 5.20487 5.35785 5.10899 5.54601C5.10899 5.54601 5.10636 5.55118 5.10265 5.56158C5.09879 5.57241 5.09236 5.59244 5.08469 5.625C5.06857 5.69345 5.04945 5.80617 5.03423 5.99247C5.00156 6.39239 5 6.92692 5 7.8V16.2C5 17.0731 5.00156 17.6076 5.03423 18.0075C5.04945 18.1938 5.06857 18.3065 5.08469 18.375C5.09236 18.4076 5.09879 18.4276 5.10265 18.4384C5.10636 18.4488 5.10899 18.454 5.10899 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.54601 18.891 5.55118 18.8936 5.56158 18.8973C5.57241 18.9012 5.59244 18.9076 5.625 18.9153C5.69345 18.9314 5.80617 18.9505 5.99247 18.9658C6.39239 18.9984 6.92692 19 7.8 19H16.2C17.0731 19 17.6076 18.9984 18.0075 18.9658C18.1938 18.9505 18.3065 18.9314 18.375 18.9153C18.4076 18.9076 18.4276 18.9012 18.4384 18.8973C18.4488 18.8936 18.454 18.891 18.454 18.891C18.6422 18.7951 18.7951 18.6422 18.891 18.454C18.891 18.454 18.8936 18.4488 18.8973 18.4384C18.9012 18.4276 18.9076 18.4076 18.9153 18.375C18.9314 18.3065 18.9505 18.1938 18.9658 18.0075C18.9984 17.6076 19 17.0731 19 16.2V7.8C19 6.92692 18.9984 6.39239 18.9658 5.99247C18.9505 5.80617 18.9314 5.69345 18.9153 5.625C18.9076 5.59244 18.9012 5.57241 18.8973 5.56158C18.8936 5.55118 18.891 5.54601 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.10899C18.454 5.10899 18.4488 5.10636 18.4384 5.10265C18.4276 5.09879 18.4076 5.09236 18.375 5.08469C18.3065 5.06857 18.1938 5.04945 18.0075 5.03423C17.6076 5.00156 17.0731 5 16.2 5ZM3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), N = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CheckboxTrue-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#CheckboxTrue-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8ZM17.7803 9.28033C18.0732 8.98744 18.0732 8.51256 17.7803 8.21967C17.4874 7.92678 17.0126 7.92678 16.7197 8.21967L10.5 14.4393L7.28033 11.2197C6.98744 10.9268 6.51256 10.9268 6.21967 11.2197C5.92678 11.5126 5.92678 11.9874 6.21967 12.2803L9.96967 16.0303C10.2626 16.3232 10.7374 16.3232 11.0303 16.0303L17.7803 9.28033Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), P = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ChevronBottom-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ChevronBottom-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L12 13.5858L6.70711 8.29289Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), F = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ChevronLeft-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ChevronLeft-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071C16.0976 18.3166 16.0976 17.6834 15.7071 17.2929L10.4142 12L15.7071 6.70711Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), I = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ChevronRight-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ChevronRight-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), L = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ChevronTop-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ChevronTop-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.2929 15.7071C17.6834 16.0976 18.3166 16.0976 18.7071 15.7071C19.0976 15.3166 19.0976 14.6834 18.7071 14.2929L12.7071 8.29289C12.3166 7.90237 11.6834 7.90237 11.2929 8.29289L5.29289 14.2929C4.90237 14.6834 4.90237 15.3166 5.29289 15.7071C5.68342 16.0976 6.31658 16.0976 6.70711 15.7071L12 10.4142L17.2929 15.7071Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), R = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Child-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Child-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16.5 13C16.5 13.8284 15.8284 14.5 15 14.5C14.1716 14.5 13.5 13.8284 13.5 13C13.5 12.1716 14.1716 11.5 15 11.5C15.8284 11.5 16.5 12.1716 16.5 13Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 20C8.63091 20 5.74825 17.9174 4.56916 14.9693C3.11643 14.7604 2 13.5106 2 12C2 10.4894 3.11643 9.23964 4.56916 9.03071C5.74825 6.08262 8.63091 4 12 4C15.3691 4 18.2518 6.08262 19.4308 9.03071C20.8836 9.23964 22 10.4894 22 12C22 13.5106 20.8836 14.7604 19.4308 14.9693C18.2518 17.9174 15.3691 20 12 20ZM19.2173 13.4846L18.3598 13.6079L18.0381 14.4123C17.079 16.8103 14.735 18.5 12 18.5C9.26498 18.5 6.92099 16.8103 5.9619 14.4123L5.64019 13.6079L4.78269 13.4846C4.05772 13.3803 3.5 12.754 3.5 12C3.5 11.246 4.05772 10.6197 4.78269 10.5154L5.64019 10.3921L5.9619 9.58773C6.81259 7.46074 8.75283 5.89099 11.0891 5.56333C10.643 7.71071 12.2826 9.75006 14.5 9.75006C14.9142 9.75006 15.25 9.41427 15.25 9.00006C15.25 8.58584 14.9142 8.25006 14.5 8.25006C13.2101 8.25006 12.2636 7.03784 12.5765 5.78646L12.6403 5.53114C15.0967 5.77136 17.1548 7.37913 18.0381 9.58773L18.3598 10.3921L19.2173 10.5154C19.9423 10.6197 20.5 11.246 20.5 12C20.5 12.754 19.9423 13.3803 19.2173 13.4846Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ee = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Close-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Close-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12 13.4142L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L12 10.5858L5.70711 4.29289Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), z = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "CloseCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#CloseCircle-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.70183 8.6413C9.40894 8.34841 8.93406 8.34841 8.64117 8.6413C8.34828 8.93419 8.34828 9.40907 8.64117 9.70196L10.9393 12.0001L8.6413 14.2982C8.34841 14.5911 8.34841 15.0659 8.6413 15.3588C8.93419 15.6517 9.40907 15.6517 9.70196 15.3588L12 13.0608L14.298 15.3588C14.5909 15.6517 15.0658 15.6517 15.3587 15.3588C15.6516 15.0659 15.6516 14.591 15.3587 14.2982L13.0607 12.0001L15.3588 9.70198C15.6517 9.40908 15.6517 8.93421 15.3588 8.64132C15.0659 8.34842 14.591 8.34842 14.2982 8.64132L12 10.9395L9.70183 8.6413Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), te = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Cloud-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Cloud-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M6.5 19.5C5.118 19.5 3.93917 19.0198 2.9635 18.0595C1.98783 17.0993 1.5 15.9283 1.5 14.5463C1.5 13.3231 1.89167 12.2353 2.675 11.2828C3.45833 10.3301 4.45767 9.76658 5.673 9.59225C5.9935 8.09742 6.74517 6.875 7.928 5.925C9.11067 4.975 10.468 4.5 12 4.5C13.809 4.5 15.3446 5.13108 16.6068 6.39325C17.8689 7.65542 18.5 9.191 18.5 11V11.5H18.8078C19.8616 11.582 20.7404 12.0058 21.4443 12.7713C22.1481 13.5366 22.5 14.4462 22.5 15.5C22.5 16.6153 22.1122 17.5608 21.3365 18.3365C20.5608 19.1122 19.6153 19.5 18.5 19.5H6.5ZM6.5 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ne = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Company-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Company-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6 13.5H8V12H6V13.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M8 10.5H6V9H8V10.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6 7.5H8V6H6V7.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M11.5 13.5H9.5V12H11.5V13.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M9.5 10.5H11.5V9H9.5V10.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M11.5 7.5H9.5V6H11.5V7.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M18 12H16V10.5H18V12Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16 15H18V13.5H16V15Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M18 18H16V16.5H18V18Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4 21C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H13.5C14.0523 3 14.5 3.44772 14.5 4V7.5H20C20.5523 7.5 21 7.94772 21 8.5V20C21 20.5523 20.5523 21 20 21H4ZM4.5 19.5V4.5H13V19.5H11.5V16C11.5 15.4477 11.0523 15 10.5 15H7C6.44772 15 6 15.4477 6 16V19.5H4.5ZM7.5 19.5H10V16.5H7.5V19.5ZM14.5 19.5H19.5V9H14.5V19.5Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), re = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Connection-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Connection-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.4697 12.4697C13.7626 12.1768 14.2374 12.1768 14.5303 12.4697L16.5303 14.4697C16.8232 14.7626 16.8232 15.2374 16.5303 15.5303L14.5303 17.5303C14.2374 17.8232 13.7626 17.8232 13.4697 17.5303C13.1768 17.2374 13.1768 16.7626 13.4697 16.4697L14.1893 15.75H8.5C8.08579 15.75 7.75 15.4142 7.75 15C7.75 14.5858 8.08579 14.25 8.5 14.25H14.1893L13.4697 13.5303C13.1768 13.2374 13.1768 12.7626 13.4697 12.4697Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.5303 11.5303C10.2374 11.8232 9.76256 11.8232 9.46967 11.5303L7.46967 9.53033C7.17678 9.23744 7.17678 8.76256 7.46967 8.46967L9.46967 6.46967C9.76256 6.17678 10.2374 6.17678 10.5303 6.46967C10.8232 6.76256 10.8232 7.23744 10.5303 7.53033L9.81066 8.25H15.5C15.9142 8.25 16.25 8.58579 16.25 9C16.25 9.41421 15.9142 9.75 15.5 9.75L9.81066 9.75L10.5303 10.4697C10.8232 10.7626 10.8232 11.2374 10.5303 11.5303Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ie = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ConnectionFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#ConnectionFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.4697 12.4697C13.7626 12.1768 14.2374 12.1768 14.5303 12.4697L16.5303 14.4697C16.8232 14.7626 16.8232 15.2374 16.5303 15.5303L14.5303 17.5303C14.2374 17.8232 13.7626 17.8232 13.4697 17.5303C13.1768 17.2374 13.1768 16.7626 13.4697 16.4697L14.1893 15.75H8.5C8.08579 15.75 7.75 15.4142 7.75 15C7.75 14.5858 8.08579 14.25 8.5 14.25H14.1893L13.4697 13.5303C13.1768 13.2374 13.1768 12.7626 13.4697 12.4697ZM9.46967 11.5303C9.76256 11.8232 10.2374 11.8232 10.5303 11.5303C10.8232 11.2374 10.8232 10.7626 10.5303 10.4697L9.81066 9.75L15.5 9.75C15.9142 9.75 16.25 9.41421 16.25 9C16.25 8.58579 15.9142 8.25 15.5 8.25H9.81066L10.5303 7.53033C10.8232 7.23744 10.8232 6.76256 10.5303 6.46967C10.2374 6.17678 9.76256 6.17678 9.46967 6.46967L7.46967 8.46967C7.17678 8.76256 7.17678 9.23744 7.46967 9.53033L9.46967 11.5303Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), B = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ContactList-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#ContactList-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.5 10.15C13.9971 10.15 14.4 9.74706 14.4 9.25C14.4 8.75294 13.9971 8.35 13.5 8.35C13.0029 8.35 12.6 8.75294 12.6 9.25C12.6 9.74706 13.0029 10.15 13.5 10.15ZM13.5 11.5C14.7426 11.5 15.75 10.4926 15.75 9.25C15.75 8.00736 14.7426 7 13.5 7C12.2574 7 11.25 8.00736 11.25 9.25C11.25 10.4926 12.2574 11.5 13.5 11.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10 16C10 14.067 11.567 12.5 13.5 12.5C15.433 12.5 17 14.067 17 16V17H10V16ZM11.563 15.5H15.437C15.215 14.6374 14.4319 14 13.5 14C12.5681 14 11.785 14.6374 11.563 15.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16 2C18.2091 2 20 3.79086 20 6V18C20 20.2091 18.2091 22 16 22H5C4.44771 22 4 21.5523 4 21L4 3C4 2.44772 4.44772 2 5 2L16 2ZM18.5 6V18C18.5 19.3807 17.3807 20.5 16 20.5H8.5V3.5L16 3.5C17.3807 3.5 18.5 4.61929 18.5 6ZM7 3.5V20.5H5.5L5.5 3.5H7Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), V = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Copy-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Copy-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.5 3.5V17.5H18.5V3.5H8.5ZM8 2C7.44772 2 7 2.44772 7 3V18C7 18.5523 7.44772 19 8 19H19C19.5523 19 20 18.5523 20 18V3C20 2.44772 19.5523 2 19 2H8Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 21.25C4 21.6642 4.33579 22 4.75 22H15.25C15.6642 22 16 21.6642 16 21.25C16 20.8358 15.6642 20.5 15.25 20.5H5.5V6.75C5.5 6.33579 5.16421 6 4.75 6C4.33579 6 4 6.33579 4 6.75V21.25Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ae = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Crew-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Crew-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18 8.5C17.1716 8.5 16.5 7.82843 16.5 7C16.5 6.17157 17.1716 5.5 18 5.5C18.8284 5.5 19.5 6.17157 19.5 7C19.5 7.82843 18.8284 8.5 18 8.5ZM15.0187 6.66272C15.1864 5.16463 16.4572 4 18 4C19.6569 4 21 5.34315 21 7C21 8.65685 19.6569 10 18 10C17.4459 10 16.9268 9.84976 16.4814 9.58779C16.3763 8.43046 15.833 7.39968 15.0187 6.66272Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6 8.5C5.17157 8.5 4.5 7.82843 4.5 7C4.5 6.17157 5.17157 5.5 6 5.5C6.82843 5.5 7.5 6.17157 7.5 7C7.5 7.82843 6.82843 8.5 6 8.5ZM3 7C3 5.34315 4.34315 4 6 4C7.54283 4 8.81364 5.16463 8.98125 6.66272C8.16702 7.39968 7.62373 8.43046 7.51863 9.58779C7.07318 9.84976 6.55414 10 6 10C4.34315 10 3 8.65685 3 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.5 10C10.5 10.8284 11.1716 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9 16.75V18.5H15V16.75C15 16.4581 14.9159 16.248 14.6595 16.0572C14.3342 15.8151 13.5797 15.5 11.9951 15.5C10.4102 15.5 9.65959 15.8152 9.33765 16.0557C9.08489 16.2444 8.99999 16.4537 9 16.75ZM7.5 16.75V19C7.5 19.5523 7.94772 20 8.5 20H15.5C16.0523 20 16.5 19.5523 16.5 19V16.75C16.5 15.3602 15.4816 14 11.9951 14C8.50865 14 7.49996 15.3602 7.5 16.75Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M17.8038 15.5C17.9395 15.9121 18 16.3358 18 16.75V17H21C21.5523 17 22 16.5523 22 16V13.75C22 12.3602 20.9533 11 17.37 11C17.0154 11 16.6857 11.0133 16.3795 11.0387C16.2391 11.633 15.9808 12.1818 15.6307 12.6591C16.0616 12.5649 16.6289 12.5 17.37 12.5C19.0096 12.5 19.8021 12.8176 20.1491 13.0688C20.4216 13.2661 20.5 13.4743 20.5 13.75V15.5H17.8038Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6.62 11C6.97844 11 7.31149 11.0136 7.62066 11.0395C7.76135 11.6345 8.02015 12.1838 8.37095 12.6613C7.9377 12.5659 7.36669 12.5 6.62 12.5C4.98007 12.5 4.19149 12.8177 3.84796 13.0673C3.57933 13.2625 3.49999 13.4698 3.5 13.75V15.5H6.19531C6.05997 15.9126 5.99999 16.3365 6 16.75V17H3C2.44772 17 2 16.5523 2 16V13.75C1.99996 12.3602 3.03667 11 6.62 11Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), oe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Departure-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Departure-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 5.5C8.85901 5.5 7.73812 5.80034 6.75 6.37084C5.76187 6.94133 4.94133 7.76188 4.37083 8.75C3.80034 9.73813 3.5 10.859 3.5 12C3.5 13.141 3.80034 14.2619 4.37084 15.25C4.94133 16.2381 5.76188 17.0587 6.75 17.6292C7.73813 18.1997 8.85901 18.5 10 18.5C11.141 18.5 12.2619 18.1997 13.25 17.6292C13.6087 17.4221 14.0674 17.545 14.2745 17.9037C14.4816 18.2624 14.3587 18.7211 14 18.9282C12.7838 19.6303 11.4043 20 10 20C8.59571 20 7.21616 19.6304 6 18.9282C4.78385 18.2261 3.77394 17.2162 3.0718 16C2.36965 14.7838 2 13.4043 2 12C2 10.5957 2.36965 9.21615 3.0718 8C3.77394 6.78385 4.78385 5.77394 6 5.0718C7.21615 4.36965 8.59571 4 10 4C11.4043 4 12.7838 4.36965 14 5.0718C14.3587 5.2789 14.4816 5.7376 14.2745 6.09632C14.0674 6.45503 13.6087 6.57794 13.25 6.37083C12.2619 5.80034 11.141 5.5 10 5.5Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.2197 7.96967C17.5126 7.67678 17.9874 7.67678 18.2803 7.96967L21.7803 11.4697C22.0732 11.7626 22.0732 12.2374 21.7803 12.5303L18.2803 16.0303C17.9874 16.3232 17.5126 16.3232 17.2197 16.0303C16.9268 15.7374 16.9268 15.2626 17.2197 14.9697L19.4393 12.75H10.75C10.3358 12.75 10 12.4142 10 12C10 11.5858 10.3358 11.25 10.75 11.25H19.4393L17.2197 9.03033C16.9268 8.73744 16.9268 8.26256 17.2197 7.96967Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), H = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Dialpad-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Dialpad-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12 19.5C12.8239 19.5 13.5 20.1761 13.5 21C13.5 21.8239 12.8239 22.5 12 22.5C11.1761 22.5 10.5 21.8239 10.5 21C10.5 20.1761 11.1761 19.5 12 19.5ZM6 13.5C6.82386 13.5 7.5 14.1761 7.5 15C7.5 15.8239 6.82386 16.5 6 16.5C5.17614 16.5 4.5 15.8239 4.5 15C4.5 14.1761 5.17614 13.5 6 13.5ZM12 13.5C12.8239 13.5 13.5 14.1761 13.5 15C13.5 15.8239 12.8239 16.5 12 16.5C11.1761 16.5 10.5 15.8239 10.5 15C10.5 14.1761 11.1761 13.5 12 13.5ZM18 13.5C18.8239 13.5 19.5 14.1761 19.5 15C19.5 15.8239 18.8239 16.5 18 16.5C17.1761 16.5 16.5 15.8239 16.5 15C16.5 14.1761 17.1761 13.5 18 13.5ZM6 7.5C6.82386 7.5 7.5 8.17614 7.5 9C7.5 9.82386 6.82386 10.5 6 10.5C5.17614 10.5 4.5 9.82386 4.5 9C4.5 8.17614 5.17614 7.5 6 7.5ZM12 7.5C12.8239 7.5 13.5 8.17614 13.5 9C13.5 9.82386 12.8239 10.5 12 10.5C11.1761 10.5 10.5 9.82386 10.5 9C10.5 8.17614 11.1761 7.5 12 7.5ZM18 7.5C18.8239 7.5 19.5 8.17614 19.5 9C19.5 9.82386 18.8239 10.5 18 10.5C17.1761 10.5 16.5 9.82386 16.5 9C16.5 8.17614 17.1761 7.5 18 7.5ZM6 1.5C6.82386 1.5 7.5 2.17614 7.5 3C7.5 3.82386 6.82386 4.5 6 4.5C5.17614 4.5 4.5 3.82386 4.5 3C4.5 2.17614 5.17614 1.5 6 1.5ZM12 1.5C12.8239 1.5 13.5 2.17614 13.5 3C13.5 3.82386 12.8239 4.5 12 4.5C11.1761 4.5 10.5 3.82386 10.5 3C10.5 2.17614 11.1761 1.5 12 1.5ZM18 1.5C18.8239 1.5 19.5 2.17614 19.5 3C19.5 3.82386 18.8239 4.5 18 4.5C17.1761 4.5 16.5 3.82386 16.5 3C16.5 2.17614 17.1761 1.5 18 1.5Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), U = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Disability-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Disability-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9.25 7C10.6307 7 11.75 5.88071 11.75 4.5C11.75 3.11929 10.6307 2 9.25 2C7.86929 2 6.75 3.11929 6.75 4.5C6.75 5.88071 7.86929 7 9.25 7ZM9.25 5.5C9.80228 5.5 10.25 5.05228 10.25 4.5C10.25 3.94772 9.80228 3.5 9.25 3.5C8.69772 3.5 8.25 3.94772 8.25 4.5C8.25 5.05228 8.69772 5.5 9.25 5.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M9.69437 8.31492C9.75894 8.28613 9.82674 8.26692 9.89563 8.2573C10.0163 8.24025 10.1349 8.25311 10.2434 8.29047C10.3275 8.31923 10.4074 8.36333 10.4789 8.42277C10.5 8.44028 10.5202 8.45896 10.5394 8.47874L11.1586 9.098C11.9634 9.90281 13.3202 9.68264 13.8292 8.66463C14.0144 8.29415 14.4649 8.14398 14.8354 8.32922C15.2059 8.51446 15.3561 8.96497 15.1708 9.33545C14.3932 10.8908 12.5738 11.4657 11.0961 10.8358L11.5886 13.5447C11.6102 13.6636 11.7138 13.75 11.8346 13.75H17C17.3228 13.75 17.6094 13.9566 17.7115 14.2628L19.9615 21.0128C20.0925 21.4058 19.8801 21.8305 19.4872 21.9615C19.0942 22.0925 18.6695 21.8801 18.5385 21.4872L16.4594 15.25H11.8346C10.9888 15.25 10.2641 14.6452 10.1128 13.8131L9.26421 9.14576C9.23998 9.02281 9.24673 8.89498 9.28447 8.77477C9.34825 8.57275 9.49619 8.40314 9.69437 8.31492Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M7.5 13.0359C7.85872 12.8288 7.98163 12.3701 7.77452 12.0114C7.56741 11.6526 7.10872 11.5297 6.75 11.7368C5.9667 12.1891 5.30702 12.8275 4.82939 13.5956C4.35176 14.3637 4.07093 15.2377 4.01178 16.1403C3.95262 17.0428 4.11696 17.946 4.49025 18.7699C4.86354 19.5937 5.43424 20.3128 6.15181 20.8634C6.86939 21.414 7.71168 21.7792 8.60408 21.9265C9.49648 22.0739 10.4114 21.9988 11.2679 21.7081C12.1244 21.4174 12.896 20.9199 13.5143 20.2597C14.1325 19.5996 14.5785 18.7971 14.8126 17.9235C14.9198 17.5234 14.6824 17.1121 14.2823 17.0049C13.8822 16.8977 13.4709 17.1352 13.3637 17.5353C13.1935 18.1706 12.8691 18.7542 12.4195 19.2343C11.9698 19.7145 11.4087 20.0763 10.7858 20.2877C10.1629 20.4991 9.49744 20.5537 8.84842 20.4466C8.1994 20.3394 7.58683 20.0738 7.06496 19.6734C6.54308 19.2729 6.12803 18.75 5.85655 18.1508C5.58507 17.5516 5.46554 16.8948 5.50857 16.2384C5.55159 15.582 5.75583 14.9463 6.10319 14.3877C6.45056 13.8291 6.93033 13.3648 7.5 13.0359Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), W = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Download-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Download-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.46967 9.96967C6.17678 10.2626 6.17678 10.7374 6.46967 11.0303L11.4697 16.0303C11.7626 16.3232 12.2374 16.3232 12.5303 16.0303L17.5303 11.0303C17.8232 10.7374 17.8232 10.2626 17.5303 9.96967C17.2374 9.67678 16.7626 9.67678 16.4697 9.96967L12.75 13.6893V3.75C12.75 3.33579 12.4142 3 12 3C11.5858 3 11.25 3.33579 11.25 3.75V13.6893L7.53033 9.96967C7.23744 9.67678 6.76256 9.67678 6.46967 9.96967Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.75 16.25C4.16421 16.25 4.5 16.5858 4.5 17V17.25C4.5 18.4926 5.50736 19.5 6.75 19.5H17.25C18.4926 19.5 19.5 18.4926 19.5 17.25V17C19.5 16.5858 19.8358 16.25 20.25 16.25C20.6642 16.25 21 16.5858 21 17V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V17C3 16.5858 3.33579 16.25 3.75 16.25Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), G = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Edit-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Edit-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.58941 21C7.85484 21 8.10939 20.8946 8.29708 20.7069L20.7069 8.29708C21.0977 7.90624 21.0977 7.27258 20.7069 6.88174L17.1183 3.29312C16.7274 2.90229 16.0938 2.90229 15.7029 3.29313L3.29313 15.7029C3.10544 15.8906 3 16.1452 3 16.4106V19.9992C3 20.5519 3.44807 21 4.00079 21H7.58941ZM4.50119 16.6179V19.4988H7.38214L15.6601 11.2208L12.7792 8.33985L4.50119 16.6179ZM13.8399 7.27919L16.7208 10.1601L19.2915 7.58941L16.4106 4.70846L13.8399 7.27919Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), K = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Euro-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Euro-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M15 3.5C16.9823 3.5 18.8133 4.18587 20.2598 5.33203L19.1914 6.40039C18.0202 5.5213 16.5678 5 15 5C12.3065 5 9.95872 6.53003 8.7959 8.76953L8.41699 9.5H14.5V10.5H8.15039L8.08594 10.9248C8.03295 11.2745 8 11.6303 8 12C8 12.3697 8.03295 12.7255 8.08594 13.0752L8.15039 13.5H14.5V14.5H8.41699L8.7959 15.2305C9.95851 17.4696 12.2961 19 15 19C16.5763 19 18.0218 18.4792 19.1846 17.5996L20.2588 18.668C18.8136 19.8139 16.9909 20.5 15 20.5C11.2999 20.5 8.16325 18.1312 6.99121 14.833L6.87305 14.5H3.5V13.5H6.62402L6.55664 12.9395C6.51911 12.6297 6.5 12.3199 6.5 12C6.5 11.6801 6.51911 11.3703 6.55664 11.0605L6.62402 10.5H3.5V9.5H6.87305L6.99121 9.16699C8.16325 5.86876 11.2999 3.5 15 3.5Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), se = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ExclamationCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#ExclamationCircle-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 6.25C12.7079 6.25 13.2647 6.85506 13.2059 7.56056L12.7474 13.0623C12.715 13.451 12.3901 13.75 12 13.75C11.6099 13.75 11.285 13.451 11.2526 13.0623L10.7941 7.56056C10.7353 6.85506 11.2921 6.25 12 6.25Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ce = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Export-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Export-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13 3.75C13 3.33579 13.3358 3 13.75 3H20.25C20.6642 3 21 3.33579 21 3.75V10.25C21 10.6642 20.6642 11 20.25 11C19.8358 11 19.5 10.6642 19.5 10.25V5.56066L12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303C11.1768 12.2374 11.1768 11.7626 11.4697 11.4697L18.4393 4.5H13.75C13.3358 4.5 13 4.16421 13 3.75Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M9 4.5H6C5.17157 4.5 4.5 5.17157 4.5 6V18C4.5 18.8284 5.17157 19.5 6 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V15C19.5 14.5858 19.8358 14.25 20.25 14.25C20.6642 14.25 21 14.5858 21 15V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H9C9.41421 3 9.75 3.33579 9.75 3.75C9.75 4.16421 9.41421 4.5 9 4.5Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), q = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FaceId-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#FaceId-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.27524 5.42796C5.86889 5.42796 5.53949 5.75736 5.53949 6.16375L5.53957 7.7641C5.53957 8.17041 5.21017 8.49985 4.80382 8.49985C4.39747 8.49988 4.06807 8.17048 4.06803 7.76413L4.06799 6.16378C4.06796 4.9447 5.05619 3.95642 6.27524 3.95642H7.98581C8.39212 3.95642 8.72156 4.28586 8.72156 4.69221C8.72156 5.09852 8.39212 5.42796 7.98581 5.42796H6.27524ZM17.7928 5.42796C18.1991 5.42796 18.5285 5.75736 18.5285 6.16375L18.5285 7.7641C18.5284 8.17041 18.8578 8.49985 19.2642 8.49985C19.6705 8.49988 19.9999 8.17048 20 7.76413L20 6.16378C20.0001 4.9447 19.0118 3.95642 17.7928 3.95642H16.0822C15.6759 3.95642 15.3465 4.28586 15.3465 4.69221C15.3465 5.09852 15.6759 5.42796 16.0822 5.42796H17.7928ZM12.7206 10.1466C12.7206 9.76731 12.4132 9.45988 12.0339 9.45988C11.6547 9.45988 11.3472 9.76731 11.3472 10.1466V12.2166H11.115C10.7358 12.2166 10.4283 12.524 10.4283 12.9033C10.4283 13.2825 10.7358 13.59 11.115 13.59H12.0247C12.4091 13.59 12.7206 13.2784 12.7206 12.8941V10.1466ZM16.0389 14.9977C16.3263 14.7104 16.3263 14.2445 16.0389 13.9572C15.7516 13.6699 15.2857 13.6699 14.9984 13.9572L14.8546 14.1011C13.2964 15.6592 10.77 15.6592 9.21183 14.1011L9.06963 13.9589C8.78234 13.6715 8.31648 13.6715 8.02912 13.9588C7.74179 14.2461 7.74176 14.7119 8.02904 14.9993L8.17132 15.1416C10.3042 17.2744 13.7622 17.2744 15.8951 15.1416L16.0389 14.9977ZM18.5285 17.7663C18.5285 18.1727 18.1991 18.5021 17.7928 18.5021H16.0822C15.6759 18.5021 15.3465 18.8315 15.3465 19.2379C15.3465 19.6442 15.6759 19.9736 16.0822 19.9736H17.7928C19.0118 19.9736 20.0001 18.9853 20 17.7663L20 16.1659C19.9999 15.7596 19.6705 15.4302 19.2642 15.4302C18.8578 15.4302 18.5284 15.7596 18.5285 16.166L18.5285 17.7663ZM5.53949 17.7663C5.53949 18.1727 5.86889 18.5021 6.27524 18.5021H7.98581C8.39212 18.5021 8.72156 18.8315 8.72156 19.2379C8.72156 19.6442 8.39212 19.9736 7.98581 19.9736H6.27524C5.05619 19.9736 4.06796 18.9853 4.06799 17.7663L4.06803 16.1659C4.06807 15.7596 4.39747 15.4302 4.80382 15.4302C5.21017 15.4302 5.53957 15.7596 5.53957 16.166L5.53949 17.7663ZM9.08703 8.08393C9.49338 8.08393 9.82278 8.41333 9.82278 8.81968V10.6873C9.82278 11.0936 9.49338 11.4231 9.08703 11.4231C8.68068 11.4231 8.35128 11.0936 8.35128 10.6873V8.81968C8.35128 8.41333 8.68068 8.08393 9.08703 8.08393ZM15.7167 8.81968C15.7167 8.41333 15.3873 8.08393 14.9809 8.08393C14.5746 8.08393 14.2452 8.41333 14.2452 8.81968V10.6873C14.2452 11.0936 14.5746 11.4231 14.9809 11.4231C15.3873 11.4231 15.7167 11.0936 15.7167 10.6873V8.81968Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), J = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Ferry-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Ferry-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9997 3C13.1786 3 14.9731 3.49267 14.9997 3.5V4.82715C15.5489 4.92623 16.0711 5.0354 16.5212 5.13672C17.3988 5.33428 17.9995 6.12297 17.9997 7.02246V10.6279C19.0654 11.1757 19.967 11.7084 20.5447 12.0645C20.9476 12.3129 21.1028 12.815 20.9255 13.2539L18.9978 18.0264C18.5796 17.7361 18.1657 17.4466 17.6599 17.333L19.3669 13.1055C18.5993 12.646 17.4789 12.0123 16.2302 11.4307C14.7963 10.7628 13.2903 10.2087 11.9997 10.0146C10.7093 10.2088 9.20385 10.7629 7.77024 11.4307C6.52111 12.0125 5.40011 12.646 4.63255 13.1055L6.3386 17.333C5.83305 17.4468 5.41906 17.7368 5.00071 18.0264L3.07493 13.2539C2.89776 12.815 3.05298 12.3129 3.45579 12.0645C4.03328 11.7084 4.93442 11.1756 5.99974 10.6279V7.02246C5.99993 6.17928 6.52818 5.43349 7.31712 5.18066C7.86908 5.03013 8.43711 4.92868 8.99974 4.82715V3.5C8.99974 3.5 10.812 3.00009 11.9997 3ZM11.9997 6C10.7741 6.00006 9.0709 6.31521 7.80735 6.59961C7.64903 6.63552 7.49993 6.78859 7.49974 7.02246V9.90625C8.95809 9.25111 10.5585 8.68023 11.9997 8.5C13.4409 8.68014 15.0413 9.25118 16.4997 9.90625V7.02246C16.4995 6.78844 16.3506 6.63539 16.1921 6.59961C14.9285 6.3152 13.2253 6 11.9997 6Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M5.32422 19.0471C6.35067 18.2995 7.74508 18.3771 8.71875 19.1692C9.17497 19.5341 9.82444 19.5336 10.2812 19.1682C11.2855 18.3648 12.7144 18.3648 13.7188 19.1682C14.1755 19.5336 14.825 19.5342 15.2812 19.1692C16.2549 18.3771 17.6493 18.2995 18.6758 19.0471C19.1821 19.4161 19.6156 19.5041 20.25 19.5041C20.6642 19.5041 20.9999 19.84 21 20.2541C21 20.6683 20.6642 21.0041 20.25 21.0041C19.3068 21.0041 18.5509 20.8116 17.793 20.26C17.3375 19.9282 16.7164 19.9423 16.2764 20.2942C15.2508 21.0975 13.8222 21.1728 12.7812 20.3401C12.3248 19.9749 11.6753 19.9749 11.2188 20.3401C10.1839 21.1679 8.74258 21.1051 7.72461 20.2942C7.28453 19.9421 6.66253 19.9282 6.20703 20.26C5.43148 20.8245 4.6823 21.0041 3.75 21.0041C3.33579 21.0041 3 20.6683 3 20.2541C3.00009 19.84 3.33584 19.5041 3.75 19.5041C4.37478 19.5041 4.80029 19.4302 5.32422 19.0471Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), le = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FerryFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#FerryFilled-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M5.32422 19.0469C6.35067 18.2993 7.74508 18.3769 8.71875 19.1689C9.17497 19.5339 9.82444 19.5334 10.2812 19.168C11.2855 18.3646 12.7144 18.3645 13.7188 19.168C14.1755 19.5334 14.825 19.534 15.2812 19.1689C16.2549 18.3769 17.6493 18.2993 18.6758 19.0469C19.1821 19.4159 19.6156 19.5039 20.25 19.5039C20.6642 19.5039 20.9999 19.8398 21 20.2539C21 20.6681 20.6642 21.0039 20.25 21.0039C19.3068 21.0039 18.5509 20.8114 17.793 20.2598C17.3375 19.928 16.7164 19.9421 16.2764 20.2939C15.2508 21.0973 13.8222 21.1726 12.7812 20.3398C12.3248 19.9747 11.6753 19.9747 11.2188 20.3398C10.1839 21.1677 8.74258 21.1049 7.72461 20.2939C7.28453 19.9419 6.66253 19.928 6.20703 20.2598C5.43148 20.8243 4.6823 21.0039 3.75 21.0039C3.33579 21.0039 3 20.6681 3 20.2539C3.00009 19.8398 3.33584 19.5039 3.75 19.5039C4.37478 19.5039 4.80029 19.4299 5.32422 19.0469Z" }), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 3C13.1877 3 15 3.5 15 3.5V4.82715C15.5085 4.92486 16.0163 5.02301 16.5215 5.13672C17.399 5.33434 17.9998 6.12302 18 7.02246V10.6279C19.0656 11.1757 19.9673 11.7084 20.5449 12.0645C20.9475 12.313 21.1029 12.8151 20.9258 13.2539L18.998 18.0264C17.8438 17.2254 16.4717 16.9466 15.2812 17.915C14.8251 18.2798 14.1755 18.2792 13.7188 17.9141C12.7144 17.1106 11.2856 17.1108 10.2812 17.9141C9.82455 18.2793 9.1749 18.2797 8.71875 17.915C7.5276 16.946 6.15627 17.2265 5.00098 18.0264L3.07422 13.2539C2.89699 12.8149 3.0531 12.3129 3.45605 12.0645C4.03361 11.7084 4.93468 11.1756 6 10.6279V7.02246C6.0002 6.17922 6.52834 5.43343 7.31738 5.18066C7.87106 5.02967 8.43644 4.93257 9 4.82715V3.5C9 3.5 10.8123 3 12 3ZM12 6C10.7743 6.00002 9.07122 6.3152 7.80762 6.59961C7.64922 6.63544 7.5002 6.78849 7.5 7.02246V9.90625C8.9583 9.25115 10.5588 8.68018 12 8.5C13.4411 8.68021 15.0416 9.25118 16.5 9.90625V7.02246C16.4998 6.78851 16.3508 6.63546 16.1924 6.59961C14.9288 6.3152 13.2257 6.00002 12 6Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ue = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Filter-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Filter-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M10 17C10 17.5523 10.4477 18 11 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H11C10.4477 16 10 16.4477 10 17ZM3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H3ZM6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7C6.44771 11 6 11.4477 6 12Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), de = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Fingerprint-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Fingerprint-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.2776 6.5086C19.0099 6.82465 18.5366 6.86383 18.2206 6.59612C14.5485 3.48567 9.1432 3.47708 5.48428 6.59473C5.16898 6.86338 4.69562 6.82558 4.42701 6.51028C4.15836 6.19502 4.19616 5.72166 4.51142 5.45301C8.73377 1.85526 14.9614 1.86959 19.1901 5.45155C19.5061 5.7193 19.5453 6.19255 19.2776 6.5086ZM14.2532 7.37683C12.6637 6.74042 10.8906 6.73787 9.29923 7.36975C6.20211 8.59948 4.48277 11.9216 5.26731 15.1602L5.42113 15.7953C5.51867 16.1978 5.27136 16.6033 4.8688 16.7008C4.46623 16.7983 4.06082 16.551 3.96328 16.1484L3.80946 15.5134C2.84899 11.5483 4.95396 7.48116 8.7457 5.97561C10.694 5.20202 12.8647 5.20517 14.8108 5.98431L14.9835 6.0535C18.6872 7.53636 20.8973 11.3588 20.3348 15.3084L20.2186 16.1243L20.1905 16.2273C19.7421 17.8662 18.2529 19.0028 16.5538 19.0028C14.5448 19.0028 12.8887 17.4275 12.7882 15.421L12.6949 13.5583C12.6736 13.133 12.3226 12.7992 11.8968 12.7992C11.433 12.7992 11.0667 13.1928 11.0999 13.6554L11.245 15.677C11.2662 15.9731 11.3218 16.2658 11.4107 16.549L11.5905 17.1224C11.9532 18.2791 12.7054 19.2073 13.7602 19.8493C14.114 20.0647 14.2262 20.5261 14.0108 20.8799C13.7955 21.2338 13.3341 21.346 12.9802 21.1306C11.6341 20.3112 10.6375 19.0965 10.1592 17.5712L9.97937 16.9978C9.85577 16.6037 9.77841 16.1965 9.74882 15.7844L9.60373 13.7628C9.50818 12.4317 10.5623 11.2992 11.8968 11.2992C13.1218 11.2992 14.1317 12.2597 14.193 13.4832L14.2863 15.346C14.3468 16.5542 15.344 17.5028 16.5538 17.5028C17.5769 17.5028 18.4736 16.8184 18.7436 15.8315L18.7469 15.8194L18.8498 15.0969C19.3148 11.8318 17.4877 8.6719 14.426 7.44602L14.2532 7.37683ZM11.9662 8.33346C8.96533 8.33346 6.53267 10.7661 6.53263 13.7669V14.2001L6.53267 14.2055C6.54317 15.6884 6.72752 18.3706 8.31145 20.3865C8.56735 20.7122 9.03883 20.7688 9.36456 20.5129C9.69025 20.257 9.74683 19.7855 9.49093 19.4598C8.24098 17.869 8.0431 15.6421 8.03263 14.1975V13.7669C8.03267 11.5945 9.79375 9.83346 11.9662 9.83346C14.1386 9.83346 15.8997 11.5946 15.8997 13.767V15.1411C15.8997 15.5553 16.2355 15.8911 16.6497 15.8911C17.0639 15.8911 17.3997 15.5553 17.3997 15.1411V13.767C17.3997 10.7661 14.967 8.33346 11.9662 8.33346Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), fe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlashlightOff-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#FlashlightOff-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M2.81 2.81 1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41zM14 20h-4v-7.17l4 4zm2-16v1H7.83l2 2H16v.39l-2 3.01v.77l2 2V11l2-3V2H6v1.17l.83.83z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), pe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlashlightOn-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#FlashlightOn-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M18 2H6v6l2 3v11h8V11l2-3zm-2 2v1H8V4zm-2 6.4V20h-4v-9.61l-2-3V7h8v.39z" }), /* @__PURE__ */ (0, c.jsx)("circle", {
				cx: "12",
				cy: "14",
				r: "1.5"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), me = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Hand-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Hand-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M12.5134 21.9814C12.6743 21.9937 12.8365 22 12.9998 22L12.7556 21.9951C12.6746 21.992 12.5938 21.9876 12.5134 21.9814Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M18.1169 6.67773C18.0648 6.73999 18.0272 6.81475 18.0105 6.89844L17.9998 7C17.9998 6.87571 18.0441 6.76438 18.1169 6.67773Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M9.11694 4.17773C9.06478 4.23999 9.0272 4.31475 9.0105 4.39844L8.99976 4.5C8.99976 4.37571 9.04414 4.26438 9.11694 4.17773Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M15.1443 3.64551C15.0771 3.71297 15.0301 3.80022 15.0105 3.89844L14.9998 4C14.9998 3.86021 15.0544 3.73548 15.1443 3.64551Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M12.1443 2.14551C12.0771 2.21297 12.0301 2.30022 12.0105 2.39844L11.9998 2.5C11.9998 2.36021 12.0544 2.23548 12.1443 2.14551Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.4998 0.5C13.3448 0.500166 14.0679 1.02561 14.366 1.77441L14.533 2.19531L14.9675 2.07031C15.1284 2.02439 15.312 2.00004 15.4998 2C16.6034 2.00022 17.4998 2.89628 17.4998 4V5.15234L18.0925 5.04102C18.2298 5.01532 18.3682 5.00004 18.4998 5C19.6034 5.00022 20.4998 5.89628 20.4998 7V16C20.4998 20.1437 17.1434 23.4998 12.9998 23.5C9.77447 23.4998 6.87932 21.5335 5.69507 18.5449L3.13452 12.1152C2.93244 11.5955 2.96496 11.0336 3.23608 10.627L3.23706 10.626C3.6083 10.0655 4.2568 9.83017 4.87671 10.002H4.87866L5.64819 10.2129L5.65405 10.2139C6.03544 10.3134 6.38385 10.5045 6.66382 10.7598L7.49976 11.5225V4.5C7.49976 3.3963 8.39611 2.50025 9.49976 2.5C9.65435 2.50003 9.79634 2.51649 9.92554 2.54688L10.4392 2.66797L10.532 2.14844C10.7002 1.21125 11.5177 0.500223 12.4998 0.5ZM12.4998 1.5C11.9438 1.50025 11.4998 1.94401 11.4998 2.5V11.5H10.4998V4.5C10.4998 3.94399 10.0557 3.50021 9.49976 3.5C8.94383 3.50025 8.49976 3.94401 8.49976 4.5V14.5H7.34155L6.48706 12.3096C6.26113 11.7249 5.76828 11.2686 5.14819 11.1064L4.61792 10.9668C4.2211 10.8617 3.87379 11.2533 4.02545 11.6347L6.62573 18.1748C7.66148 20.785 10.1854 22.4998 12.9998 22.5C16.5857 22.4998 19.4998 19.586 19.4998 16V7C19.4998 6.44399 19.0557 6.00021 18.4998 6C17.9438 6.00025 17.4998 6.44401 17.4998 7V11.5H16.4998V4C16.4998 3.44399 16.0557 3.00021 15.4998 3C14.9438 3.00025 14.4998 3.44401 14.4998 4V11.5H13.4998V2.5C13.4998 1.94399 13.0557 1.50021 12.4998 1.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M20.9998 16C20.9998 17.6574 20.4968 19.1969 19.6345 20.4736L19.4109 20.7871C19.5643 20.5819 19.7081 20.3691 19.8416 20.1494C20.0421 19.8193 20.219 19.4734 20.3708 19.1143C20.5732 18.6356 20.7302 18.1332 20.8367 17.6123C20.8633 17.4822 20.8868 17.3511 20.907 17.2188C20.9474 16.9539 20.9752 16.6848 20.989 16.4121L20.9998 16Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6.73022 10.1729C6.7775 10.2064 6.82389 10.2411 6.8689 10.2773L6.99976 10.3896C6.95722 10.3509 6.91386 10.3135 6.8689 10.2773L6.73022 10.1729Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M5.78003 9.73047C6.00999 9.79047 6.23033 9.87705 6.4353 9.98828C6.28139 9.90484 6.11864 9.83541 5.94995 9.78027L5.78003 9.73047Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M20.572 5.60254C20.7968 5.93505 20.9443 6.32407 20.9871 6.74414L20.9998 7C20.9998 6.48246 20.8417 6.00158 20.572 5.60254Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M8.30835 2.30176C8.16664 2.37875 8.03342 2.46937 7.90991 2.57129C7.97171 2.52027 8.03572 2.47175 8.10229 2.42676L8.30835 2.30176Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13.6052 0.257812C13.883 0.395465 14.1316 0.583309 14.3396 0.80957L14.4587 0.949219C14.2674 0.708274 14.0329 0.503877 13.7673 0.34668L13.6052 0.257812Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M12.8884 0.0302734C13.0155 0.0501447 13.1396 0.0788821 13.2595 0.117188L13.4353 0.181641C13.2619 0.111337 13.0788 0.0600873 12.8884 0.0302734Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), he = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "History-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#History-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M14.8929 3.47763C12.9212 2.80833 10.7784 2.84339 8.82968 3.57685C7.15206 4.20826 5.70759 5.32361 4.67392 6.7722L4.49457 4.96296C4.4537 4.55077 4.08643 4.24974 3.67424 4.29061C3.26204 4.33147 2.96102 4.69874 3.00188 5.11093L3.44581 9.58898L7.92386 9.14506C8.33605 9.1042 8.63707 8.73692 8.59621 8.32473C8.55535 7.91254 8.18808 7.61151 7.77588 7.65238L5.75063 7.85315C6.61937 6.54389 7.88015 5.53695 9.35805 4.98071C10.982 4.36949 12.7676 4.34027 14.4107 4.89802C16.0538 5.45578 17.4527 6.56599 18.3689 8.03949C19.2852 9.513 19.6622 11.2586 19.4358 12.9789C19.2093 14.6993 18.3933 16.2878 17.1269 17.474C15.8604 18.6601 14.2219 19.3705 12.4904 19.4839C10.759 19.5974 9.04177 19.107 7.63134 18.0963C6.22092 17.0857 5.20458 15.6172 4.75548 13.9411C4.64828 13.541 4.23702 13.3036 3.83692 13.4108C3.43682 13.518 3.19939 13.9293 3.30659 14.3294C3.8455 16.3406 5.06512 18.1028 6.75763 19.3156C8.45013 20.5285 10.5108 21.1169 12.5886 20.9807C14.6663 20.8445 16.6325 19.9922 18.1523 18.5688C19.672 17.1454 20.6511 15.2391 20.9229 13.1747C21.1947 11.1104 20.7423 9.0156 19.6427 7.24739C18.5432 5.47918 16.8646 4.14693 14.8929 3.47763Z" }), /* @__PURE__ */ (0, c.jsx)("path", { d: "M12.75 7.75C12.75 7.33579 12.4142 7 12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.75H16.25C16.6642 12.75 17 12.4142 17 12C17 11.5858 16.6642 11.25 16.25 11.25H12.75V7.75Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ge = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Home-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Home-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 3.75C19 3.33579 18.6642 3 18.25 3C17.8358 3 17.5 3.33579 17.5 3.75V6.67941L14.5204 3.97482C13.0907 2.67709 10.9093 2.67708 9.4796 3.97481L2.24532 10.5413C1.93861 10.8197 1.91566 11.294 2.19405 11.6007C2.47245 11.9074 2.94677 11.9304 3.25347 11.652L5 10.0667V17.25C5 18.7688 6.23122 20 7.75 20H16.25C17.7673 20 19 18.7732 19 17.2529V10.0667L20.7466 11.6521C21.0533 11.9305 21.5276 11.9076 21.806 11.6009C22.0844 11.2942 22.0615 10.8198 21.7548 10.5414L19 8.04096V3.75ZM13.5122 5.0855L17.5 8.7052V17.2529C17.5 17.9419 16.9418 18.5 16.25 18.5H14.5V14C14.5 13.0335 13.7165 12.25 12.75 12.25H11.25C10.2835 12.25 9.5 13.0335 9.5 14V18.5H7.75C7.05965 18.5 6.5 17.9404 6.5 17.25V8.70515L10.4878 5.08549C11.3456 4.30686 12.6544 4.30686 13.5122 5.0855ZM11 18.5H13V14C13 13.8619 12.8881 13.75 12.75 13.75H11.25C11.1119 13.75 11 13.8619 11 14V18.5Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), _e = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "HomeFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#HomeFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.25 3C18.6642 3 19 3.33579 19 3.75V8.04096L21.7548 10.5414C22.0615 10.8198 22.0844 11.2942 21.806 11.6009C21.5276 11.9076 21.0533 11.9305 20.7466 11.6521L19 10.0667V17.2529C19 18.7732 17.7673 20 16.25 20H7.75C6.23122 20 5 18.7688 5 17.25V10.0667L3.25347 11.652C2.94677 11.9304 2.47245 11.9074 2.19405 11.6007C1.91566 11.294 1.93861 10.8197 2.24532 10.5413L9.4796 3.97481C10.9093 2.67708 13.0907 2.67709 14.5204 3.97482L17.5 6.67941V3.75C17.5 3.33579 17.8358 3 18.25 3ZM13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9ZM11.5 13C10.9477 13 10.5 13.4477 10.5 14V18.5H13.5V14C13.5 13.4477 13.0523 13 12.5 13H11.5Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ve = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Hourglass-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Hourglass-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 2.75C4 2.33579 4.33579 2 4.75 2H19.25C19.6642 2 20 2.33579 20 2.75C20 3.16421 19.6642 3.5 19.25 3.5H18.8988L18.4408 7.85177C18.2528 9.63697 17.2202 11.1465 15.7654 12C17.2202 12.8535 18.2528 14.363 18.4408 16.1482L18.8988 20.5H19.25C19.6642 20.5 20 20.8358 20 21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25C4 20.8358 4.33579 20.5 4.75 20.5H5.10116L5.55924 16.1482C5.74716 14.363 6.77977 12.8535 8.23458 12C6.77977 11.1465 5.74716 9.63697 5.55924 7.85177L5.10116 3.5H4.75C4.33579 3.5 4 3.16421 4 2.75ZM17.3906 20.5H6.60945L6.94707 17.2926L7.24304 17.1076C8.79338 16.1387 10.8073 16.368 12.1001 17.6608C13.1177 18.6784 14.4979 19.2501 15.937 19.2501H17.259L17.3906 20.5ZM17.1011 17.7501H15.937C14.8957 17.7501 13.8971 17.3364 13.1608 16.6001C11.589 15.0284 9.24599 14.594 7.24634 15.4239C7.78763 13.8547 9.27578 12.7501 11 12.7501V11.2501C8.96791 11.2501 7.26373 9.71569 7.051 7.69474L6.60945 3.5L17.3906 3.5L16.949 7.69474C16.7363 9.71569 15.0321 11.2499 13 11.2499V12.7499C15.0321 12.7499 16.7363 14.2843 16.949 16.3053L17.1011 17.7501Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Y = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "InboundConnection-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#InboundConnection-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M18.1634 3C19.1732 3 20 3.8287 20 4.84075V19.1593C20 20.1713 19.1732 21 18.1634 21H11.0223C10.5705 21 10.2043 20.6338 10.2043 20.182C10.2043 19.7302 10.5705 19.364 11.0223 19.364H17.979C18.1937 19.364 18.3677 19.19 18.3677 18.9753V5.02473C18.3677 4.81004 18.1937 4.636 17.979 4.636H11.0223C10.5705 4.636 10.2043 4.26977 10.2043 3.818C10.2043 3.36623 10.5705 3 11.0223 3H18.1634Z" }), /* @__PURE__ */ (0, c.jsx)("path", { d: "M15.088 11.2936C15.4774 11.684 15.4774 12.316 15.0879 12.7063L11.5498 16.2517C11.2345 16.5676 10.7227 16.5676 10.4074 16.2516C10.0931 15.9366 10.0932 15.4265 10.4076 15.1116L12.3488 13.1676L12.6966 12.818H2.818C2.36623 12.818 2 12.4518 2 12C2 11.5482 2.36623 11.182 2.818 11.182H12.6966L12.3488 10.8324L10.4074 8.88745C10.0931 8.57248 10.093 8.06247 10.4073 7.74744C10.7226 7.43144 11.2345 7.43144 11.5498 7.74744L15.088 11.2936Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), X = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "InfoCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#InfoCircle-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 10.5C12.4142 10.5 12.75 10.8358 12.75 11.25V16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.25C11.25 10.8358 11.5858 10.5 12 10.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Z = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "InstantApproval-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#InstantApproval-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.5005 11.5004V5.95774L7.5195 12.4996H11.4995V18.0423L16.4805 11.5004H12.5005ZM18.4986 10.0017C18.9125 10.0017 19.1475 10.4746 18.8971 10.8035L10.4475 21.9009C10.3024 22.0913 9.99797 21.989 9.99797 21.7497V13.9983H5.50142C5.08751 13.9983 4.85249 13.5254 5.10294 13.1965L13.5525 2.09913C13.6976 1.90865 14.002 2.01103 14.002 2.25028V10.0017H18.4986Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Q = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Insurance-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Insurance-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.9687 6.45354C3.46949 6.53672 3.03838 6.90556 3.01509 7.41035C2.82818 11.4623 4.30313 18.8573 11.6358 21.9275C11.8668 22.0242 12.1332 22.0242 12.3642 21.9275C19.6969 18.8573 21.1718 11.4623 20.9849 7.41035C20.9616 6.90556 20.5305 6.53672 20.0313 6.45354C17.221 5.98523 14.1022 3.48649 12.7232 2.27104C12.3132 1.90965 11.6868 1.90965 11.2768 2.27104C9.89776 3.48649 6.77903 5.98523 3.9687 6.45354ZM11.25 20.0949V4.25235C10.6083 4.76877 9.82764 5.35312 8.96965 5.9029C7.67979 6.72941 6.10555 7.54986 4.50125 7.87775C4.44419 11.4978 5.79783 17.2652 11.25 20.0949ZM19.4988 7.87775C19.5558 11.4978 18.2022 17.2652 12.75 20.0949V4.25235C13.3917 4.76877 14.1724 5.35312 15.0304 5.9029C16.3202 6.72941 17.8945 7.54986 19.4988 7.87775Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ye = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "IosAddBox-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#IosAddBox-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M11.25 12.75V16C11.25 16.2128 11.3218 16.391 11.4655 16.5345C11.609 16.6782 11.7872 16.75 12 16.75C12.2128 16.75 12.391 16.6782 12.5345 16.5345C12.6782 16.391 12.75 16.2128 12.75 16V12.75H16C16.2128 12.75 16.391 12.6782 16.5345 12.5345C16.6782 12.391 16.75 12.2128 16.75 12C16.75 11.7872 16.6782 11.609 16.5345 11.4655C16.391 11.3218 16.2128 11.25 16 11.25H12.75V8C12.75 7.78717 12.6782 7.609 12.5345 7.4655C12.391 7.32183 12.2128 7.25 12 7.25C11.7872 7.25 11.609 7.32183 11.4655 7.4655C11.3218 7.609 11.25 7.78717 11.25 8V11.25H8C7.78717 11.25 7.609 11.3218 7.4655 11.4655C7.32183 11.609 7.25 11.7872 7.25 12C7.25 12.2128 7.32183 12.391 7.4655 12.5345C7.609 12.6782 7.78717 12.75 8 12.75H11.25ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7693 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7693 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), $ = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "IosShare-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#IosShare-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M6.30775 21.5C5.80258 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V10.3078C4.5 9.8026 4.675 9.37502 5.025 9.02502C5.375 8.67502 5.80258 8.50002 6.30775 8.50002H8.1155C8.32817 8.50002 8.50633 8.57185 8.65 8.71552C8.7935 8.85902 8.86525 9.03718 8.86525 9.25002C8.86525 9.46285 8.7935 9.64102 8.65 9.78452C8.50633 9.92818 8.32817 10 8.1155 10H6.30775C6.23075 10 6.16025 10.0321 6.09625 10.0963C6.03208 10.1603 6 10.2308 6 10.3078V19.6923C6 19.7693 6.03208 19.8398 6.09625 19.9038C6.16025 19.9679 6.23075 20 6.30775 20H17.6923C17.7693 20 17.8398 19.9679 17.9038 19.9038C17.9679 19.8398 18 19.7693 18 19.6923V10.3078C18 10.2308 17.9679 10.1603 17.9038 10.0963C17.8398 10.0321 17.7693 10 17.6923 10H15.8845C15.6718 10 15.4937 9.92818 15.35 9.78452C15.2065 9.64102 15.1348 9.46285 15.1348 9.25002C15.1348 9.03718 15.2065 8.85902 15.35 8.71552C15.4937 8.57185 15.6718 8.50002 15.8845 8.50002H17.6923C18.1974 8.50002 18.625 8.67502 18.975 9.02502C19.325 9.37502 19.5 9.8026 19.5 10.3078V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6923 21.5H6.30775ZM12 15.75C11.7872 15.75 11.609 15.6782 11.4655 15.5345C11.3218 15.391 11.25 15.2129 11.25 15V4.71927L9.927 6.04227C9.77817 6.1911 9.60408 6.26452 9.40475 6.26252C9.20542 6.26068 9.02817 6.18218 8.873 6.02702C8.72817 5.87185 8.65317 5.69618 8.648 5.50002C8.643 5.30385 8.718 5.12827 8.873 4.97327L11.3673 2.47902C11.4609 2.38535 11.5597 2.31927 11.6635 2.28077C11.7673 2.24243 11.8795 2.22327 12 2.22327C12.1205 2.22327 12.2327 2.24243 12.3365 2.28077C12.4403 2.31927 12.5391 2.38535 12.6328 2.47902L15.127 4.97327C15.2653 5.1116 15.3362 5.28302 15.3395 5.48752C15.3427 5.69202 15.2718 5.87185 15.127 6.02702C14.9718 6.18218 14.7936 6.25977 14.5923 6.25977C14.3911 6.25977 14.2129 6.18218 14.0578 6.02702L12.75 4.71927V15C12.75 15.2129 12.6782 15.391 12.5345 15.5345C12.391 15.6782 12.2128 15.75 12 15.75Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), be = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LiveIndicator-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#LiveIndicator-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("circle", {
				cx: "12",
				cy: "12",
				r: "10",
				opacity: "0.1"
			}), /* @__PURE__ */ (0, c.jsx)("circle", {
				cx: "12",
				cy: "12",
				r: "4"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), xe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Locale-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Locale-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12 2C14.6568 2.00684 17.2022 3.06791 19.0772 4.95017C20.9522 6.83242 22.0034 9.38193 22 12.0387C21.9911 14.6335 20.9739 17.1234 19.1633 18.9821C17.3527 20.8409 14.8905 21.923 12.2968 22H11.9742C9.37928 21.9946 6.88811 20.9806 5.02694 19.1724C3.16576 17.3642 2.08035 14.9033 2 12.3097V11.9871C2.00342 9.33717 3.05849 6.79695 4.93349 4.92437C6.80848 3.05179 9.35007 2 12 2ZM14.5161 12.9677H9.48387C9.67742 16.7097 10.9935 19.8581 11.9097 20.0645H12C12.8774 20.0645 14.2194 17.0065 14.4903 13.3161L14.5161 12.9677ZM20.0129 12.9677H16.4516C16.3355 15.4968 15.7677 17.8452 14.929 19.5226C16.2373 19.011 17.3896 18.1671 18.2721 17.0742C19.1547 15.9812 19.7369 14.6771 19.9613 13.2903L20.0129 12.9677ZM4 12.9677C4.1755 14.4179 4.74098 15.7934 5.63622 16.9476C6.53146 18.1019 7.72296 18.9918 9.08387 19.5226C8.19733 17.6169 7.68901 15.5573 7.58709 13.4581L7.54838 12.9677H4ZM9.08387 4.47742L8.92903 4.54194C7.60343 5.08788 6.44702 5.97678 5.57853 7.11739C4.71004 8.258 4.16076 9.6092 3.9871 11.0323H7.53548C7.65161 8.67097 8.15484 6.46452 8.90322 4.82581L9.08387 4.47742ZM11.9871 3.93548C11.0839 3.93548 9.69032 7.17419 9.48387 11.0323H14.5161C14.3226 7.29032 12.9935 4.14194 12.0774 3.93548H11.9871ZM14.929 4.49032L14.9677 4.55484C15.891 6.59286 16.3956 8.79555 16.4516 11.0323H20C19.8207 9.58672 19.2552 8.21622 18.3628 7.06498C17.4704 5.91374 16.2842 5.02432 14.929 4.49032Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Se = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Lock-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Lock-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 9V6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V9H18C19.1046 9 20 9.89543 20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11C4 9.89543 4.89543 9 6 9H7ZM8.5 6C8.5 4.067 10.067 2.5 12 2.5C13.933 2.5 15.5 4.067 15.5 6V9H8.5V6ZM6 10.5C5.72386 10.5 5.5 10.7239 5.5 11V19C5.5 19.2761 5.72386 19.5 6 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V11C18.5 10.7239 18.2761 10.5 18 10.5H6Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ce = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LogoAlfred-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#LogoAlfred-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsxs)("g", { children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M11.1075 0.0141128C11.0303 0.023766 10.755 0.0575521 10.5039 0.0865116C8.82337 0.274748 6.9207 0.96495 5.48163 1.90613C3.31337 3.32032 1.59421 5.4585 0.724976 7.82352C0.49318 8.45098 0.203434 9.60936 0.0923653 10.3382C-0.0331911 11.149 -0.028362 12.8625 0.0923653 13.6685C0.295187 15.0055 0.657369 16.1687 1.21271 17.2981C1.83084 18.5482 2.56969 19.5714 3.56448 20.556C5.38022 22.3564 7.70302 23.5147 10.2866 23.9057C11.1027 24.0312 12.8991 24.0312 13.7152 23.9057C17.6171 23.312 20.8913 20.976 22.6925 17.496C23.33 16.2652 23.6825 15.1358 23.9384 13.5237C24.0205 12.9976 24.0205 11.0911 23.9384 10.5071C23.5521 7.77043 22.3835 5.39093 20.5001 3.50856C18.6602 1.66963 16.3809 0.525731 13.7056 0.105818C13.2565 0.0334192 11.4214 -0.0293264 11.1075 0.0141128ZM10.7019 1.3366C10.8709 1.38969 11.2717 1.58275 11.5904 1.77099C11.9092 1.9544 12.223 2.10885 12.2858 2.10885C12.3534 2.10885 12.6239 1.97853 12.8895 1.81925C13.5752 1.41865 13.8987 1.2835 14.2706 1.25454C14.6907 1.22076 14.9032 1.29316 15.2026 1.5731C15.6855 2.02197 16.0429 3.05969 16.1346 4.28081L16.1684 4.72486L15.8738 4.99997C15.1688 5.67569 13.947 6.01838 12.2569 6.01838C10.7647 6.01838 9.6926 5.74809 8.88132 5.17373C8.71713 5.05307 8.53362 4.87931 8.47567 4.7876C8.37426 4.62833 8.37426 4.59454 8.42255 4.19393C8.73161 1.81925 9.43183 0.940817 10.7019 1.3366ZM7.89618 5.0772C8.18593 5.54538 9.07448 6.08595 9.97269 6.33694C12.4886 7.03679 15.642 6.47208 16.6175 5.13994C16.8203 4.86483 16.8397 4.86483 17.3129 5.17373C18.2256 5.7674 18.4622 6.45277 17.9745 7.08988C17.3564 7.89592 15.9318 8.45581 13.8118 8.7261C13.1068 8.8178 11.2959 8.80332 10.5522 8.70196C9.41735 8.54751 8.27768 8.23861 7.61126 7.90075C6.87724 7.53393 6.39916 7.00783 6.36053 6.52035C6.33155 6.1487 6.44745 5.87358 6.78066 5.54055C7.04143 5.28474 7.60643 4.90827 7.73199 4.90827C7.76579 4.90827 7.83823 4.98549 7.89618 5.0772ZM3.98944 10.1065C4.15363 10.203 4.22124 10.3382 4.9456 11.984C5.2112 12.597 5.43334 13.1666 5.43334 13.2486C5.43334 13.4658 5.28847 13.6154 5.08082 13.6154C4.85868 13.6154 4.72829 13.4996 4.57859 13.1617C4.51581 13.0169 4.43855 12.8818 4.40475 12.8625C4.33231 12.819 3.15884 12.8094 3.04294 12.8528C2.99465 12.8721 2.9029 13.0169 2.82563 13.181C2.68076 13.5141 2.61315 13.5816 2.41033 13.6251C2.30892 13.6444 2.23165 13.6251 2.1399 13.5527C1.89845 13.3596 1.9081 13.3113 2.56486 11.8199C2.89807 11.0573 3.20713 10.3768 3.24576 10.3092C3.40512 10.0389 3.72867 9.95205 3.98944 10.1065ZM6.67925 10.1692C6.7372 10.2272 6.79032 10.2754 6.79515 10.2803C6.79998 10.2851 6.81929 10.8546 6.83378 11.5448L6.85793 12.7997L7.59195 12.8239C8.28251 12.848 8.3308 12.8528 8.4467 12.9638C8.70747 13.21 8.53845 13.5575 8.12798 13.6203C8.00725 13.6396 7.55331 13.6444 7.1187 13.6347C6.21083 13.6203 6.09976 13.5816 6.01766 13.2727C5.95006 13.0314 5.95006 10.6374 6.01283 10.4009C6.04181 10.2996 6.11424 10.1885 6.17219 10.1451C6.31707 10.0438 6.55369 10.0534 6.67925 10.1692ZM11.5663 10.1355C11.7981 10.2513 11.8174 10.6326 11.6001 10.7581C11.5325 10.8015 11.2138 10.8305 10.6971 10.845L9.90025 10.8691V11.1587V11.4483L10.5763 11.4772C10.9627 11.4917 11.3007 11.5303 11.3635 11.5641C11.5808 11.68 11.6098 12.0033 11.4118 12.1819C11.3297 12.2543 11.2041 12.2736 10.6053 12.2929L9.90025 12.3171L9.87611 12.8577C9.85679 13.3355 9.83748 13.4127 9.74572 13.5092C9.58636 13.6685 9.31593 13.654 9.17106 13.4803L9.05516 13.35V11.8682C9.05516 10.2706 9.05999 10.2223 9.31593 10.121C9.48495 10.0534 11.4262 10.0631 11.5663 10.1355ZM14.5603 10.203C14.9853 10.3961 15.2316 10.7677 15.2364 11.2263C15.2364 11.6269 15.1495 11.8537 14.8887 12.1095C14.7632 12.235 14.6569 12.3509 14.6569 12.375C14.6569 12.3943 14.7776 12.5632 14.9225 12.7418C15.2171 13.1086 15.2605 13.3017 15.0964 13.5044C15.0288 13.5913 14.9563 13.6203 14.8018 13.6203C14.5748 13.6203 14.5169 13.5623 13.9664 12.877L13.6863 12.5294L13.411 12.5439L13.1357 12.5584L13.1116 12.9831C13.0875 13.3837 13.0778 13.4224 12.9474 13.5334C12.7736 13.683 12.5611 13.6589 12.4017 13.4706C12.2907 13.35 12.2907 13.3355 12.2907 11.8923C12.2907 10.8208 12.31 10.4009 12.3534 10.314C12.4645 10.092 12.5852 10.0679 13.4979 10.0872C14.2223 10.1017 14.3768 10.1162 14.5603 10.203ZM18.298 10.121C18.4671 10.1837 18.5781 10.372 18.5395 10.5312C18.4767 10.7774 18.3319 10.8208 17.4819 10.845L16.7093 10.8691V11.1346V11.4L17.3805 11.4338C17.9359 11.4628 18.0759 11.4821 18.1773 11.5593C18.3463 11.6848 18.3705 11.9454 18.2256 12.0806C18.1387 12.1578 18.0276 12.1771 17.4143 12.1964L16.7093 12.2205V12.5343V12.848L17.5351 12.8721C18.2642 12.8914 18.3801 12.9059 18.4671 12.988C18.6023 13.1135 18.6023 13.3693 18.4671 13.4948C18.3174 13.6299 18.0856 13.654 17.0715 13.6347C16.1201 13.6203 16.0187 13.5961 15.9173 13.3693C15.8835 13.2969 15.8642 12.737 15.8642 11.8199C15.8642 10.2754 15.8738 10.2223 16.125 10.121C16.265 10.0631 18.1483 10.0631 18.298 10.121ZM20.9347 10.1258C21.3597 10.1934 21.6108 10.314 21.9006 10.5843C22.4462 11.0911 22.5959 11.8972 22.2724 12.597C21.9392 13.3307 21.1182 13.6926 19.9255 13.6347C19.486 13.6106 19.3315 13.5527 19.2494 13.3693C19.2156 13.2969 19.1963 12.737 19.1963 11.8199C19.1963 9.99549 19.1528 10.0824 20.0896 10.0775C20.3842 10.0727 20.7609 10.0968 20.9347 10.1258ZM22.2869 14.127C22.34 14.2091 22.3497 14.6242 22.3062 14.7883L22.2772 14.8993H12.0975C2.85944 14.8993 1.91776 14.8945 1.88879 14.8221C1.83084 14.6773 1.85981 14.185 1.92742 14.1174C1.98054 14.0643 3.65624 14.0498 12.1168 14.0546C21.0651 14.0546 22.2482 14.0643 22.2869 14.127ZM10.7309 15.2661C10.8033 15.382 10.8033 15.4061 10.7405 15.5219C10.6826 15.6281 10.5812 15.6715 10.1176 15.8019C9.61051 15.9467 9.3594 16.0577 9.5429 16.0577C9.5767 16.0577 9.90508 16.0818 10.2624 16.1059L10.9144 16.159L11.6146 15.8936C12.0009 15.7488 12.4838 15.5654 12.6963 15.4785C13.1068 15.3192 13.2178 15.324 13.3337 15.5074C13.4883 15.7391 13.4158 15.8115 12.3486 16.5017C11.7981 16.8637 11.2331 17.2112 11.0979 17.2836L10.8468 17.4091H9.34008H7.8334L7.63058 17.6167C7.42293 17.8242 7.42293 17.8242 7.39878 17.6987C7.3022 17.2305 7.07041 15.7053 7.08972 15.6909C7.10421 15.6764 7.36981 15.5654 7.6837 15.4447C8.32114 15.1985 8.58674 15.1648 9.9582 15.1503L10.6488 15.1406L10.7309 15.2661ZM6.91587 15.9853C7.0366 16.5741 7.33118 18.3262 7.31186 18.3455C7.2684 18.3841 5.37056 18.7123 5.34159 18.6882C5.3271 18.6689 5.30779 18.0655 5.29813 17.3464C5.28847 16.328 5.29813 16.0142 5.34642 15.9515C5.4092 15.8694 6.41848 15.6715 6.71305 15.686C6.84827 15.6957 6.85793 15.715 6.91587 15.9853Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M3.66104 11.2408C3.58378 11.3325 3.35681 11.9116 3.35681 12.013C3.35681 12.0902 3.40027 12.0999 3.69485 12.0999C3.93147 12.0999 4.04254 12.0806 4.06186 12.0371C4.08118 11.9792 3.82523 11.2987 3.74797 11.2166C3.72382 11.1973 3.68519 11.207 3.66104 11.2408Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13.1696 10.9077C13.1261 10.956 13.1116 11.1104 13.1213 11.3614L13.1358 11.7379L13.5317 11.7524C13.9808 11.7668 14.2175 11.6944 14.343 11.5014C14.4444 11.3469 14.4058 11.1394 14.2416 10.9849C14.1354 10.8836 14.0629 10.8691 13.6718 10.8546C13.3193 10.8401 13.213 10.8498 13.1696 10.9077Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M20.0365 10.9801C20.0269 11.0139 20.022 11.4531 20.0269 11.9551L20.0413 12.8721L20.4615 12.8866C21.0458 12.9059 21.3162 12.7659 21.4901 12.3509C21.7122 11.8199 21.4756 11.2021 20.9734 10.9898C20.7464 10.8981 20.0751 10.8884 20.0365 10.9801Z" })
			] })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), we = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LogoOuiboard-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#LogoOuiboard-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM8.7207 15.9668C7.68104 15.967 6.89176 16.7064 6.8916 17.791C6.8916 18.8759 7.68093 19.616 8.7207 19.6162C9.7607 19.6162 10.5566 18.876 10.5566 17.791C10.5565 16.7062 9.7606 15.9668 8.7207 15.9668ZM4 16.041V19.541H5.48047C6.08515 19.5409 6.61014 19.2363 6.61035 18.5518C6.61035 18.0219 6.31518 17.7516 5.90039 17.6865V17.6768C6.25024 17.5667 6.43457 17.2958 6.43457 16.9209C6.43435 16.3412 5.99961 16.041 5.38477 16.041H4ZM11.9697 16.041L10.5645 19.541H11.2744L11.5703 18.7461H13.0098L13.3047 19.541H14.0146L12.6104 16.041H11.9697ZM14.3418 16.041V19.541H14.9814V18.1465H15.2168L16.1719 19.541H16.9766L15.9414 18.1162C16.4563 18.0112 16.7616 17.6214 16.7617 17.1016C16.7617 16.4716 16.3268 16.041 15.6318 16.041H14.3418ZM17.3301 16.041V19.541H18.4502C19.5051 19.541 20.2705 18.881 20.2705 17.791C20.2704 16.7012 19.505 16.0411 18.4502 16.041H17.3301ZM8.7207 16.6211C9.3806 16.6211 9.85142 17.0962 9.85156 17.791C9.85156 18.486 9.3807 18.9609 8.7207 18.9609C8.06595 18.9607 7.59082 18.4858 7.59082 17.791C7.59097 17.0964 8.06605 16.6213 8.7207 16.6211ZM5.34473 18.0215C5.72972 18.0215 5.92968 18.1963 5.92969 18.4863C5.92969 18.7763 5.72005 18.9511 5.37012 18.9512H4.63965V18.0215H5.34473ZM18.4805 16.6309C19.1102 16.631 19.5799 17.0364 19.5801 17.791C19.5801 18.5459 19.1103 18.951 18.4805 18.9512H17.9697V16.6309H18.4805ZM12.7998 18.166H11.7803L12.29 16.791L12.7998 18.166ZM15.5322 16.6309C15.9019 16.631 16.0771 16.8264 16.0771 17.1113C16.0771 17.4062 15.9019 17.5809 15.5322 17.5811H14.9814V16.6309H15.5322ZM5.28516 16.6309C5.56992 16.6309 5.76444 16.7712 5.76465 17.0459C5.76465 17.3159 5.58477 17.4717 5.25977 17.4717H4.63965V16.6309H5.28516ZM9.64453 10.9668C8.60487 10.967 7.81559 11.7064 7.81543 12.791C7.81543 13.8759 8.60476 14.616 9.64453 14.6162C10.6845 14.6162 11.4805 13.876 11.4805 12.791C11.4803 11.7062 10.6844 10.9668 9.64453 10.9668ZM11.8613 11.041V13.1611C11.8613 14.0461 12.3866 14.6113 13.3066 14.6113C14.2215 14.6112 14.7461 14.046 14.7461 13.1611V11.041H14.0713V13.1211C14.0713 13.626 13.7715 13.951 13.3066 13.9512C12.8366 13.9512 12.5361 13.6261 12.5361 13.1211V11.041H11.8613ZM15.3682 11.041V14.541H16.0127V11.041H15.3682ZM9.64453 11.6211C10.3044 11.6211 10.7752 12.0962 10.7754 12.791C10.7754 13.486 10.3045 13.9609 9.64453 13.9609C8.98977 13.9607 8.51465 13.4858 8.51465 12.791C8.51479 12.0964 8.98987 11.6213 9.64453 11.6211ZM16.6855 8.00293C15.2061 7.49018 11.3327 6.77234 7.67578 8.00293V9.54102H16.6855V8.00293ZM6.5791 8.66113C6.592 8.66577 6.60507 8.67122 6.61816 8.67578V8.66113H6.5791ZM12.167 4.00098C8.76942 3.96 5.78274 5.69038 5.6748 6.85059C5.58529 7.81611 6.72336 8.46979 7.30371 8.67578V7.77734C8.99877 7.17864 10.6655 6.93886 12.1699 6.9043C13.6745 6.93878 15.3409 7.17863 17.0361 7.77734V8.67578C17.6164 8.46989 18.7547 7.81632 18.665 6.85059C18.557 5.68961 15.5674 3.95762 12.167 4.00098ZM17.7217 8.66113V8.67578C17.7347 8.67125 17.7479 8.66577 17.7607 8.66113H17.7217Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Te = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LogoSmasara-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#LogoSmasara-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_1000_1070)",
				children: [/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.3815 7.64333C16.1925 8.11129 15.8901 8.46227 15.4744 8.69623C15.1342 8.93019 14.7185 9.04721 14.3027 9.04721C14.1138 9.04721 13.9626 8.89121 13.9626 8.73521C13.9626 8.54023 14.1138 8.38427 14.2649 8.38427C14.5673 8.38427 14.8319 8.26729 15.0964 8.11129C15.3988 7.91631 15.5878 7.68231 15.739 7.33137C15.8146 7.13639 15.8146 6.90239 15.7011 6.74642C15.5878 6.55144 15.3988 6.47344 15.2098 6.43442C14.7563 6.39544 14.4161 6.55144 14.1138 6.82439C13.6602 7.29235 13.4712 8.15027 13.3956 8.50125C13.3201 8.81321 12.5641 12.1279 12.2618 13.4928C12.224 13.6878 12.035 13.8434 11.8082 13.8434C11.5815 13.8434 11.4303 13.6878 11.3547 13.4928L11.2413 12.9858C10.9011 11.465 10.2586 8.77423 10.2208 8.50125C10.1452 8.15027 9.95627 7.29235 9.50271 6.82439C9.23817 6.55144 8.8602 6.39544 8.40664 6.43442C8.2177 6.43442 8.02872 6.55144 7.91534 6.74642C7.80192 6.9414 7.80192 7.13639 7.87752 7.33137C8.02872 7.64333 8.25548 7.91631 8.52006 8.11129C8.7846 8.26729 9.04919 8.34525 9.35155 8.38427C9.54053 8.38427 9.65391 8.54023 9.65391 8.73521C9.65391 8.93019 9.50271 9.04721 9.31377 9.04721C8.89799 9.04721 8.52006 8.89121 8.1421 8.69623C7.76414 8.42325 7.46178 8.07231 7.23501 7.64333C7.08383 7.25337 7.08383 6.7854 7.3106 6.43442C7.53737 6.08348 7.91534 5.84948 8.29326 5.8105C8.89799 5.77148 9.46493 5.9665 9.88067 6.39544C10.4854 7.0194 10.6744 7.99431 10.7878 8.38427C10.8634 8.65725 11.3925 10.997 11.7327 12.5569C12.0728 10.997 12.6397 8.65725 12.6775 8.38427C12.7531 7.95529 12.9799 6.98039 13.5846 6.39544C14.0003 5.9665 14.5295 5.77148 15.172 5.8105C15.5878 5.84948 15.9657 6.08348 16.1547 6.43442C16.5327 6.7854 16.5327 7.25337 16.3815 7.64333ZM13.5092 2.37854C13.0934 2.37854 12.6399 2.45653 12.1863 2.61252C11.9974 2.69051 11.7706 2.69051 11.5816 2.61252C11.1281 2.45653 10.7123 2.37854 10.2588 2.37854C7.7643 2.37854 5.68555 4.95231 5.68555 7.95502C5.68555 11.3087 8.18004 14.3115 11.7706 15.208H11.9974C15.5879 14.3115 18.0824 11.3477 18.0824 7.95502C18.0824 4.91329 15.9659 2.37854 13.5092 2.37854Z"
				}), /* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.2682 16.0554C12.1915 16.0949 12.0765 16.0949 11.9998 16.0949C11.9231 16.0949 11.808 16.0949 11.7313 16.0554C7.82022 15.1059 5.0594 11.8221 5.0594 8.06362C5.0594 4.62164 7.47511 1.73352 10.351 1.73352C10.8494 1.73352 11.3863 1.81265 11.8847 2.01047C11.9614 2.05003 12.0381 2.05003 12.0765 2.01047C12.5749 1.85221 13.1118 1.73352 13.6102 1.73352C16.4861 1.73352 18.9018 4.62164 18.9018 8.06362C18.9401 11.8221 16.1793 15.1059 12.2682 16.0554ZM18.5567 15.1453C18.5567 15.3431 18.4033 15.5013 18.2116 15.5013C18.0198 15.5013 17.8664 15.3431 17.8664 15.1453V14.6705C17.8664 14.4727 18.0198 14.3144 18.2116 14.3144C18.4033 14.3144 18.5567 14.4727 18.5567 14.6705V15.1453ZM18.5567 17.2814C18.5567 17.4792 18.4033 17.6375 18.2116 17.6375C18.0198 17.6375 17.8664 17.4792 17.8664 17.2814V16.8062C17.8664 16.6084 18.0198 16.4506 18.2116 16.4506C18.4033 16.4506 18.5567 16.6084 18.5567 16.8062V17.2814ZM16.486 18.3502C16.486 18.548 16.3327 18.7063 16.1409 18.7063C15.9492 18.7063 15.7958 18.548 15.7958 18.3502V17.8754C15.7958 17.6776 15.9492 17.5193 16.1409 17.5193C16.3327 17.5193 16.486 17.6776 16.486 17.8754V18.3502ZM16.486 20.4864C16.486 20.6842 16.3327 20.8424 16.1409 20.8424C15.9492 20.8424 15.7958 20.6842 15.7958 20.4864V20.0116C15.7958 19.8138 15.9492 19.6555 16.1409 19.6555C16.3327 19.6555 16.486 19.8138 16.486 20.0116V20.4864ZM14.4158 19.418C14.4158 19.6158 14.2624 19.7736 14.0707 19.7736C13.8789 19.7736 13.7255 19.6158 13.7255 19.418V18.9432C13.7255 18.7454 13.8789 18.5867 14.0707 18.5867C14.2624 18.5867 14.4158 18.7454 14.4158 18.9432V19.418ZM14.4158 21.554C14.4158 21.7518 14.2624 21.9105 14.0707 21.9105C13.8789 21.9105 13.7255 21.7518 13.7255 21.554V21.0796C13.7255 20.8818 13.8789 20.7236 14.0707 20.7236C14.2624 20.7236 14.4158 20.8818 14.4158 21.0796V21.554ZM12.3067 18.3502C12.3067 18.548 12.1534 18.7063 11.9616 18.7063C11.7699 18.7063 11.6165 18.548 11.6165 18.3502V17.8754C11.6165 17.6776 11.7699 17.5193 11.9616 17.5193C12.1534 17.5193 12.3067 17.6776 12.3067 17.8754V18.3502ZM12.3067 20.4864C12.3067 20.6842 12.1534 20.8424 11.9616 20.8424C11.7699 20.8424 11.6165 20.6842 11.6165 20.4864V20.0116C11.6165 19.8138 11.7699 19.6555 11.9616 19.6555C12.1534 19.6555 12.3067 19.8138 12.3067 20.0116V20.4864ZM10.2361 19.418C10.2361 19.6158 10.0827 19.7736 9.891 19.7736C9.69928 19.7736 9.54588 19.6158 9.54588 19.418V18.9432C9.54588 18.7454 9.69928 18.5867 9.891 18.5867C10.0827 18.5867 10.2361 18.7454 10.2361 18.9432V19.418ZM10.2361 21.554C10.2361 21.7518 10.0827 21.9105 9.891 21.9105C9.69928 21.9105 9.54588 21.7518 9.54588 21.554V21.0796C9.54588 20.8818 9.69928 20.7236 9.891 20.7236C10.0827 20.7236 10.2361 20.8818 10.2361 21.0796V21.554ZM8.16546 18.3502C8.16546 18.548 8.01206 18.7063 7.82034 18.7063C7.62863 18.7063 7.47526 18.548 7.47526 18.3502V17.8754C7.47526 17.6776 7.62863 17.5193 7.82034 17.5193C8.01206 17.5193 8.16546 17.6776 8.16546 17.8754V18.3502ZM8.16546 20.4864C8.16546 20.6842 8.01206 20.8424 7.82034 20.8424C7.62863 20.8424 7.47526 20.6842 7.47526 20.4864V20.0116C7.47526 19.8138 7.62863 19.6555 7.82034 19.6555C8.01206 19.6555 8.16546 19.8138 8.16546 20.0116V20.4864ZM6.09483 15.1453C6.09483 15.3431 5.94145 15.5013 5.74973 15.5013C5.558 15.5013 5.40463 15.3431 5.40463 15.1453V14.6705C5.40463 14.4727 5.558 14.3144 5.74973 14.3144C5.94145 14.3144 6.09483 14.4727 6.09483 14.6705V15.1453ZM6.09483 17.2814C6.09483 17.4792 5.94145 17.6375 5.74973 17.6375C5.558 17.6375 5.40463 17.4792 5.40463 17.2814V16.8062C5.40463 16.6084 5.558 16.4506 5.74973 16.4506C5.94145 16.4506 6.09483 16.6084 6.09483 16.8062V17.2814ZM11.9999 -0.00738525C7.51358 -0.00738525 3.87085 3.75111 3.87085 8.37999V15.6197C3.87085 20.2489 7.51358 24.0074 11.9999 24.0074C16.4862 24.0074 20.1289 20.2489 20.1289 15.6197V8.37999C20.1289 3.75111 16.4862 -0.00738525 11.9999 -0.00738525Z"
				})]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_1000_1070",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "24",
					height: "24"
				})
			}) })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ee = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Luggage-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Luggage-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M8 7V5.75C8 4.7835 8.7835 4 9.75 4H14.25C15.2165 4 16 4.7835 16 5.75V7H21C21.5523 7 22 7.44772 22 8V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V8C2 7.44772 2.44772 7 3 7H8ZM9.5 5.75C9.5 5.61193 9.61193 5.5 9.75 5.5H14.25C14.3881 5.5 14.5 5.61193 14.5 5.75V7H9.5V5.75ZM3.5 18.5V8.5H20.5V18.5H3.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.75 10.25C7.16421 10.25 7.5 10.5858 7.5 11L7.5 16C7.5 16.4142 7.16421 16.75 6.75 16.75C6.33579 16.75 6 16.4142 6 16L6 11C6 10.5858 6.33579 10.25 6.75 10.25Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M17.25 10.25C17.6642 10.25 18 10.5858 18 11V16C18 16.4142 17.6642 16.75 17.25 16.75C16.8358 16.75 16.5 16.4142 16.5 16V11C16.5 10.5858 16.8358 10.25 17.25 10.25Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), De = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LuggageFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#LuggageFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8 7V5.75C8 4.7835 8.7835 4 9.75 4H14.25C15.2165 4 16 4.7835 16 5.75V7H21C21.5523 7 22 7.44772 22 8V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V8C2 7.44772 2.44772 7 3 7H8ZM9.5 5.75C9.5 5.61193 9.61193 5.5 9.75 5.5H14.25C14.3881 5.5 14.5 5.61193 14.5 5.75V7H9.5V5.75ZM7.5 11C7.5 10.5858 7.16421 10.25 6.75 10.25C6.33579 10.25 6 10.5858 6 11L6 16C6 16.4142 6.33579 16.75 6.75 16.75C7.16421 16.75 7.5 16.4142 7.5 16L7.5 11ZM17.25 10.25C17.6642 10.25 18 10.5858 18 11V16C18 16.4142 17.6642 16.75 17.25 16.75C16.8358 16.75 16.5 16.4142 16.5 16V11C16.5 10.5858 16.8358 10.25 17.25 10.25Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Oe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Mail-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Mail-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM19.4395 5.5H4.56066L10.4091 11.3484C11.2877 12.2271 12.7124 12.2271 13.591 11.3484L19.4395 5.5ZM3.5 6.56066V18C3.5 18.2761 3.72386 18.5 4 18.5H20C20.2761 18.5 20.5 18.2761 20.5 18V6.56077L14.6517 12.4091C13.1872 13.8735 10.8129 13.8735 9.34841 12.4091L3.5 6.56066Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ke = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Map-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Map-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.31149 4.5091C3.52372 4.79833 3 5.54919 3 6.38937V17.0067C3 18.4358 4.45186 19.405 5.76923 18.8554L8.52682 17.7048C8.8239 17.5809 9.16239 17.6077 9.43632 17.7768L14.1735 20.7019C14.6954 21.0242 15.336 21.0889 15.9117 20.8776L19.6885 19.4909C20.4763 19.2017 21 18.4508 21 17.6107V6.99331C21 5.56423 19.5481 4.59503 18.2308 5.14468L15.4732 6.29521C15.1761 6.41916 14.8376 6.39236 14.5637 6.22321L9.82656 3.29806C9.30465 2.97579 8.66396 2.91105 8.08827 3.12242L4.31149 4.5091ZM19.5 17.6107V6.99331C19.5 6.63604 19.137 6.39374 18.8077 6.53115L16.0501 7.68169C15.9517 7.72275 15.8514 7.7572 15.75 7.78507V19.3372L19.1721 18.0807C19.3691 18.0084 19.5 17.8207 19.5 17.6107ZM14.25 18.9846L10.2236 16.4984C10.0727 16.4051 9.91383 16.3292 9.75 16.2708V5.01543L13.7763 7.50168C13.9273 7.59491 14.0862 7.67085 14.25 7.72926V18.9846ZM8.25 16.215V4.66284L4.82787 5.9193C4.63093 5.99161 4.5 6.17933 4.5 6.38937V17.0067C4.5 17.364 4.86296 17.6063 5.19231 17.4689L7.9499 16.3184C8.04832 16.2773 8.14856 16.2428 8.25 16.215Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ae = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "MeetingPoint-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#MeetingPoint-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 7C10.8954 7 10 7.89543 10 9V9.5C10 10.6046 10.8954 11.5 12 11.5C13.1046 11.5 14 10.6046 14 9.5V9C14 7.89543 13.1046 7 12 7Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.99994 16.1C8.16661 16.3833 7.62494 16.9042 7.37494 17.6625C7.23776 18.0786 7.13822 18.501 7.07632 18.9296C7.66608 19.3494 8.31174 19.6958 8.99994 19.9555V16.1ZM14.9999 14.7C16.4166 14.2167 17.3109 13.4176 18 12C18.5192 10.9318 18.4949 9.97718 18.5 9C18.5 8.44772 18.0523 8 17.5 8C16.9477 8 16.5 8.44772 16.5 9C16.5 9.86603 16.4468 10.8884 15.7499 11.7625C14.7887 12.9684 13.6666 13 11.9999 13C9.83327 13 8.12494 13.6333 6.87494 14.9C6.19624 15.5877 5.70179 16.4032 5.3916 17.3465C4.20865 15.8861 3.5 14.0258 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 15.6384 18.214 18.7428 14.9999 19.9554V14.7ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5V9Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), je = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "MeetingPointFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#MeetingPointFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM19 8L18.9999 8.01158C18.9983 9.47357 18.6858 10.7822 18.0624 11.9375C17.4374 13.0958 16.4166 13.9167 14.9999 14.4V19.9554C14.0671 20.3074 13.056 20.5 11.9999 20.5C10.9439 20.5 9.93282 20.3074 8.99994 19.9555V16.1C8.16661 16.3833 7.62494 16.9042 7.37494 17.6625C7.23776 18.0786 7.13822 18.501 7.07632 18.9296C6.44534 18.4805 5.87833 17.9473 5.3916 17.3465C5.70179 16.4032 6.19624 15.5877 6.87494 14.9C8.12494 13.6333 9.83327 13 11.9999 13C13.6666 13 14.9166 12.5875 15.7499 11.7625C16.5833 10.9375 17 9.68333 17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8ZM12 7C10.8954 7 10 7.89543 10 9V9.5C10 10.6046 10.8954 11.5 12 11.5C13.1046 11.5 14 10.6046 14 9.5V9C14 7.89543 13.1046 7 12 7Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Me = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "MessageDouble-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#MessageDouble-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.18668 16.4583V13.2576L4.81824 12.8342C3.96364 11.8521 3.5 10.7034 3.5 9.5C3.5 6.46489 6.66057 3.5 11.25 3.5C15.8394 3.5 19 6.46489 19 9.5C19 12.5351 15.8394 15.5 11.25 15.5C9.78433 15.5 8.97178 15.2771 8.71181 15.191L8.12526 14.9966L5.18668 16.4583ZM10.6424 16.9879C11.6682 17.6062 13.0046 18 14.4999 18C14.9366 18 15.3611 17.9663 15.7693 17.9028L16.2353 17.8303L18.8238 19.0964V16.7264L19.2944 16.2823C20.0973 15.5247 20.4999 14.6402 20.4999 13.75C20.4999 13.1606 20.3218 12.5693 19.9663 12.0168C18.6906 14.921 15.2697 17 11.25 17C11.0362 17 10.8338 16.9957 10.6424 16.9879ZM20.454 10.253C20.4844 10.0053 20.5 9.75414 20.5 9.5C20.5 5.35786 16.3586 2 11.25 2C6.14137 2 2 5.35786 2 9.5C2 11.108 2.62413 12.5978 3.68668 13.8189V18.0726C3.68668 18.4439 4.07697 18.6856 4.40936 18.5203L8.06314 16.7028C9.37376 18.3785 11.766 19.5 14.4999 19.5C15.0136 19.5 15.5153 19.4604 15.9999 19.385L19.6041 21.1479C19.9363 21.3104 20.3238 21.0686 20.3238 20.6988V17.3733C21.3718 16.3844 21.9999 15.1234 21.9999 13.75C21.9999 12.4343 21.4236 11.2219 20.454 10.253Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ne = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "MessageDoubleFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#MessageDoubleFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.2099 18.467C11.4256 19.1181 12.9046 19.5 14.4999 19.5C15.0136 19.5 15.5153 19.4604 15.9999 19.385L19.6041 21.1479C19.9363 21.3104 20.3238 21.0686 20.3238 20.6988V17.3733C21.3718 16.3844 21.9999 15.1234 21.9999 13.75C21.9999 13.1128 21.8648 12.4999 21.6152 11.927C20.0816 16.6094 14.8056 18.7683 10.2099 18.467ZM2 9.5C2 11.108 2.62413 12.5978 3.68668 13.8189V18.0726C3.68668 18.4439 4.07697 18.6856 4.40936 18.5203L8.24006 16.6148C8.65702 16.753 9.62919 17 11.25 17C16.3586 17 20.5 13.6421 20.5 9.5C20.5 5.35786 16.3586 2 11.25 2C6.14137 2 2 5.35786 2 9.5Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Pe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Minus-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Minus-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Fe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "MinusCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#MinusCircle-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ie = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "More-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#More-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 12C7 12.8284 6.32843 13.5 5.5 13.5C4.67157 13.5 4 12.8284 4 12C4 11.1716 4.67157 10.5 5.5 10.5C6.32843 10.5 7 11.1716 7 12ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12ZM18.5 13.5C19.3284 13.5 20 12.8284 20 12C20 11.1716 19.3284 10.5 18.5 10.5C17.6716 10.5 17 11.1716 17 12C17 12.8284 17.6716 13.5 18.5 13.5Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Le = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "NewFolder-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#NewFolder-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H9.05C9.291 4.5 9.52275 4.54683 9.74525 4.6405C9.96758 4.734 10.1608 4.86283 10.325 5.027L11.798 6.5H19.6923C20.1974 6.5 20.625 6.675 20.975 7.025C21.325 7.375 21.5 7.80258 21.5 8.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775ZM4.30775 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V8.30775C20 8.21792 19.9712 8.14417 19.9135 8.0865C19.8558 8.02883 19.7821 8 19.6923 8H11.1845L9.27125 6.0865C9.23908 6.0545 9.20542 6.03208 9.17025 6.01925C9.13492 6.00642 9.098 6 9.0595 6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM14.25 13.75V15C14.25 15.2128 14.3218 15.391 14.4655 15.5345C14.609 15.6782 14.7872 15.75 15 15.75C15.2128 15.75 15.391 15.6782 15.5345 15.5345C15.6782 15.391 15.75 15.2128 15.75 15V13.75H17C17.2128 13.75 17.391 13.6782 17.5345 13.5345C17.6782 13.391 17.75 13.2128 17.75 13C17.75 12.7872 17.6782 12.609 17.5345 12.4655C17.391 12.3218 17.2128 12.25 17 12.25H15.75V11C15.75 10.7872 15.6782 10.609 15.5345 10.4655C15.391 10.3218 15.2128 10.25 15 10.25C14.7872 10.25 14.609 10.3218 14.4655 10.4655C14.3218 10.609 14.25 10.7872 14.25 11V12.25H13C12.7872 12.25 12.609 12.3218 12.4655 12.4655C12.3218 12.609 12.25 12.7872 12.25 13C12.25 13.2128 12.3218 13.391 12.4655 13.5345C12.609 13.6782 12.7872 13.75 13 13.75H14.25Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Re = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "NotLiveIndicator-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#NotLiveIndicator-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("circle", {
					cx: "12",
					cy: "12",
					r: "12",
					opacity: "0.1"
				}),
				/* @__PURE__ */ (0, c.jsx)("circle", {
					cx: "12",
					cy: "12",
					r: "4"
				}),
				/* @__PURE__ */ (0, c.jsx)("line", {
					x1: "21.2929",
					y1: "22.7071",
					x2: "1.29289",
					y2: "2.70711",
					stroke: "currentColor",
					strokeWidth: "2"
				}),
				/* @__PURE__ */ (0, c.jsx)("line", {
					x1: "22.2929",
					y1: "21.7071",
					x2: "2.29289",
					y2: "1.70711",
					stroke: "white",
					strokeWidth: "2"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ze = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Offline-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Offline-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "m21 11 2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73m-2 2c-1.08-1.08-2.36-1.85-3.72-2.33l3.02 3.02zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0M3.41 1.64 2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24C7.79 10.89 6.27 11.74 5 13l2 2c1.35-1.35 3.11-2.04 4.89-2.06l7.08 7.08 1.41-1.41z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Be = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "OpenInNew-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#OpenInNew-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ve = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "OutboundConnection-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#OutboundConnection-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M12.7998 3C13.2415 3 13.5996 3.35808 13.5996 3.7998C13.5996 4.24152 13.2415 4.59961 12.7998 4.59961H6.93294C6.74885 4.59961 6.59961 4.74885 6.59961 4.93294V18.6667C6.59961 18.8508 6.74885 19 6.93294 19H12.7998C13.2415 19 13.5996 19.3581 13.5996 19.7998C13.5996 20.2415 13.2415 20.5996 12.7998 20.5996H6.7998C5.81026 20.5996 5 19.7893 5 18.7998V4.7998C5 3.81026 5.81026 3 6.7998 3H12.7998Z" }), /* @__PURE__ */ (0, c.jsx)("path", { d: "M19.8094 11.0926C20.2 11.4832 20.1999 12.1164 19.8093 12.5069L17.3676 14.9479C17.0543 15.2612 16.5462 15.2602 16.234 14.9459C15.9233 14.633 15.9242 14.1277 16.2361 13.816L17.4531 12.5996H9.7998C9.35809 12.5996 9 12.2415 9 11.7998C9 11.3581 9.35808 11 9.7998 11H17.4502L16.2331 9.77485C15.9229 9.46261 15.9238 8.95825 16.2352 8.64717C16.547 8.33555 17.0525 8.33566 17.3642 8.64741L19.8094 11.0926Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), He = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Passenger-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Passenger-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("circle", {
				cx: "12",
				cy: "4",
				r: "2"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ue = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Person-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Person-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.5 19V19.5H19.5V19C19.5 18.4034 19.146 17.5788 17.955 16.8345C16.7604 16.0878 14.8099 15.5 12 15.5C9.19007 15.5 7.23963 16.0878 6.04497 16.8345C4.85404 17.5788 4.49998 18.4034 4.5 19ZM3 19V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V19C21.0001 16.5 18 14 12 14C6 14 2.99993 16.5 3 19ZM12 12.5C14.4853 12.5 16.5 10.4853 16.5 8V7C16.5 4.51472 14.4853 2.5 12 2.5C9.51472 2.5 7.5 4.51472 7.5 7V8C7.5 10.4853 9.51472 12.5 12 12.5ZM15 8V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), We = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonCheck-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonCheck-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20.7803 14.7197C21.0732 15.0126 21.0732 15.4874 20.7803 15.7803L15.7803 20.7803C15.4874 21.0732 15.0126 21.0732 14.7197 20.7803L12.2197 18.2803C11.9268 17.9874 11.9268 17.5126 12.2197 17.2197C12.5126 16.9268 12.9874 16.9268 13.2803 17.2197L15.25 19.1893L19.7197 14.7197C20.0126 14.4268 20.4874 14.4268 20.7803 14.7197Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M4.5 19C4.49998 18.4034 4.85404 17.5788 6.04497 16.8345C7.23963 16.0878 9.19007 15.5 12 15.5C12.4142 15.5 12.75 15.1642 12.75 14.75C12.75 14.3358 12.4142 14 12 14C6 14 2.99993 16.5 3 19V20C3 20.5523 3.44772 21 4 21H10C10.4142 21 10.75 20.6642 10.75 20.25C10.75 19.8358 10.4142 19.5 10 19.5H4.5V19Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8ZM15 7V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ge = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonCross-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonCross-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M4.5 19.5V19C4.49998 18.4034 4.85404 17.5788 6.04497 16.8345C7.23963 16.0878 9.19007 15.5 12 15.5C12.4142 15.5 12.75 15.1642 12.75 14.75C12.75 14.3358 12.4142 14 12 14C6 14 2.99993 16.5 3 19V20C3 20.5523 3.44772 21 4 21H12C12.4142 21 12.75 20.6642 12.75 20.25C12.75 19.8358 12.4142 19.5 12 19.5H4.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8ZM15 7V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M15.7703 14.7097C15.4774 14.4168 15.0026 14.4168 14.7097 14.7097C14.4168 15.0026 14.4168 15.4774 14.7097 15.7703L16.685 17.7457L14.7097 19.7211C14.4168 20.014 14.4168 20.4889 14.7097 20.7818C15.0026 21.0746 15.4774 21.0746 15.7703 20.7818L17.7457 18.8064L19.7211 20.7817C20.014 21.0746 20.4888 21.0746 20.7817 20.7817C21.0746 20.4888 21.0746 20.014 20.7817 19.7211L18.8064 17.7457L20.7817 15.7703C21.0746 15.4774 21.0746 15.0026 20.7817 14.7097C20.4888 14.4168 20.014 14.4168 19.7211 14.7097L17.7457 16.685L15.7703 14.7097Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ke = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonFilled-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M4 21C3.44772 21 3 20.5523 3 20V19C2.99993 16.5 6 14 12 14C18 14 21.0001 16.5 21 19V20C21 20.5523 20.5523 21 20 21H4Z" }), /* @__PURE__ */ (0, c.jsx)("path", { d: "M7.5 7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), qe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonIncome-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonIncome-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M4.5 19C4.49998 18.4034 4.85404 17.5788 6.04497 16.8345C7.23963 16.0878 9.19007 15.5 12 15.5C12.4142 15.5 12.75 15.1642 12.75 14.75C12.75 14.3358 12.4142 14 12 14C6 14 2.99993 16.5 3 19V20C3 20.5523 3.44772 21 4 21H10C10.4142 21 10.75 20.6642 10.75 20.25C10.75 19.8358 10.4142 19.5 10 19.5H4.5V19Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8ZM15 7V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16.5263 13.4179C16.8209 13.1777 17.2557 13.1951 17.5302 13.4697L20.5303 16.4697C20.8231 16.7626 20.8231 17.2373 20.5303 17.5302C20.2374 17.8231 19.7626 17.8231 19.4697 17.5302L17.75 15.8105V20.5C17.75 20.9142 17.4141 21.25 17 21.25C16.5857 21.25 16.25 20.9142 16.25 20.5V15.8105L14.5302 17.5302C14.2373 17.8231 13.7626 17.8231 13.4697 17.5302C13.1768 17.2373 13.1768 16.7626 13.4697 16.4697L16.4697 13.4697L16.5263 13.4179Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Je = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonOutcome-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonOutcome-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M4.5 19C4.49998 18.4034 4.85404 17.5788 6.04497 16.8345C7.23963 16.0878 9.19007 15.5 12 15.5C12.4142 15.5 12.75 15.1642 12.75 14.75C12.75 14.3358 12.4142 14 12 14C6 14 2.99993 16.5 3 19V20C3 20.5523 3.44772 21 4 21H10C10.4142 21 10.75 20.6642 10.75 20.25C10.75 19.8358 10.4142 19.5 10 19.5H4.5V19Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8ZM15 7V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M17.75 14V18.6895L19.4697 16.9697C19.7626 16.6768 20.2374 16.6768 20.5303 16.9697C20.8232 17.2626 20.8232 17.7374 20.5303 18.0303L17.5303 21.0303L17.4736 21.082C17.179 21.3223 16.7443 21.3049 16.4697 21.0303L13.4697 18.0303C13.1768 17.7374 13.1768 17.2626 13.4697 16.9697C13.7626 16.6768 14.2374 16.6768 14.5303 16.9697L16.25 18.6895V14C16.25 13.5858 16.5858 13.25 17 13.25C17.4142 13.25 17.75 13.5858 17.75 14Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ye = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PersonQuestion-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PersonQuestion-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M4.5 19.5V19C4.49998 18.4034 4.85404 17.5788 6.04497 16.8345C7.23963 16.0878 9.19007 15.5 12 15.5C12.4142 15.5 12.75 15.1642 12.75 14.75C12.75 14.3358 12.4142 14 12 14C6 14 2.99993 16.5 3 19V20C3 20.5523 3.44772 21 4 21H12C12.4142 21 12.75 20.6642 12.75 20.25C12.75 19.8358 12.4142 19.5 12 19.5H4.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V8ZM15 7V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16.1905 14.5773C16.1905 13.8317 16.7768 13.2273 17.5 13.2273C18.2232 13.2273 18.8095 13.8317 18.8095 14.5773C18.8095 15.0074 18.6151 15.3904 18.3095 15.6386C18.0327 15.8634 17.6916 16.1512 17.4205 16.4949C17.1468 16.8419 16.9048 17.2957 16.9048 17.8501C16.9048 18.189 17.1713 18.4637 17.5 18.4637C17.8287 18.4637 18.0952 18.189 18.0952 17.8501C18.0952 17.6814 18.1667 17.4942 18.3442 17.2691C18.5243 17.0407 18.7721 16.8253 19.0462 16.6026C19.626 16.1317 20 15.3993 20 14.5773C20 13.1539 18.8807 12 17.5 12C16.1193 12 15 13.1539 15 14.5773C15 14.9162 15.2665 15.1909 15.5952 15.1909C15.924 15.1909 16.1905 14.9162 16.1905 14.5773Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M17.3809 21C17.8193 21 18.1746 20.6337 18.1746 20.1818C18.1746 19.7299 17.8193 19.3636 17.3809 19.3636C16.9426 19.3636 16.5873 19.7299 16.5873 20.1818C16.5873 20.6337 16.9426 21 17.3809 21Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Xe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Phone-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Phone-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.80967 9.70484L9.64107 7.41565C9.7471 7.28312 9.77871 7.10587 9.72504 6.94486L9.02448 4.84317C8.95637 4.63886 8.76517 4.50105 8.5498 4.50105H5.7894C4.87848 4.50105 4.4234 5.19155 4.51545 5.74162C5.68616 12.7376 11.2624 18.3138 18.2584 19.4845C18.8084 19.5766 19.499 19.1215 19.499 18.2106V15.4502C19.499 15.2348 19.3611 15.0436 19.1568 14.9755L17.0551 14.275C16.8941 14.2213 16.7169 14.2529 16.5843 14.3589L14.2951 16.1903L13.5204 15.932C12.4283 15.568 11.2244 14.6107 10.3068 13.6931C9.38923 12.7755 8.43195 11.5717 8.06791 10.4796L7.80967 9.70484ZM9.49193 10.0049L10.8132 8.35336C11.2373 7.82323 11.3637 7.11425 11.1491 6.47019L10.4485 4.3685C10.1761 3.55124 9.41126 3 8.5498 3H5.7894C4.13139 3 2.76135 4.35409 3.03499 5.98937C4.31144 13.6172 10.3828 19.6886 18.0106 20.965C19.6459 21.2387 21 19.8686 21 18.2106V15.4502C21 14.5887 20.4488 13.8239 19.6315 13.5515L17.5298 12.8509C16.8857 12.6362 16.1768 12.7627 15.6466 13.1868L13.9951 14.508C12.494 14.0077 9.99228 11.5059 9.49193 10.0049Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ze = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PhoneFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#PhoneFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M3.03499 5.98937C4.31144 13.6172 10.3828 19.6886 18.0106 20.965C19.6459 21.2387 21 19.8686 21 18.2106L21 15.9505C21 15.0891 20.4487 14.3243 19.6315 14.0519L17.6703 13.3981C16.9511 13.1584 16.1582 13.3456 15.6222 13.8816L14.4954 15.0084C12.494 14.508 9.49194 11.5059 8.99159 9.50453L10.1183 8.37778C10.6544 7.84174 10.8416 7.04886 10.6018 6.32968L9.94811 4.3685C9.67569 3.55124 8.91088 3 8.04941 3H5.7894C4.13139 3 2.76135 4.35409 3.03499 5.98937Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Qe = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Pin-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Pin-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.0633C16.3526 16.4284 18.5 13.4213 18.5 10C18.5 6.41015 15.5899 3.5 12 3.5C8.41015 3.5 5.5 6.41015 5.5 10C5.5 13.4213 7.64736 16.4284 12 20.0633ZM12 22C17 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 7 18 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12ZM12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), $e = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Plus-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Plus-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H11V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H13V4Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), et = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PlusCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PlusCircle-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", { d: "M12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.25H8C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H11.25V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V12.75H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H12.75V8Z" })]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), tt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Print-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Print-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M8.30776 20.5C7.8106 20.5 7.38501 20.323 7.03101 19.969C6.67701 19.615 6.50001 19.1894 6.50001 18.6922V16.5H4.59626C4.0991 16.5 3.67351 16.323 3.31951 15.969C2.96551 15.615 2.78851 15.1894 2.78851 14.6922V10.8077C2.78851 10.0994 3.03051 9.50566 3.51451 9.02649C3.99851 8.54732 4.58985 8.30774 5.28851 8.30774H18.7115C19.4198 8.30774 20.0136 8.54732 20.4928 9.02649C20.9719 9.50566 21.2115 10.0994 21.2115 10.8077V14.6922C21.2115 15.1894 21.0345 15.615 20.6805 15.969C20.3265 16.323 19.9009 16.5 19.4038 16.5H17.5V18.6922C17.5 19.1894 17.323 19.615 16.969 19.969C16.615 20.323 16.1894 20.5 15.6923 20.5H8.30776ZM4.59626 15H6.50001C6.51285 14.5142 6.69435 14.0978 7.04451 13.751C7.39485 13.4042 7.81593 13.2307 8.30776 13.2307H15.6923C16.1841 13.2307 16.6051 13.4042 16.9553 13.751C17.3056 14.0978 17.4872 14.5142 17.5 15H19.4038C19.4936 15 19.5673 14.9712 19.625 14.9135C19.6827 14.8558 19.7115 14.7821 19.7115 14.6922V10.8077C19.7115 10.5244 19.6157 10.2869 19.424 10.0952C19.2323 9.90357 18.9948 9.80774 18.7115 9.80774H5.28851C5.00518 9.80774 4.76768 9.90357 4.57601 10.0952C4.38435 10.2869 4.28851 10.5244 4.28851 10.8077V14.6922C4.28851 14.7821 4.31735 14.8558 4.37501 14.9135C4.43268 14.9712 4.50643 15 4.59626 15ZM16 8.30774V5.61549C16 5.52566 15.9712 5.45191 15.9135 5.39424C15.8558 5.33657 15.7821 5.30774 15.6923 5.30774H8.30776C8.21793 5.30774 8.14418 5.33657 8.08651 5.39424C8.02885 5.45191 8.00001 5.52566 8.00001 5.61549V8.30774H6.50001V5.61549C6.50001 5.11832 6.67701 4.69274 7.03101 4.33874C7.38501 3.98474 7.8106 3.80774 8.30776 3.80774H15.6923C16.1894 3.80774 16.615 3.98474 16.969 4.33874C17.323 4.69274 17.5 5.11832 17.5 5.61549V8.30774H16ZM17.8078 12.3077C18.0911 12.3077 18.3286 12.2119 18.5203 12.0202C18.7119 11.8286 18.8078 11.5911 18.8078 11.3077C18.8078 11.0244 18.7119 10.7869 18.5203 10.5952C18.3286 10.4036 18.0911 10.3077 17.8078 10.3077C17.5244 10.3077 17.2869 10.4036 17.0953 10.5952C16.9036 10.7869 16.8078 11.0244 16.8078 11.3077C16.8078 11.5911 16.9036 11.8286 17.0953 12.0202C17.2869 12.2119 17.5244 12.3077 17.8078 12.3077ZM16 18.6922V15.0385C16 14.9487 15.9712 14.8749 15.9135 14.8172C15.8558 14.7596 15.7821 14.7307 15.6923 14.7307H8.30776C8.21793 14.7307 8.14418 14.7596 8.08651 14.8172C8.02885 14.8749 8.00001 14.9487 8.00001 15.0385V18.6922C8.00001 18.7821 8.02885 18.8558 8.08651 18.9135C8.14418 18.9712 8.21793 19 8.30776 19H15.6923C15.7821 19 15.8558 18.9712 15.9135 18.9135C15.9712 18.8558 16 18.7821 16 18.6922ZM4.59626 9.80774H4.28851H19.7115H4.59626Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), nt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "PriorityService-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#PriorityService-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.5 8V7.5C13.5 5.84315 12.1569 4.5 10.5 4.5C8.84315 4.5 7.5 5.84315 7.5 7.5V8C7.5 9.65685 8.84315 11 10.5 11C12.1569 11 13.5 9.65685 13.5 8ZM10.5 3C8.01472 3 6 5.01472 6 7.5V8C6 10.4853 8.01472 12.5 10.5 12.5C12.9853 12.5 15 10.4853 15 8V7.5C15 5.01472 12.9853 3 10.5 3Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.9739 14.2197C17.2668 13.9268 17.7417 13.9268 18.0346 14.2197L20.7845 16.9697C21.0774 17.2626 21.0774 17.7374 20.7845 18.0303L18.0346 20.7803C17.7417 21.0732 17.2668 21.0732 16.9739 20.7803C16.681 20.4874 16.681 20.0126 16.9739 19.7197L19.1936 17.5L16.9739 15.2803C16.681 14.9874 16.681 14.5126 16.9739 14.2197Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.7197 14.2197C13.0126 13.9268 13.4874 13.9268 13.7803 14.2197L16.5303 16.9697C16.8232 17.2626 16.8232 17.7374 16.5303 18.0303L13.7803 20.7803C13.4874 21.0732 13.0126 21.0732 12.7197 20.7803C12.4268 20.4874 12.4268 20.0126 12.7197 19.7197L14.9393 17.5L12.7197 15.2803C12.4268 14.9874 12.4268 14.5126 12.7197 14.2197Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M10.5 14C5.5 14 2.99994 16.5 3 19V20C3 20.5523 3.44772 21 4 21H10.5C10.9142 21 11.25 20.6642 11.25 20.25C11.25 19.8358 10.9142 19.5 10.5 19.5H4.5V19C4.49997 17.7001 5.89996 15.5 10.5 15.5C10.9142 15.5 11.25 15.1642 11.25 14.75C11.25 14.3358 10.9142 14 10.5 14Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), rt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Profile-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Profile-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 6C9.92893 6 8.25 7.67893 8.25 9.75V10.75C8.25 12.8211 9.92893 14.5 12 14.5C14.0711 14.5 15.75 12.8211 15.75 10.75V9.75C15.75 7.67893 14.0711 6 12 6ZM14.25 10.75V9.75C14.25 8.50736 13.2426 7.5 12 7.5C10.7574 7.5 9.75 8.50736 9.75 9.75V10.75C9.75 11.9926 10.7574 13 12 13C13.2426 13 14.25 11.9926 14.25 10.75Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.2859 18.6569C19.2444 17.0997 20.5 14.6965 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.6965 4.75559 17.0997 6.714 18.6569L7.21333 18.0327C8.11475 16.9059 9.47949 16.25 10.9225 16.25H13.0775C14.5204 16.25 15.8852 16.9059 16.7866 18.0327L17.2859 18.6569ZM16.0287 19.4865L15.6153 18.9697C14.9985 18.1988 14.0648 17.75 13.0775 17.75H10.9225C9.93516 17.75 9.00139 18.1988 8.38463 18.9697L7.97125 19.4865C9.17024 20.133 10.5423 20.5 12 20.5C13.4577 20.5 14.8297 20.1331 16.0287 19.4865Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), it = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "ProfileFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#ProfileFilled-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 6C9.92893 6 8.25 7.67893 8.25 9.75V10.75C8.25 12.8211 9.92893 14.5 12 14.5C14.0711 14.5 15.75 12.8211 15.75 10.75V9.75C15.75 7.67893 14.0711 6 12 6Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.2859 18.6569C19.2444 17.0997 20.5 14.6965 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.6965 4.75559 17.0997 6.714 18.6569L7.21333 18.0327C8.11475 16.9059 9.47949 16.25 10.9225 16.25H13.0775C14.5204 16.25 15.8852 16.9059 16.7866 18.0327L17.2859 18.6569Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), at = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Public-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Public-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM11 19.95V18C10.45 18 9.97917 17.8042 9.5875 17.4125C9.19583 17.0208 9 16.55 9 16V15L4.2 10.2C4.15 10.5 4.10417 10.8 4.0625 11.1C4.02083 11.4 4 11.7 4 12C4 14.0167 4.6625 15.7833 5.9875 17.3C7.3125 18.8167 8.98333 19.7 11 19.95ZM17.9 17.4C18.5833 16.65 19.1042 15.8125 19.4625 14.8875C19.8208 13.9625 20 12.9988 20 11.9965C20 10.3592 19.5474 8.86392 18.6423 7.51075C17.7371 6.15742 16.523 5.18075 15 4.58075V5C15 5.55 14.8042 6.02083 14.4125 6.4125C14.0208 6.80417 13.55 7 13 7H11V9C11 9.28333 10.9042 9.52083 10.7125 9.7125C10.5208 9.90417 10.2833 10 10 10H8V12H14C14.2833 12 14.5208 12.0958 14.7125 12.2875C14.9042 12.4792 15 12.7167 15 13V16H16C16.4333 16 16.825 16.1292 17.175 16.3875C17.525 16.6458 17.7667 16.9833 17.9 17.4Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ot = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Qr-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Qr-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M3.75 3C3.33579 3 3 3.33579 3 3.75V7.75C3 8.16421 3.33579 8.5 3.75 8.5C4.16421 8.5 4.5 8.16421 4.5 7.75V4.5H7.75C8.16421 4.5 8.5 4.16421 8.5 3.75C8.5 3.33579 8.16421 3 7.75 3H3.75Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M3.75 21C3.33579 21 3 20.6642 3 20.25V16.25C3 15.8358 3.33579 15.5 3.75 15.5C4.16421 15.5 4.5 15.8358 4.5 16.25V19.5H7.75C8.16421 19.5 8.5 19.8358 8.5 20.25C8.5 20.6642 8.16421 21 7.75 21H3.75Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M21 3.75C21 3.33579 20.6642 3 20.25 3H16.25C15.8358 3 15.5 3.33579 15.5 3.75C15.5 4.16421 15.8358 4.5 16.25 4.5H19.5V7.75C19.5 8.16421 19.8358 8.5 20.25 8.5C20.6642 8.5 21 8.16421 21 7.75V3.75Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M20.25 21C20.6642 21 21 20.6642 21 20.25V16.25C21 15.8358 20.6642 15.5 20.25 15.5C19.8358 15.5 19.5 15.8358 19.5 16.25V19.5H16.25C15.8358 19.5 15.5 19.8358 15.5 20.25C15.5 20.6642 15.8358 21 16.25 21H20.25Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7 6C6.44772 6 6 6.44772 6 7V10C6 10.5523 6.44772 11 7 11H10C10.5523 11 11 10.5523 11 10V7C11 6.44772 10.5523 6 10 6H7ZM7.5 7.5V9.5H9.5V7.5H7.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6 14C6 13.4477 6.44772 13 7 13H10C10.5523 13 11 13.4477 11 14V17C11 17.5523 10.5523 18 10 18H7C6.44772 18 6 17.5523 6 17V14ZM7.5 16.5V14.5H9.5V16.5H7.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M14 6C13.4477 6 13 6.44772 13 7V10C13 10.5523 13.4477 11 14 11H17C17.5523 11 18 10.5523 18 10V7C18 6.44772 17.5523 6 17 6H14ZM14.5 7.5V9.5H16.5V7.5H14.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 13V15H15V13H13Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16 13V16H13V18H18V13H16Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), st = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "QuestionCircle-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#QuestionCircle-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M10.35 9.60022C10.35 8.68894 11.0887 7.9502 12 7.9502C12.9113 7.9502 13.65 8.68894 13.65 9.60022C13.65 10.1259 13.405 10.594 13.0199 10.8974C12.6712 11.1721 12.2414 11.5239 11.8998 11.9439C11.555 12.3681 11.25 12.9227 11.25 13.6003C11.25 14.0145 11.5858 14.3503 12 14.3503C12.4142 14.3503 12.75 14.0145 12.75 13.6003C12.75 13.3941 12.84 13.1654 13.0637 12.8902C13.2907 12.611 13.6029 12.3477 13.9483 12.0756C14.6788 11.5001 15.15 10.605 15.15 9.60022C15.15 7.86051 13.7397 6.4502 12 6.4502C10.2603 6.4502 8.84998 7.86051 8.84998 9.60022C8.84998 10.0144 9.18576 10.3502 9.59998 10.3502C10.0142 10.3502 10.35 10.0144 10.35 9.60022Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M11.85 17.4502C12.4023 17.4502 12.85 17.0025 12.85 16.4502C12.85 15.8979 12.4023 15.4502 11.85 15.4502C11.2977 15.4502 10.85 15.8979 10.85 16.4502C10.85 17.0025 11.2977 17.4502 11.85 17.4502Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ct = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Queue-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Queue-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M3.75 6.25V20.25H17.75V21.75H4C3.03807 21.75 2.25 20.9619 2.25 20V6.25H3.75Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M14.75 5.25V9.25H18.75V10.75H14.75V14.75H13.25V10.75H9.25V9.25H13.25V5.25H14.75Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20 2.25C20.9619 2.25 21.75 3.03807 21.75 4V16C21.75 16.9619 20.9619 17.75 20 17.75H8C7.03807 17.75 6.25 16.9619 6.25 16V4C6.25 3.03807 7.03807 2.25 8 2.25H20ZM7.75 3.75V16.25H20.25V3.75H7.75Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), lt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "RadioButtonFalse-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#RadioButtonFalse-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ut = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "RadioButtonTrue-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#RadioButtonTrue-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), dt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Reload-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Reload-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M15.1703 3.57685C13.2215 2.84339 11.0788 2.80833 9.10706 3.47763C7.13537 4.14693 5.45674 5.47918 4.3572 7.24739C3.25766 9.0156 2.80523 11.1104 3.07701 13.1747C3.34879 15.2391 4.32797 17.1454 5.84769 18.5688C7.36741 19.9922 9.33365 20.8445 11.4114 20.9807C13.4891 21.1169 15.5498 20.5285 17.2423 19.3156C18.9348 18.1028 20.1544 16.3406 20.6933 14.3294C20.8006 13.9293 20.5631 13.518 20.163 13.4108C19.7629 13.3036 19.3517 13.541 19.2445 13.9411C18.7954 15.6172 17.779 17.0857 16.3686 18.0963C14.9582 19.107 13.2409 19.5974 11.5095 19.4839C9.77804 19.3705 8.13951 18.6601 6.87308 17.474C5.60664 16.2878 4.79067 14.6993 4.56418 12.9789C4.3377 11.2586 4.71472 9.513 5.631 8.03949C6.54728 6.56599 7.94614 5.45578 9.58922 4.89802C11.2323 4.34027 13.0179 4.36949 14.6419 4.98071C16.125 5.5389 17.3894 6.55095 18.2584 7.86691L14.8507 7.52909C14.4386 7.48823 14.0713 7.78925 14.0304 8.20144C13.9896 8.61364 14.2906 8.98091 14.7028 9.02177L20.4247 9.58901L20.992 3.86706C21.0328 3.45487 20.7318 3.08759 20.3196 3.04673C19.9074 3.00587 19.5401 3.30689 19.4993 3.71908L19.2121 6.6161C18.1874 5.24345 16.7871 4.18539 15.1703 3.57685Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ft = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Search-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Search-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.2465 16.3072C13.9536 17.3652 12.301 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5C18 12.301 17.3652 13.9536 16.3072 15.2465L20.7761 19.7155C21.069 20.0084 21.069 20.4832 20.7761 20.7761C20.4832 21.069 20.0084 21.069 19.7155 20.7761L15.2465 16.3072ZM16.5 10.5C16.5 13.8137 13.8137 16.5 10.5 16.5C7.18629 16.5 4.5 13.8137 4.5 10.5C4.5 7.18629 7.18629 4.5 10.5 4.5C13.8137 4.5 16.5 7.18629 16.5 10.5Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), pt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Seat-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Seat-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M15.1538 2C16.1965 2.00006 17.0648 2.80146 17.1479 3.84082L17.8804 13H18.0005C19.1049 13.0002 20.0005 13.8955 20.0005 15V18C20.0005 18.5522 19.5526 18.9998 19.0005 19H16.7505V20.5H18.2505C18.6646 20.5002 19.0005 20.8359 19.0005 21.25C19.0005 21.6641 18.6645 21.9998 18.2505 22H5.75049C5.3363 22 5.00052 21.6642 5.00049 21.25C5.00049 20.8358 5.33627 20.5 5.75049 20.5H7.25049V19H5.00049C4.44822 19 4.00052 18.5523 4.00049 18V15C4.00049 13.8954 4.89592 13 6.00049 13H6.12061L6.85303 3.84082C6.93618 2.80142 7.80445 2 8.84717 2H15.1538ZM8.75049 20.5H15.2505V19H8.75049V20.5ZM6.00049 14.5C5.72435 14.5 5.50049 14.7239 5.50049 15V17.5H18.5005V15C18.5005 14.724 18.2765 14.5002 18.0005 14.5H6.00049ZM8.84717 3.5C8.58654 3.5 8.36901 3.70019 8.34814 3.95996L7.62549 13H16.3755L15.6519 3.95996C15.631 3.70025 15.4144 3.50006 15.1538 3.5H8.84717Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), mt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "SeatCheckFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#SeatCheckFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.66481 3C6.85041 3 7.89322 3.78376 8.22289 4.9226L10.4163 12.5H17.25C18.2165 12.5 19 13.2835 19 14.25V16.25C19 17.2165 18.2165 18 17.25 18H12.5L12.4999 19.5H16.25C16.6642 19.5 17 19.8358 17 20.25C17 20.6642 16.6642 21 16.25 21H7.75C7.33579 21 7 20.6642 7 20.25C7 19.8358 7.33579 19.5 7.75 19.5H10.9999L11 18H7.10266C6.77051 18 6.47792 17.7815 6.38356 17.4631L3.11144 6.41965C2.60572 4.71286 3.88468 3 5.66481 3ZM20.7803 4.28033C21.0732 3.98744 21.0732 3.51256 20.7803 3.21967C20.4874 2.92678 20.0126 2.92678 19.7197 3.21967L15.25 7.68934L13.2803 5.71967C12.9874 5.42678 12.5126 5.42678 12.2197 5.71967C11.9268 6.01256 11.9268 6.48744 12.2197 6.78033L14.7197 9.28033C15.0126 9.57322 15.4874 9.57322 15.7803 9.28033L20.7803 4.28033Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), ht = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "SeatComfort-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#SeatComfort-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.22289 4.9226C8.89322 3.78376 7.85041 3 6.66481 3C4.88468 3 3.60572 4.71286 4.11144 6.41965L7.38356 17.4631C7.47792 17.7815 7.77051 18 8.10266 18H12L11.9999 19.5H8.75C8.33579 19.5 8 19.8358 8 20.25C8 20.6642 8.33579 21 8.75 21H17.25C17.6642 21 18 20.6642 18 20.25C18 19.8358 17.6642 19.5 17.25 19.5H13.4999L13.5 18H18.25C19.2165 18 20 17.2165 20 16.25V14.25C20 13.2835 19.2165 12.5 18.25 12.5H11.4163L9.22289 4.9226ZM5.54964 5.99352C5.32877 5.24809 5.88735 4.5 6.66481 4.5C7.18262 4.5 7.63806 4.84231 7.78204 5.33969L10.1322 13.4585C10.2251 13.7793 10.5188 14 10.8527 14H18.25C18.3881 14 18.5 14.1119 18.5 14.25V16.25C18.5 16.3881 18.3881 16.5 18.25 16.5H8.66267L5.54964 5.99352Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), gt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "SeatComfortFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#SeatComfortFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.22289 4.9226C8.89322 3.78376 7.85041 3 6.66481 3C4.88468 3 3.60572 4.71286 4.11144 6.41965L7.38356 17.4631C7.47792 17.7815 7.77051 18 8.10266 18H12L11.9999 19.5H8.75C8.33579 19.5 8 19.8358 8 20.25C8 20.6642 8.33579 21 8.75 21H17.25C17.6642 21 18 20.6642 18 20.25C18 19.8358 17.6642 19.5 17.25 19.5H13.4999L13.5 18H18.25C19.2165 18 20 17.2165 20 16.25V14.25C20 13.2835 19.2165 12.5 18.25 12.5H11.4163L9.22289 4.9226Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), _t = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Send-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Send-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.03223 4.25079C2.8218 3.42005 3.68199 2.72535 4.4474 3.10787L20.4465 11.1035C21.1845 11.4723 21.1845 12.5276 20.4465 12.8964L4.44741 20.8921C3.68199 21.2747 2.8218 20.58 3.03222 19.7492L4.93264 12.2464C4.97361 12.0847 4.97361 11.9152 4.93264 11.7535L3.03223 4.25079ZM6.35186 11.2485L4.754 4.94027L18.8803 12L4.754 19.0597L6.35192 12.7512H10.25C10.6641 12.7512 11 12.4148 11 11.9998C11 11.5849 10.6641 11.2485 10.25 11.2485H6.35186Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), vt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Settings-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Settings-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.7477 3.5L10.4382 5.97592C9.3084 6.35012 8.35262 6.90543 7.46921 7.69192L5.16843 6.72121L3.98051 8.77874L5.96984 10.2846C5.73049 11.4501 5.73192 12.5568 5.96983 13.7153L3.98051 15.2212L5.16843 17.2787L7.46918 16.308C8.3526 17.0946 9.30839 17.6499 10.4382 18.0241L10.7477 20.5H13.1235L13.433 18.0241C14.5562 17.6521 15.5129 17.0996 16.402 16.308L18.7028 17.2787L19.8907 15.2212L17.9014 13.7153C18.1393 12.5568 18.1407 11.4501 17.9014 10.2846L19.8907 8.77874L18.7028 6.72122L16.402 7.69192C15.5129 6.9004 14.5562 6.34794 13.433 5.97592L13.1235 3.5H10.7477ZM9.28664 3.09495C9.36483 2.46942 9.89658 2 10.527 2H13.3442C13.9746 2 14.5064 2.46942 14.5846 3.09496L14.806 4.8665C15.4828 5.13909 16.1116 5.505 16.6765 5.94806L18.323 5.25339C18.9038 5.00834 19.5763 5.23414 19.8915 5.78009L21.3001 8.21987C21.6153 8.76582 21.4746 9.46104 20.972 9.84152L19.5477 10.9197C19.6472 11.6263 19.6472 12.3737 19.5477 13.0803L20.972 14.1584C21.4746 14.5389 21.6153 15.2341 21.3001 15.7801L19.8915 18.2199C19.5763 18.7658 18.9038 18.9916 18.323 18.7466L16.6765 18.0519C16.1117 18.495 15.4829 18.8609 14.806 19.1335L14.5846 20.905C14.5064 21.5306 13.9746 22 13.3442 22H10.527C9.89658 22 9.36483 21.5306 9.28664 20.905L9.0652 19.1335C8.38833 18.8609 7.75952 18.495 7.19464 18.0519L5.54817 18.7466C4.96734 18.9916 4.29494 18.7658 3.97974 18.2199L2.57113 15.7801C2.25592 15.2341 2.39658 14.5389 2.89921 14.1584L4.3235 13.0803C4.22404 12.3737 4.22404 11.6263 4.3235 10.9197L2.89921 9.84152C2.39658 9.46104 2.25592 8.76582 2.57113 8.21987L3.97974 5.78009C4.29494 5.23414 4.96734 5.00834 5.54817 5.25339L7.19468 5.94806C7.75955 5.505 8.38835 5.13909 9.0652 4.8665L9.28664 3.09495ZM12.0001 9.5C10.6193 9.5 9.50006 10.6193 9.50006 12C9.50006 13.3807 10.6193 14.5 12.0001 14.5C13.3808 14.5 14.5001 13.3807 14.5001 12C14.5001 10.6193 13.3808 9.5 12.0001 9.5ZM8.00006 12C8.00006 9.79086 9.79092 8 12.0001 8C14.2092 8 16.0001 9.79086 16.0001 12C16.0001 14.2091 14.2092 16 12.0001 16C9.79092 16 8.00006 14.2091 8.00006 12Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), yt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Sort-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Sort-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M4.25 17.5C4.0375 17.5 3.85942 17.4281 3.71575 17.2843C3.57192 17.1404 3.5 16.9622 3.5 16.7497C3.5 16.5371 3.57192 16.359 3.71575 16.2155C3.85942 16.0718 4.0375 16 4.25 16H8.125C8.3375 16 8.51558 16.0719 8.65925 16.2158C8.80308 16.3596 8.875 16.5378 8.875 16.7503C8.875 16.9629 8.80308 17.141 8.65925 17.2845C8.51558 17.4282 8.3375 17.5 8.125 17.5H4.25ZM4.25 12.75C4.0375 12.75 3.85942 12.6781 3.71575 12.5342C3.57192 12.3904 3.5 12.2122 3.5 11.9997C3.5 11.7871 3.57192 11.609 3.71575 11.4655C3.85942 11.3218 4.0375 11.25 4.25 11.25H13.9328C14.1453 11.25 14.3233 11.3219 14.467 11.4658C14.6108 11.6096 14.6828 11.7878 14.6828 12.0003C14.6828 12.2129 14.6108 12.391 14.467 12.5345C14.3233 12.6782 14.1453 12.75 13.9328 12.75H4.25ZM4.25 8C4.0375 8 3.85942 7.92808 3.71575 7.78425C3.57192 7.64042 3.5 7.46225 3.5 7.24975C3.5 7.03708 3.57192 6.859 3.71575 6.7155C3.85942 6.57183 4.0375 6.5 4.25 6.5H19.75C19.9625 6.5 20.1406 6.57192 20.2843 6.71575C20.4281 6.85958 20.5 7.03775 20.5 7.25025C20.5 7.46292 20.4281 7.641 20.2843 7.7845C20.1406 7.92817 19.9625 8 19.75 8H4.25Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), bt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Split-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Split-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M11.25 20.75V17.1443C11.25 16.2238 11.1148 15.5193 10.8443 15.0308C10.5738 14.5423 10.1923 14.0782 9.70001 13.6385L10.7693 12.5693C10.9821 12.7654 11.1946 12.9933 11.4068 13.253C11.6189 13.5125 11.8167 13.7878 12 14.079C12.2142 13.7173 12.4613 13.3837 12.7413 13.078C13.0214 12.7722 13.3122 12.4833 13.6135 12.2115C14.3493 11.5513 14.9692 10.7578 15.473 9.83076C15.9768 8.90376 16.2327 7.4211 16.2405 5.38276L14.9423 6.68076C14.8038 6.81926 14.6323 6.8901 14.428 6.89326C14.2235 6.89643 14.0437 6.8256 13.8885 6.68076C13.7333 6.5256 13.6558 6.34743 13.6558 6.14626C13.6558 5.94493 13.7333 5.76668 13.8885 5.61151L16.3673 3.13276C16.4609 3.0391 16.5597 2.9731 16.6635 2.93476C16.7673 2.89626 16.8795 2.87701 17 2.87701C17.1205 2.87701 17.2327 2.89626 17.3365 2.93476C17.4403 2.9731 17.5391 3.0391 17.6328 3.13276L20.127 5.62701C20.2653 5.76551 20.3387 5.93693 20.347 6.14126C20.3553 6.34576 20.282 6.5256 20.127 6.68076C19.982 6.8256 19.8063 6.89801 19.6 6.89801C19.3937 6.89801 19.218 6.8256 19.073 6.68076L17.7403 5.36351C17.7326 7.67635 17.4188 9.3946 16.799 10.5183C16.1792 11.6419 15.4583 12.5782 14.6365 13.327C14.084 13.8295 13.6314 14.3243 13.2788 14.8115C12.9263 15.2987 12.75 16.0763 12.75 17.1443V20.75C12.75 20.9628 12.6782 21.141 12.5345 21.2845C12.391 21.4282 12.2128 21.5 12 21.5C11.7872 21.5 11.609 21.4282 11.4655 21.2845C11.3218 21.141 11.25 20.9628 11.25 20.75ZM6.47876 8.14626C6.40576 7.80643 6.3536 7.38526 6.32226 6.88276C6.29076 6.3801 6.26993 5.87368 6.25976 5.36351L4.92701 6.69626C4.78851 6.8346 4.61701 6.90543 4.41251 6.90876C4.20801 6.91193 4.02818 6.83593 3.87301 6.68076C3.72818 6.53593 3.65576 6.36026 3.65576 6.15376C3.65576 5.94743 3.72818 5.77185 3.87301 5.62701L6.36726 3.13276C6.46093 3.0391 6.55968 2.9731 6.66351 2.93476C6.76735 2.89626 6.87951 2.87701 7.00001 2.87701C7.12051 2.87701 7.23268 2.89626 7.33651 2.93476C7.44034 2.9731 7.5391 3.0391 7.63276 3.13276L10.127 5.62701C10.2757 5.77568 10.349 5.94968 10.347 6.14901C10.3452 6.34835 10.2667 6.5256 10.1115 6.68076C9.95634 6.8256 9.78068 6.89801 9.58451 6.89801C9.38851 6.89801 9.21293 6.8256 9.05776 6.68076L7.75951 5.39801C7.75318 5.85068 7.76826 6.28726 7.80476 6.70776C7.84126 7.12826 7.88585 7.4911 7.93851 7.79626L6.47876 8.14626ZM8.48476 12.4595C8.18343 12.1223 7.89143 11.7285 7.60876 11.278C7.3261 10.8273 7.09051 10.3276 6.90201 9.77876L8.34626 9.41926C8.48726 9.8051 8.66126 10.1644 8.86826 10.4973C9.07526 10.8299 9.30376 11.1277 9.55376 11.3905L8.48476 12.4595Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), xt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Star-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Star-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 3C12.2855 3 12.5462 3.16208 12.6726 3.41808L15.0475 8.23017L20.3579 9.00182C20.6404 9.04288 20.8751 9.24076 20.9633 9.51227C21.0515 9.78377 20.978 10.0818 20.7735 10.2811L16.9309 14.0268L17.838 19.3158C17.8863 19.5972 17.7706 19.8815 17.5396 20.0493C17.3087 20.2171 17.0025 20.2393 16.7498 20.1064L12 17.6093L7.25025 20.1064C6.99756 20.2393 6.69136 20.2171 6.4604 20.0493C6.22944 19.8815 6.11378 19.5972 6.16203 19.3158L7.06916 14.0268L3.22651 10.2811C3.02208 10.0818 2.94851 9.78377 3.03673 9.51227C3.12495 9.24076 3.35966 9.04288 3.64217 9.00182L8.95258 8.23017L11.3275 3.41808C11.4538 3.16208 11.7145 3 12 3ZM12 5.44468L10.1232 9.2476C10.0139 9.46896 9.80276 9.62238 9.55848 9.65788L5.36173 10.2677L8.39853 13.2279C8.5753 13.4002 8.65596 13.6484 8.61423 13.8917L7.89734 18.0716L11.651 16.0981C11.8695 15.9832 12.1305 15.9832 12.349 16.0981L16.1027 18.0716L15.3858 13.8917C15.3441 13.6484 15.4247 13.4002 15.6015 13.2279L18.6383 10.2677L14.4416 9.65788C14.1973 9.62238 13.9861 9.46896 13.8769 9.2476L12 5.44468Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), St = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "StarFilled-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#StarFilled-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 3C12.2855 3 12.5462 3.16208 12.6726 3.41808L15.0475 8.23017L20.3579 9.00182C20.6404 9.04288 20.8751 9.24076 20.9633 9.51227C21.0515 9.78377 20.978 10.0818 20.7735 10.2811L16.9309 14.0268L17.838 19.3158C17.8863 19.5972 17.7706 19.8815 17.5396 20.0493C17.3087 20.2171 17.0025 20.2393 16.7498 20.1064L12 17.6093L7.25025 20.1064C6.99756 20.2393 6.69136 20.2171 6.4604 20.0493C6.22944 19.8815 6.11378 19.5972 6.16203 19.3158L7.06916 14.0268L3.22651 10.2811C3.02208 10.0818 2.94851 9.78377 3.03673 9.51227C3.12495 9.24076 3.35966 9.04288 3.64217 9.00182L8.95258 8.23017L11.3275 3.41808C11.4538 3.16208 11.7145 3 12 3Z"
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ct = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Support-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Support-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.5 9C16.5 6.51472 14.4853 4.5 12 4.5C9.51472 4.5 7.5 6.51472 7.5 9V15.75H6.75C4.67893 15.75 3 14.0711 3 12C3 10.1722 4.30762 8.64989 6.0384 8.31743C6.37724 5.32512 8.91709 3 12 3C15.0829 3 17.6228 5.32512 17.9616 8.31743C19.6924 8.64989 21 10.1722 21 12C21 13.8766 19.6216 15.4313 17.822 15.7067C17.281 17.8759 15.5594 19.5779 13.3792 20.0907C13.1499 20.6254 12.6187 21 12 21C11.1716 21 10.5 20.3284 10.5 19.5C10.5 18.6716 11.1716 18 12 18C12.4863 18 12.9186 18.2315 13.1927 18.5902C15.0991 18.0675 16.5 16.3224 16.5 14.25V9ZM6 9.87803C5.12611 10.1869 4.5 11.0203 4.5 12C4.5 12.9797 5.12611 13.8131 6 14.122V9.87803ZM18 9.87803C18.8739 10.1869 19.5 11.0203 19.5 12C19.5 12.9797 18.8739 13.8131 18 14.122V9.87803Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9.96967 13.9697C10.2626 13.6768 10.7374 13.6768 11.0303 13.9697C11.5659 14.5052 12.4341 14.5052 12.9697 13.9697C13.2626 13.6768 13.7374 13.6768 14.0303 13.9697C14.3232 14.2626 14.3232 14.7374 14.0303 15.0303C12.909 16.1516 11.091 16.1516 9.96967 15.0303C9.67678 14.7374 9.67678 14.2626 9.96967 13.9697Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.25 9C10.6642 9 11 9.33579 11 9.75V11C11 11.4142 10.6642 11.75 10.25 11.75C9.83579 11.75 9.5 11.4142 9.5 11V9.75C9.5 9.33579 9.83579 9 10.25 9Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.75 9C14.1642 9 14.5 9.33579 14.5 9.75V11C14.5 11.4142 14.1642 11.75 13.75 11.75C13.3358 11.75 13 11.4142 13 11V9.75C13 9.33579 13.3358 9 13.75 9Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), wt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Ticket-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Ticket-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", { d: "M13 10.5H14.5V13.5H13V10.5Z" }), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22 7V10.5H20.5C19.6716 10.5 19 11.1716 19 12C19 12.8284 19.6716 13.5 20.5 13.5H22V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V13.5H3.5C4.32843 13.5 5 12.8284 5 12C5 11.1716 4.32843 10.5 3.5 10.5H2V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7ZM3.5 7C3.5 6.72386 3.72386 6.5 4 6.5H13V9H14.5V6.5H20C20.2761 6.5 20.5 6.72386 20.5 7V9C18.8431 9 17.5 10.3431 17.5 12C17.5 13.6569 18.8431 15 20.5 15V17C20.5 17.2761 20.2761 17.5 20 17.5H14.5V15H13V17.5H4C3.72386 17.5 3.5 17.2761 3.5 17V15C5.15685 15 6.5 13.6569 6.5 12C6.5 10.3431 5.15685 9 3.5 9V7Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Tt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Time-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Time-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 5.75C12.4142 5.75 12.75 6.08579 12.75 6.5V12C12.75 12.4142 12.4142 12.75 12 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H11.25V6.5C11.25 6.08579 11.5858 5.75 12 5.75Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Et = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Timer-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Timer-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V9C11.25 8.58579 11.5858 8.25 12 8.25Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.75 2C7.33579 2 7 2.33579 7 2.75C7 3.16421 7.33579 3.5 7.75 3.5H11.25V5.03263C6.90686 5.41233 3.5 9.05831 3.5 13.5C3.5 18.1944 7.30558 22 12 22C16.6944 22 20.5 18.1944 20.5 13.5C20.5 11.5506 19.8438 9.75448 18.7402 8.32049L20.2803 6.78033C20.5732 6.48744 20.5732 6.01256 20.2803 5.71967C19.9874 5.42678 19.5126 5.42678 19.2197 5.71967L17.7236 7.21576C16.3863 5.99708 14.6585 5.19949 12.75 5.03263V3.5H16.25C16.6642 3.5 17 3.16421 17 2.75C17 2.33579 16.6642 2 16.25 2H7.75ZM5 13.5C5 9.63401 8.13401 6.5 12 6.5C15.866 6.5 19 9.63401 19 13.5C19 17.366 15.866 20.5 12 20.5C8.13401 20.5 5 17.366 5 13.5Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Dt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Tracking-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Tracking-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M12 2.5C12.878 2.50008 13.625 3.18848 13.625 4.08008V16.1396L18.7334 11.2354C19.3662 10.6282 20.3839 10.6282 21.0166 11.2354C21.6608 11.8539 21.6608 12.8658 21.0166 13.4844L13.1416 21.0439C12.5088 21.6514 11.4912 21.6514 10.8584 21.0439L2.9834 13.4844C2.33908 12.8658 2.33908 11.8539 2.9834 11.2354C3.61617 10.6282 4.63387 10.6282 5.2666 11.2354L10.375 16.1396V4.08008C10.375 3.18843 11.122 2.5 12 2.5Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ot = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Trash-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Trash-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M8.75 3C8.33579 3 8 3.33579 8 3.75V6.5H3.75C3.33579 6.5 3 6.83579 3 7.25C3 7.66421 3.33579 8 3.75 8H20.25C20.6642 8 21 7.66421 21 7.25C21 6.83579 20.6642 6.5 20.25 6.5H16V3.75C16 3.33579 15.6642 3 15.25 3H8.75ZM14.5 6.5V4.5H9.5V6.5H14.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M6.5 9.5H5V17.9999C5 19.6567 6.34315 20.9999 8 20.9999H16C17.6569 20.9999 19 19.6567 19 17.9999V9.5H17.5V17.9999C17.5 18.8283 16.8284 19.4999 16 19.4999H8C7.17157 19.4999 6.5 18.8283 6.5 17.9999V9.5Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.5 9.5V17.25C10.5 17.6642 10.1642 18 9.75 18C9.33579 18 9 17.6642 9 17.25V9.5H10.5Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15 9.5V17.25C15 17.6642 14.6642 18 14.25 18C13.8358 18 13.5 17.6642 13.5 17.25V9.5H15Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), kt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Under12-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Under12-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M8.15982 12.305V13.745H4.24482V12.305H8.15982ZM11.453 6.875V17H9.98303V8.345H9.35303V6.875H11.453ZM13.4095 17V15.92L16.9045 11.96C17.8795 10.865 18.2245 10.235 18.2245 9.545C18.2245 8.615 17.6095 8.03 16.6345 8.03C15.5995 8.03 14.9395 8.66 14.9095 9.695H13.4395C13.4845 7.82 14.7295 6.65 16.6945 6.65C18.5995 6.65 19.7545 7.715 19.7545 9.47C19.7545 10.52 19.3045 11.42 18.1345 12.725L15.5545 15.59H19.7395V17H13.4095Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), At = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Under16-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Under16-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M8.02066 12.305V13.745H4.10566V12.305H8.02066ZM11.3139 6.875V17H9.84387V8.345H9.21387V6.875H11.3139ZM16.7088 17.225C14.5338 17.225 13.1238 15.785 13.1238 13.58C13.1238 11.915 13.6788 10.625 15.1638 8.9L16.9338 6.8H18.7638L15.0438 11.15L15.0888 11.18C15.6738 10.55 16.2888 10.265 17.0688 10.265C18.9588 10.265 20.2638 11.675 20.2638 13.715C20.2638 15.785 18.8088 17.225 16.7088 17.225ZM16.6938 15.845C17.9388 15.845 18.7338 15.005 18.7338 13.715C18.7338 12.425 17.9388 11.6 16.6788 11.6C15.4338 11.6 14.6388 12.44 14.6388 13.73C14.6388 15.02 15.4338 15.845 16.6938 15.845Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), jt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Under18-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Under18-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M7.99137 12.305V13.745H4.07637V12.305H7.99137ZM11.2846 6.875V17H9.81457V8.345H9.18457V6.875H11.2846ZM16.6195 17.225C14.5045 17.225 13.1695 16.055 13.1695 14.195C13.1695 12.905 13.8745 11.93 15.0295 11.585V11.555C14.0845 11.27 13.4545 10.37 13.4545 9.32C13.4545 7.715 14.7145 6.65 16.6195 6.65C18.5245 6.65 19.7845 7.715 19.7845 9.32C19.7845 10.37 19.1545 11.27 18.2095 11.555V11.585C19.3645 11.93 20.0695 12.905 20.0695 14.195C20.0695 16.055 18.7345 17.225 16.6195 17.225ZM16.6195 10.925C17.6095 10.925 18.2395 10.355 18.2395 9.44C18.2395 8.525 17.6245 7.955 16.6195 7.955C15.6145 7.955 14.9995 8.525 14.9995 9.44C14.9995 10.355 15.6295 10.925 16.6195 10.925ZM16.6195 15.92C17.8345 15.92 18.5245 15.245 18.5245 14.075C18.5245 12.965 17.7895 12.26 16.6195 12.26C15.4495 12.26 14.7145 12.965 14.7145 14.075C14.7145 15.245 15.4045 15.92 16.6195 15.92Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Mt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Under3-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#Under3-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("path", { d: "M10.1007 12.305V13.745H6.18574V12.305H10.1007ZM14.5045 6.65C16.3795 6.65 17.6095 7.685 17.6095 9.245C17.6095 10.43 16.9345 11.315 15.7945 11.585V11.615C17.1895 11.78 17.9695 12.695 17.9695 14.18C17.9695 16.07 16.7095 17.225 14.6245 17.225C12.5395 17.225 11.2795 16.13 11.2195 14.285H12.6895C12.7645 15.275 13.4845 15.845 14.6245 15.845C15.8095 15.845 16.4245 15.245 16.4245 14.09C16.4245 12.845 15.7195 12.335 14.0395 12.365H13.5595V11.045H14.0395C15.3895 11.045 16.0795 10.52 16.0795 9.5C16.0795 8.555 15.5095 8.03 14.4745 8.03C13.4245 8.03 12.8095 8.54 12.7795 9.455H11.3095C11.3695 7.73 12.5995 6.65 14.5045 6.65Z" })
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Nt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Upload-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Upload-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.75 16.25C4.16421 16.25 4.5 16.5858 4.5 17V17.25C4.5 18.4926 5.50736 19.5 6.75 19.5H17.25C18.4926 19.5 19.5 18.4926 19.5 17.25V17C19.5 16.5858 19.8358 16.25 20.25 16.25C20.6642 16.25 21 16.5858 21 17V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V17C3 16.5858 3.33579 16.25 3.75 16.25Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.5303 9.28033C17.8232 8.98744 17.8232 8.51256 17.5303 8.21967L12.5303 3.21967C12.2374 2.92678 11.7626 2.92678 11.4697 3.21967L6.46967 8.21967C6.17678 8.51256 6.17678 8.98744 6.46967 9.28033C6.76256 9.57322 7.23744 9.57322 7.53033 9.28033L11.25 5.56066V15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5V5.56066L16.4697 9.28033C16.7626 9.57322 17.2374 9.57322 17.5303 9.28033Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Pt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Visibility-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Visibility-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.004 4.5C15.7816 4.5 18.2885 6.33204 19.8281 8.13865C21.2671 9.82718 21.8733 11.4873 21.9593 11.7328C22.0095 11.879 22.0178 12.0937 21.9683 12.241C21.5133 13.5608 20.7278 14.8057 19.8281 15.8614C18.2885 17.668 15.7816 19.5 12.004 19.5C8.22651 19.5 5.71953 17.668 4.17994 15.8614C2.74098 14.1728 2.13478 12.5127 2.0488 12.2672C1.99225 12.1038 1.98338 11.9281 2.0385 11.7628C2.50731 10.4416 3.2744 9.20125 4.17994 8.13865C5.71953 6.33204 8.22651 4.5 12.004 4.5ZM12.004 6C8.77873 6 6.65885 7.54296 5.32227 9.11135C4.31105 10.298 3.75603 11.4996 3.55267 12C3.75603 12.5004 4.31105 13.702 5.32227 14.8886C6.65885 16.457 8.77873 18 12.004 18C15.2293 18 17.3492 16.457 18.6858 14.8886C19.6923 13.7076 20.2468 12.5118 20.4525 12.0071C19.9832 10.964 19.4331 9.98829 18.6858 9.11135C17.3492 7.54296 15.2293 6 12.004 6Z"
			}), /* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
			})]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ft = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "VisibilityOff-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsx)("g", {
			clipPath: n ? "url(#VisibilityOff-clip)" : void 0,
			children: /* @__PURE__ */ (0, c.jsx)("g", {
				color: "var(--_1gzv7bh9)",
				children: /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					d: "M20.6364 3.82975c.1953-.19526.1953-.51184 0-.70711-.1952-.19526-.5118-.19526-.7071 0l-3.3142 3.31425c-1.3935-.89834-3.0469-1.55591-4.9044-1.55591-3.05376 0-5.55576 1.77722-7.25832 3.47978-.85762.85763-1.52992 1.71354-1.98783 2.35464-.22927.3209-.40562.5892-.52535.7785-.05988.0946-.10566.1696-.13688.2216-.01561.026-.02758.0463-.03586.0605l-.00963.0165-.00273.0048-.00084.0014-.00029.0005c-.00011.0002-.0002.0004.43392.2484l-.43412-.248c-.08784.1537-.08784.3424 0 .4961l.43412-.2481c-.43412.2481-.43403.2483-.43392.2485l.00029.0005.00084.0014.00273.0048.00963.0165c.00828.0142.02025.0345.03586.0605.03122.052.077.127.13688.2216.11973.1893.29608.4576.52535.7785.45791.6411 1.13021 1.497 1.98783 2.3546.45315.4532.96292.9116 1.52466 1.3404l-3.19058 3.1906c-.19526.1953-.19526.5118 0 .7071.19526.1953.51185.1953.70711 0l3.31364-3.3136c1.39329.898 3.04636 1.5553 4.90349 1.5553 3.0538 0 5.5558-1.7772 7.2583-3.4798.8576-.8576 1.5299-1.7135 1.9879-2.3546.2292-.3209.4056-.5892.5253-.7785.0599-.0946.1057-.1696.1369-.2216.0156-.026.0276-.0463.0358-.0605l.0097-.0165.0027-.0048.0008-.0014.0003-.0005c.0001-.0002.0002-.0004-.4339-.2485l.4341.2481c.0879-.1537.0879-.3424 0-.4961l-.4341.248c.4341-.248.434-.2482.4339-.2484l-.0003-.0005-.0008-.0014-.0027-.0048-.0097-.0165c-.0082-.0142-.0202-.0345-.0358-.0605-.0312-.052-.077-.127-.1369-.2216-.1197-.1893-.2961-.4576-.5253-.7785-.458-.6411-1.1303-1.49701-1.9879-2.35464-.4529-.45292-.9624-.91113-1.5238-1.33976l3.1912-3.19125Zm-4.7462 3.33203c-1.2288-.75759-2.6368-1.2808-4.1795-1.2808-2.66052 0-4.92043 1.55611-6.55121 3.18689-.80904.80904-1.44627 1.61983-1.88121 2.22873-.21716.304-.38308.5566-.494.7319l-.01208.0191.01208.0192c.11092.1753.27684.4279.494.7319.43494.6089 1.07217 1.4197 1.88121 2.2287.46175.4618.97394.9175 1.53138 1.3337l2.31977-2.3198c-.41212-.5575-.65578-1.2471-.65578-1.9936 0-1.8541 1.50304-3.35715 3.35714-3.35715.7465 0 1.4361.24366 1.9936.65579l2.1846-2.18456Zm-1.4774 2.89162 2.3186-2.31858c.5571.41598 1.069.87153 1.5305 1.33305.809.80904 1.4463 1.61983 1.8812 2.22873.2172.304.3831.5566.494.7319l.0121.0191-.0121.0192c-.1109.1753-.2768.4279-.494.7319-.4349.6089-1.0722 1.4197-1.8812 2.2287-1.6308 1.6308-3.8907 3.1869-6.5512 3.1869-1.5423 0-2.95004-.5229-4.17859-1.2802l2.18555-2.1856c.55764.4125 1.24754.6563 1.99434.6563 1.8541 0 3.3571-1.503 3.3571-3.3571 0-.7468-.2438-1.4367-.6563-1.9943Zm-1.4257.0115c-.3676-.2369-.8053-.37435-1.2751-.37435-1.3018 0-2.35714 1.05535-2.35714 2.35715 0 .4698.13744.9075.37431 1.2751l3.25793-3.2579Zm-2.551 3.9651 3.2582-3.2582c.2372.3678.3748.8058.3748 1.2759 0 1.3018-1.0553 2.3571-2.3571 2.3571-.4701 0-.9081-.1376-1.2759-.3748Z",
					clipRule: "evenodd"
				}) })
			})
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), It = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Warning-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Warning-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20.4361 17.7587L12.4316 3.74322C12.2398 3.41118 11.7606 3.41118 11.5689 3.74322L3.56389 17.7587C3.37219 18.0908 3.61182 18.5 3.99523 18.5H20.0048C20.3882 18.5 20.6278 18.0908 20.4361 17.7587ZM13.7256 2.99613C12.9587 1.66796 11.0417 1.66796 10.2749 2.99613L2.26988 17.0116C1.50306 18.3398 2.46159 20 3.99523 20H20.0048C21.5384 20 22.4969 18.3398 21.7301 17.0116L13.7256 2.99613Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M13.0001 16C13.0001 16.5523 12.5524 17 12.0001 17C11.4478 17 11.0001 16.5523 11.0001 16C11.0001 15.4477 11.4478 15 12.0001 15C12.5524 15 13.0001 15.4477 13.0001 16Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12.0001 7.75C12.5664 7.75 13.0165 8.22576 12.9851 8.79122L12.749 13.0416C12.7269 13.439 12.3982 13.75 12.0001 13.75C11.6021 13.75 11.2733 13.439 11.2513 13.0416L11.0151 8.79122C10.9837 8.22576 11.4338 7.75 12.0001 7.75Z"
				})
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Lt = ({ size: e = 24, iconColor: t = "#5F7B80", strikeThrough: n = !1, strikeThroughColor: r = "currentColor", ...i }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: t,
	xmlns: "http://www.w3.org/2000/svg",
	...i,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "Wifi-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: n ? "url(#Wifi-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 18.5C12.6904 18.5 13.25 17.9404 13.25 17.25C13.25 16.5596 12.6904 16 12 16C11.3096 16 10.75 16.5596 10.75 17.25C10.75 17.9404 11.3096 18.5 12 18.5ZM12 20C13.5188 20 14.75 18.7688 14.75 17.25C14.75 15.7312 13.5188 14.5 12 14.5C10.4812 14.5 9.25 15.7312 9.25 17.25C9.25 18.7688 10.4812 20 12 20Z"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M2 8.70845L3.10515 9.74859C3.536 9.11996 4.07735 8.55237 4.63341 8.06304C6.07518 6.79427 8.45288 5.5 12 5.5C15.5471 5.5 17.9233 6.79427 19.365 8.06304C19.921 8.5523 20.4625 9.11988 20.8933 9.7485L22 8.70692C21.5214 8.05039 20.9437 7.45416 20.356 6.93696C18.6728 5.45572 15.9529 4 12 4C8.04712 4 5.32569 5.45572 3.64246 6.93696C3.05268 7.45598 2.47782 8.05218 2 8.70845Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M19.3846 11.1233L18.275 12.1677C18.035 11.8327 17.7114 11.4374 17.2967 11.0445C16.2204 10.0248 14.5225 9 12 9C9.47739 9 7.77959 10.0248 6.70328 11.0445C6.34932 11.3798 6.00932 11.7545 5.71708 12.1602L4.61499 11.1229C4.93588 10.7014 5.29755 10.31 5.67166 9.95554C6.97035 8.7252 9.02255 7.5 12 7.5C14.9774 7.5 17.0296 8.7252 18.3283 9.95554C18.7019 10.3095 19.0636 10.7014 19.3846 11.1233Z" }),
				/* @__PURE__ */ (0, c.jsx)("path", { d: "M16.841 13.5173L15.7121 14.5798C15.6039 14.3707 15.387 14.0102 15.0321 13.6553C14.4681 13.0914 13.528 12.5 11.9999 12.5C10.4718 12.5 9.53171 13.0914 8.96773 13.6553C8.70214 13.9209 8.45459 14.2344 8.28507 14.5771L7.15942 13.5177C7.37318 13.1803 7.63294 12.8688 7.90707 12.5947C8.71809 11.7836 10.028 11 11.9999 11C13.9718 11 15.2817 11.7836 16.0927 12.5947C16.367 12.869 16.6272 13.1801 16.841 13.5173Z" })
			]
		}),
		n && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: r,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Rt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagCs-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagCs-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_2430)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M11.1305 12C11.1305 12 4.93481 19.0725 4.92896 19.0711C6.73856 20.8807 9.2386 22 12 22C17.5229 22 22 17.5228 22 12H11.1305Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M4.92893 4.92889C1.02369 8.83413 1.02369 15.1658 4.92893 19.0711C6.54271 17.4573 8.09478 15.9052 12 12L4.92893 4.92889Z",
						fill: "#0052B4"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_2430",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), zt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagDe-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagDe-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_2554)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.62195 15.4782C4.03488 19.2862 7.70031 22 12 22C16.2996 22 19.965 19.2862 21.378 15.4782L12 14.6087L2.62195 15.4782Z",
						fill: "#FFDA44"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 2C7.70031 2 4.03488 4.71375 2.62195 8.52176L12 9.39129L21.378 8.52172C19.965 4.71375 16.2996 2 12 2Z",
						fill: "black"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.62199 8.52173C2.22004 9.60505 2 10.7768 2 12C2 13.2232 2.22004 14.3949 2.62199 15.4782H21.378C21.78 14.3949 22 13.2232 22 12C22 10.7768 21.78 9.60505 21.378 8.52173H2.62199Z",
						fill: "#D80027"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_2554",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Bt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagEn-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagEn-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3143)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M4.06718 5.91174C3.28167 6.93374 2.68937 8.11167 2.34448 9.39131H7.54675L4.06718 5.91174Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M21.6556 9.3914C21.3107 8.11179 20.7183 6.93386 19.9329 5.91187L16.4534 9.3914H21.6556Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.34448 14.6088C2.6894 15.8884 3.28171 17.0663 4.06718 18.0883L7.54663 14.6088H2.34448Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M18.0882 4.06722C17.0662 3.28171 15.8883 2.6894 14.6086 2.34448V7.54671L18.0882 4.06722Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M5.91187 19.9328C6.93386 20.7183 8.11179 21.3106 9.3914 21.6556V16.4534L5.91187 19.9328Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.39136 2.34448C8.11175 2.6894 6.93382 3.28171 5.91187 4.06718L9.39136 7.54667V2.34448Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.6086 21.6556C15.8883 21.3106 17.0662 20.7183 18.0881 19.9329L14.6086 16.4534V21.6556Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M16.4534 14.6088L19.9329 18.0883C20.7183 17.0663 21.3107 15.8884 21.6556 14.6088H16.4534Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M21.9154 10.6957H13.3044H13.3044V2.08465C12.8774 2.02906 12.4421 2 12 2C11.5579 2 11.1226 2.02906 10.6957 2.08465V10.6956V10.6956H2.08465C2.02906 11.1226 2 11.5579 2 12C2 12.4421 2.02906 12.8774 2.08465 13.3043H10.6956H10.6956V21.9154C11.1226 21.9709 11.5579 22 12 22C12.4421 22 12.8774 21.971 13.3043 21.9154V13.3044V13.3044H21.9154C21.9709 12.8774 22 12.4421 22 12C22 11.5579 21.9709 11.1226 21.9154 10.6957Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.6086 14.6088L19.071 19.0711C19.2762 18.866 19.472 18.6515 19.6588 18.4292L15.8384 14.6088H14.6086V14.6088Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.39134 14.6088H9.39126L4.92896 19.0711C5.13411 19.2763 5.3486 19.4721 5.57095 19.6589L9.39134 15.8384V14.6088Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.39122 9.39142V9.39134L4.92888 4.92896C4.72364 5.13411 4.52786 5.3486 4.34106 5.57095L8.16149 9.39138H9.39122V9.39142Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.6086 9.39138L19.071 4.92896C18.8659 4.72373 18.6514 4.52794 18.429 4.34119L14.6086 8.16162V9.39138Z",
						fill: "#D80027"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3143",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Vt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagEs-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagEs-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3093)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2 12C2 13.2232 2.22004 14.395 2.62199 15.4783L12 16.3478L21.378 15.4783C21.78 14.395 22 13.2232 22 12C22 10.7768 21.78 9.60511 21.378 8.52179L12 7.65222L2.62199 8.52179C2.22004 9.60511 2 10.7768 2 12V12Z",
						fill: "#FFDA44"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M21.378 8.52176C19.965 4.71379 16.2996 2 12 2C7.70031 2 4.03488 4.71379 2.62195 8.52176H21.378Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.62195 15.4783C4.03488 19.2862 7.70031 22 12 22C16.2996 22 19.965 19.2862 21.378 15.4783H2.62195Z",
						fill: "#D80027"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3093",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ht = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagFr-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagFr-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_2546)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M22 12C22 7.70037 19.2863 4.03494 15.4783 2.62201V21.3781C19.2863 19.9651 22 16.2997 22 12Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2 12C2 16.2997 4.71379 19.9651 8.52176 21.378V2.62201C4.71379 4.03494 2 7.70037 2 12Z",
						fill: "#0052B4"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_2546",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Ut = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagHr-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagHr-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2733_2317)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M22 12C22 10.7768 21.78 9.60506 21.378 8.52178L12 8.08698L2.62199 8.52174C2.22004 9.60506 2 10.7768 2 12C2 13.2232 2.22004 14.395 2.62199 15.4783L12 15.9131L21.378 15.4783C21.78 14.395 22 13.2232 22 12Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C16.2996 22 19.965 19.2863 21.378 15.4783H2.62195C4.03488 19.2863 7.70031 22 12 22Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.62195 8.52176H21.378C19.965 4.71375 16.2996 2 12 2C7.70031 2 4.03488 4.71375 2.62195 8.52176Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.6086 8.95654H12.8695L13.1594 6.7826L14.3188 5.91302L15.4782 6.7826V8.52174L14.6086 8.95654Z",
						fill: "#338AF3"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.39126 8.95654H11.1304L10.8405 6.7826L9.6811 5.91302L8.52173 6.7826V8.52174L9.39126 8.95654Z",
						fill: "#338AF3"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M13.1595 8.95654H10.8406V6.7826L12 5.91302L13.1595 6.7826V8.95654Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M8.52173 8.52179V13.3044C8.52173 14.4432 9.07181 15.4559 9.92024 16.0908L10.529 15.9385L11.2971 16.7112C11.5242 16.758 11.7593 16.7826 12 16.7826C12.2395 16.7826 12.4733 16.7583 12.6993 16.712L13.5761 15.9819L14.0797 16.0894C14.9278 15.4545 15.4783 14.4428 15.4783 13.3044V8.52179H8.52173Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M8.52173 8.52173H9.91302V9.91302H8.52173V8.52173Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M11.3043 8.52173H12.6956V9.91302H11.3043V8.52173Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.0869 8.52173H15.4782V9.91302H14.0869V8.52173Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.91296 9.91302H11.3043V11.3043H9.91296V9.91302Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12.6957 9.91302H14.087V11.3043H12.6957V9.91302Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M8.52173 11.3039H9.91302V12.6952H8.52173V11.3039Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.91296 12.6952H11.3043V14.0865H9.91296V12.6952Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M11.3043 11.3039H12.6956V12.6952H11.3043V11.3039Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.0869 11.3039H15.4782V12.6952H14.0869V11.3039Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12.6957 12.6952H14.087V14.0865H12.6957V12.6952Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M11.3043 14.0865H12.6956V15.4778H11.3043V14.0865Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.91297 14.0866H8.61145C8.73083 14.6038 8.96551 15.077 9.28731 15.4779H9.91297V14.0866Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M14.0869 15.478H14.7125C15.0344 15.0771 15.269 14.6038 15.3884 14.0867H14.0869V15.478Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M9.91296 15.478V16.085C10.3176 16.3895 10.7905 16.6078 11.3043 16.7126V15.478H9.91296Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12.6957 15.478V16.7126C13.2095 16.6079 13.6823 16.3895 14.087 16.085V15.478H12.6957Z",
						fill: "#D80027"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2733_2317",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Wt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagHu-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagHu-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_2562)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2.62199 8.52173C2.22004 9.60509 2 10.7768 2 12C2 13.2232 2.22004 14.3949 2.62199 15.4782L12 16.3478L21.378 15.4782C21.78 14.3949 22 13.2232 22 12C22 10.7768 21.78 9.60509 21.378 8.52173L12 7.65216L2.62199 8.52173Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 2C7.70043 2 4.03496 4.71375 2.62207 8.52176H21.3781C19.9651 4.71375 16.2997 2 12 2Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C16.2997 22 19.9651 19.2863 21.3781 15.4783H2.62207C4.03496 19.2863 7.70043 22 12 22Z",
						fill: "#6DA544"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_2562",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Gt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagIt-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagIt-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_2584)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M22 12C22 7.70037 19.2863 4.03494 15.4783 2.62201V21.3781C19.2863 19.9651 22 16.2997 22 12Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2 12C2 16.2997 4.71375 19.9651 8.52176 21.378V2.62201C4.71375 4.03494 2 7.70037 2 12Z",
						fill: "#6DA544"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_2584",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Kt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagNl-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagNl-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3013)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12.0001 2C7.70043 2 4.035 4.71375 2.62207 8.52176H21.3781C19.9652 4.71375 16.2997 2 12.0001 2Z",
						fill: "#A2001D"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12.0001 22C16.2997 22 19.9652 19.2863 21.3781 15.4783H2.62207C4.035 19.2863 7.70043 22 12.0001 22Z",
						fill: "#0052B4"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3013",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), qt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagPl-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagPl-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3019)",
				children: [/* @__PURE__ */ (0, c.jsx)("path", {
					d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
					fill: "#F0F0F0"
				}), /* @__PURE__ */ (0, c.jsx)("path", {
					d: "M22 12C22 17.5228 17.5228 22 12 22C6.47719 22 2 17.5228 2 12",
					fill: "#D80027"
				})]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3019",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Jt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagPt-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagPt-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3031)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M2 12C2 16.2996 4.71375 19.9651 8.52168 21.378L9.39129 12L8.52168 2.62201C4.71375 4.03498 2 7.70037 2 12Z",
						fill: "#6DA544"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M22 12C22 6.47719 17.5229 2 12 2C10.7768 2 9.60509 2.22004 8.52173 2.62199V21.378C9.60509 21.78 10.7768 22 12 22C17.5229 22 22 17.5228 22 12Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M8.5217 15.4782C10.4427 15.4782 11.9999 13.921 11.9999 12C11.9999 10.079 10.4427 8.52173 8.5217 8.52173C6.60072 8.52173 5.04346 10.079 5.04346 12C5.04346 13.921 6.60072 15.4782 8.5217 15.4782Z",
						fill: "#FFDA44"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M6.56519 10.2609V12.4348C6.56519 13.5153 7.44112 14.3913 8.52171 14.3913C9.60229 14.3913 10.4782 13.5154 10.4782 12.4348V10.2609H6.56519Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M8.52182 13.087C8.16221 13.087 7.86963 12.7944 7.86963 12.4348V11.5652H9.17396V12.4348C9.17396 12.7944 8.88139 13.087 8.52182 13.087Z",
						fill: "#F0F0F0"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3031",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Yt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "FlagSk-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#FlagSk-clip)" : void 0,
			children: [/* @__PURE__ */ (0, c.jsxs)("g", {
				clipPath: "url(#clip0_2734_3083)",
				children: [
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C17.5228 22 22 17.5228 22 12C22 10.7768 21.78 9.60501 21.378 8.52173H2.62199C2.22004 9.60501 2 10.7768 2 12C2 17.5228 6.47719 22 12 22Z",
						fill: "#0052B4"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M12 22C16.2996 22 19.965 19.2863 21.378 15.4783H2.62195C4.03488 19.2863 7.70031 22 12 22Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M4.58582 7.65222V12.6407C4.58582 15.4784 8.29289 16.3479 8.29289 16.3479C8.29289 16.3479 11.9999 15.4784 11.9999 12.6407V7.65222H4.58582Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M5.45544 7.65222V12.6407C5.45544 12.9739 5.52943 13.2885 5.67599 13.5834H10.9099C11.0564 13.2885 11.1304 12.9739 11.1304 12.6407V7.65222H5.45544Z",
						fill: "#D80027"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M10.0321 11.1304H8.72778V10.2608H9.59735V9.39126H8.72778V8.52173H7.85821V9.39126H6.98868V10.2608H7.85821V11.1304H6.55383V12H7.85821V12.8695H8.72778V12H10.0321V11.1304Z",
						fill: "#F0F0F0"
					}),
					/* @__PURE__ */ (0, c.jsx)("path", {
						d: "M6.8622 14.7973C7.42255 15.1494 7.99826 15.3539 8.29298 15.4448C8.58771 15.3539 9.16341 15.1494 9.72377 14.7973C10.2888 14.4421 10.685 14.0359 10.9099 13.5834C10.6618 13.4079 10.3591 13.3044 10.0321 13.3044C9.91306 13.3044 9.7974 13.3185 9.68619 13.3444C9.45052 12.8089 8.91556 12.4348 8.29302 12.4348C7.67048 12.4348 7.13548 12.8089 6.89986 13.3444C6.78865 13.3185 6.67294 13.3044 6.55392 13.3044C6.22693 13.3044 5.92423 13.4079 5.67615 13.5834C5.90095 14.0359 6.29708 14.4421 6.8622 14.7973Z",
						fill: "#0052B4"
					})
				]
			}), /* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
				id: "clip0_2734_3083",
				children: /* @__PURE__ */ (0, c.jsx)("rect", {
					width: "20",
					height: "20",
					fill: "white",
					transform: "translate(2 2)"
				})
			}) })]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Xt = ({ size: e = 24, strikeThrough: t = !1, strikeThroughColor: n = "currentColor", ...r }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: e,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [
		/* @__PURE__ */ (0, c.jsx)("defs", { children: /* @__PURE__ */ (0, c.jsx)("clipPath", {
			id: "LogoBbb-clip",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 M 3 0 L 0 3 L 21 24 L 24 21 Z",
				fillRule: "evenodd"
			})
		}) }),
		/* @__PURE__ */ (0, c.jsxs)("g", {
			clipPath: t ? "url(#LogoBbb-clip)" : void 0,
			children: [
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20.9262 13.6581C20.4479 10.9098 17.7738 9.0597 14.9535 9.52584L15.7862 4.92416L12.7724 4.40625C12.5134 4.95879 11.379 7.48263 10.8281 10.3317C11.9514 11.0775 12.7745 12.2492 13.0197 13.6581C13.2815 15.1625 12.83 16.6232 11.9062 17.7146C12.1329 17.9832 12.3917 18.2321 12.6867 18.457C13.8666 19.3567 15.2944 19.7084 16.6857 19.4784C19.506 19.0123 21.4046 16.4065 20.9262 13.6581Z",
					fill: "#001536"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M11.0223 10.6449C11.0405 10.5401 11.0597 10.4358 11.0795 10.3317C10.0286 9.62277 8.71071 9.29867 7.35788 9.52584L8.1774 4.92416L5.21114 4.40625C4.94689 4.97898 3.7567 7.66944 3.24028 10.6449C2.82628 13.0303 2.84546 15.5988 4.12176 17.4064C4.39604 17.7948 4.7282 18.1483 5.12677 18.457C6.28811 19.3567 7.69342 19.7084 9.06278 19.4784C10.3193 19.2674 11.3887 18.6172 12.1406 17.7146C12.0574 17.6145 11.9783 17.5118 11.9038 17.4064C10.6275 15.5988 10.6083 13.0303 11.0223 10.6449Z",
					fill: "#FF595A"
				}),
				/* @__PURE__ */ (0, c.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.1407 13.6567C12.8811 12.1807 12.0094 10.9531 10.82 10.1719C10.7987 10.2809 10.7781 10.3902 10.7585 10.5C10.313 12.9989 10.3339 15.6896 11.7068 17.5833C11.7869 17.6938 11.8723 17.8014 11.9618 17.9062C12.9398 16.7628 13.4181 15.2326 13.1407 13.6567Z",
					fill: "white"
				})
			]
		}),
		t && /* @__PURE__ */ (0, c.jsx)("g", { children: /* @__PURE__ */ (0, c.jsx)("line", {
			x1: "20",
			y1: "20",
			x2: "4",
			y2: "4",
			stroke: n,
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}) })
	]
}), Zt = /* @__PURE__ */ n({
	FlagCs: () => Rt,
	FlagCsIllustrationIcon: () => Rt,
	FlagDe: () => zt,
	FlagDeIllustrationIcon: () => zt,
	FlagEn: () => Bt,
	FlagEnIllustrationIcon: () => Bt,
	FlagEs: () => Vt,
	FlagEsIllustrationIcon: () => Vt,
	FlagFr: () => Ht,
	FlagFrIllustrationIcon: () => Ht,
	FlagHr: () => Ut,
	FlagHrIllustrationIcon: () => Ut,
	FlagHu: () => Wt,
	FlagHuIllustrationIcon: () => Wt,
	FlagIt: () => Gt,
	FlagItIllustrationIcon: () => Gt,
	FlagNl: () => Kt,
	FlagNlIllustrationIcon: () => Kt,
	FlagPl: () => qt,
	FlagPlIllustrationIcon: () => qt,
	FlagPt: () => Jt,
	FlagPtIllustrationIcon: () => Jt,
	FlagSk: () => Yt,
	FlagSkIllustrationIcon: () => Yt,
	LogoBbb: () => Xt,
	LogoBbbIllustrationIcon: () => Xt
}), Qt = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsx)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 215 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: /* @__PURE__ */ (0, c.jsxs)("g", {
		clipPath: "url(#clip0_1478_13825)",
		children: [
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M189.009 26.8703V17.2887C189.009 17.0979 189.104 17.0024 189.295 17.0024H191.459C191.496 16.9971 191.533 17.0006 191.569 17.0128C191.605 17.0249 191.637 17.0454 191.665 17.0727C191.692 17.0999 191.713 17.1334 191.727 17.1706C191.741 17.2078 191.747 17.2478 191.744 17.2878V26.0153C191.744 28.1577 192.675 29.2289 194.535 29.2289C195.041 29.2379 195.543 29.1259 196.003 28.9009C196.464 28.676 196.871 28.3438 197.197 27.9286C197.966 26.8784 198.346 25.5612 198.265 24.2293V17.2878C198.265 17.0975 198.36 17.0024 198.551 17.0024H200.714C200.751 16.9971 200.789 17.0006 200.824 17.0128C200.86 17.025 200.893 17.0456 200.92 17.073C200.947 17.1004 200.969 17.1339 200.982 17.1713C200.996 17.2086 201.002 17.2487 200.999 17.2887V31.4167C200.999 31.6076 200.904 31.703 200.714 31.703H198.55C198.513 31.7084 198.475 31.7048 198.439 31.6926C198.403 31.6803 198.37 31.6597 198.343 31.6322C198.316 31.6046 198.294 31.5709 198.281 31.5335C198.267 31.4961 198.261 31.4558 198.264 31.4157V30.0789C197.079 31.3202 195.483 32.0075 193.826 31.9903C193.18 32.0327 192.533 31.9356 191.922 31.7046C191.312 31.4736 190.751 31.1134 190.273 30.6456C189.834 30.1412 189.496 29.5464 189.279 28.8973C189.061 28.2482 188.969 27.5586 189.009 26.8703",
				fill: "#054752"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M203 27.1391C203 26.9521 203.088 26.8586 203.263 26.8586H205.519C205.677 26.8586 205.769 26.9514 205.795 27.1371C206.048 28.5675 207.139 29.2827 209.068 29.2827C211.027 29.2827 212.007 28.6809 212.007 27.4774C211.993 27.2133 211.901 26.9595 211.745 26.7478C211.589 26.5362 211.375 26.3763 211.129 26.288C210.179 25.8882 209.18 25.6245 208.158 25.5044C206.798 25.3592 205.495 24.8658 204.373 24.0701C203.976 23.7381 203.661 23.3167 203.453 22.8394C203.244 22.3621 203.148 21.8419 203.172 21.3202C203.141 20.6835 203.277 20.0499 203.565 19.484C203.854 18.9181 204.285 18.4401 204.815 18.099C206.003 17.3452 207.384 16.9653 208.784 17.0069C210.214 16.9401 211.625 17.3592 212.794 18.1983C213.286 18.5632 213.695 19.0309 213.994 19.5699C214.293 20.1088 214.476 20.7066 214.529 21.3231C214.534 21.362 214.53 21.4016 214.518 21.4387C214.505 21.4758 214.484 21.5094 214.456 21.5367C214.429 21.564 214.395 21.5843 214.358 21.5959C214.321 21.6076 214.282 21.6102 214.244 21.6036H211.8C211.669 21.6036 211.571 21.5101 211.505 21.3231C211.139 20.2487 210.179 19.7115 208.625 19.7115C207.98 19.691 207.337 19.8127 206.743 20.0682C206.52 20.1484 206.327 20.2973 206.191 20.4943C206.055 20.6912 205.982 20.9264 205.984 21.167C205.986 21.4407 206.064 21.7083 206.21 21.9387C206.355 22.169 206.562 22.3527 206.806 22.4682C207.748 22.9054 208.75 23.1934 209.777 23.3222C211.15 23.5078 212.472 23.9716 213.665 24.686C214.107 24.9939 214.462 25.4138 214.694 25.9041C214.927 26.3944 215.03 26.9381 214.992 27.4813C215.014 28.1294 214.874 28.7727 214.586 29.3512C214.297 29.9297 213.87 30.4247 213.342 30.7902C212.049 31.6472 210.523 32.0675 208.981 31.9912C207.464 32.0529 205.972 31.5938 204.744 30.688C204.202 30.2743 203.763 29.7383 203.461 29.1224C203.158 28.5065 203 27.8275 203 27.1391Z",
				fill: "#054752"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M179.699 28.9919C181.683 28.9919 183.043 27.9726 183.043 25.6937C183.051 25.2472 182.968 24.8039 182.799 24.3927C182.631 23.9814 182.381 23.6112 182.066 23.306C181.751 23.0008 181.377 22.7673 180.97 22.6207C180.562 22.474 180.129 22.4174 179.699 22.4546H174.948V28.9919H179.699ZM178.31 19.4558C178.666 19.4837 179.023 19.4328 179.358 19.3063C179.693 19.1798 179.998 18.9808 180.253 18.7225C180.508 18.4641 180.706 18.1525 180.835 17.8084C180.964 17.4643 181.02 17.0957 181 16.7273C181.02 16.3587 180.964 15.9899 180.835 15.6456C180.706 15.3014 180.507 14.9897 180.252 14.7313C179.997 14.473 179.692 14.274 179.357 14.1476C179.021 14.0213 178.664 13.9706 178.308 13.9988H174.946V19.4568L178.31 19.4558ZM185.992 25.8729C186.034 26.6911 185.908 27.5092 185.623 28.2736C185.338 29.0381 184.9 29.7317 184.338 30.309C183.776 30.8864 183.103 31.3345 182.362 31.6242C181.621 31.9138 180.83 32.0384 180.039 31.9897H172.284C172.09 31.9897 172 31.8996 172 31.6894V11.3004C172 11.0901 172.085 11 172.284 11H178.112C181.145 11 183.951 12.8594 183.951 16.3678C184.006 17.0754 183.899 17.7865 183.638 18.443C183.377 19.0995 182.969 19.6829 182.449 20.1457C183.537 20.6072 184.462 21.4049 185.096 22.4298C185.73 23.4548 186.043 24.6572 185.992 25.8729V25.8729Z",
				fill: "#054752"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M37.7031 19.554C36.7181 13.7454 31.2107 9.8352 25.4023 10.8203L27.1171 1.09459L20.9104 0C20.3769 1.16787 18.0408 6.50195 16.9062 12.5236C19.2195 14.0998 20.9147 16.5763 21.4196 19.554C21.9589 22.7335 21.0292 25.8207 19.1266 28.1275C19.5935 28.6952 20.1265 29.2212 20.7341 29.6966C23.164 31.5981 26.1045 32.3413 28.9697 31.8554C34.7781 30.8701 38.6882 25.3628 37.7031 19.554Z",
				fill: "#054752"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.7861 13.1856C16.8242 12.964 16.8644 12.7435 16.9058 12.5236C14.7068 11.0253 11.9493 10.3402 9.11857 10.8203L10.8334 1.09459L4.62665 0C4.07372 1.21056 1.58335 6.89689 0.502766 13.1856C-0.363493 18.2271 -0.323367 23.6556 2.34721 27.476C2.92114 28.297 3.61614 29.044 4.45015 29.6966C6.88016 31.5981 9.82068 32.3413 12.6859 31.8554C15.3151 31.4094 17.5528 30.0351 19.1261 28.1275C18.952 27.9159 18.7864 27.6989 18.6306 27.476C15.96 23.6556 15.9199 18.2271 16.7861 13.1856Z",
				fill: "#FF595A"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.4192 19.5541C20.9142 16.5763 19.2189 14.0998 16.9057 12.5237C16.8642 12.7435 16.8242 12.9641 16.786 13.1856C15.9196 18.2272 15.9601 23.6557 18.6303 27.4761C18.7862 27.699 18.9522 27.9159 19.1263 28.1275C21.0285 25.8208 21.9586 22.7335 21.4192 19.5541Z",
				fill: "#2ED1FF"
			}),
			/* @__PURE__ */ (0, c.jsx)("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M160.389 16.634C160.063 16.5748 159.679 16.5452 159.294 16.5452C157.636 16.5452 156.334 17.2853 155.386 18.2921V17.1374C155.386 16.9301 155.297 16.8413 155.09 16.8413H152.781C152.573 16.8413 152.484 16.9301 152.484 17.1374V31.4078C152.484 31.6151 152.573 31.7039 152.781 31.7039H155.09C155.297 31.7039 155.386 31.6151 155.386 31.4078V23.6805C155.386 20.3349 158.08 19.0617 160.33 19.5355C160.538 19.5651 160.655 19.4763 160.655 19.269V16.9597C160.655 16.7821 160.567 16.6637 160.389 16.634ZM143.294 29.2169C141.518 29.2169 140.6 28.3879 140.6 27.0556C140.6 25.5456 141.991 24.835 143.708 24.835C145.248 24.835 146.136 25.0423 147.498 25.4569C147.498 27.8846 145.574 29.2169 143.294 29.2169ZM144.33 16.5452C141.133 16.5452 139.149 18.2031 138.35 20.3349C138.262 20.5718 138.41 20.6606 138.587 20.6901L140.985 21.075C141.163 21.1047 141.252 21.0453 141.34 20.8677C141.577 20.394 142.317 19.2098 144.33 19.2098C146.403 19.2098 147.498 20.4237 147.498 22.2594V22.7922C146.195 22.4073 145.159 22.1706 143.561 22.1706C140.245 22.1706 137.521 23.8877 137.521 27.1741C137.521 30.3124 140.097 32 142.88 32C145.159 32 146.462 31.3189 147.498 30.3124V31.4078C147.498 31.6151 147.587 31.7039 147.794 31.7039H150.104C150.311 31.7039 150.399 31.6151 150.399 31.4078V22.0521C150.399 18.6176 148.031 16.5452 144.33 16.5452ZM127.055 13.6437C129.956 13.6437 131.85 15.0056 132.709 17.9959C132.768 18.2031 132.887 18.2921 133.065 18.2921H135.462C135.699 18.2921 135.788 18.2328 135.788 17.9959C135.226 13.4661 131.703 10.6831 127.055 10.6831C122.377 10.6831 117.936 13.999 117.936 21.3415C117.936 28.684 122.377 32 127.055 32C131.703 32 135.226 29.2169 135.788 24.6871C135.788 24.4503 135.699 24.3909 135.462 24.3909H133.065C132.887 24.3909 132.768 24.4798 132.709 24.6871C131.85 27.6773 129.956 29.0393 127.055 29.0393C124.005 29.0393 121.134 26.6116 121.134 21.3415C121.134 16.0715 124.005 13.6437 127.055 13.6437ZM108.971 29.2169C107.195 29.2169 106.277 28.3879 106.277 27.0556C106.277 25.5456 107.668 24.835 109.385 24.835C110.925 24.835 111.813 25.0423 113.175 25.4569C113.175 27.8846 111.251 29.2169 108.971 29.2169ZM110.007 16.5452C106.81 16.5452 104.826 18.2031 104.027 20.3349C103.938 20.5718 104.086 20.6606 104.263 20.6901L106.661 21.075C106.839 21.1047 106.928 21.0453 107.017 20.8677C107.254 20.394 107.994 19.2098 110.007 19.2098C112.079 19.2098 113.175 20.4237 113.175 22.2594V22.7922C111.872 22.4073 110.836 22.1706 109.237 22.1706C105.922 22.1706 103.198 23.8877 103.198 27.1741C103.198 30.3124 105.774 32 108.556 32C110.836 32 112.139 31.3189 113.175 30.3124V31.4078C113.175 31.6151 113.264 31.7039 113.471 31.7039H115.78C115.988 31.7039 116.076 31.6151 116.076 31.4078V22.0521C116.076 18.6176 113.707 16.5452 110.007 16.5452ZM100.797 10.9792L98.4883 11.364C98.3103 11.3936 98.2214 11.512 98.2214 11.6896V31.4078C98.2214 31.6151 98.3103 31.7039 98.5177 31.7039H100.826C101.034 31.7039 101.122 31.6151 101.122 31.4078V11.2456C101.122 11.0384 100.975 10.9495 100.797 10.9792ZM89.5678 28.7431H84.6061V22.2889H89.5678C91.64 22.2889 93.0613 23.5917 93.0613 25.4866C93.0613 27.7366 91.64 28.7431 89.5678 28.7431ZM84.6061 13.9398H88.117C89.5972 13.9398 90.9296 14.7984 90.9296 16.634C90.9296 18.4697 89.5972 19.3283 88.117 19.3283H84.6061V13.9398ZM92.4393 20.0092C92.4393 20.0092 94.0085 18.9729 94.0085 16.2788C94.0085 12.8148 91.0774 10.9792 87.9096 10.9792H81.8229C81.6155 10.9792 81.5272 11.068 81.5272 11.2752V31.4078C81.5272 31.6151 81.6155 31.7039 81.8229 31.7039H89.9229C93.7423 31.7039 96.1402 29.1577 96.1402 25.6642C96.1402 22.3186 94.0085 20.6309 92.4393 20.0092ZM72.3584 29.2169C70.5825 29.2169 69.6642 28.3879 69.6642 27.0556C69.6642 25.5456 71.0561 24.835 72.7731 24.835C74.3122 24.835 75.2005 25.0423 76.5623 25.4569C76.5623 27.8846 74.638 29.2169 72.3584 29.2169ZM73.3945 16.5452C70.1972 16.5452 68.214 18.2031 67.4147 20.3349C67.3257 20.5718 67.4735 20.6606 67.6508 20.6901L70.0494 21.075C70.2267 21.1047 70.3156 21.0453 70.4046 20.8677C70.6414 20.394 71.3818 19.2098 73.3945 19.2098C75.4667 19.2098 76.5623 20.4237 76.5623 22.2594V22.7922C75.26 22.4073 74.2239 22.1706 72.6246 22.1706C69.309 22.1706 66.5853 23.8877 66.5853 27.1741C66.5853 30.3124 69.1611 32 71.9437 32C74.2239 32 75.5262 31.3189 76.5623 30.3124V31.4078C76.5623 31.6151 76.6513 31.7039 76.8587 31.7039H79.1677C79.375 31.7039 79.464 31.6151 79.464 31.4078V22.0521C79.464 18.6176 77.0954 16.5452 73.3945 16.5452ZM64.1841 10.9792L61.8751 11.364C61.6975 11.3936 61.6087 11.512 61.6087 11.6896V31.4078C61.6087 31.6151 61.6975 31.7039 61.9049 31.7039H64.2142C64.4215 31.7039 64.5099 31.6151 64.5099 31.4078V11.2456C64.5099 11.0384 64.362 10.9495 64.1841 10.9792ZM52.9547 28.7431H47.9931V22.2889H52.9547C55.027 22.2889 56.4482 23.5917 56.4482 25.4866C56.4482 27.7366 55.027 28.7431 52.9547 28.7431ZM47.9931 13.9398H51.5043C52.9844 13.9398 54.3165 14.7984 54.3165 16.634C54.3165 18.4697 52.9844 19.3283 51.5043 19.3283H47.9931V13.9398ZM55.8265 20.0092C55.8265 20.0092 57.3955 18.9729 57.3955 16.2788C57.3955 12.8148 54.4646 10.9792 51.2968 10.9792H45.2101C45.003 10.9792 44.9141 11.068 44.9141 11.2752V31.4078C44.9141 31.6151 45.003 31.7039 45.2101 31.7039H53.3099C57.1291 31.7039 59.5272 29.1577 59.5272 25.6642C59.5272 22.3186 57.3955 20.6309 55.8265 20.0092Z",
				fill: "#054752"
			})
		]
	})
}), $t = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 654 102",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M118.081 61.2412C114.996 43.0492 97.7474 30.8027 79.5563 33.8882L84.9268 3.42818L65.4881 0C63.8174 3.65741 56.5004 20.3635 52.9473 39.2225C60.1924 44.1589 65.5015 51.9151 67.0828 61.2412C68.7717 71.1988 65.8597 80.8678 59.9011 88.0922C61.3634 89.8701 63.0327 91.5178 64.9354 93.0066C72.5457 98.9619 81.7551 101.29 90.7289 99.7677C108.92 96.682 121.166 79.4334 118.081 61.2412Z",
			fill: "#001536"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.5723 41.2958C52.6917 40.6021 52.8175 39.9113 52.9472 39.2225C46.0601 34.5298 37.4239 32.3845 28.5584 33.8882L33.9289 3.42818L14.4902 0C12.7585 3.79111 4.95887 21.6001 1.57462 41.2958C-1.13842 57.0854 -1.01276 74.0869 7.35122 86.052C9.14865 88.6232 11.3254 90.9628 13.9373 93.0066C21.5479 98.9619 30.7573 101.29 39.7311 99.7677C47.9651 98.371 54.9733 94.0666 59.901 88.0922C59.3557 87.4297 58.8372 86.7501 58.3491 86.052C49.9851 74.0869 49.8593 57.0854 52.5723 41.2958Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M67.0831 61.2412C65.5013 51.9152 60.192 44.1589 52.9473 39.2225C52.8174 39.9113 52.6921 40.6022 52.5727 41.296C49.8592 57.0855 49.9861 74.0867 58.3488 86.0518C58.8367 86.7501 59.3567 87.4297 59.902 88.0924C65.8593 80.8678 68.7723 71.1991 67.0831 61.2412Z",
			fill: "#2ED1FF"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M163.843 100.677H138.116V36.5588H163.709C175.084 36.5588 182.549 42.8684 182.549 52.5549C182.549 59.3533 177.528 65.4407 171.13 66.5071V66.8625C179.839 67.8401 185.704 74.0164 185.704 82.5476C185.704 93.8337 177.484 100.677 163.843 100.677ZM148.069 44.6902V63.8411H159.222C167.842 63.8411 172.596 60.2864 172.596 53.9324C172.596 47.9783 168.508 44.6902 161.31 44.6902H148.069ZM148.069 92.5452H161.799C170.774 92.5452 175.529 88.8572 175.529 81.9255C175.529 74.9939 170.641 71.4392 161.221 71.4392H148.069V92.5452ZM190.75 100.677V36.5588H200.348V100.677H190.75ZM223.833 93.8782C230.543 93.8782 235.786 89.2571 235.786 83.1697V79.4817L224.278 80.1926C218.546 80.5925 215.302 83.1252 215.302 87.1243C215.302 91.2122 218.679 93.8782 223.833 93.8782ZM221.167 101.476C212.014 101.476 205.616 95.7888 205.616 87.3909C205.616 79.2151 211.881 74.1941 222.989 73.572L235.786 72.8167V69.2175C235.786 64.0188 232.276 60.9084 226.411 60.9084C220.856 60.9084 217.391 63.5745 216.546 67.7512H207.482C208.015 59.3088 215.213 53.0881 226.766 53.0881C238.097 53.0881 245.339 59.0867 245.339 68.4622V100.677H236.142V92.9895H235.919C233.209 98.1882 227.299 101.476 221.167 101.476ZM278.823 100.677H253.096V36.5588H278.689C290.064 36.5588 297.529 42.8684 297.529 52.5549C297.529 59.3533 292.508 65.4407 286.11 66.5071V66.8625C294.819 67.8401 300.684 74.0164 300.684 82.5476C300.684 93.8337 292.464 100.677 278.823 100.677ZM263.049 44.6902V63.8411H274.202C282.822 63.8411 287.576 60.2864 287.576 53.9324C287.576 47.9783 283.488 44.6902 276.29 44.6902H263.049ZM263.049 92.5452H276.779C285.754 92.5452 290.509 88.8572 290.509 81.9255C290.509 74.9939 285.621 71.4392 276.201 71.4392H263.049V92.5452ZM305.73 100.677V36.5588H315.328V100.677H305.73ZM338.813 93.8782C345.523 93.8782 350.766 89.2571 350.766 83.1697V79.4817L339.258 80.1926C333.526 80.5925 330.282 83.1252 330.282 87.1243C330.282 91.2122 333.659 93.8782 338.813 93.8782ZM336.147 101.476C326.994 101.476 320.596 95.7888 320.596 87.3909C320.596 79.2151 326.861 74.1941 337.969 73.572L350.766 72.8167V69.2175C350.766 64.0188 347.256 60.9084 341.391 60.9084C335.836 60.9084 332.371 63.5745 331.526 67.7512H322.462C322.995 59.3088 330.193 53.0881 341.746 53.0881C353.077 53.0881 360.319 59.0867 360.319 68.4622V100.677H351.121V92.9895H350.899C348.189 98.1882 342.279 101.476 336.147 101.476ZM395.136 101.743C377.14 101.743 365.765 89.0349 365.765 68.5955C365.765 48.2893 377.229 35.4924 395.136 35.4924C409.665 35.4924 420.641 44.4236 422.329 57.7981H412.465C410.687 49.5779 403.845 44.2014 395.136 44.2014C383.494 44.2014 375.94 53.7546 375.94 68.5955C375.94 83.5696 383.405 93.0339 395.18 93.0339C404.111 93.0339 410.465 88.4573 412.465 80.7258H422.373C419.93 93.967 409.888 101.743 395.136 101.743ZM443.815 93.8782C450.525 93.8782 455.768 89.2571 455.768 83.1697V79.4817L444.26 80.1926C438.528 80.5925 435.284 83.1252 435.284 87.1243C435.284 91.2122 438.661 93.8782 443.815 93.8782ZM441.149 101.476C431.996 101.476 425.598 95.7888 425.598 87.3909C425.598 79.2151 431.863 74.1941 442.971 73.572L455.768 72.8167V69.2175C455.768 64.0188 452.258 60.9084 446.392 60.9084C440.838 60.9084 437.372 63.5745 436.528 67.7512H427.464C427.997 59.3088 435.195 53.0881 446.748 53.0881C458.078 53.0881 465.321 59.0867 465.321 68.4622V100.677H456.123V92.9895H455.901C453.191 98.1882 447.281 101.476 441.149 101.476ZM471.922 100.677V53.9324H481.076V61.886H481.298C482.853 56.4207 487.03 53.177 492.539 53.177C493.917 53.177 495.117 53.3992 495.827 53.5325V62.4636C495.072 62.1526 493.384 61.9304 491.517 61.9304C485.341 61.9304 481.52 66.0627 481.52 72.6833V100.677H471.922ZM541.688 100.677H515.961V36.5588H541.555C552.93 36.5588 560.395 42.8684 560.395 52.5549C560.395 59.3533 555.374 65.4407 548.975 66.5071V66.8625C557.684 67.8401 563.55 74.0164 563.55 82.5476C563.55 93.8337 555.329 100.677 541.688 100.677ZM525.914 44.6902V63.8411H537.067C545.687 63.8411 550.442 60.2864 550.442 53.9324C550.442 47.9783 546.354 44.6902 539.156 44.6902H525.914ZM525.914 92.5452H539.644C548.62 92.5452 553.374 88.8572 553.374 81.9255C553.374 74.9939 548.487 71.4392 539.067 71.4392H525.914V92.5452ZM608.319 53.9324V100.677H599.121V92.7673H598.899C596.322 98.366 591.568 101.521 584.414 101.521C574.239 101.521 568.018 94.9001 568.018 84.1917V53.9324H577.616V82.3254C577.616 89.4348 580.992 93.2561 587.613 93.2561C594.545 93.2561 598.721 88.4573 598.721 81.1702V53.9324H608.319ZM614.254 67.1736C614.254 58.8201 621.63 53.0881 632.56 53.0881C642.958 53.0881 650.245 58.9089 650.556 67.218H641.536C641.092 62.9968 637.67 60.3752 632.294 60.3752C627.095 60.3752 623.629 62.908 623.629 66.5959C623.629 69.4841 625.94 71.4392 630.783 72.6389L638.648 74.4607C648.068 76.7268 651.622 80.2815 651.622 87.1687C651.622 95.7 643.669 101.565 632.205 101.565C621.141 101.565 613.809 95.8333 613.054 87.2576H622.563C623.318 91.7454 626.784 94.2336 632.649 94.2336C638.426 94.2336 641.98 91.8342 641.98 88.0574C641.98 85.0803 640.203 83.4363 635.315 82.1921L626.962 80.1482C618.519 78.1042 614.254 73.7053 614.254 67.1736Z",
			fill: "#ffffff"
		})
	]
}), en = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 38 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M37.7031 19.554C36.7181 13.7454 31.2107 9.8352 25.4023 10.8203L27.1171 1.09459L20.9104 0C20.3769 1.16787 18.0408 6.50195 16.9062 12.5236C19.2195 14.0998 20.9147 16.5763 21.4196 19.554C21.9589 22.7335 21.0292 25.8207 19.1266 28.1275C19.5935 28.6952 20.1265 29.2212 20.7341 29.6966C23.164 31.5981 26.1045 32.3413 28.9697 31.8554C34.7781 30.8701 38.6882 25.3628 37.7031 19.554Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.7861 13.1856C16.8242 12.964 16.8644 12.7435 16.9058 12.5236C14.7068 11.0253 11.9493 10.3402 9.11857 10.8203L10.8334 1.09459L4.62665 0C4.07372 1.21056 1.58335 6.89689 0.502766 13.1856C-0.363493 18.2271 -0.323367 23.6556 2.34721 27.476C2.92114 28.297 3.61614 29.044 4.45015 29.6966C6.88016 31.5981 9.82068 32.3413 12.6859 31.8554C15.3151 31.4094 17.5528 30.0351 19.1261 28.1275C18.952 27.9159 18.7864 27.6989 18.6306 27.476C15.96 23.6556 15.9199 18.2271 16.7861 13.1856Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.4192 19.5541C20.9142 16.5763 19.2189 14.0998 16.9057 12.5237C16.8642 12.7435 16.8242 12.9641 16.786 13.1856C15.9196 18.2272 15.9601 23.6557 18.6303 27.4761C18.7862 27.699 18.9522 27.9159 19.1263 28.1275C21.0285 25.8208 21.9586 22.7335 21.4192 19.5541Z",
			fill: "#2ED1FF"
		})
	]
}), tn = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsx)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 160 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: /* @__PURE__ */ (0, c.jsxs)("g", { children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M37.5394 19.554C36.5587 13.7454 31.0752 9.8352 25.292 10.8203L26.9994 1.09459L20.8195 0C20.2883 1.16787 17.9622 6.50195 16.8326 12.5236C19.1359 14.0998 20.8238 16.5763 21.3265 19.554C21.8634 22.7335 20.9377 25.8207 19.0433 28.1275C19.5082 28.6952 20.0389 29.2212 20.6438 29.6966C23.0633 31.5981 25.9911 32.3413 28.8439 31.8554C34.6272 30.8701 38.5203 25.3628 37.5394 19.554Z",
			fill: "#001536"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.7134 13.1856C16.7513 12.964 16.7913 12.7435 16.8325 12.5236C14.643 11.0253 11.8974 10.3402 9.07898 10.8203L10.7863 1.09459L4.6065 0C4.05596 1.21056 1.57637 6.89689 0.500468 13.1856C-0.362041 18.2271 -0.322089 23.6556 2.33693 27.476C2.90837 28.297 3.60036 29.044 4.43076 29.6966C6.85026 31.5981 9.77804 32.3413 12.6309 31.8554C15.2486 31.4094 17.4767 30.0351 19.0432 28.1275C18.8699 27.9159 18.705 27.6989 18.5498 27.476C15.8908 23.6556 15.8508 18.2271 16.7134 13.1856Z",
			fill: "#007BFF"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M159.695 16.634C159.37 16.5748 158.987 16.5453 158.604 16.5453C156.954 16.5453 155.657 17.2854 154.713 18.2921V17.1374C154.713 16.9301 154.625 16.8413 154.419 16.8413H152.119C151.913 16.8413 151.824 16.9301 151.824 17.1374V31.4078C151.824 31.6151 151.913 31.7039 152.119 31.7039H154.419C154.625 31.7039 154.713 31.6151 154.713 31.4078V23.6805C154.713 20.3349 157.396 19.0618 159.636 19.5355C159.843 19.5651 159.96 19.4763 159.96 19.2691V16.9597C159.96 16.7821 159.872 16.6637 159.695 16.634ZM142.674 29.2169C140.905 29.2169 139.991 28.388 139.991 27.0556C139.991 25.5457 141.377 24.8351 143.086 24.8351C144.619 24.8351 145.504 25.0424 146.86 25.4569C146.86 27.8846 144.944 29.2169 142.674 29.2169ZM143.706 16.5453C140.522 16.5453 138.547 18.2031 137.751 20.3349C137.663 20.5718 137.81 20.6607 137.987 20.6902L140.374 21.0751C140.551 21.1047 140.64 21.0454 140.728 20.8678C140.964 20.394 141.701 19.2099 143.706 19.2099C145.769 19.2099 146.86 20.4237 146.86 22.2594V22.7923C145.562 22.4074 144.531 22.1706 142.939 22.1706C139.638 22.1706 136.926 23.8877 136.926 27.1741C136.926 30.3125 139.491 32 142.261 32C144.531 32 145.828 31.319 146.86 30.3125V31.4078C146.86 31.6151 146.948 31.7039 147.154 31.7039H149.454C149.66 31.7039 149.748 31.6151 149.748 31.4078V22.0521C149.748 18.6177 147.39 16.5453 143.706 16.5453ZM126.504 13.6438C129.394 13.6438 131.28 15.0056 132.135 17.996C132.193 18.2031 132.311 18.2921 132.488 18.2921H134.876C135.112 18.2921 135.2 18.2328 135.2 17.996C134.64 13.4661 131.132 10.6831 126.504 10.6831C121.847 10.6831 117.426 13.999 117.426 21.3415C117.426 28.684 121.847 32 126.504 32C131.132 32 134.64 29.2169 135.2 24.6871C135.2 24.4503 135.112 24.391 134.876 24.391H132.488C132.311 24.391 132.193 24.4798 132.135 24.6871C131.28 27.6773 129.394 29.0393 126.504 29.0393C123.468 29.0393 120.609 26.6116 120.609 21.3415C120.609 16.0716 123.468 13.6438 126.504 13.6438ZM108.499 29.2169C106.73 29.2169 105.817 28.388 105.817 27.0556C105.817 25.5457 107.202 24.8351 108.911 24.8351C110.445 24.8351 111.329 25.0424 112.685 25.4569C112.685 27.8846 110.769 29.2169 108.499 29.2169ZM109.531 16.5453C106.347 16.5453 104.372 18.2031 103.576 20.3349C103.488 20.5718 103.636 20.6607 103.812 20.6902L106.2 21.0751C106.377 21.1047 106.465 21.0454 106.553 20.8678C106.79 20.394 107.526 19.2099 109.531 19.2099C111.594 19.2099 112.685 20.4237 112.685 22.2594V22.7923C111.388 22.4074 110.356 22.1706 108.764 22.1706C105.463 22.1706 102.751 23.8877 102.751 27.1741C102.751 30.3125 105.316 32 108.086 32C110.356 32 111.653 31.319 112.685 30.3125V31.4078C112.685 31.6151 112.774 31.7039 112.979 31.7039H115.279C115.485 31.7039 115.573 31.6151 115.573 31.4078V22.0521C115.573 18.6177 113.215 16.5453 109.531 16.5453ZM100.36 10.9792L98.0613 11.364C97.8842 11.3937 97.7956 11.5121 97.7956 11.6897V31.4078C97.7956 31.6151 97.8842 31.7039 98.0906 31.7039H100.39C100.596 31.7039 100.685 31.6151 100.685 31.4078V11.2456C100.685 11.0384 100.537 10.9496 100.36 10.9792ZM89.1794 28.7432H84.2393V22.2889H89.1794C91.2427 22.2889 92.6579 23.5917 92.6579 25.4866C92.6579 27.7366 91.2427 28.7432 89.1794 28.7432ZM84.2393 13.9398H87.7349C89.2087 13.9398 90.5354 14.7985 90.5354 16.634C90.5354 18.4697 89.2087 19.3283 87.7349 19.3283H84.2393V13.9398ZM92.0385 20.0092C92.0385 20.0092 93.6009 18.9729 93.6009 16.2788C93.6009 12.8148 90.6826 10.9792 87.5285 10.9792H81.4681C81.2616 10.9792 81.1737 11.068 81.1737 11.2752V31.4078C81.1737 31.6151 81.2616 31.7039 81.4681 31.7039H89.5331C93.3359 31.7039 95.7234 29.1578 95.7234 25.6642C95.7234 22.3186 93.6009 20.631 92.0385 20.0092ZM72.0446 29.2169C70.2764 29.2169 69.362 28.388 69.362 27.0556C69.362 25.5457 70.7479 24.8351 72.4575 24.8351C73.9899 24.8351 74.8744 25.0424 76.2303 25.4569C76.2303 27.8846 74.3143 29.2169 72.0446 29.2169ZM73.0762 16.5453C69.8928 16.5453 67.9181 18.2031 67.1222 20.3349C67.0337 20.5718 67.1809 20.6607 67.3574 20.6902L69.7456 21.0751C69.9221 21.1047 70.0107 21.0454 70.0992 20.8678C70.335 20.394 71.0722 19.2099 73.0762 19.2099C75.1394 19.2099 76.2303 20.4237 76.2303 22.2594V22.7923C74.9336 22.4074 73.902 22.1706 72.3097 22.1706C69.0084 22.1706 66.2964 23.8877 66.2964 27.1741C66.2964 30.3125 68.8612 32 71.6317 32C73.902 32 75.1987 31.319 76.2303 30.3125V31.4078C76.2303 31.6151 76.3189 31.7039 76.5254 31.7039H78.8244C79.0308 31.7039 79.1194 31.6151 79.1194 31.4078V22.0521C79.1194 18.6177 76.7611 16.5453 73.0762 16.5453ZM63.9057 10.9792L61.6067 11.364C61.4299 11.3937 61.3414 11.5121 61.3414 11.6897V31.4078C61.3414 31.6151 61.4299 31.7039 61.6364 31.7039H63.9356C64.1421 31.7039 64.23 31.6151 64.23 31.4078V11.2456C64.23 11.0384 64.0828 10.9496 63.9057 10.9792ZM52.7249 28.7432H47.7848V22.2889H52.7249C54.7882 22.2889 56.2032 23.5917 56.2032 25.4866C56.2032 27.7366 54.7882 28.7432 52.7249 28.7432ZM47.7848 13.9398H51.2807C52.7545 13.9398 54.0808 14.7985 54.0808 16.634C54.0808 18.4697 52.7545 19.3283 51.2807 19.3283H47.7848V13.9398ZM55.5843 20.0092C55.5843 20.0092 57.1465 18.9729 57.1465 16.2788C57.1465 12.8148 54.2283 10.9792 51.0741 10.9792H45.0138C44.8076 10.9792 44.7191 11.068 44.7191 11.2752V31.4078C44.7191 31.6151 44.8076 31.7039 45.0138 31.7039H53.0785C56.8812 31.7039 59.2689 29.1578 59.2689 25.6642C59.2689 22.3186 57.1465 20.631 55.5843 20.0092Z",
			fill: "#001536"
		})
	] })
}), nn = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsx)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 37 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: /* @__PURE__ */ (0, c.jsxs)("g", { children: [/* @__PURE__ */ (0, c.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M36.8287 19.1182C35.8664 13.439 30.4868 9.61599 24.8132 10.5792L26.4882 1.07016L20.4253 0C19.9043 1.14181 17.6221 6.35704 16.514 12.2445C18.7737 13.7855 20.4295 16.2068 20.9228 19.1182C21.4495 22.2268 20.5412 25.2453 18.6828 27.5006C19.1389 28.0556 19.6595 28.5699 20.253 29.0347C22.6266 30.8938 25.499 31.6205 28.2978 31.1454C33.9716 30.1821 37.7909 24.7975 36.8287 19.1182Z",
		fill: "#001536"
	}), /* @__PURE__ */ (0, c.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.3971 12.8918C16.4343 12.6751 16.4735 12.4595 16.514 12.2445C14.3659 10.7795 11.6724 10.1097 8.90729 10.5792L10.5823 1.07016L4.51944 0C3.97933 1.18354 1.5467 6.74316 0.491129 12.8918C-0.354987 17.8209 -0.315799 23.1284 2.29288 26.8636C2.85347 27.6663 3.5324 28.3967 4.34706 29.0347C6.72073 30.8938 9.5931 31.6205 12.3919 31.1454C14.9601 30.7093 17.1459 29.3656 18.6828 27.5006C18.5128 27.2937 18.351 27.0816 18.1988 26.8636C15.5901 23.1284 15.5509 17.8209 16.3971 12.8918Z",
		fill: "#007BFF"
	})] })
}), rn = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 375 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.2",
			d: "M43.6699 150.06L331.29 149.5L317.83 146.7L63.7299 146.26L43.6699 150.06Z",
			fill: "#8E415F"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M168.33 85.9302L162.36 86.0102C162.36 86.0102 161.45 88.7102 161.59 93.7402C161.59 93.9502 166.73 95.4102 166.73 95.4102L168.32 85.9302H168.33Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M171.98 98.71C170.8 96.63 167.02 91.87 167.02 91.87L161.71 90.99C161.71 90.99 157.89 93.69 156.93 98.2C156.89 98.37 157.26 103.11 157.26 103.11H173.3C173.3 103.11 172 98.77 171.97 98.72L171.98 98.71Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M170.34 86.97C170.17 87.66 169.24 87.69 167.7 87.98C167.69 87.98 167.67 87.98 167.66 87.98C167.47 88.01 167.24 88 166.98 87.98C166.59 87.93 166.14 87.82 165.69 87.69C164.61 87.37 163.54 86.92 163.27 86.8C161.13 85.87 160.32 81.91 160.32 80.3C160.32 76.9 163.27 76.5 165.45 76.87C166.63 77.07 167.57 77.54 168.29 78.13C169.55 79.15 170.14 81.2 170.04 81.45C169.93 81.74 169.77 82.15 169.77 82.4C169.77 82.65 170.1 83.48 170.08 83.78C170.08 83.87 170.08 83.96 170.08 84.05C170.02 86.28 170.57 86.09 170.35 86.97H170.34Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M167.9 81.13C168.05 80.95 168.93 80.41 169.82 81.02L167.9 81.13Z",
			fill: "#F5B240"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M168.83 82.37C168.99 82.37 169.12 82.2402 169.12 82.08C169.12 81.9198 168.99 81.79 168.83 81.79C168.67 81.79 168.54 81.9198 168.54 82.08C168.54 82.2402 168.67 82.37 168.83 82.37Z",
			fill: "#014753"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M169.66 81.46C170.09 82.71 170.6 83.31 170.77 83.8C170.8 83.89 170.08 84 169.99 84C169.98 84 169.6 83.51 169.52 82.94C169.43 82.25 169.65 81.46 169.65 81.46H169.66Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M164.96 88.1402C165.08 88.2002 164.29 91.4402 167.27 92.3302L167.98 87.9302L164.95 88.1402H164.96Z",
			fill: "#DDA678"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.67",
			d: "M164.22 81.8601C164.22 81.8601 164.11 83.0701 164.69 83.2901C165.09 83.4401 165.47 83.3101 165.47 83.3101C165.47 83.3101 165.26 85.0901 164.29 84.7001C163.32 84.3101 164.22 81.8601 164.22 81.8601Z",
			fill: "#DDA678"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M168.57 78.0601C168.57 78.0601 165.33 73.8801 160.54 76.7301C157.63 78.4701 158.92 82.8101 162.15 86.5201C162.19 86.5701 163.58 86.2401 163.97 85.6001C164.45 84.7901 164.42 82.4401 164.42 82.4401L166.1 82.7901C166.1 82.7901 166.54 80.9401 166.62 80.6201C166.97 79.2301 168.57 78.0601 168.57 78.0601Z",
			fill: "#F5B240"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M165.41 82.28C165.41 82.28 164.86 81.19 164.38 81.63C163.9 82.07 164.09 83.23 165.04 83.23C165.62 83.23 165.67 83.1 165.67 83.1L165.4 82.28H165.41Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M164.95 82.2901C164.95 82.0901 164.68 81.9901 164.57 82.1501C164.57 82.1601 164.55 82.1801 164.55 82.2001C164.53 82.2501 164.53 82.3001 164.54 82.3501C164.54 82.4601 164.58 82.5701 164.67 82.6401C164.76 82.7101 164.89 82.7201 164.96 82.6401V82.3001L164.95 82.2901Z",
			fill: "#DDA678"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M170.06 84.52C170.06 84.52 169.28 84.72 169.29 84.86C169.32 85.16 170.11 85.19 170.11 85.19L170.05 84.53L170.06 84.52Z",
				fill: "#FACCA3"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.3",
			d: "M170.34 86.9699C170.17 87.6599 169.24 87.6899 167.7 87.9799C167.69 87.9799 167.67 87.9799 167.66 87.9799C167.43 87.9799 167.2 87.9799 166.98 87.9799C166.69 87.9699 166.41 87.9399 166.18 87.8899C166 87.8499 165.83 87.7799 165.69 87.6899C164.63 86.9799 164.59 84.8599 164.59 84.8599L170.05 83.9399C170.05 83.9399 170.05 83.9799 170.07 84.0399C170.01 86.2699 170.56 86.0799 170.34 86.9599V86.9699Z",
			fill: "#95ABBD"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			opacity: "0.47",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M170.82 87.82C170.82 87.82 170.8 87.82 170.79 87.8C170.82 87.8 170.83 87.8 170.82 87.82Z",
				fill: "#95ABBD"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M164.52 80.02C164.52 80.02 169.55 80.25 170.25 79.61C170.95 78.97 173.11 75.28 169.37 75.28C165.63 75.28 163.23 77.79 163.23 77.79L164.52 80.01V80.02Z",
			fill: "#F5B240"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M161.69 90.05L168.34 93.44L172.31 98.7L173.39 103.19H157.24L156.88 97.81C156.88 97.81 158.27 93.74 160.45 92.1L161.7 90.06L161.69 90.05Z",
			fill: "#2AAAD7"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M161.54 89.73L168.36 93.5L160.82 90.99L161.54 89.73Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.3",
			d: "M162.11 98.84C162.11 98.84 161.93 101.15 163.42 102.48C165.17 104.05 172.58 110.75 173.02 110.88C176.11 111.81 175.89 108.99 175.25 107.7C174.64 106.47 173.33 103.06 170.88 100.48C168.68 98.17 164.55 94.17 162.12 98.84H162.11Z",
			fill: "#8F4160"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M174.03 110.37C175.25 110.71 175.58 109.96 175.58 109.96C176.92 106 178.36 100.88 179.19 98.3501C179.35 97.8701 179.23 97.6601 179.3 97.3601L177.62 96.4001C169.44 107.49 172.8 110.03 174.02 110.37H174.03Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M178.87 93.33C178.85 93.39 179.04 92.48 179.25 92.1C179.3 92 179.17 91.41 179.28 91.01C179.3 90.95 179.06 90.6 178.9 90.25C178.77 89.97 178.97 89.76 178.97 89.76L180.07 90.98L180.16 92.24L180.33 93.7C180.33 93.7 180.06 94.03 179.46 93.89C178.97 93.78 178.88 93.36 178.88 93.33H178.87Z",
				fill: "#FACCA3"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M177.37 93.4801C177.33 93.7501 177.36 94.3201 177.34 94.5501C177.26 95.4101 177.47 95.6601 177.56 97.3301C177.66 99.1401 179.15 98.8401 179.28 98.1101C179.32 97.8701 179.31 97.5301 179.37 97.2901C179.52 96.6401 180.21 94.8901 180.35 93.8301C180.35 93.8301 180.17 93.2501 179.71 93.1701C179.13 93.0301 178.85 93.5001 178.85 93.5001C178.81 93.6401 178.76 93.8201 178.53 93.7901C178.2 93.6801 178.1 93.4901 178.09 93.1301C178.14 92.3601 177.92 92.1001 177.72 92.1001C177.72 92.3401 177.42 93.0601 177.36 93.4801H177.37Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M178.85 93.75C178.85 93.75 178.85 92.88 178.97 92.46C179 92.35 178.76 91.79 178.78 91.38C178.78 91.32 178.48 91.02 178.25 90.71C178.06 90.46 178.22 90.21 178.22 90.21L179.54 91.19L179.88 92.41L180.34 93.81C180.34 93.81 180.14 94.25 179.59 94.22C179.22 94.2 178.85 93.78 178.84 93.74L178.85 93.75Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M162.47 98.4801C162.47 98.4801 162.29 100.79 163.78 102.12C165.53 103.69 172.94 110.39 173.38 110.52C176.47 111.45 176.25 108.63 175.61 107.34C175 106.11 173.69 102.7 171.24 100.12C169.04 97.8101 164.91 93.8101 162.48 98.4801H162.47Z",
			fill: "#FACCA3"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M166.2 104.63L171.59 99.6L166.2 95.48L162.43 96.55L161.54 99.96L166.2 104.63Z",
			fill: "#008CB2"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M171.59 99.6001L166.2 104.63L166.56 104.99L171.95 99.9601L171.59 99.6001Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M128.63 81.7102C128.63 81.7102 127.82 85.5602 130.04 87.4402C134.39 91.1202 130.41 95.0802 126.88 94.1702C123.41 93.2802 124.44 85.8602 124.44 85.8602L128.63 81.7002V81.7102Z",
			fill: "#F1890E"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M127.79 82.72C127.79 82.72 127.57 86.17 129.17 88.58C131.11 91.51 129.04 94.48 127.36 94.31C127.03 94.28 124 90.36 124 90.36C124 90.36 127.01 82.71 127.79 82.72Z",
			fill: "#C98727"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M127.77 85.2902L124.23 85.1802C124.23 85.1802 122.25 87.6802 122.36 91.7402C122.36 91.9102 126.51 93.0902 126.51 93.0902L127.77 85.2902Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M122.87 93.74C122.87 93.74 122.53 96.08 124.56 100.14C126.62 104.27 133.94 109.56 134.44 109.7C137.91 110.73 138 107.94 137.28 106.49C136.67 105.28 135.06 102.6 130.71 97.26C128.7 94.79 125.25 91.41 122.88 93.72L122.87 93.74Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M118.07 100.66L121.02 112.43L129.83 112.51L130.72 100.51L118.07 100.66Z",
			fill: "#E9CA91"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M128.28 102.79C128.28 102.79 132.81 103.19 132.81 100.53C132.81 99.12 132.7 100.08 128.96 94.76",
			fill: "#E9CA91"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M130.09 96.3901C129.21 95.4301 127 90.1001 127 90.1001L122.05 89.8701C122.05 89.8701 118.92 92.9601 118.47 95.4201C118.02 97.8801 118.41 100.53 118.41 100.53L129.6 100.51C129.6 100.51 130.13 96.4401 130.09 96.3901Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M120.75 91.3301C120.75 91.3301 122.29 93.1601 124.83 93.2201C127.37 93.2801 127.94 92.2701 127.94 92.2701L128.47 93.3301L132.81 99.8601C132.81 99.8601 133.72 101.95 130.55 102.81C127.38 103.66 130.55 102.81 130.55 102.81L129.83 112.51L121.03 112.42C121.03 112.42 116.99 100.99 117.79 97.0001C118.59 93.0101 120.75 91.3201 120.75 91.3201",
			fill: "#00B2B2"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M118.81 103.6C118.81 103.6 115.39 94.3401 119.92 93.8101C123.92 93.3401 126.05 101.8 126.05 101.8L118.82 103.6H118.81Z",
			fill: "#00B2B2"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M125.33 86.28C125.16 87.1 125.68 89.85 126.95 90.29L127.71 85.8L125.33 86.29V86.28Z",
			fill: "#E8B1A6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M129.11 81.8101C129.05 82.7001 129.04 83.4301 129.05 84.0201C129.05 84.1801 129.05 84.3301 129.05 84.4701C129.08 86.4601 129.16 86.7301 127.5 87.0101C126.57 87.1701 124.14 85.8101 123.94 85.4801C123.22 84.2601 122.21 82.5501 122.21 81.2701C122.21 78.5801 124.3 77.3101 126.08 77.3101C127.11 77.3101 128.54 78.2401 128.89 79.3401C129.26 80.5301 129.17 80.6701 129.1 81.8001L129.11 81.8101Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M127.4 81.4201L127.42 81.4001L127.38 81.4301C127.4 81.4301 127.42 81.4001 127.43 81.3901C127.47 81.3701 127.52 81.3501 127.55 81.3301C127.55 81.3301 127.48 81.3601 127.52 81.3401C127.53 81.3401 127.55 81.3301 127.56 81.3201C127.59 81.3201 127.61 81.3001 127.64 81.3001C127.7 81.2801 127.76 81.2701 127.83 81.2601C127.88 81.2601 127.83 81.2501 127.82 81.2601C127.82 81.2601 127.86 81.2601 127.87 81.2601C127.91 81.2601 127.94 81.2601 127.98 81.2601C128.07 81.2601 128.15 81.2601 128.24 81.2601C128.28 81.2601 128.33 81.2601 128.37 81.2701H128.44C128.44 81.2701 128.5 81.2901 128.46 81.2801C128.58 81.3001 128.69 81.3201 128.8 81.3501C128.95 81.3901 129.13 81.3001 129.17 81.1401C129.2 80.9901 129.12 80.8101 128.96 80.7701C128.53 80.6701 128.1 80.6301 127.67 80.6901C127.41 80.7301 127.16 80.8301 126.96 81.0001C126.84 81.1101 126.84 81.3201 126.96 81.4201C127.08 81.5301 127.26 81.5301 127.38 81.4201H127.4Z",
				fill: "#E8B1A6"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M128.02 82.1402C128.153 82.1402 128.26 82.0327 128.26 81.9002C128.26 81.7676 128.153 81.6602 128.02 81.6602C127.887 81.6602 127.78 81.7676 127.78 81.9002C127.78 82.0327 127.887 82.1402 128.02 82.1402Z",
				fill: "#014753"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M128.95 81.5801C128.99 81.6401 129.35 82.3701 129.57 82.6801C129.72 82.8901 129.59 82.9101 129.33 82.9801C129.31 82.9801 128.97 83.0401 128.95 83.0501C128.7 83.0701 128.94 81.5901 128.94 81.5901L128.95 81.5801Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M129.06 84.5C128.62 84.48 128.33 84.07 128.33 84.07C128.33 84.07 128.78 84.05 129.06 84.02C129.06 84.18 129.06 84.35 129.06 84.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M125.29 78.39C125.35 78.39 125.47 79.07 126.06 79.07C127.93 79.09 129.71 78.53 129.22 76.71C128.94 75.66 127.65 75.49 125.55 76.15C122.69 77.05 121.06 78.7401 120.74 79.6601C120.22 81.1501 125.28 78.39 125.28 78.39H125.29Z",
			fill: "#F1890E"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M126.97 77.6701C126.97 77.6701 127.12 79.2901 126.25 80.6901C125.87 81.3001 123.82 81.7901 123.77 82.7401C123.74 83.2101 124.47 83.9401 124.51 84.5501C124.84 88.8601 125.21 93.9901 119.37 94.3701C115.69 94.6101 113.65 93.3401 114.19 89.3501C114.37 88.0001 116.14 86.5501 119.04 86.1201C119.69 86.0201 120.21 83.0301 120.4 80.9501C120.55 79.3101 121.68 78.3401 121.68 78.3401C121.68 78.3401 125.39 76.6301 126.98 77.6601L126.97 77.6701Z",
			fill: "#F1890E"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.69",
			d: "M123.55 82.3C123.52 82.38 122.85 84.7 124.46 85.27C124.63 85.33 124.57 83.69 124.57 83.69L123.55 82.3Z",
			fill: "#C98727"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M124.68 82.53C124.68 82.53 124.05 81.77 123.66 82.13C123.27 82.49 123.97 83.86 124.41 83.7C124.85 83.54 124.87 83.32 124.87 83.32L124.68 82.53Z",
			fill: "#F9CFC4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M124.39 82.59C124.28 82.53 124.12 82.53 124.05 82.63C124.03 82.66 124.02 82.7 124.01 82.74C124 82.83 124.01 82.92 124.05 82.99C124.09 83.06 124.21 83.09 124.28 83.04",
			fill: "#E8B1A6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M254.29 81.9301C254.66 82.4101 255.1 82.8201 255.51 83.2601C256.17 83.9701 258.2 85.5201 258.18 87.3801C258.14 90.4501 256.04 91.0101 254.64 91.1101C254.24 91.1401 253.85 91.2901 253.47 91.1701C252.88 90.9801 251.58 90.4201 251.24 89.9001C250.13 88.1801 251.76 85.0401 251.24 83.0601C250.96 82.0101 250.48 79.7101 251.89 79.2301C252.4 79.0501 252.85 79.2501 253.12 79.7001C253.56 80.4301 253.75 81.2401 254.29 81.9401V81.9301Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M248.77 79.9102C248.16 80.4102 247.29 80.5802 246.54 80.3502C246.3 81.8801 245.23 83.1901 243.92 84.0201C243.55 84.2601 243.14 84.4602 242.7 84.5002C242.32 84.5302 241.95 84.4301 241.59 84.3101C240.72 84.0101 239.82 83.5202 239.46 82.6802C239.21 82.1002 239.25 81.4102 239.57 80.8702C239.89 80.3302 240.47 79.9502 241.1 79.8902C241.65 79.8302 242.2 80.0001 242.75 79.9201C243.32 79.8301 243.8 79.4701 244.21 79.0601C244.81 78.4701 245.4 77.0502 245.88 76.3602C247.61 73.8902 249.39 74.7102 250.23 74.7802C252.18 74.9402 249.97 78.9402 248.77 79.9302V79.9102Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M253.75 82.98L250.14 83.04C250.14 83.04 248.25 85.68 248.57 89.81C248.58 89.98 252.86 90.97 252.86 90.97L253.76 82.97L253.75 82.98Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M250.67 83.6102C250.77 83.6502 250.78 86.6202 253.26 87.2302L253.77 83.1802L250.66 83.6202L250.67 83.6102Z",
			fill: "#895F2C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M254.83 79.2601C254.64 80.0401 254.97 80.4101 255 80.9201C255.12 83.4201 255.43 84.3401 253.57 84.7501C252.64 84.9501 250.09 83.7001 249.88 83.3701C249.09 82.1701 247.98 80.4701 247.91 79.1701C247.78 76.4301 249.83 75.04 251.65 74.95C252.69 74.9 254.2 75.7701 254.61 76.8801C255.05 78.0701 255.1 78.1601 254.83 79.2601Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M253.25 79.2301C253.25 79.2301 253.34 79.1401 253.38 79.1001C253.42 79.0701 253.33 79.1301 253.36 79.1101L253.39 79.0901C253.39 79.0901 253.43 79.0601 253.45 79.0501C253.47 79.0401 253.49 79.0201 253.52 79.0101H253.55C253.47 79.0401 253.51 79.0101 253.53 79.0101C253.58 78.9901 253.62 78.9801 253.67 78.9701C253.69 78.9701 253.72 78.9701 253.74 78.9601C253.78 78.9601 253.66 78.9601 253.71 78.9601H253.76C253.82 78.9501 253.88 78.9501 253.94 78.9501C254.09 78.9501 254.24 78.9501 254.38 78.9501C254.54 78.9501 254.69 78.8101 254.68 78.6501C254.67 78.4901 254.55 78.3501 254.38 78.3501C254.08 78.3501 253.78 78.3301 253.49 78.3901C253.23 78.4501 253 78.6001 252.81 78.7901C252.7 78.9001 252.69 79.1001 252.81 79.2101C252.93 79.3201 253.12 79.3301 253.23 79.2101L253.25 79.2301Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M253.84 79.76C253.973 79.76 254.08 79.6525 254.08 79.52C254.08 79.3874 253.973 79.28 253.84 79.28C253.707 79.28 253.6 79.3874 253.6 79.52C253.6 79.6525 253.707 79.76 253.84 79.76Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M254.81 79.24C254.84 79.31 254.93 79.79 255.34 80.35C255.55 80.63 255.19 80.92 254.92 80.93C254.9 80.93 255.01 80.93 254.99 80.93C254.05 80.39 254.81 79.24 254.81 79.24Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M251.15 77.1399C251.29 77.1399 254.86 77.7799 255.84 76.2699C256.76 74.8499 255.57 72.6899 253.03 73.0099C249.94 73.3899 246.97 75.7199 246.66 77.1499C246.16 79.4799 251.14 77.1499 251.14 77.1499L251.15 77.1399Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M254.97 81.1902C254.97 81.1902 254.05 81.7602 254.07 81.8302C254.21 82.3702 255.01 82.3602 255.01 82.3602C255.01 82.3602 255.74 82.1602 255.26 81.7502C255.08 81.6002 255.48 81.2802 254.97 81.1802V81.1902Z",
			fill: "#6D471D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M254.07 75.8401C254.07 75.8401 252.85 80.4701 251.29 80.2701C249.73 80.0701 249.52 77.4401 249.52 77.4401L254.07 75.8301V75.8401Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M248.26 90.3601C248.26 90.3601 247.92 92.7001 249.95 96.7601C252.01 100.89 259.33 106.18 259.83 106.32C263.3 107.35 263.39 104.56 262.67 103.11C262.06 101.9 260.45 99.2201 256.1 93.8801C254.09 91.4101 250.64 88.0301 248.27 90.3401L248.26 90.3601Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M243.46 97.2801L246.42 109.05L255.22 109.13L256.11 97.1201L243.46 97.2801Z",
			fill: "#E9CA91"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M253.67 99.4101C253.67 99.4101 258.2 99.8101 258.2 97.1501C258.2 95.7401 258.09 96.7001 254.35 91.3801",
			fill: "#E9CA91"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M255.49 93.01C254.61 92.05 252.4 86.72 252.4 86.72L247.45 86.49C247.45 86.49 244.32 89.58 243.87 92.04C243.42 94.5 243.81 97.15 243.81 97.15L255 97.13C255 97.13 255.53 93.06 255.49 93.01Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M246.14 87.9402C246.14 87.9402 247.68 89.7702 250.22 89.8302C252.76 89.8902 253.33 88.8802 253.33 88.8802L253.86 89.9402L258.2 96.4702C258.2 96.4702 259.11 98.5602 255.94 99.4202C252.77 100.28 255.94 99.4202 255.94 99.4202L255.22 109.12L246.42 109.03C246.42 109.03 242.38 97.6002 243.18 93.6102C243.98 89.6202 246.14 87.9302 246.14 87.9302",
			fill: "#00737F"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M244.83 90.66C244.83 90.66 242.01 92.88 243.55 97.16C244.45 99.65 247.88 109.73 248.26 110.08C250.94 112.52 252.24 110.05 252.21 108.43C252.19 107.08 252.13 101.09 250.67 97.37C249.51 94.41 247.97 89.62 244.83 90.66Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M244.2 100.21C244.2 100.21 240.78 90.95 245.31 90.42C249.31 89.95 251.44 98.41 251.44 98.41L244.21 100.21H244.2Z",
			fill: "#005C66"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M240.95 91.48C241.89 91.77 242.9 91.48 243.82 91.14C244.82 90.76 245.8 90.32 246.74 89.81C247.1 89.61 247.47 89.4 247.71 89.07C248 88.68 248.1 88.19 248.18 87.71C248.29 87.07 248.39 86.37 248.06 85.81C247.78 85.34 247.24 85.08 246.71 85.02C244.87 84.83 242.71 86.31 241.35 87.45C240.78 87.93 239.85 88.64 239.64 89.36C239.36 90.27 240.1 91.21 240.95 91.47V91.48Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M239.86 84.0601C239.35 84.2601 238.79 84.4901 238.52 84.9701C238.33 85.3001 238.31 85.7001 238.31 86.0801C238.31 86.4701 238.33 86.8801 238.53 87.2101C238.82 87.7001 239.44 87.9001 240.01 87.9001C241.53 87.9001 242.79 86.7801 244.18 86.1601C244.79 85.8901 245.45 85.7101 246.01 85.3501C246.57 84.9901 247.05 84.3901 247.02 83.7201C246.85 80.2301 241.2 83.5401 239.86 84.0501V84.0601Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M252.88 76.56C252.88 76.56 249.86 78.77 250.77 81.62C252.41 86.8 250.87 89.83 248.1 90.84C245.33 91.85 241.51 91.82 241.44 91.47C241.37 91.12 245.85 77.6 245.85 77.6L252.88 76.55V76.56Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M251.18 80.28C251.18 80.28 250.56 79.54 250.22 79.92C249.88 80.3 250.34 81.65 250.74 81.47C251.14 81.29 251.4 81.08 251.4 81.08L251.19 80.28H251.18Z",
			fill: "#947347"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M250.76 80.3202C250.66 80.2602 250.51 80.2702 250.45 80.3802C250.43 80.4102 250.42 80.4502 250.42 80.4902C250.42 80.5802 250.42 80.6702 250.47 80.7402C250.52 80.8102 250.62 80.8402 250.68 80.7802",
			fill: "#895F2C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M84.1699 87.05L78.1899 87.13C78.1899 87.13 77.2799 89.84 77.4199 94.89C77.4199 95.1 82.5799 96.56 82.5799 96.56L84.1799 87.05H84.1699Z",
			fill: "#DDB68D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M85.8801 82.2101C85.7701 82.5101 85.6101 82.9501 85.6101 83.2201C85.6101 83.7701 85.9401 84.3601 85.9201 84.6801C85.8001 87.3401 86.4101 87.0801 86.1801 88.0501C86.0101 88.7701 85.0801 88.8101 83.5301 89.1201C82.3801 89.3501 79.5501 88.0801 79.0801 87.8701C76.9301 86.8901 76.1201 82.7101 76.1201 81.0101C76.1201 77.4201 79.0801 77.0001 81.2601 77.3901C82.4401 77.6001 83.3901 78.1001 84.1101 78.7201C85.3701 79.8001 85.9701 81.9601 85.8701 82.2201L85.8801 82.2101Z",
			fill: "#DDB68D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M83.74 82.2301C83.89 82.0501 84.78 81.5101 85.67 82.1101L83.74 82.2301Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M84.6699 83.4801C84.8301 83.4801 84.9599 83.3503 84.9599 83.1901C84.9599 83.0299 84.8301 82.9001 84.6699 82.9001C84.5098 82.9001 84.3799 83.0299 84.3799 83.1901C84.3799 83.3503 84.5098 83.4801 84.6699 83.4801Z",
			fill: "#014753"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M85.51 82.5601C85.94 83.8101 86.46 84.4101 86.62 84.9101C86.65 85.0001 85.93 85.1101 85.84 85.1101C85.81 85.1101 85.51 82.5601 85.51 82.5601Z",
			fill: "#DDB68D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M80.7899 89.2701C80.9099 89.3301 80.1199 92.5801 83.1099 93.4801L83.8299 89.0701L80.7899 89.2801V89.2701Z",
			fill: "#BC8A5C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M80.05 82.96C80.05 82.96 79.94 84.17 80.52 84.4C80.92 84.55 81.3 84.42 81.3 84.42C81.3 84.42 81.09 86.21 80.12 85.81C79.14 85.41 80.05 82.96 80.05 82.96Z",
			fill: "#BC8A5C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M86.0101 80.4202C86.0101 80.4202 83.5501 74.0402 76.9901 77.6002C74.0001 79.2202 75.1401 83.8002 77.6901 87.6702C77.7301 87.7302 79.2401 87.9202 79.6301 87.2702C80.1101 86.4602 80.2501 83.5302 80.2501 83.5302L81.9401 83.8802C81.9401 83.8802 82.1401 81.7902 82.4601 81.7002C85.5301 80.8402 86.0101 80.4002 86.0101 80.4002V80.4202Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M81.24 83.3802C81.24 83.3802 80.69 82.2802 80.21 82.7302C79.73 83.1802 79.92 84.3402 80.87 84.3402C81.45 84.3402 81.51 84.2102 81.51 84.2102L81.24 83.3902V83.3802Z",
			fill: "#DDB68D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M80.7801 83.4C80.7801 83.2 80.5101 83.1 80.4001 83.26C80.4001 83.27 80.3801 83.29 80.3801 83.31C80.3601 83.36 80.3601 83.41 80.3701 83.46C80.3701 83.57 80.4101 83.68 80.5001 83.75C80.5901 83.82 80.7201 83.83 80.7901 83.75V83.41L80.7801 83.4Z",
			fill: "#BC8A5C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M85.91 85.6301C85.91 85.6301 85.13 85.8301 85.14 85.9701C85.17 86.2701 85.97 86.3001 85.97 86.3001L85.91 85.6301Z",
			fill: "#BC8A5C"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M85.9501 85.04C85.9501 85.04 84.0901 85.19 84.0901 85.8C84.0901 85.84 85.9101 85.64 85.9101 85.64L85.9501 85.05V85.04Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M81.94 83.9001C81.88 83.8501 81.96 87.5001 83.77 87.6401C85.58 87.7801 86.19 87.5101 86.19 87.5101C86.19 87.5101 86.91 88.3801 86.42 88.8201C85.94 89.2601 83.98 90.7801 82.78 89.8901C80 87.8401 81.24 83.3801 81.24 83.3801L81.93 83.9001H81.94Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M88.17 100.23C86.99 98.1501 82.99 93.4501 82.99 93.4501L77.68 92.5701C77.68 92.5701 73.86 95.2701 72.9 99.7801C72.86 99.9501 73.23 104.69 73.23 104.69H89.27C89.27 104.69 88.2 100.29 88.17 100.23Z",
			fill: "#DDB68D"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			opacity: "0.47",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M86.78 89.4001C86.78 89.4001 86.76 89.4001 86.75 89.3801C86.78 89.3801 86.79 89.3801 86.78 89.4001Z",
				fill: "#95ABBD"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M77.6501 91.6301L84.3001 95.0201L88.2701 100.28L89.3501 104.77H73.2001L72.8401 99.3901C72.8401 99.3901 74.2301 95.3201 76.4101 93.6801L77.6601 91.6401L77.6501 91.6301Z",
			fill: "#008CB2"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M77.5 91.3101L84.32 95.0801L76.78 92.5701L77.5 91.3101Z",
			fill: "#ADECFE"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M204.07 90.6101C204.07 90.6101 200.46 90.6501 200.55 95.3801C200.59 97.6201 201.23 106.61 201.45 106.98C202.99 109.54 204.52 107.78 204.84 106.45C205.11 105.33 205.62 100.4 205.99 97.0301C206.21 94.9901 206.71 90.4101 204.07 90.6201V90.6101Z",
				fill: "#CD904D"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M208.71 91.04L205.92 87.74C205.92 87.74 198.67 88.89 197.07 92.73C194.46 99.01 194.5 109 194.5 109L204.76 109.13L208.71 91.04Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M211.46 87.4801L207.91 84.8101C207.91 84.8101 204.93 88.4001 204.62 89.3001C204.56 89.4601 208.66 91.3001 208.66 91.3001L211.46 87.4901V87.4801Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M213.68 82.59C213.66 82.86 213.42 83.22 213.46 83.38C213.56 83.84 213.46 84.41 213.39 84.67C212.83 86.8 213.11 86.65 212.77 87.39C212.51 87.94 211.89 88.27 210.66 88.22C209.75 88.18 207.96 86.21 207.65 85.95C206.2 84.75 206.33 81.23 206.63 79.85C207.27 76.95 209.59 77.17 211.17 77.9C213.52 78.98 213.75 81.58 213.68 82.59Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M212.2 82.28C212.34 82.17 212.85 82.05 213.46 82.46L212.2 82.28Z",
			fill: "#B26B26"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M212.73 83.8801C212.857 83.8801 212.96 83.7726 212.96 83.6401C212.96 83.5075 212.857 83.4001 212.73 83.4001C212.603 83.4001 212.5 83.5075 212.5 83.6401C212.5 83.7726 212.603 83.8801 212.73 83.8801Z",
			fill: "#014753"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M213.42 82.78C213.9 84.07 214.01 84.52 213.77 84.66C213.75 84.67 213.42 84.83 213.18 84.66C213.01 84.53 213.39 82.76 213.42 82.78Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.67",
			d: "M209.27 87.6001C209.34 87.6401 208.65 89.4101 209.24 90.5401L210.93 88.2001L209.26 87.6001H209.27Z",
			fill: "#B26B26"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M211.4 86.7902C212.25 87.0102 212.64 85.6102 212.55 85.4102",
			stroke: "#B26B26",
			strokeWidth: "1.03",
			strokeMiterlimit: "10"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M213.14 83.75C213.01 84.08 212.74 84.34 212.41 84.44C212.08 84.54 211.42 84.42 211.33 83.89",
			fill: "#B26B26"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M212.4 85.23C212.67 84.98 213.08 84.69 213.42 84.84L213.39 86.29L211.85 86.15C211.79 86.15 212.13 85.48 212.4 85.23Z",
			fill: "#A9B7C0"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.67",
			d: "M209.2 83.0701C209.2 83.0701 208.9 84.0301 209.3 84.3201C209.58 84.5201 209.89 84.4801 209.89 84.4801C209.89 84.4801 209.41 85.8801 208.75 85.3801C208.08 84.8701 209.2 83.0701 209.2 83.0701Z",
			fill: "#B26B26"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M215.31 80.1901C216.06 79.7901 216.52 78.9201 216.47 78.0801C216.41 77.2301 215.84 76.4501 215.06 76.1101C214.78 75.9901 214.47 75.9301 214.17 75.9701C213.48 76.0701 212.98 76.6901 212.34 76.9501C212.1 76.5101 211.55 76.2801 211.05 76.3501C210.55 76.4201 210.11 76.7301 209.81 77.1301C209.72 77.2501 209.62 77.4001 209.47 77.4101C209.35 77.4201 209.24 77.3501 209.14 77.2901C208.58 77.0101 207.89 77.2701 207.41 77.6801C206.47 78.4801 205.26 78.9701 205.91 81.4701C206.22 82.6701 206.34 83.5001 206.72 84.6801C207.82 85.0701 209.24 84.9301 209.02 83.4001C209.24 83.5701 210.09 83.1901 210.29 82.9901C210.49 82.7901 210.45 80.2201 212.43 80.0301C213.46 79.9301 214.22 80.7601 215.31 80.1701V80.1901Z",
			fill: "#A9B7C0"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M210.03 83.6402C210.03 83.6402 209.81 82.6502 209.36 82.9202C208.91 83.1902 208.92 84.3502 209.36 84.2902C209.8 84.2302 210.07 84.0602 210.07 84.0602L210.02 83.6302L210.03 83.6402Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M209.68 83.5602C209.71 83.4002 209.53 83.2702 209.42 83.3802C209.42 83.3802 209.4 83.4002 209.39 83.4102C209.37 83.4402 209.36 83.4802 209.35 83.5202C209.34 83.6102 209.35 83.7002 209.39 83.7802C209.43 83.8602 209.54 83.8802 209.61 83.8302L209.67 83.5602H209.68Z",
			fill: "#B26B26"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M205.66 87.77C205.66 87.77 198.06 89.02 196.63 92.75C196.45 93.19 194.93 97.23 194.5 103.51C194.07 109.79 194.6 108.96 194.6 108.96L204.86 109.09L208.64 91.63C208.64 91.63 205.29 89.93 205.66 87.77Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M201.1 90.5001C201.1 90.5001 198.26 92.7201 201.2 96.4201C202.59 98.1701 208.57 104.93 208.96 105.09C211.74 106.19 211.88 103.86 211.33 102.61C210.87 101.56 208.27 97.3301 206.52 94.4301C205.46 92.6801 203.07 88.7301 201.1 90.5001Z",
				fill: "#CD904D"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M201.09 90.5001C201.09 90.5001 198.25 92.7201 201.19 96.4201C202.58 98.1701 208.56 104.93 208.95 105.09C211.73 106.19 211.87 103.86 211.32 102.61C210.86 101.56 208.26 97.3301 206.51 94.4301C205.45 92.6801 203.06 88.7301 201.09 90.5001Z",
			fill: "#01353A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M303.1 112.31C303.4 113.77 305.41 113.72 305.41 113.72C309.37 112.31 313.86 110.42 316.37 109.49C316.84 109.32 316.94 109.09 317.22 108.96L316.93 107.04C303.09 107.49 302.84 111.06 303.1 112.31Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M320.13 106.11C320.07 106.13 320.91 105.72 321.33 105.64C321.44 105.62 321.83 105.15 322.21 104.98C322.27 104.96 322.4 104.55 322.57 104.21C322.71 103.93 323 103.95 323 103.95L322.72 105.58L321.78 106.44L320.73 107.48C320.73 107.48 320.3 107.47 320.04 106.91C319.83 106.45 320.09 106.12 320.12 106.1L320.13 106.11Z",
				fill: "#CD8F4D"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M319.08 105.02C318.84 105.15 318.41 105.54 318.22 105.66C317.49 106.13 317.42 106.46 316.17 107.57C314.81 108.77 315.96 109.77 316.63 109.41C316.85 109.29 317.1 109.08 317.33 108.97C317.94 108.68 319.74 108.14 320.67 107.59C320.67 107.59 321.02 107.08 320.79 106.68C320.54 106.14 319.99 106.21 319.99 106.21C319.85 106.26 319.68 106.34 319.56 106.13C319.44 105.81 319.53 105.61 319.81 105.38C320.45 104.94 320.52 104.61 320.39 104.45C320.2 104.6 319.44 104.81 319.08 105.03V105.02Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M319.79 106.36C319.79 106.36 320.47 105.82 320.88 105.66C320.99 105.62 321.27 105.08 321.62 104.84C321.67 104.81 321.72 104.38 321.82 104.01C321.9 103.71 322.19 103.67 322.19 103.67L322.24 105.32L321.49 106.35L320.67 107.58C320.67 107.58 320.2 107.7 319.88 107.24C319.66 106.93 319.77 106.38 319.79 106.35V106.36Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M294.83 100.36C294.83 100.36 294.28 102.62 295.55 104.18C297.04 106.02 302.74 113.86 304.9 113.62C308.12 113.27 306.89 112.61 306.47 111.23C306.06 109.91 305.31 106.32 303.27 103.37C301.45 100.73 297.99 96.1001 294.83 100.35V100.36Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M290.74 101.69C290.74 101.69 289.73 104.11 290.86 106.07C292.19 108.38 297.81 118.19 298.24 118.49C301.24 120.58 301.99 117.46 301.76 115.85C301.54 114.31 301.33 110.18 299.59 106.54C298.04 103.29 294.99 97.5199 290.74 101.69Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M301.13 90.6501L295.49 90.7301C295.49 90.7301 294.63 93.2801 294.76 98.0401C294.76 98.2401 299.62 99.6201 299.62 99.6201L301.13 90.6601V90.6501Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M304.79 102.67C303.67 100.7 299.89 96.2599 299.89 96.2599L294.87 95.4199C294.87 95.4199 291.26 97.9799 290.36 102.24C290.33 102.4 290.67 106.88 290.67 106.88H305.83C305.83 106.88 304.82 102.72 304.79 102.67Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M302.74 86.08C302.63 86.37 302.49 86.78 302.49 87.03C302.49 87.55 302.8 88.11 302.79 88.4C302.68 90.91 303.25 90.66 303.04 91.57C302.88 92.25 302 92.29 300.54 92.58C299.46 92.79 296.79 91.6 296.35 91.4C294.32 90.48 293.56 86.54 293.56 84.94C293.56 81.55 296.35 81.16 298.41 81.53C299.52 81.73 300.42 82.2 301.1 82.78C302.29 83.8 302.85 85.83 302.76 86.08H302.74Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M300.72 86.11C300.86 85.94 301.7 85.43 302.54 86L300.72 86.11Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M301.6 87.29C301.755 87.29 301.88 87.1646 301.88 87.01C301.88 86.8554 301.755 86.73 301.6 86.73C301.445 86.73 301.32 86.8554 301.32 87.01C301.32 87.1646 301.445 87.29 301.6 87.29Z",
			fill: "#014753"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M302.39 86.4199C302.79 87.5999 303.28 88.1699 303.44 88.6299C303.47 88.7099 302.79 88.8199 302.71 88.8199C302.69 88.8199 302.4 86.4199 302.4 86.4199H302.39Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.67",
			d: "M297.94 92.74C298.05 92.8 297.31 95.86 300.13 96.7L300.8 92.54L297.94 92.74Z",
			fill: "#B26E29"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M297.25 86.8C297.25 86.8 297.15 87.94 297.7 88.15C298.08 88.29 298.44 88.17 298.44 88.17C298.44 88.17 298.25 89.86 297.32 89.48C296.39 89.1 297.25 86.8 297.25 86.8Z",
			fill: "#B26E29"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M301.36 83.2101C301.36 83.2101 298.3 79.2601 293.77 81.9601C291.02 83.6001 292.24 87.7101 295.29 91.2101C295.33 91.2601 296.64 90.9501 297.01 90.3401C297.47 89.5801 297.43 87.3501 297.43 87.3501L299.02 87.6801C299.02 87.6801 299.43 85.9301 299.51 85.6301C299.84 84.3101 301.35 83.2101 301.35 83.2101H301.36Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M298.37 87.1902C298.37 87.1902 297.85 86.1602 297.4 86.5802C296.95 87.0002 297.13 88.0902 298.03 88.0902C298.58 88.0902 298.63 87.9602 298.63 87.9602L298.38 87.1802L298.37 87.1902Z",
			fill: "#CD904D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M297.94 87.2102C297.94 87.0202 297.69 86.9302 297.58 87.0802C297.58 87.0902 297.56 87.1102 297.56 87.1202C297.54 87.1602 297.54 87.2102 297.55 87.2602C297.55 87.3602 297.59 87.4702 297.67 87.5302C297.75 87.5902 297.88 87.6002 297.94 87.5302V87.2102Z",
			fill: "#B26E29"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M302.76 89.3101C302.76 89.3101 302.02 89.4901 302.04 89.6301C302.07 89.9101 302.82 89.9401 302.82 89.9401L302.77 89.3101H302.76Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M304.9 83.3002C304.86 82.6802 304.24 82.1302 303.63 82.2202C303.38 82.2602 303.15 82.3802 302.9 82.4202C302.65 82.4602 302.34 82.3702 302.27 82.1202C302.21 81.9102 302.34 81.7002 302.39 81.4802C302.51 80.9602 302.07 80.4502 301.56 80.3002C301.05 80.1502 300.51 80.5602 299.98 80.5302C298.41 80.4502 297 80.0702 295.17 81.2902L297.14 82.8802C297.02 82.8302 296.95 83.0202 296.97 83.1502C297.07 83.9002 297.53 84.5602 298.11 85.0402C298.42 85.3002 298.77 85.5302 299.17 85.6002C301.79 86.0502 299.84 83.3302 302.18 84.1302C302.86 84.5202 303.27 84.8402 303.87 84.6802C304.47 84.5202 304.95 83.9202 304.91 83.3002H304.9Z",
			fill: "black"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M294.44 95.52L301.39 97.89L304.91 102.66L305.79 106.33L304.5 124.1L293.74 121.61L294.88 118.07L290.48 106.08C290.48 106.08 289.44 101.62 291.55 98.96C293.66 96.3 294.45 95.51 294.45 95.51",
			fill: "#2AAAD7"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			opacity: "0.67",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M313.71 110.49C298.02 110.51 300.6 114.46 300.85 115.89L313.71 110.49Z",
				fill: "#B26E29"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M317.25 116.1C317.03 116.1 316.8 116.05 316.59 115.94C315.9 115.58 315.63 114.72 316 114.03L321.44 103.66C321.8 102.97 322.66 102.71 323.35 103.07C324.04 103.43 324.31 104.28 323.94 104.98L318.5 115.35C318.25 115.83 317.76 116.11 317.25 116.11V116.1Z",
			fill: "#022327"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.12",
			d: "M291.65 100.7C291.65 101.05 290.04 104.01 292.92 110.5C295.92 117.26 304.66 120.29 304.66 120.29L304.9 117.35L291.65 100.7Z",
			fill: "#022327"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M300.36 116.63C300.65 118.3 302.92 118.31 302.92 118.31C307.45 116.86 312.61 114.87 315.49 113.91C316.03 113.73 316.15 113.48 316.47 113.34L316.21 111.16C300.52 111.18 300.11 115.21 300.36 116.64V116.63Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M319.87 110.21C319.8 110.23 320.76 109.79 321.25 109.72C321.38 109.7 321.83 109.18 322.27 109.01C322.33 108.99 322.5 108.53 322.7 108.15C322.87 107.84 323.2 107.88 323.2 107.88L322.83 109.71L321.74 110.65L320.52 111.8C320.52 111.8 320.03 111.77 319.76 111.13C319.54 110.61 319.85 110.24 319.88 110.22L319.87 110.21Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M318.71 108.93C318.43 109.07 317.93 109.49 317.71 109.62C316.87 110.13 316.78 110.49 315.32 111.71C313.73 113.03 315.01 114.19 315.77 113.81C316.02 113.69 316.32 113.45 316.58 113.34C317.28 113.04 319.34 112.48 320.41 111.9C320.41 111.9 320.82 111.34 320.58 110.87C320.31 110.25 319.69 110.31 319.69 110.31C319.53 110.36 319.34 110.44 319.21 110.21C319.09 109.84 319.2 109.61 319.52 109.37C320.26 108.89 320.36 108.52 320.21 108.33C319.99 108.5 319.13 108.71 318.7 108.94L318.71 108.93Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M319.47 110.48C319.47 110.48 320.26 109.89 320.73 109.72C320.85 109.68 321.19 109.07 321.59 108.82C321.65 108.78 321.72 108.3 321.84 107.89C321.94 107.55 322.27 107.52 322.27 107.52V109.39L321.38 110.53L320.41 111.9C320.41 111.9 319.88 112.02 319.53 111.49C319.3 111.14 319.43 110.51 319.46 110.48H319.47Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M292.63 101.69C292.63 101.69 291.74 104.17 292.97 106.08C294.42 108.34 299.89 117.86 302.34 117.86C306.01 117.86 304.71 116.97 304.4 115.36C304.1 113.82 303.69 109.68 301.76 106.11C300.04 102.92 296.7 97.2799 292.63 101.68V101.69Z",
			fill: "#CD8F4D"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M302.21 106.66L295.35 110.37C295.35 110.37 288.99 101.72 292.46 99.9601C295.93 98.2001 300.29 98.0401 302.22 106.66H302.21Z",
			fill: "#2AAAD7"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M293.71 96.4302C293.71 96.4302 304.48 100.12 305.4 105.22C305.91 108.04 305.63 108.46 305.63 108.46C305.63 108.46 302.64 99.8502 292.31 98.0002",
			fill: "#022327"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M294.98 94.1301L298.92 96.7501L299.69 99.3701L293.37 96.4501L294.98 94.1301Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M300.9 96.5701L301.43 97.9501L300.78 99.8101L299.8 98.1701L300.9 96.5701Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M292.78 101.63L292.6 70.4799H292.31C292.31 69.9299 327.44 70.2199 330.53 70.2599C330.52 69.6799 330.51 69.1899 330.5 68.7999C330.48 67.7399 330.18 66.7099 329.62 65.8199C328.35 63.7899 325.44 60.6899 319.49 60.6899C316.87 60.6899 292.23 60.7999 258.64 60.9599C249.03 61.0099 238.68 61.0499 227.9 61.1099C197.73 61.2599 164.21 61.4199 134.05 61.5599C123.27 61.6199 112.92 61.6599 103.31 61.7099C97.49 61.7399 91.94 61.7599 86.73 61.7899C70.03 61.8699 56.8 61.9299 49.27 61.9599C49.12 61.9599 48.97 61.9599 48.83 61.9799C45.86 62.2199 43.52 64.7499 43.52 67.8299V131.06C43.52 133.98 45.64 136.46 48.49 136.87L73.09 140.39C73.36 140.43 73.62 140.45 73.89 140.45H322.86C322.86 140.45 329.19 140.45 330.46 136.16C330.6 135.71 330.7 134.56 330.78 132.88C330.86 131.27 330.92 129.17 330.96 126.71C330.98 125.42 330.99 124.02 331.01 122.55C316.81 121.63 307.29 104.37 292.76 101.63H292.78ZM51.98 102.49V70.9399H58.84C59.12 71.0299 59.42 71.0699 59.72 71.0699H88.68C88.99 71.0699 89.29 71.0199 89.57 70.9399H134.64C134.92 71.0299 135.22 71.0699 135.53 71.0699H203.44C203.75 71.0699 204.05 71.0199 204.32 70.9399H279.32L279.5 102.49H51.98ZM316.96 91.6699C320.33 91.6699 323.08 88.8699 323.08 85.4499V79.6499C323.08 76.2299 320.32 73.4299 316.96 73.4299V91.6699Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.45",
			d: "M206.46 66.53V67.77C206.46 69.12 205.56 70.28 204.32 70.66C204.04 70.75 203.74 70.79 203.44 70.79H135.53C135.22 70.79 134.92 70.74 134.64 70.66C133.4 70.28 132.5 69.12 132.5 67.77V66.53C132.5 64.87 133.86 63.51 135.53 63.51H203.44C205.1 63.51 206.46 64.87 206.46 66.53Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.45",
			d: "M91.7099 66.53V67.77C91.7099 69.12 90.81 70.28 89.57 70.66C89.29 70.75 88.99 70.79 88.68 70.79H59.72C59.41 70.79 59.11 70.74 58.84 70.66C57.6 70.28 56.7 69.12 56.7 67.77V66.53C56.7 64.87 58.0599 63.51 59.7299 63.51H88.69C90.36 63.51 91.72 64.87 91.72 66.53H91.7099Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M134.07 58.26H103.33V61.98H134.07V58.26Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M86.94 61.9701H48.29V58.1801C48.29 55.6401 50.31 53.5901 52.81 53.5901H79.03L86.93 61.9701H86.94Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M82.0399 59.7802H53.4399V57.9202C53.4399 56.6702 54.4499 55.6602 55.6999 55.6602H78.0899L82.0399 59.7802Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M258.66 58.26H227.92V61.98H258.66V58.26Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M58.8401 70.6602H89.5701C89.2901 70.7502 88.9901 70.7902 88.6801 70.7902H59.7201C59.4101 70.7902 59.1101 70.7402 58.8401 70.6602Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M134.64 70.6602H204.32C204.04 70.7502 203.74 70.7902 203.44 70.7902H135.53C135.22 70.7902 134.92 70.7402 134.64 70.6602Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.3",
			d: "M244.55 139.16V128.05C244.55 122.35 249.17 117.73 254.87 117.73H264.27C269.97 117.73 274.59 122.35 274.59 128.05V139.16H244.56H244.55Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M259.57 147.73C266.739 147.73 272.55 141.919 272.55 134.75C272.55 127.581 266.739 121.77 259.57 121.77C252.401 121.77 246.59 127.581 246.59 134.75C246.59 141.919 252.401 147.73 259.57 147.73Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.45",
			d: "M259.57 144.26C264.822 144.26 269.08 140.002 269.08 134.75C269.08 129.498 264.822 125.24 259.57 125.24C254.318 125.24 250.06 129.498 250.06 134.75C250.06 140.002 254.318 144.26 259.57 144.26Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			opacity: "0.45",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M259.57 144.27C264.828 144.27 269.09 140.008 269.09 134.75C269.09 129.492 264.828 125.23 259.57 125.23C254.312 125.23 250.05 129.492 250.05 134.75C250.05 140.008 254.312 144.27 259.57 144.27Z",
				fill: "#044752"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.86",
			d: "M259.57 142.4C263.795 142.4 267.22 138.975 267.22 134.75C267.22 130.525 263.795 127.1 259.57 127.1C255.345 127.1 251.92 130.525 251.92 134.75C251.92 138.975 255.345 142.4 259.57 142.4Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M263.23 134.75C263.23 136.77 261.59 138.41 259.57 138.41C257.55 138.41 255.91 136.77 255.91 134.75C255.91 132.73 257.55 131.09 259.57 131.09C261.59 131.09 263.23 132.73 263.23 134.75Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M159.23 129.73H154.16V131.84H159.23V129.73Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M221.86 129.73H216.79V131.84H221.86V129.73Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M317.71 129.73H312.64V131.84H317.71V129.73Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M326.01 125.5C326.01 125.5 326.09 129.5 326.51 130.1C327.31 131.24 329.09 131.66 331.14 131.56V125.5H326.01Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M323.09 79.2301V84.9301C323.09 88.3001 320.33 91.0501 316.97 91.0501V73.1101C320.34 73.1101 323.09 75.8601 323.09 79.2301Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M330.86 121.73C330.63 121.73 330.39 121.71 330.16 121.7C330.28 105.17 329.84 78.46 329.68 70.28C329.91 70.28 330.04 70.28 330.04 70.28C330.04 70.28 331.07 121.73 330.86 121.73Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M323.09 79.6599V85.4599C323.09 88.8799 320.33 91.6799 316.97 91.6799V73.4399C320.34 73.4399 323.09 76.2399 323.09 79.6599Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M43.54 112.46C45.65 108.12 49 104.71 52.99 102.49L89.26 102.64C89.35 104.43 89.4 106.26 89.39 108.11C83.87 110.49 79.29 115.02 77.01 121.09C74.58 127.57 75.28 134.46 78.35 140.1C78.21 140.21 78.07 140.33 77.93 140.44H73.56L48.51 136.86C48.51 136.86 47.3 136.64 46.7 136.28C46.1 135.92 44.99 135.09 44.99 135.09C44.99 135.09 43.54 133.37 43.54 131.82C43.54 130.27 43.54 112.44 43.54 112.44V112.46Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M118.02 140.45C122.08 133.66 123.53 124.79 123.71 116.2C123.81 111.48 123.52 106.84 123.08 102.67L106.59 102.65L106.51 107.71C100.74 105.54 94.6401 105.86 89.4001 108.13C89.4001 108.61 89.4001 109.09 89.3801 109.57C89.1501 120.55 86.8601 131.98 79.6701 138.95C79.2501 139.36 78.8101 139.75 78.3601 140.12C78.4201 140.23 78.4801 140.35 78.5501 140.46H118.03L118.02 140.45Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M77.01 121.1C79.29 115.03 83.87 110.5 89.39 108.12C89.39 108.6 89.39 109.08 89.37 109.56C89.14 120.54 86.85 131.97 79.66 138.94C79.24 139.35 78.8 139.74 78.35 140.11C75.28 134.47 74.58 127.58 77.01 121.1Z",
			fill: "#55BCD7"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M45.0899 101.78H45.0799C43.887 101.78 42.9199 102.747 42.9199 103.94V122.76C42.9199 123.953 43.887 124.92 45.0799 124.92H45.0899C46.2828 124.92 47.2499 123.953 47.2499 122.76V103.94C47.2499 102.747 46.2828 101.78 45.0899 101.78Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.3",
			d: "M82.49 139.16V128.05C82.49 122.35 87.11 117.73 92.81 117.73H102.21C107.91 117.73 112.53 122.35 112.53 128.05V139.16H82.5H82.49Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M97.5 147.73C104.669 147.73 110.48 141.919 110.48 134.75C110.48 127.581 104.669 121.77 97.5 121.77C90.3313 121.77 84.52 127.581 84.52 134.75C84.52 141.919 90.3313 147.73 97.5 147.73Z",
			fill: "#054752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.45",
			d: "M97.5 144.26C102.752 144.26 107.01 140.002 107.01 134.75C107.01 129.498 102.752 125.24 97.5 125.24C92.2478 125.24 87.99 129.498 87.99 134.75C87.99 140.002 92.2478 144.26 97.5 144.26Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("g", {
			style: { mixBlendMode: "multiply" },
			opacity: "0.45",
			children: /* @__PURE__ */ (0, c.jsx)("path", {
				d: "M97.5 144.27C102.758 144.27 107.02 140.008 107.02 134.75C107.02 129.492 102.758 125.23 97.5 125.23C92.2422 125.23 87.98 129.492 87.98 134.75C87.98 140.008 92.2422 144.27 97.5 144.27Z",
				fill: "#044752"
			})
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.86",
			d: "M97.5001 142.4C101.725 142.4 105.15 138.975 105.15 134.75C105.15 130.525 101.725 127.1 97.5001 127.1C93.2751 127.1 89.8501 130.525 89.8501 134.75C89.8501 138.975 93.2751 142.4 97.5001 142.4Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M101.16 134.75C101.16 136.77 99.5201 138.41 97.5001 138.41C95.4801 138.41 93.8401 136.77 93.8401 134.75C93.8401 132.73 95.4801 131.09 97.5001 131.09C99.5201 131.09 101.16 132.73 101.16 134.75Z",
			fill: "#044752"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M138.35 114.3C138.35 114.3 139.63 113.46 139.63 111.26C139.63 108.44 137.24 106.94 134.66 106.94H129.7C129.53 106.94 129.46 107.01 129.46 107.18V123.58C129.46 123.75 129.53 123.82 129.7 123.82H136.3C139.41 123.82 141.36 121.75 141.36 118.9C141.36 116.05 139.62 114.8 138.35 114.29V114.3ZM131.97 109.36H134.83C136.04 109.36 137.12 110.06 137.12 111.55C137.12 113.04 136.04 113.74 134.83 113.74H131.97V109.35V109.36ZM136.01 121.42H131.97V116.16H136.01C137.7 116.16 138.86 117.22 138.86 118.76C138.86 120.59 137.7 121.41 136.01 121.41V121.42ZM145.16 106.95L143.28 107.26C143.14 107.28 143.06 107.38 143.06 107.53V123.59C143.06 123.76 143.13 123.83 143.3 123.83H145.18C145.35 123.83 145.42 123.76 145.42 123.59V107.17C145.42 107 145.3 106.93 145.15 106.95H145.16ZM152.66 111.48C150.06 111.48 148.44 112.83 147.79 114.57C147.72 114.76 147.84 114.84 147.98 114.86L149.93 115.17C150.07 115.19 150.15 115.15 150.22 115C150.41 114.61 151.02 113.65 152.66 113.65C154.3 113.65 155.24 114.64 155.24 116.13V116.56C154.18 116.25 153.34 116.05 152.03 116.05C149.33 116.05 147.11 117.45 147.11 120.12C147.11 122.79 149.21 124.05 151.47 124.05C153.33 124.05 154.39 123.5 155.23 122.68V123.57C155.23 123.74 155.3 123.81 155.47 123.81H157.35C157.52 123.81 157.59 123.74 157.59 123.57V115.95C157.59 113.15 155.66 111.47 152.65 111.47L152.66 111.48ZM151.82 121.8C150.37 121.8 149.63 121.12 149.63 120.04C149.63 118.81 150.76 118.23 152.16 118.23C153.41 118.23 154.14 118.4 155.25 118.74C155.25 120.72 153.68 121.8 151.83 121.8H151.82ZM168.17 114.3C168.17 114.3 169.45 113.46 169.45 111.26C169.45 108.44 167.06 106.94 164.48 106.94H159.52C159.35 106.94 159.28 107.01 159.28 107.18V123.58C159.28 123.75 159.35 123.82 159.52 123.82H166.12C169.23 123.82 171.18 121.75 171.18 118.9C171.18 116.05 169.44 114.8 168.17 114.29V114.3ZM161.79 109.36H164.65C165.86 109.36 166.94 110.06 166.94 111.55C166.94 113.04 165.86 113.74 164.65 113.74H161.79V109.35V109.36ZM165.83 121.42H161.79V116.16H165.83C167.52 116.16 168.68 117.22 168.68 118.76C168.68 120.59 167.52 121.41 165.83 121.41V121.42ZM174.98 106.95L173.1 107.26C172.96 107.28 172.88 107.38 172.88 107.53V123.59C172.88 123.76 172.95 123.83 173.12 123.83H175C175.17 123.83 175.24 123.76 175.24 123.59V107.17C175.24 107 175.12 106.93 174.97 106.95H174.98ZM182.48 111.48C179.88 111.48 178.26 112.83 177.61 114.57C177.54 114.76 177.66 114.84 177.8 114.86L179.75 115.17C179.89 115.19 179.97 115.15 180.04 115C180.23 114.61 180.84 113.65 182.48 113.65C184.12 113.65 185.06 114.64 185.06 116.13V116.56C184 116.25 183.16 116.05 181.85 116.05C179.15 116.05 176.93 117.45 176.93 120.12C176.93 122.79 179.03 124.05 181.29 124.05C183.15 124.05 184.21 123.5 185.05 122.68V123.57C185.05 123.74 185.12 123.81 185.29 123.81H187.17C187.34 123.81 187.41 123.74 187.41 123.57V115.95C187.41 113.15 185.48 111.47 182.47 111.47L182.48 111.48ZM181.64 121.8C180.19 121.8 179.45 121.12 179.45 120.04C179.45 118.81 180.58 118.23 181.98 118.23C183.23 118.23 183.96 118.4 185.07 118.74C185.07 120.72 183.5 121.8 181.65 121.8H181.64ZM196.37 109.12C198.73 109.12 200.28 110.23 200.98 112.66C201.03 112.83 201.12 112.9 201.27 112.9H203.22C203.41 112.9 203.49 112.85 203.49 112.66C203.03 108.97 200.16 106.7 196.38 106.7C192.6 106.7 188.95 109.4 188.95 115.38C188.95 121.36 192.57 124.06 196.38 124.06C200.19 124.06 203.03 121.79 203.49 118.1C203.49 117.91 203.42 117.86 203.22 117.86H201.27C201.13 117.86 201.03 117.93 200.98 118.1C200.28 120.54 198.74 121.64 196.37 121.64C193.89 121.64 191.55 119.66 191.55 115.37C191.55 111.08 193.89 109.1 196.37 109.1V109.12ZM210.44 111.48C207.84 111.48 206.22 112.83 205.57 114.57C205.5 114.76 205.62 114.84 205.76 114.86L207.71 115.17C207.85 115.19 207.93 115.15 208 115C208.19 114.61 208.8 113.65 210.44 113.65C212.08 113.65 213.02 114.64 213.02 116.13V116.56C211.96 116.25 211.12 116.05 209.81 116.05C207.11 116.05 204.89 117.45 204.89 120.12C204.89 122.79 206.99 124.05 209.25 124.05C211.11 124.05 212.17 123.5 213.01 122.68V123.57C213.01 123.74 213.08 123.81 213.25 123.81H215.13C215.3 123.81 215.37 123.74 215.37 123.57V115.95C215.37 113.15 213.44 111.47 210.43 111.47L210.44 111.48ZM209.6 121.8C208.15 121.8 207.41 121.12 207.41 120.04C207.41 118.81 208.54 118.23 209.94 118.23C211.19 118.23 211.92 118.4 213.03 118.74C213.03 120.72 211.46 121.8 209.61 121.8H209.6ZM223.52 111.55C223.25 111.5 222.94 111.48 222.63 111.48C221.28 111.48 220.22 112.08 219.45 112.9V111.96C219.45 111.79 219.38 111.72 219.21 111.72H217.33C217.16 111.72 217.09 111.79 217.09 111.96V123.58C217.09 123.75 217.16 123.82 217.33 123.82H219.21C219.38 123.82 219.45 123.75 219.45 123.58V117.29C219.45 114.57 221.64 113.53 223.48 113.91C223.65 113.93 223.75 113.86 223.75 113.69V111.81C223.75 111.67 223.68 111.57 223.53 111.54L223.52 111.55Z",
			fill: "white"
		})
	]
}), an = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 680 430",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M390 80C290 58 215 -8.00002 115 52C-18 130 80 390 340 385C530 385 790 295 620 178C562 90 468 100 390 80Z",
			fill: "#E6F2FE"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M680 310H0V420H680V310Z",
			fill: "#D4D1C8"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M680 352H0V420H680V352Z",
			fill: "#E8E5DC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M680 350H0V354H680V350Z",
			fill: "#C2BFB6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M93.5 328H42.5C41.1193 328 40 329.119 40 330.5C40 331.881 41.1193 333 42.5 333H93.5C94.8807 333 96 331.881 96 330.5C96 329.119 94.8807 328 93.5 328Z",
			fill: "#B8B5AC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M253.5 328H202.5C201.119 328 200 329.119 200 330.5C200 331.881 201.119 333 202.5 333H253.5C254.881 333 256 331.881 256 330.5C256 329.119 254.881 328 253.5 328Z",
			fill: "#B8B5AC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M413.5 328H362.5C361.119 328 360 329.119 360 330.5C360 331.881 361.119 333 362.5 333H413.5C414.881 333 416 331.881 416 330.5C416 329.119 414.881 328 413.5 328Z",
			fill: "#B8B5AC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M573.5 328H522.5C521.119 328 520 329.119 520 330.5C520 331.881 521.119 333 522.5 333H573.5C574.881 333 576 331.881 576 330.5C576 329.119 574.881 328 573.5 328Z",
			fill: "#B8B5AC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M456 170H204C201.791 170 200 171.791 200 174V178C200 180.209 201.791 182 204 182H456C458.209 182 460 180.209 460 178V174C460 171.791 458.209 170 456 170Z",
			fill: "#003F83"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M462 160H198C195.791 160 194 161.791 194 164V168C194 170.209 195.791 172 198 172H462C464.209 172 466 170.209 466 168V164C466 161.791 464.209 160 462 160Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M207 160H203C201.343 160 200 161.343 200 163V349C200 350.657 201.343 352 203 352H207C208.657 352 210 350.657 210 349V163C210 161.343 208.657 160 207 160Z",
			fill: "#003F83"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M457 160H453C451.343 160 450 161.343 450 163V349C450 350.657 451.343 352 453 352H457C458.657 352 460 350.657 460 349V163C460 161.343 458.657 160 457 160Z",
			fill: "#003F83"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.08",
			d: "M458 182H212C210.895 182 210 182.895 210 184V320C210 321.105 210.895 322 212 322H458C459.105 322 460 321.105 460 320V184C460 182.895 459.105 182 458 182Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M458 182H212C210.895 182 210 182.895 210 184V320C210 321.105 210.895 322 212 322H458C459.105 322 460 321.105 460 320V184C460 182.895 459.105 182 458 182Z",
			stroke: "#003F83",
			strokeWidth: "1.2"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.92",
			d: "M382 196H244C240.686 196 238 198.686 238 202V290C238 293.314 240.686 296 244 296H382C385.314 296 388 293.314 388 290V202C388 198.686 385.314 196 382 196Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M382 196H244C240.686 196 238 198.686 238 202V212C238 215.314 240.686 218 244 218H382C385.314 218 388 215.314 388 212V202C388 198.686 385.314 196 382 196Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.9",
			d: "M294 228H250C248.895 228 248 228.895 248 230V231C248 232.105 248.895 233 250 233H294C295.105 233 296 232.105 296 231V230C296 228.895 295.105 228 294 228Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.9",
			d: "M336 228H304C302.895 228 302 228.895 302 230V231C302 232.105 302.895 233 304 233H336C337.105 233 338 232.105 338 231V230C338 228.895 337.105 228 336 228Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.7",
			d: "M294 242H250C248.895 242 248 242.895 248 244V245C248 246.105 248.895 247 250 247H294C295.105 247 296 246.105 296 245V244C296 242.895 295.105 242 294 242Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.7",
			d: "M336 242H304C302.895 242 302 242.895 302 244V245C302 246.105 302.895 247 304 247H336C337.105 247 338 246.105 338 245V244C338 242.895 337.105 242 336 242Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M294 256H250C248.895 256 248 256.895 248 258V259C248 260.105 248.895 261 250 261H294C295.105 261 296 260.105 296 259V258C296 256.895 295.105 256 294 256Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.5",
			d: "M336 256H304C302.895 256 302 256.895 302 258V259C302 260.105 302.895 261 304 261H336C337.105 261 338 260.105 338 259V258C338 256.895 337.105 256 336 256Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.35",
			d: "M294 270H250C248.895 270 248 270.895 248 272V273C248 274.105 248.895 275 250 275H294C295.105 275 296 274.105 296 273V272C296 270.895 295.105 270 294 270Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.35",
			d: "M336 270H304C302.895 270 302 270.895 302 272V273C302 274.105 302.895 275 304 275H336C337.105 275 338 274.105 338 273V272C338 270.895 337.105 270 336 270Z",
			fill: "#B5D4F4"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M452 308H218C215.791 308 214 309.791 214 312V313C214 315.209 215.791 317 218 317H452C454.209 317 456 315.209 456 313V312C456 309.791 454.209 308 452 308Z",
			fill: "#003F83"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M227 317H223C221.343 317 220 318.343 220 320V336C220 337.657 221.343 339 223 339H227C228.657 339 230 337.657 230 336V320C230 318.343 228.657 317 227 317Z",
			fill: "#002E6B"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M293 317H289C287.343 317 286 318.343 286 320V336C286 337.657 287.343 339 289 339H293C294.657 339 296 337.657 296 336V320C296 318.343 294.657 317 293 317Z",
			fill: "#002E6B"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M371 317H367C365.343 317 364 318.343 364 320V336C364 337.657 365.343 339 367 339H371C372.657 339 374 337.657 374 336V320C374 318.343 372.657 317 371 317Z",
			fill: "#002E6B"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M445 317H441C439.343 317 438 318.343 438 320V336C438 337.657 439.343 339 441 339H445C446.657 339 448 337.657 448 336V320C448 318.343 446.657 317 445 317Z",
			fill: "#002E6B"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M481 130H479C477.343 130 476 131.343 476 133V349C476 350.657 477.343 352 479 352H481C482.657 352 484 350.657 484 349V133C484 131.343 482.657 130 481 130Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M480 148C496.569 148 510 134.569 510 118C510 101.431 496.569 88 480 88C463.431 88 450 101.431 450 118C450 134.569 463.431 148 480 148Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M480 144C494.359 144 506 132.359 506 118C506 103.641 494.359 92 480 92C465.641 92 454 103.641 454 118C454 132.359 465.641 144 480 144Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M498.724 120.885C497.748 115.274 492.288 111.497 486.53 112.449L488.23 103.053L482.077 101.996C481.548 103.124 479.232 108.277 478.107 114.094C480.401 115.616 482.081 118.009 482.582 120.885C483.116 123.957 482.195 126.939 480.309 129.167C480.771 129.716 481.3 130.224 481.902 130.683C484.311 132.52 487.226 133.238 490.067 132.768C495.825 131.817 499.701 126.497 498.724 120.885Z",
			fill: "#001536"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M478.504 114.733C478.541 114.519 478.58 114.306 478.621 114.094C476.475 112.646 473.784 111.985 471.022 112.449L472.696 103.053L466.639 101.996C466.1 103.165 463.67 108.658 462.616 114.733C461.77 119.604 461.809 124.847 464.415 128.538C464.975 129.331 465.653 130.053 466.467 130.683C468.838 132.52 471.707 133.238 474.503 132.768C477.069 132.338 479.252 131.01 480.787 129.167C480.617 128.963 480.456 128.753 480.304 128.538C477.698 124.847 477.659 119.604 478.504 114.733Z",
			fill: "#FF595A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M482.829 120.882C482.299 117.869 480.519 115.363 478.091 113.768C478.047 113.99 478.005 114.213 477.965 114.438C477.056 119.54 477.098 125.033 479.901 128.899C480.065 129.125 480.239 129.344 480.422 129.559C482.419 127.224 483.395 124.1 482.829 120.882Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M73 258H71C69.3431 258 68 259.343 68 261V307C68 308.657 69.3431 310 71 310H73C74.6569 310 76 308.657 76 307V261C76 259.343 74.6569 258 73 258Z",
			fill: "#5B7C3A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M72 272C85.2548 272 96 260.359 96 246C96 231.641 85.2548 220 72 220C58.7452 220 48 231.641 48 246C48 260.359 58.7452 272 72 272Z",
			fill: "#6B9B47"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M60 273C69.3888 273 77 264.493 77 254C77 243.507 69.3888 235 60 235C50.6112 235 43 243.507 43 254C43 264.493 50.6112 273 60 273Z",
			fill: "#7BAD52"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M621 262H619C617.343 262 616 263.343 616 265V307C616 308.657 617.343 310 619 310H621C622.657 310 624 308.657 624 307V265C624 263.343 622.657 262 621 262Z",
			fill: "#5B7C3A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M620 274C632.15 274 642 263.255 642 250C642 236.745 632.15 226 620 226C607.85 226 598 236.745 598 250C598 263.255 607.85 274 620 274Z",
			fill: "#6B9B47"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M650 268H649C647.343 268 646 269.343 646 271V307C646 308.657 647.343 310 649 310H650C651.657 310 653 308.657 653 307V271C653 269.343 651.657 268 650 268Z",
			fill: "#5B7C3A"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M650 278C659.941 278 668 269.046 668 258C668 246.954 659.941 238 650 238C640.059 238 632 246.954 632 258C632 269.046 640.059 278 650 278Z",
			fill: "#7BAD52"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M531 300H519C517.343 300 516 301.343 516 303V325C516 326.657 517.343 328 519 328H531C532.657 328 534 326.657 534 325V303C534 301.343 532.657 300 531 300Z",
			fill: "#555450"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M534 296H516C514.895 296 514 296.895 514 298V301C514 302.105 514.895 303 516 303H534C535.105 303 536 302.105 536 301V298C536 296.895 535.105 296 534 296Z",
			fill: "#444340"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			opacity: "0.25",
			d: "M335 361C406.797 361 465 358.314 465 355C465 351.686 406.797 349 335 349C263.203 349 205 351.686 205 355C205 358.314 263.203 361 335 361Z",
			fill: "#B8B5AC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M565.993 42.2953C568.04 41.4635 570.373 42.4491 571.205 44.4955L576.182 56.7367L585.043 45.3451C586.399 43.6019 588.913 43.2881 590.656 44.6439C592.4 46.0002 592.713 48.5136 591.357 50.2572L579.661 65.2943L586.664 82.5189C587.496 84.5653 586.511 86.8989 584.465 87.7308C582.418 88.5625 580.085 87.5779 579.253 85.5316L573.989 72.5853L566.157 82.6566C564.801 84.4004 562.288 84.7151 560.544 83.3588C558.801 82.0024 558.487 79.4891 559.843 77.7455L570.511 64.0287L563.795 47.5082C562.963 45.4617 563.947 43.1273 565.993 42.2953Z",
			fill: "#A4D2FF"
		})
	]
}), on = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 375 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M207.358 139.013C148.851 150.939 113.783 213.521 61.4614 184.75C-10.0774 145.412 42.3077 20.0917 190.271 20.0917C262.77 20.0917 386.681 65.4441 344.054 124.087C312.479 167.524 259.976 128.287 207.358 139.013Z",
			fill: "#E6F2FE"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M137.522 141.244C139.713 140.967 141.715 142.518 141.993 144.709C142.27 146.901 140.718 148.902 138.527 149.18L111.07 152.657C108.878 152.935 106.877 151.383 106.599 149.191C106.322 147 107.873 144.998 110.064 144.72L137.522 141.244Z",
			fill: "#A4D2FF"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M211.176 119.54L223.402 111.601L247.426 148.6L235.2 156.539L211.176 119.54Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M211.176 119.54L213.876 117.787L237.9 154.785L235.2 156.539L211.176 119.54Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M223.183 148.26C219.207 142.137 220.948 133.949 227.071 129.973C233.195 125.997 241.383 127.738 245.359 133.861L275.261 179.912L253.085 194.312L223.183 148.26Z",
			fill: "#0071EB"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M257.142 191.677L253.085 194.312L223.183 148.261C220.94 144.806 220.516 140.695 221.673 137.053L257.142 191.677Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M275.281 179.845C277.436 183.162 274.217 189.077 268.092 193.055C261.966 197.032 255.254 197.567 253.099 194.25C250.945 190.932 254.164 185.017 260.289 181.04C266.414 177.062 273.126 176.527 275.281 179.845Z",
			fill: "#A4D2FF"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M229.137 41.2126C250.831 63.9738 252.392 97.6995 232.624 116.541C212.856 135.383 179.244 132.205 157.55 109.444C135.855 86.6827 134.294 52.957 154.063 34.1155C173.831 15.2739 207.443 18.4514 229.137 41.2126Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M228.238 40.2688C249.435 62.5086 251.554 94.8962 232.97 112.608C214.387 130.321 182.138 126.65 160.941 104.411C139.744 82.1707 137.625 49.7831 156.208 32.0709C174.792 14.3586 207.041 18.0289 228.238 40.2688Z",
			fill: "#0071EB"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M220.683 47.4685C237.585 65.2021 239.573 90.7425 225.124 104.515C210.674 118.287 185.259 115.075 168.356 97.3416C151.454 79.608 149.466 54.0675 163.915 40.2955C178.365 26.5234 203.78 29.7348 220.683 47.4685Z",
			fill: "#004FD6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M213.461 54.3512C227.362 68.9361 229.088 89.8557 217.315 101.076C205.543 112.297 184.73 109.57 170.829 94.9849C156.928 80.4 155.202 59.4805 166.975 48.2598C178.747 37.0391 199.56 39.7663 213.461 54.3512Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M203.331 46.4021C206.933 48.4501 210.369 51.1074 213.461 54.3523C215.087 56.0575 216.543 57.851 217.833 59.7039L184.656 104.802C179.715 102.617 174.966 99.3265 170.829 94.9861C170.21 94.3376 169.618 93.6749 169.048 93.0027L203.331 46.4021Z",
			fill: "#E6F2FE"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M64.846 90.1664C66.9631 89.5351 69.1916 90.7398 69.8229 92.8568L69.8578 92.974C69.8637 92.9936 69.8693 93.0138 69.8751 93.0335C69.881 93.053 69.8868 93.0725 69.8926 93.0921C69.8985 93.1119 69.904 93.1318 69.9099 93.1517C69.9158 93.1715 69.9223 93.1915 69.9282 93.2114C69.9341 93.2312 69.9396 93.2511 69.9455 93.2709C69.9514 93.2908 69.9578 93.3107 69.9638 93.3307L70.0361 93.5734C70.0422 93.5938 70.048 93.6146 70.0541 93.6351C70.0601 93.6554 70.0671 93.6755 70.0731 93.6959C70.0792 93.7164 70.0849 93.737 70.0911 93.7576C70.0972 93.7781 70.1038 93.7987 70.11 93.8194C70.1161 93.8399 70.1218 93.8605 70.1279 93.881L70.1653 94.0066C70.1715 94.0272 70.178 94.0477 70.1842 94.0684C70.1904 94.0892 70.1967 94.1103 70.2029 94.1312C70.2092 94.1522 70.2152 94.1739 70.2215 94.1949C70.2277 94.2158 70.234 94.2367 70.2402 94.2577C70.2465 94.2788 70.2524 94.3002 70.2588 94.3214C70.2651 94.3426 70.2719 94.3641 70.2783 94.3853C70.2846 94.4065 70.2905 94.4279 70.2968 94.4491L70.3359 94.5769C70.3422 94.5983 70.3478 94.6201 70.3542 94.6416L70.4123 94.8362C70.4187 94.8579 70.4261 94.8795 70.4326 94.9013C70.4391 94.923 70.4452 94.9453 70.4518 94.9671C70.4582 94.9887 70.4646 95.0103 70.4711 95.032C70.4776 95.0538 70.4847 95.076 70.4912 95.098C70.4978 95.1198 70.5039 95.1419 70.5104 95.1638C70.5169 95.1857 70.524 95.2078 70.5305 95.2298C70.5371 95.2518 70.543 95.2745 70.5496 95.2966C70.5561 95.3186 70.5631 95.3405 70.5697 95.3626L70.6496 95.6304C70.6563 95.6529 70.6627 95.6759 70.6694 95.6984C70.6761 95.7208 70.6836 95.743 70.6903 95.7655C70.697 95.788 70.7034 95.8109 70.7101 95.8334C70.7168 95.856 70.7241 95.8788 70.7309 95.9015C70.7376 95.9241 70.7439 95.9468 70.7507 95.9694C70.7574 95.9921 70.7646 96.0148 70.7714 96.0375C70.7782 96.0603 70.7842 96.0836 70.7911 96.1064C70.7978 96.1291 70.805 96.1517 70.8118 96.1745L70.9148 96.5198C70.9217 96.5429 70.9283 96.5666 70.9352 96.5898C70.9421 96.613 70.9497 96.6367 70.9566 96.66C70.9634 96.683 70.9703 96.706 70.9772 96.729C70.9841 96.7524 70.9916 96.7759 70.9986 96.7992C71.0055 96.8225 71.012 96.8459 71.019 96.8693C71.0259 96.8926 71.0334 96.9161 71.0404 96.9394C71.0474 96.9629 71.0536 96.9869 71.0606 97.0104C71.0676 97.0338 71.075 97.0571 71.082 97.0806L71.2093 97.5075C71.2164 97.5313 71.2232 97.5557 71.2304 97.5796C71.2375 97.6034 71.2454 97.627 71.2526 97.6509L71.2946 97.7951C71.3018 97.8192 71.3095 97.8434 71.3167 97.8674C71.3238 97.8914 71.3305 97.9155 71.3377 97.9395L71.3817 98.0841C71.3889 98.1083 71.3954 98.1329 71.4026 98.1572C71.4098 98.1813 71.4174 98.2053 71.4246 98.2294L71.5557 98.6689C71.563 98.6934 71.57 98.7185 71.5773 98.7431C71.5846 98.7676 71.5928 98.792 71.6001 98.8165L71.6435 98.9649C71.6508 98.9896 71.6587 99.0146 71.6661 99.0393C71.6734 99.0639 71.6804 99.0889 71.6878 99.1135C71.6951 99.1382 71.703 99.1631 71.7104 99.1878C71.7178 99.2125 71.7247 99.2374 71.7321 99.2621L71.7774 99.4108C71.7848 99.4357 71.7914 99.461 71.7989 99.486C71.8063 99.5108 71.8141 99.5355 71.8215 99.5603L72.0012 100.163C72.0087 100.188 72.016 100.214 72.0235 100.239C72.031 100.265 72.0394 100.29 72.0469 100.315C72.0545 100.34 72.0617 100.366 72.0692 100.391C72.0767 100.416 72.0842 100.441 72.0917 100.466C72.0993 100.492 72.1074 100.518 72.115 100.543L72.1596 100.695C72.1671 100.721 72.1752 100.746 72.1828 100.772C72.1904 100.797 72.1975 100.823 72.2051 100.848L72.2516 101.001C72.2592 101.027 72.2661 101.053 72.2737 101.078L72.3203 101.231C72.3279 101.257 72.3347 101.283 72.3424 101.309C72.35 101.334 72.358 101.36 72.3656 101.385L72.4349 101.617C72.4425 101.643 72.4506 101.668 72.4582 101.694L72.5736 102.081C72.5813 102.107 72.5888 102.133 72.5965 102.159L72.6658 102.392C72.6735 102.418 72.681 102.444 72.6887 102.47C72.6965 102.496 72.705 102.522 72.7128 102.548C72.7205 102.574 72.7279 102.6 72.7357 102.626C72.7434 102.652 72.7511 102.678 72.7588 102.703C72.7665 102.729 72.774 102.756 72.7817 102.782C72.7894 102.808 72.798 102.833 72.8058 102.859L72.8516 103.016C72.8594 103.042 72.8677 103.069 72.8755 103.095C72.8832 103.121 72.8909 103.146 72.8986 103.172C72.9063 103.198 72.9147 103.225 72.9225 103.251L72.9683 103.407C72.9761 103.434 72.9844 103.46 72.9922 103.486C73 103.512 73.0073 103.538 73.0151 103.564C73.0229 103.591 73.0312 103.617 73.039 103.643C73.0468 103.669 73.0541 103.695 73.0619 103.721L73.1097 103.878C73.1174 103.905 73.1248 103.931 73.1326 103.957C73.1404 103.983 73.1487 104.009 73.1565 104.035C73.1643 104.062 73.1714 104.089 73.1792 104.115L73.227 104.272C73.2348 104.298 73.2421 104.324 73.2499 104.35C73.2577 104.377 73.2658 104.404 73.2736 104.43C73.2814 104.456 73.2888 104.482 73.2965 104.508L73.3443 104.665C73.3521 104.692 73.3592 104.718 73.367 104.745L73.4148 104.902C73.4226 104.928 73.4297 104.955 73.4376 104.981C73.4454 105.007 73.4536 105.033 73.4614 105.06C73.4693 105.086 73.4773 105.113 73.4852 105.139C73.4929 105.165 73.5003 105.191 73.5081 105.218C73.5159 105.244 73.5242 105.27 73.532 105.296L73.5557 105.376C73.5635 105.402 73.5717 105.428 73.5796 105.454C73.5874 105.481 73.5945 105.507 73.6023 105.534L73.6501 105.691C73.6579 105.717 73.665 105.744 73.6728 105.77C73.6806 105.796 73.6889 105.822 73.6967 105.849C73.7045 105.875 73.7126 105.902 73.7204 105.928C73.7282 105.954 73.7356 105.98 73.7433 106.006C73.7511 106.033 73.7594 106.059 73.7672 106.085C73.7751 106.111 73.7831 106.138 73.7909 106.165C73.7987 106.191 73.807 106.217 73.8148 106.243C73.8226 106.269 73.8297 106.296 73.8376 106.322L73.8853 106.48C73.8932 106.506 73.9002 106.533 73.9081 106.559L73.9558 106.716C73.9636 106.742 73.971 106.768 73.9788 106.794C73.9866 106.821 73.9947 106.848 74.0025 106.874C74.0103 106.9 74.0176 106.926 74.0254 106.952L74.0732 107.109C74.0809 107.136 74.0883 107.162 74.0961 107.188C74.1039 107.214 74.112 107.241 74.1198 107.267C74.1276 107.293 74.135 107.32 74.1427 107.346C74.1505 107.372 74.1588 107.398 74.1666 107.424C74.1744 107.45 74.1817 107.477 74.1895 107.503C74.1973 107.529 74.2056 107.555 74.2134 107.581C74.2212 107.607 74.2285 107.634 74.2363 107.66C74.2441 107.686 74.2524 107.712 74.2602 107.738C74.268 107.764 74.2754 107.791 74.2831 107.817C74.2909 107.843 74.2992 107.869 74.307 107.895C74.3147 107.921 74.3224 107.947 74.3301 107.973C74.3379 107.999 74.3462 108.025 74.354 108.051L74.3998 108.208C74.4076 108.234 74.4161 108.26 74.4239 108.285L74.4697 108.442C74.4774 108.468 74.486 108.494 74.4938 108.52C74.5015 108.546 74.5089 108.572 74.5167 108.598C74.5244 108.624 74.5321 108.65 74.5398 108.676C74.5475 108.702 74.555 108.728 74.5627 108.754C74.5704 108.78 74.5781 108.806 74.5858 108.831C74.5935 108.857 74.6021 108.883 74.6098 108.909C74.6175 108.935 74.6252 108.961 74.6329 108.987C74.6406 109.012 74.6481 109.039 74.6558 109.065L74.7944 109.529C74.802 109.555 74.81 109.58 74.8176 109.606C74.8253 109.632 74.8321 109.658 74.8398 109.683C74.8474 109.709 74.8552 109.735 74.8628 109.761C74.8705 109.786 74.8785 109.812 74.8861 109.837L74.9092 109.914C74.9168 109.94 74.9248 109.965 74.9324 109.991C74.9401 110.017 74.9469 110.043 74.9546 110.068L75.0011 110.221C75.0087 110.247 75.0158 110.272 75.0234 110.297C75.031 110.323 75.0391 110.348 75.0466 110.374C75.0542 110.399 75.0614 110.425 75.0689 110.45C75.0765 110.476 75.0846 110.501 75.0922 110.527L75.1368 110.679C75.1444 110.705 75.1525 110.73 75.1601 110.756C75.1675 110.781 75.175 110.806 75.1825 110.831C75.1901 110.856 75.1973 110.882 75.2048 110.907C75.2123 110.933 75.2207 110.958 75.2282 110.983C75.2357 111.008 75.2432 111.033 75.2507 111.058C75.2582 111.083 75.2655 111.109 75.273 111.134L75.3853 111.511C75.3927 111.536 75.4006 111.561 75.408 111.586C75.4154 111.611 75.422 111.636 75.4295 111.661C75.4369 111.686 75.4447 111.71 75.4521 111.735C75.4595 111.76 75.4671 111.786 75.4746 111.81C75.4819 111.835 75.4889 111.86 75.4962 111.885L75.5415 112.033C75.5489 112.058 75.5558 112.083 75.5632 112.108C75.5705 112.132 75.5784 112.157 75.5858 112.182L75.6292 112.33C75.6365 112.355 75.6447 112.379 75.652 112.404C75.6593 112.428 75.6663 112.453 75.6736 112.478L75.8047 112.917C75.8119 112.942 75.8195 112.966 75.8267 112.99C75.8339 113.014 75.8403 113.039 75.8476 113.063L75.8916 113.207C75.8988 113.231 75.9053 113.256 75.9125 113.28C75.9196 113.304 75.9273 113.329 75.9345 113.353C75.9415 113.376 75.9486 113.4 75.9557 113.424C75.9628 113.448 75.9706 113.472 75.9777 113.496C75.9848 113.52 75.9916 113.544 75.9987 113.568C76.0058 113.592 76.0129 113.616 76.02 113.639C76.0271 113.663 76.0339 113.688 76.041 113.711L76.1259 113.996C76.1329 114.019 76.1403 114.043 76.1473 114.066L76.1685 114.137C76.1755 114.161 76.1829 114.184 76.1899 114.208C76.1969 114.231 76.2031 114.255 76.2101 114.279C76.2171 114.302 76.2246 114.325 76.2315 114.349C76.2384 114.372 76.245 114.396 76.2519 114.419C76.2588 114.442 76.2666 114.465 76.2735 114.488L76.3143 114.628L76.3349 114.697C76.3418 114.72 76.3496 114.743 76.3565 114.766L76.3977 114.904C76.4045 114.927 76.4105 114.95 76.4173 114.973L76.4379 115.042L76.4794 115.179C76.4862 115.201 76.4925 115.224 76.4992 115.246C76.506 115.269 76.5132 115.292 76.52 115.315L76.5596 115.45C76.5663 115.473 76.5738 115.495 76.5805 115.518C76.5872 115.54 76.5938 115.562 76.6005 115.584C76.6072 115.607 76.6136 115.63 76.6203 115.652L76.6402 115.719C76.6468 115.741 76.6538 115.763 76.6604 115.785C76.667 115.808 76.6728 115.83 76.6794 115.852C76.686 115.874 76.693 115.896 76.6995 115.918L76.7195 115.985C76.726 116.007 76.7322 116.029 76.7387 116.051C76.7452 116.073 76.7523 116.095 76.7588 116.117L76.7782 116.182C76.7847 116.204 76.7909 116.226 76.7973 116.248C76.8038 116.269 76.8112 116.291 76.8176 116.313C76.8241 116.334 76.8304 116.357 76.8368 116.379C76.8432 116.4 76.8498 116.422 76.8562 116.443C76.8625 116.465 76.8693 116.486 76.8757 116.507C76.8821 116.529 76.8877 116.551 76.8941 116.572L76.9134 116.637C76.9198 116.658 76.9266 116.68 76.9329 116.701C76.9392 116.722 76.9452 116.743 76.9515 116.765C76.9578 116.786 76.9647 116.807 76.971 116.828C76.9772 116.849 76.9835 116.87 76.9897 116.891C76.996 116.912 77.002 116.934 77.0083 116.955C77.0145 116.976 77.0217 116.997 77.0279 117.018L77.0654 117.143C77.0716 117.164 77.077 117.185 77.0831 117.206C77.0893 117.227 77.0957 117.248 77.1019 117.269C77.108 117.289 77.1146 117.31 77.1207 117.331C77.1269 117.351 77.1326 117.372 77.1387 117.392C77.1448 117.413 77.1515 117.434 77.1576 117.454C77.1637 117.475 77.1694 117.495 77.1755 117.516C77.1816 117.536 77.1885 117.556 77.1946 117.577L77.2127 117.637C77.2187 117.658 77.2245 117.679 77.2306 117.699C77.2365 117.719 77.2429 117.739 77.2488 117.759C77.2548 117.779 77.26 117.799 77.266 117.819C77.272 117.839 77.2781 117.86 77.2841 117.88C77.29 117.9 77.2964 117.92 77.3023 117.94C77.3083 117.959 77.3138 117.979 77.3196 117.999C77.3256 118.019 77.332 118.039 77.3379 118.059C77.3437 118.078 77.3496 118.098 77.3554 118.117C77.3613 118.137 77.3668 118.157 77.3727 118.177L77.4076 118.294C77.4134 118.314 77.4195 118.333 77.4253 118.352C77.4311 118.371 77.437 118.391 77.4427 118.41C77.4485 118.43 77.4547 118.449 77.4604 118.468L77.4937 118.583C77.4994 118.602 77.5057 118.622 77.5114 118.641L77.5788 118.867C77.5843 118.885 77.5903 118.904 77.5958 118.922C77.6013 118.941 77.6064 118.959 77.6119 118.978C77.6174 118.996 77.6234 119.015 77.6289 119.033C77.6344 119.051 77.6395 119.07 77.6449 119.088C77.6504 119.107 77.6558 119.125 77.6612 119.143C77.6666 119.161 77.6718 119.18 77.6772 119.198C77.6826 119.216 77.6881 119.235 77.6934 119.253C77.6988 119.271 77.7045 119.288 77.7098 119.306C77.7152 119.324 77.7207 119.343 77.7261 119.36C77.7314 119.378 77.7371 119.396 77.7425 119.414L77.7733 119.52C77.7786 119.538 77.7847 119.555 77.7899 119.573C77.7951 119.591 77.8001 119.609 77.8053 119.626L77.8365 119.731C77.8416 119.748 77.8463 119.765 77.8513 119.782L77.8829 119.885C77.8879 119.902 77.8926 119.919 77.8977 119.936C77.9027 119.953 77.9077 119.969 77.9126 119.986C77.9177 120.003 77.9224 120.021 77.9275 120.037C77.9324 120.054 77.9375 120.071 77.9424 120.088C77.9474 120.104 77.9527 120.12 77.9576 120.137C77.9625 120.153 77.9676 120.171 77.9725 120.187C77.9774 120.203 77.9819 120.22 77.9867 120.236C77.9916 120.253 77.997 120.269 78.0019 120.285C78.0067 120.301 78.0115 120.318 78.0162 120.334C78.0211 120.35 78.0256 120.367 78.0304 120.383L78.0591 120.479L78.0882 120.573C78.0928 120.589 78.0971 120.605 78.1017 120.62C78.1064 120.636 78.1116 120.652 78.1162 120.667C78.1208 120.683 78.1254 120.698 78.13 120.713C78.1346 120.729 78.139 120.745 78.1435 120.76C78.148 120.776 78.153 120.79 78.1574 120.806C78.162 120.821 78.1666 120.836 78.1712 120.852C78.1756 120.867 78.1797 120.882 78.1841 120.896C78.1886 120.911 78.1936 120.927 78.198 120.942L78.2239 121.031L78.2501 121.119L78.2766 121.205C78.2809 121.219 78.2847 121.234 78.2889 121.248C78.2932 121.262 78.298 121.277 78.3022 121.291C78.3064 121.305 78.3105 121.319 78.3147 121.333C78.3189 121.347 78.3228 121.362 78.327 121.376C78.3311 121.389 78.3356 121.403 78.3396 121.417C78.3438 121.43 78.3471 121.445 78.3512 121.458C78.3553 121.472 78.3598 121.486 78.3638 121.499C78.3679 121.513 78.3715 121.526 78.3755 121.54C78.3795 121.553 78.3842 121.567 78.3882 121.581L78.4119 121.66C78.4158 121.673 78.42 121.686 78.4239 121.699C78.4278 121.712 78.4309 121.726 78.4348 121.739C78.4387 121.752 78.443 121.765 78.4468 121.777C78.4506 121.79 78.4541 121.803 78.4579 121.816C78.4616 121.829 78.4654 121.841 78.4691 121.854C78.4729 121.866 78.4776 121.879 78.4813 121.892C78.485 121.904 78.4879 121.917 78.4916 121.929C78.4952 121.941 78.4993 121.954 78.503 121.966L78.5248 122.039C78.5284 122.051 78.5317 122.064 78.5353 122.076C78.5388 122.088 78.5433 122.099 78.5468 122.111C78.5503 122.123 78.553 122.135 78.5565 122.147C78.56 122.158 78.5636 122.171 78.5671 122.182C78.5705 122.194 78.5744 122.205 78.5779 122.217C78.5813 122.228 78.5843 122.24 78.5877 122.251C78.5911 122.263 78.5953 122.274 78.5986 122.285L78.6186 122.352C78.6219 122.363 78.6244 122.374 78.6276 122.385L78.6479 122.45C78.6511 122.461 78.6539 122.472 78.6571 122.483L78.6758 122.545C78.6789 122.556 78.6823 122.566 78.6854 122.576C78.6884 122.586 78.6907 122.597 78.6938 122.607C78.6968 122.617 78.7003 122.628 78.7033 122.637L78.7382 122.755C78.741 122.764 78.7434 122.774 78.7462 122.783C78.749 122.792 78.7523 122.802 78.7551 122.811L78.7794 122.893C78.7821 122.902 78.7851 122.91 78.7877 122.919C78.7903 122.928 78.7925 122.937 78.795 122.945C78.7976 122.954 78.8008 122.963 78.8033 122.971L78.8183 123.022C78.8207 123.03 78.8224 123.038 78.8248 123.047L78.8401 123.095C78.8425 123.103 78.8445 123.111 78.8468 123.119L78.8605 123.165C78.8627 123.172 78.8645 123.18 78.8666 123.187C78.8688 123.194 78.8715 123.202 78.8736 123.209C78.8758 123.216 78.8776 123.224 78.8797 123.231L78.8984 123.293C78.9004 123.3 78.9029 123.307 78.9048 123.313C78.9068 123.32 78.9084 123.327 78.9103 123.333L78.9271 123.39C78.929 123.396 78.9312 123.402 78.9329 123.408C78.9347 123.413 78.936 123.419 78.9378 123.425C78.9395 123.431 78.942 123.437 78.9437 123.442C78.9454 123.448 78.9469 123.454 78.9485 123.46C78.9501 123.465 78.9521 123.47 78.9537 123.476C78.9553 123.481 78.9561 123.487 78.9577 123.492C78.9593 123.497 78.9614 123.503 78.9629 123.508L78.9804 123.567C78.9817 123.571 78.9826 123.576 78.9839 123.58C78.9852 123.585 78.9874 123.589 78.9886 123.593L78.9961 123.618C78.9973 123.622 78.9977 123.626 78.9989 123.63C79.0001 123.634 79.0017 123.638 79.0028 123.642L79.0153 123.684C79.0162 123.687 79.0168 123.69 79.0176 123.693C79.0185 123.696 79.0202 123.699 79.0211 123.702L79.0261 123.718C79.0268 123.721 79.0271 123.723 79.0278 123.726C79.0285 123.728 79.0298 123.731 79.0304 123.733C79.0311 123.735 79.0315 123.738 79.0322 123.74L79.0359 123.753L79.037 123.758L79.039 123.763C79.6701 125.88 78.4657 128.108 76.3488 128.739C74.2318 129.371 72.0042 128.166 71.3729 126.049L71.3708 126.044L71.3698 126.038L71.3677 126.033C71.3671 126.031 71.3667 126.028 71.366 126.026C71.3654 126.024 71.3638 126.022 71.3632 126.019C71.3625 126.017 71.3622 126.015 71.3615 126.012C71.3607 126.01 71.3596 126.007 71.3588 126.005L71.3538 125.988L71.3492 125.969C71.3482 125.966 71.3468 125.963 71.3459 125.96L71.3396 125.939C71.3385 125.935 71.3378 125.931 71.3367 125.928L71.3289 125.904C71.3277 125.9 71.3273 125.896 71.3261 125.892C71.3248 125.888 71.3227 125.884 71.3214 125.879L71.3142 125.852C71.3129 125.848 71.3111 125.843 71.3097 125.839L71.3009 125.809C71.2994 125.804 71.2983 125.799 71.2967 125.794L71.2864 125.762C71.2848 125.757 71.284 125.751 71.2824 125.746C71.2807 125.74 71.2791 125.734 71.2774 125.729C71.2757 125.723 71.2733 125.717 71.2716 125.711L71.261 125.675C71.2592 125.669 71.257 125.664 71.2552 125.657C71.2534 125.651 71.2515 125.645 71.2496 125.639L71.2387 125.599L71.2259 125.559C71.2239 125.552 71.2217 125.545 71.2196 125.538C71.2176 125.531 71.2157 125.523 71.2136 125.516C71.2115 125.509 71.2094 125.502 71.2073 125.495C71.2052 125.488 71.2025 125.481 71.2003 125.473C71.1981 125.466 71.1966 125.458 71.1944 125.45L71.1807 125.404C71.1784 125.397 71.1752 125.389 71.1728 125.381C71.1705 125.373 71.1685 125.365 71.1662 125.357C71.1638 125.349 71.1609 125.341 71.1585 125.333C71.1561 125.325 71.1544 125.316 71.152 125.308L71.1445 125.283C71.142 125.275 71.1386 125.266 71.136 125.258C71.1335 125.249 71.1313 125.24 71.1287 125.232C71.1261 125.223 71.123 125.214 71.1204 125.205C71.1179 125.197 71.1157 125.188 71.1131 125.179L71.0969 125.125C71.0941 125.116 71.0917 125.106 71.0889 125.097C71.0862 125.088 71.0828 125.078 71.08 125.068C71.0773 125.059 71.0749 125.05 71.0721 125.04C71.0693 125.031 71.066 125.022 71.0632 125.012L71.0457 124.953C71.0428 124.944 71.0401 124.933 71.0371 124.923C71.0342 124.913 71.0306 124.903 71.0276 124.893C71.0246 124.883 71.0221 124.873 71.019 124.862C71.016 124.852 71.0128 124.841 71.0097 124.831C71.0067 124.821 71.0032 124.811 71.0002 124.801C70.997 124.79 70.9941 124.779 70.991 124.768C70.9878 124.758 70.9838 124.747 70.9806 124.737C70.9775 124.726 70.9747 124.715 70.9715 124.704C70.9682 124.694 70.9645 124.683 70.9613 124.672C70.9581 124.661 70.9556 124.65 70.9523 124.639L70.9423 124.605C70.939 124.594 70.9347 124.583 70.9313 124.571L70.9117 124.503L70.8902 124.433C70.8867 124.422 70.8831 124.41 70.8796 124.398C70.876 124.386 70.8727 124.373 70.8691 124.361L70.8585 124.326C70.8549 124.314 70.8517 124.301 70.8481 124.289C70.8444 124.277 70.8403 124.265 70.8367 124.252C70.833 124.24 70.8291 124.227 70.8254 124.215C70.8218 124.202 70.8177 124.19 70.814 124.178C70.8103 124.166 70.8065 124.153 70.8028 124.14L70.7807 124.063C70.7769 124.05 70.7725 124.037 70.7686 124.024C70.7648 124.011 70.7614 123.999 70.7576 123.986L70.722 123.866C70.718 123.853 70.7134 123.839 70.7094 123.825L70.685 123.744C70.681 123.73 70.6765 123.717 70.6724 123.703C70.6683 123.689 70.665 123.675 70.6609 123.661L70.6484 123.619C70.6442 123.605 70.6391 123.592 70.6349 123.577L70.6103 123.492C70.6061 123.478 70.6013 123.463 70.597 123.449L70.5446 123.273C70.5402 123.258 70.5361 123.243 70.5317 123.228L70.5039 123.138C70.4994 123.123 70.4957 123.107 70.4911 123.092L70.4637 123C70.4591 122.985 70.4536 122.969 70.449 122.954L70.4219 122.86C70.4172 122.844 70.412 122.828 70.4073 122.813L70.3499 122.62C70.3451 122.604 70.3406 122.587 70.3357 122.571C70.3309 122.555 70.3255 122.538 70.3206 122.522C70.3157 122.506 70.3113 122.489 70.3064 122.473C70.3015 122.456 70.2962 122.44 70.2913 122.423L70.2314 122.223C70.2263 122.206 70.2207 122.188 70.2156 122.171C70.2105 122.154 70.2059 122.137 70.2008 122.12C70.1957 122.103 70.1901 122.086 70.185 122.069C70.1799 122.051 70.1755 122.034 70.1704 122.017L70.1236 121.86C70.1184 121.842 70.1122 121.825 70.107 121.807C70.1018 121.79 70.0968 121.771 70.0916 121.754C70.0863 121.736 70.0805 121.718 70.0752 121.7C70.0699 121.683 70.0653 121.664 70.0599 121.646C70.0546 121.628 70.0489 121.611 70.0435 121.593L69.9786 121.375C69.9732 121.357 69.9671 121.338 69.9616 121.32C69.9561 121.301 69.9511 121.283 69.9455 121.264C69.94 121.246 69.9341 121.227 69.9285 121.209C69.923 121.19 69.9182 121.171 69.9126 121.152C69.9071 121.134 69.9012 121.115 69.8956 121.097L69.8619 120.984C69.8563 120.965 69.8509 120.945 69.8453 120.926C69.8396 120.907 69.8331 120.889 69.8274 120.87C69.8218 120.851 69.8165 120.831 69.8108 120.812C69.8051 120.793 69.7988 120.774 69.7931 120.755C69.7874 120.735 69.7824 120.715 69.7766 120.696C69.7709 120.677 69.7647 120.658 69.759 120.638L69.6891 120.404C69.6832 120.384 69.6777 120.364 69.6718 120.345C69.6659 120.325 69.6594 120.305 69.6535 120.285C69.6476 120.265 69.6421 120.245 69.6362 120.225L69.5997 120.106C69.5937 120.086 69.5885 120.065 69.5825 120.045L69.5463 119.924C69.5403 119.904 69.5333 119.883 69.5273 119.863L69.4914 119.74C69.4854 119.719 69.4785 119.699 69.4724 119.679C69.4662 119.658 69.4608 119.637 69.4546 119.616L69.4168 119.493C69.4106 119.472 69.4043 119.451 69.3981 119.43C69.3919 119.409 69.3866 119.388 69.3803 119.367C69.3741 119.346 69.3669 119.325 69.3607 119.304C69.3544 119.283 69.3482 119.263 69.3419 119.242L69.3048 119.114C69.2985 119.093 69.2917 119.071 69.2853 119.05C69.279 119.029 69.2731 119.008 69.2668 118.986L69.2277 118.859C69.2214 118.837 69.2158 118.815 69.2094 118.794L69.1513 118.599C69.1449 118.578 69.1375 118.556 69.131 118.534L69.0927 118.403C69.0861 118.381 69.0791 118.359 69.0725 118.337C69.066 118.315 69.0599 118.293 69.0534 118.271L69.0131 118.139C69.0065 118.117 68.9997 118.094 68.9931 118.072C68.9865 118.05 68.9807 118.027 68.9741 118.005L68.9342 117.871C68.9275 117.849 68.9199 117.826 68.9132 117.804C68.9065 117.781 68.9002 117.759 68.8934 117.736C68.8868 117.714 68.8801 117.691 68.8735 117.669C68.8667 117.646 68.8595 117.624 68.8527 117.601C68.846 117.578 68.8397 117.556 68.8329 117.533C68.8261 117.51 68.8189 117.488 68.8121 117.465C68.8054 117.442 68.7991 117.42 68.7923 117.397L68.7512 117.259C68.7444 117.236 68.7372 117.214 68.7304 117.191L68.6686 116.984C68.6617 116.961 68.6551 116.937 68.6482 116.914C68.6413 116.891 68.6345 116.868 68.6276 116.845C68.6207 116.821 68.6141 116.798 68.6072 116.775C68.6002 116.751 68.5927 116.728 68.5858 116.704C68.5789 116.681 68.5723 116.658 68.5654 116.634L68.5226 116.494C68.5157 116.471 68.5091 116.447 68.5022 116.424L68.4597 116.282C68.4528 116.258 68.4453 116.235 68.4384 116.211C68.4313 116.188 68.4242 116.164 68.4171 116.14C68.4101 116.117 68.4032 116.092 68.3961 116.068L68.3537 115.926C68.3465 115.902 68.3397 115.878 68.3326 115.854C68.3255 115.83 68.3175 115.806 68.3104 115.783L68.2683 115.638C68.2612 115.614 68.2535 115.59 68.2463 115.566C68.2392 115.542 68.2324 115.518 68.2253 115.494C68.2181 115.47 68.2105 115.446 68.2033 115.422C68.1961 115.397 68.1886 115.373 68.1814 115.348C68.1742 115.324 68.1666 115.3 68.1594 115.276C68.1522 115.252 68.1458 115.227 68.1385 115.203C68.1313 115.179 68.1237 115.155 68.1165 115.131L68.051 114.911C68.0437 114.887 68.0366 114.861 68.0293 114.837C68.0221 114.812 68.0148 114.788 68.0075 114.764C68.0002 114.739 67.992 114.715 67.9847 114.69L67.9413 114.542C67.934 114.517 67.9259 114.493 67.9185 114.468C67.9112 114.444 67.9042 114.419 67.8969 114.394C67.8895 114.369 67.8816 114.345 67.8742 114.32C67.8669 114.295 67.8599 114.27 67.8526 114.246C67.8452 114.221 67.8373 114.196 67.8299 114.171C67.8225 114.146 67.8158 114.121 67.8084 114.096C67.801 114.071 67.7932 114.047 67.7858 114.022C67.7784 113.997 67.7708 113.971 67.7633 113.946C67.7559 113.922 67.7481 113.897 67.7407 113.872C67.7332 113.847 67.7266 113.822 67.7192 113.797L67.5844 113.345C67.5769 113.32 67.5685 113.294 67.561 113.269C67.5534 113.244 67.5462 113.218 67.5387 113.193L67.5162 113.118C67.5087 113.092 67.5015 113.067 67.4939 113.041C67.4864 113.016 67.4782 112.99 67.4707 112.965C67.4632 112.94 67.4557 112.915 67.4482 112.89C67.4406 112.864 67.4325 112.839 67.4249 112.813L67.3803 112.661L67.3338 112.508C67.3262 112.482 67.3193 112.456 67.3117 112.43L67.2652 112.277C67.2575 112.252 67.2507 112.226 67.243 112.2C67.2354 112.175 67.2274 112.149 67.2198 112.124C67.2121 112.098 67.2044 112.072 67.1967 112.046C67.1891 112.021 67.1811 111.995 67.1734 111.97C67.1658 111.944 67.158 111.918 67.1504 111.892C67.1427 111.867 67.1359 111.841 67.1282 111.815L66.9666 111.273C66.9589 111.247 66.9503 111.221 66.9426 111.196C66.9348 111.17 66.9274 111.143 66.9196 111.117L66.8735 110.962C66.8657 110.936 66.8583 110.91 66.8505 110.884C66.8428 110.858 66.8342 110.832 66.8265 110.806C66.8187 110.78 66.8113 110.754 66.8036 110.728C66.7959 110.702 66.7882 110.676 66.7805 110.65C66.7727 110.624 66.7644 110.598 66.7566 110.572C66.7488 110.546 66.7414 110.52 66.7337 110.494C66.726 110.468 66.7183 110.442 66.7106 110.416C66.7028 110.39 66.6945 110.364 66.6867 110.338L66.6409 110.181C66.6331 110.155 66.6248 110.128 66.617 110.102C66.6092 110.076 66.6018 110.05 66.5941 110.024C66.5863 109.998 66.578 109.971 66.5702 109.945C66.5624 109.919 66.555 109.893 66.5473 109.867C66.5395 109.841 66.5312 109.814 66.5234 109.788C66.5156 109.762 66.5082 109.736 66.5005 109.71C66.4927 109.684 66.4844 109.658 66.4766 109.631C66.4688 109.605 66.4614 109.579 66.4537 109.553L66.4059 109.396C66.3981 109.37 66.3907 109.344 66.383 109.318C66.3751 109.291 66.3671 109.264 66.3593 109.238C66.3515 109.212 66.3441 109.186 66.3363 109.16L66.2886 109.002C66.2807 108.976 66.2737 108.949 66.2658 108.923L66.2181 108.766C66.2102 108.74 66.2031 108.713 66.1953 108.687L66.1475 108.53C66.1397 108.503 66.1326 108.477 66.1248 108.45L66.077 108.293C66.0692 108.267 66.0621 108.24 66.0543 108.214C66.0465 108.188 66.0382 108.161 66.0304 108.135C66.0225 108.109 66.0145 108.082 66.0067 108.056C65.9989 108.03 65.9915 108.003 65.9838 107.977C65.976 107.951 65.9677 107.925 65.9599 107.899C65.952 107.872 65.944 107.846 65.9362 107.819C65.9283 107.793 65.9201 107.767 65.9123 107.741C65.9044 107.714 65.8974 107.688 65.8895 107.661L65.8418 107.504C65.8339 107.478 65.8269 107.451 65.819 107.425C65.8112 107.399 65.803 107.373 65.7951 107.346C65.7873 107.32 65.7793 107.293 65.7714 107.267C65.7636 107.241 65.7563 107.214 65.7485 107.188C65.7407 107.162 65.7324 107.136 65.7246 107.11C65.7168 107.084 65.7087 107.057 65.7009 107.03C65.6931 107.004 65.6858 106.978 65.678 106.952C65.6702 106.926 65.6619 106.9 65.6541 106.873C65.6463 106.847 65.6382 106.82 65.6304 106.794C65.6226 106.768 65.6152 106.742 65.6075 106.715L65.5597 106.558C65.5519 106.532 65.5448 106.505 65.537 106.479C65.5292 106.453 65.5209 106.427 65.5131 106.4C65.5053 106.374 65.4979 106.348 65.4902 106.322L65.4424 106.165C65.4346 106.139 65.4272 106.113 65.4195 106.087C65.4117 106.06 65.4034 106.034 65.3956 106.008C65.3878 105.982 65.3804 105.956 65.3727 105.93C65.3649 105.904 65.3566 105.877 65.3488 105.851C65.341 105.825 65.3336 105.799 65.3259 105.773C65.3181 105.747 65.3098 105.72 65.302 105.694C65.2942 105.668 65.2868 105.642 65.2791 105.616C65.2713 105.59 65.263 105.563 65.2552 105.537L65.2093 105.38C65.2016 105.354 65.1932 105.328 65.1855 105.302C65.1778 105.276 65.1701 105.25 65.1624 105.224C65.1546 105.198 65.1472 105.172 65.1394 105.146C65.1317 105.12 65.1233 105.093 65.1156 105.067C65.1079 105.042 65.1002 105.016 65.0925 104.99C65.0847 104.964 65.0773 104.938 65.0696 104.912C65.0618 104.886 65.0532 104.86 65.0455 104.834C65.0378 104.808 65.0303 104.782 65.0226 104.756L64.9764 104.601C64.9687 104.575 64.9612 104.548 64.9535 104.522L64.9073 104.368C64.8996 104.342 64.891 104.316 64.8833 104.29L64.7909 103.98C64.7832 103.955 64.7764 103.929 64.7688 103.903L64.7457 103.826C64.7381 103.8 64.73 103.775 64.7224 103.749L64.6762 103.594C64.6686 103.569 64.6606 103.543 64.653 103.518C64.6454 103.492 64.6383 103.467 64.6307 103.442C64.6231 103.416 64.6152 103.39 64.6076 103.364C64.6 103.339 64.5919 103.313 64.5843 103.288C64.5768 103.262 64.5696 103.237 64.5621 103.211C64.5545 103.186 64.5464 103.16 64.5388 103.135C64.5312 103.109 64.5243 103.083 64.5167 103.058C64.5091 103.032 64.5008 103.007 64.4932 102.982C64.4857 102.957 64.4785 102.931 64.4709 102.906C64.4634 102.88 64.4553 102.855 64.4477 102.829L64.4031 102.677C64.3956 102.651 64.3872 102.626 64.3797 102.601C64.3721 102.576 64.3649 102.55 64.3574 102.525L64.3124 102.374C64.3049 102.349 64.2977 102.323 64.2901 102.298L64.2003 101.997C64.1929 101.972 64.185 101.947 64.1776 101.922L64.1327 101.772C64.1254 101.747 64.1184 101.722 64.111 101.697C64.1037 101.673 64.0958 101.648 64.0884 101.623C64.081 101.598 64.0734 101.573 64.0659 101.548C64.0586 101.523 64.0516 101.498 64.0443 101.473C64.0369 101.449 64.029 101.424 64.0216 101.399C64.0143 101.374 64.0073 101.35 64 101.325C63.9926 101.3 63.9847 101.275 63.9773 101.251C63.97 101.226 63.9628 101.202 63.9555 101.177C63.9482 101.153 63.9411 101.128 63.9338 101.103C63.9265 101.078 63.9185 101.053 63.9112 101.029L63.7365 100.443C63.7293 100.419 63.7226 100.395 63.7154 100.371C63.7082 100.347 63.7006 100.322 63.6934 100.298C63.6862 100.274 63.6788 100.249 63.6716 100.225C63.6644 100.201 63.6576 100.177 63.6505 100.153C63.6433 100.129 63.6357 100.105 63.6285 100.081C63.6214 100.057 63.6144 100.033 63.6073 100.01C63.6001 99.9857 63.5924 99.9613 63.5853 99.9374C63.5781 99.9134 63.5714 99.8891 63.5642 99.8653C63.5571 99.8415 63.5501 99.8178 63.543 99.7941C63.5359 99.7703 63.5291 99.7458 63.522 99.722L63.4583 99.5086C63.4513 99.4851 63.4439 99.4618 63.4369 99.4384L63.3945 99.2961C63.3875 99.2727 63.381 99.2493 63.3741 99.2261L63.3313 99.0857L63.2904 98.9456C63.2835 98.9224 63.276 98.8987 63.2691 98.8755L63.2073 98.6683C63.2004 98.6452 63.1937 98.6213 63.1869 98.5983C63.1801 98.5755 63.1729 98.5529 63.1661 98.5302L63.1249 98.3921C63.1182 98.3694 63.1118 98.3467 63.1051 98.3241L63.0636 98.188L63.024 98.0521C63.0173 98.0296 63.0099 98.0065 63.0032 97.984L62.8834 97.5822C62.8769 97.5603 62.8708 97.5383 62.8642 97.5164L62.824 97.3844L62.7856 97.2527C62.7791 97.2309 62.7718 97.2094 62.7653 97.1877C62.7588 97.1659 62.7526 97.1436 62.7461 97.1219L62.6881 96.9272C62.6817 96.9059 62.6749 96.8846 62.6686 96.8633C62.6622 96.8419 62.6566 96.82 62.6502 96.7986C62.6438 96.7774 62.637 96.7559 62.6307 96.7347C62.6244 96.7135 62.6184 96.6921 62.6121 96.671C62.6058 96.6498 62.5989 96.6283 62.5926 96.6071C62.5864 96.5861 62.5801 96.5652 62.5739 96.5443C62.5676 96.5232 62.5616 96.5016 62.5553 96.4806L62.4805 96.2295L62.4427 96.1058C62.4366 96.0853 62.4308 96.0646 62.4248 96.0442C62.4186 96.0236 62.412 96.0028 62.4059 95.9824C62.3998 95.9619 62.394 95.9411 62.3879 95.9207C62.3819 95.9004 62.3759 95.8802 62.3698 95.86C62.3638 95.8397 62.358 95.8187 62.3519 95.7984C62.3459 95.7782 62.3398 95.7578 62.3338 95.7377C62.3279 95.7177 62.3215 95.6979 62.3155 95.678C62.3095 95.6579 62.3034 95.6373 62.2974 95.6173C62.2915 95.5973 62.2851 95.5775 62.2792 95.5576C62.2732 95.5376 62.268 95.517 62.262 95.497C62.2561 95.4772 62.2497 95.4571 62.2438 95.4373C62.2379 95.4178 62.2321 95.3982 62.2263 95.3787C62.2204 95.359 62.2149 95.3388 62.209 95.3192C62.2031 95.2995 62.1964 95.28 62.1906 95.2604L62.1556 95.1432C61.5243 93.0262 62.729 90.7977 64.846 90.1664Z",
			fill: "#A4D2FF"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M113.384 97.0253C114.489 95.1125 116.936 94.4577 118.849 95.5627C120.762 96.6679 121.416 99.1151 120.311 101.028L104.182 128.947C103.077 130.86 100.629 131.515 98.7165 130.41C96.804 129.304 96.1491 126.858 97.2538 124.945L113.384 97.0253Z",
			fill: "#A4D2FF"
		})
	]
}), sn = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 375 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M131.115 68.2678C258.578 78.526 209.412 58.5108 285.921 32.1027C332.198 16.1296 353.562 81.372 259.79 162.294C135.39 269.647 -25.6022 55.6553 131.115 68.2678Z",
			fill: "#E6F2FE"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M183.505 90.5081C184.193 89.8342 185.181 89.5694 186.113 89.8092L256.646 107.963C257.693 108.232 258.394 109.027 258.64 109.943C259.452 112.969 260.095 115.379 260.802 118.011C261.048 118.928 260.839 119.967 260.066 120.725L208.059 171.713C207.372 172.387 206.384 172.652 205.451 172.412L134.917 154.258C133.869 153.989 133.168 153.194 132.923 152.277C132.113 149.249 131.465 146.839 130.761 144.208C130.516 143.291 130.725 142.253 131.497 141.496L183.505 90.5081Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M183.505 90.5091C184.192 89.8343 185.18 89.5696 186.113 89.8101L256.656 107.999C258.752 108.539 259.46 111.181 257.915 112.697L205.917 163.72C205.23 164.395 204.242 164.66 203.309 164.419L132.766 146.23C130.67 145.69 129.962 143.048 131.507 141.532L183.505 90.5091Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M165.443 17.8821C171.329 16.3051 176.739 17.4123 177.528 20.355L231.557 110.101C232.759 111.921 234.157 114.476 234.674 116.405C237.631 127.44 222.136 141.18 200.065 147.094C177.995 153.008 157.706 148.856 154.749 137.821C154.232 135.892 154.166 132.98 154.297 130.803L156.214 26.0659C155.426 23.1231 159.558 19.4591 165.443 17.8821Z",
			fill: "#0071EB"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M223.264 96.3288C223.421 105.759 210.72 116.479 193.121 121.195C175.529 125.908 159.175 122.98 154.588 114.742L155.028 90.7205C157.851 97.8301 171.585 100.388 186.479 96.3969C201.377 92.4046 211.992 83.318 210.874 75.7476L223.264 96.3288Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M155.884 46.1375C157.067 50.5514 165.182 52.2122 174.01 49.8468C182.838 47.4813 189.036 41.9852 187.854 37.5712C187.843 37.5293 187.828 37.4884 187.815 37.447L198.258 54.7913C199.347 60.8436 191.228 68.0782 179.723 71.1611C168.205 74.247 157.546 72.034 155.479 66.2348L155.85 45.991C155.861 46.0398 155.871 46.089 155.884 46.1375Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M175.22 22.4057C175.811 24.6127 172.712 27.3607 168.298 28.5435C163.884 29.7263 159.826 28.8959 159.235 26.6888C158.643 24.4818 161.742 21.7338 166.156 20.551C170.57 19.3682 174.628 20.1986 175.22 22.4057Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M227.794 37.6156C229.84 36.7838 232.174 37.7695 233.006 39.8158L237.982 52.057L246.844 40.6654C248.2 38.9222 250.713 38.6084 252.457 39.9642C254.2 41.3205 254.514 43.8339 253.158 45.5775L241.462 60.6146L248.465 77.8392C249.296 79.8856 248.312 82.2192 246.265 83.0512C244.219 83.8828 241.885 82.8983 241.053 80.8519L235.79 67.9056L227.958 77.9769C226.602 79.7207 224.088 80.0354 222.345 78.6791C220.601 77.3227 220.287 74.8094 221.643 73.0658L232.311 59.349L225.595 42.8285C224.763 40.782 225.747 38.4476 227.794 37.6156Z",
			fill: "#A4D2FF"
		})
	]
}), cn = ({ width: e = "100%", height: t, ...n }) => /* @__PURE__ */ (0, c.jsxs)("svg", {
	width: e,
	height: t,
	viewBox: "0 0 375 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...n,
	children: [
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M131.115 68.2678C258.578 78.526 209.412 58.5108 285.921 32.1027C332.198 16.1296 353.562 81.372 259.79 162.294C135.39 269.647 -25.6022 55.6553 131.115 68.2678Z",
			fill: "#E6F2FE"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M183.505 90.5081C184.193 89.8342 185.181 89.5694 186.113 89.8092L256.646 107.963C257.693 108.232 258.394 109.027 258.64 109.943C259.452 112.969 260.095 115.379 260.802 118.011C261.048 118.928 260.839 119.967 260.066 120.725L208.059 171.713C207.372 172.387 206.384 172.652 205.451 172.412L134.917 154.258C133.869 153.989 133.168 153.194 132.923 152.277C132.113 149.249 131.465 146.839 130.761 144.208C130.516 143.291 130.725 142.253 131.497 141.496L183.505 90.5081Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M183.505 90.5091C184.192 89.8343 185.18 89.5696 186.113 89.8101L256.656 107.999C258.752 108.539 259.46 111.181 257.915 112.697L205.917 163.72C205.23 164.395 204.242 164.66 203.309 164.419L132.766 146.23C130.67 145.69 129.962 143.048 131.507 141.532L183.505 90.5091Z",
			fill: "#0055E6"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M165.443 17.8821C171.329 16.3051 176.739 17.4123 177.528 20.355L231.557 110.101C232.759 111.921 234.157 114.476 234.674 116.405C237.631 127.44 222.136 141.18 200.065 147.094C177.995 153.008 157.706 148.856 154.749 137.821C154.232 135.892 154.166 132.98 154.297 130.803L156.214 26.0659C155.426 23.1231 159.558 19.4591 165.443 17.8821Z",
			fill: "#0071EB"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M223.264 96.3288C223.421 105.759 210.72 116.479 193.121 121.195C175.529 125.908 159.175 122.98 154.588 114.742L155.028 90.7205C157.851 97.8301 171.585 100.388 186.479 96.3969C201.377 92.4046 211.992 83.318 210.874 75.7476L223.264 96.3288Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M155.884 46.1375C157.067 50.5514 165.182 52.2122 174.01 49.8468C182.838 47.4813 189.036 41.9852 187.854 37.5712C187.843 37.5293 187.828 37.4884 187.815 37.447L198.258 54.7913C199.347 60.8436 191.228 68.0782 179.723 71.1611C168.205 74.247 157.546 72.034 155.479 66.2348L155.85 45.991C155.861 46.0398 155.871 46.089 155.884 46.1375Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M175.22 22.4057C175.811 24.6127 172.712 27.3607 168.298 28.5435C163.884 29.7263 159.826 28.8959 159.235 26.6888C158.643 24.4818 161.742 21.7338 166.156 20.551C170.57 19.3682 174.628 20.1986 175.22 22.4057Z",
			fill: "#0045BC"
		}),
		/* @__PURE__ */ (0, c.jsx)("path", {
			d: "M227.794 37.6156C229.84 36.7838 232.174 37.7695 233.006 39.8158L237.982 52.057L246.844 40.6654C248.2 38.9222 250.713 38.6084 252.457 39.9642C254.2 41.3205 254.514 43.8339 253.158 45.5775L241.462 60.6146L248.465 77.8392C249.296 79.8856 248.312 82.2192 246.265 83.0512C244.219 83.8828 241.885 82.8983 241.053 80.8519L235.79 67.9056L227.958 77.9769C226.602 79.7207 224.088 80.0354 222.345 78.6791C220.601 77.3227 220.287 74.8094 221.643 73.0658L232.311 59.349L225.595 42.8285C224.763 40.782 225.747 38.4476 227.794 37.6156Z",
			fill: "#A4D2FF"
		})
	]
}), ln = /* @__PURE__ */ n({
	BbcBusDesktop: () => Qt,
	BbcBusDesktopIllustration: () => Qt,
	BbcBusInvertedDesktop: () => $t,
	BbcBusInvertedDesktopIllustration: () => $t,
	BbcBusMobile: () => en,
	BbcBusMobileIllustration: () => en,
	BbcDesktop: () => tn,
	BbcDesktopIllustration: () => tn,
	BbcMobile: () => nn,
	BbcMobileIllustration: () => nn,
	BusRideBranded: () => rn,
	BusRideBrandedIllustration: () => rn,
	EmptyBusStation: () => an,
	EmptyBusStationIllustration: () => an,
	EmptyState: () => on,
	EmptyStateIllustration: () => on,
	Error404: () => sn,
	Error404Illustration: () => sn,
	Error500: () => cn,
	Error500Illustration: () => cn
}), un = /* @__PURE__ */ n({
	AddLocation: () => l,
	AddLocationIcon: () => l,
	Albatross: () => u,
	AlbatrossIcon: () => u,
	AltRoute: () => d,
	AltRouteIcon: () => d,
	ArrowBottom: () => f,
	ArrowBottomIcon: () => f,
	ArrowLeft: () => p,
	ArrowLeftIcon: () => p,
	ArrowRight: () => m,
	ArrowRightIcon: () => m,
	ArrowTop: () => h,
	ArrowTopIcon: () => h,
	Ban: () => g,
	BanIcon: () => g,
	Bell: () => _,
	BellIcon: () => _,
	Bill: () => v,
	BillIcon: () => v,
	BlurLinear: () => y,
	BlurLinearIcon: () => y,
	Boost: () => b,
	BoostIcon: () => b,
	Bug: () => x,
	BugIcon: () => x,
	Bus: () => S,
	BusFilled: () => C,
	BusFilledIcon: () => C,
	BusIcon: () => S,
	Calendar: () => w,
	CalendarIcon: () => w,
	CalendarTime: () => T,
	CalendarTimeIcon: () => T,
	Campaign: () => E,
	CampaignIcon: () => E,
	CardMember: () => D,
	CardMemberIcon: () => D,
	Charter: () => O,
	CharterIcon: () => O,
	Check: () => k,
	CheckCircle: () => A,
	CheckCircleFilled: () => j,
	CheckCircleFilledIcon: () => j,
	CheckCircleIcon: () => A,
	CheckIcon: () => k,
	CheckboxFalse: () => M,
	CheckboxFalseIcon: () => M,
	CheckboxTrue: () => N,
	CheckboxTrueIcon: () => N,
	ChevronBottom: () => P,
	ChevronBottomIcon: () => P,
	ChevronLeft: () => F,
	ChevronLeftIcon: () => F,
	ChevronRight: () => I,
	ChevronRightIcon: () => I,
	ChevronTop: () => L,
	ChevronTopIcon: () => L,
	Child: () => R,
	ChildIcon: () => R,
	Close: () => ee,
	CloseCircle: () => z,
	CloseCircleIcon: () => z,
	CloseIcon: () => ee,
	Cloud: () => te,
	CloudIcon: () => te,
	Company: () => ne,
	CompanyIcon: () => ne,
	Connection: () => re,
	ConnectionFilled: () => ie,
	ConnectionFilledIcon: () => ie,
	ConnectionIcon: () => re,
	ContactList: () => B,
	ContactListIcon: () => B,
	Copy: () => V,
	CopyIcon: () => V,
	Crew: () => ae,
	CrewIcon: () => ae,
	Departure: () => oe,
	DepartureIcon: () => oe,
	Dialpad: () => H,
	DialpadIcon: () => H,
	Disability: () => U,
	DisabilityIcon: () => U,
	Download: () => W,
	DownloadIcon: () => W,
	Edit: () => G,
	EditIcon: () => G,
	Euro: () => K,
	EuroIcon: () => K,
	ExclamationCircle: () => se,
	ExclamationCircleIcon: () => se,
	Export: () => ce,
	ExportIcon: () => ce,
	FaceId: () => q,
	FaceIdIcon: () => q,
	Ferry: () => J,
	FerryFilled: () => le,
	FerryFilledIcon: () => le,
	FerryIcon: () => J,
	Filter: () => ue,
	FilterIcon: () => ue,
	Fingerprint: () => de,
	FingerprintIcon: () => de,
	FlashlightOff: () => fe,
	FlashlightOffIcon: () => fe,
	FlashlightOn: () => pe,
	FlashlightOnIcon: () => pe,
	Hand: () => me,
	HandIcon: () => me,
	History: () => he,
	HistoryIcon: () => he,
	Home: () => ge,
	HomeFilled: () => _e,
	HomeFilledIcon: () => _e,
	HomeIcon: () => ge,
	Hourglass: () => ve,
	HourglassIcon: () => ve,
	InboundConnection: () => Y,
	InboundConnectionIcon: () => Y,
	InfoCircle: () => X,
	InfoCircleIcon: () => X,
	InstantApproval: () => Z,
	InstantApprovalIcon: () => Z,
	Insurance: () => Q,
	InsuranceIcon: () => Q,
	IosAddBox: () => ye,
	IosAddBoxIcon: () => ye,
	IosShare: () => $,
	IosShareIcon: () => $,
	LiveIndicator: () => be,
	LiveIndicatorIcon: () => be,
	Locale: () => xe,
	LocaleIcon: () => xe,
	Lock: () => Se,
	LockIcon: () => Se,
	LogoAlfred: () => Ce,
	LogoAlfredIcon: () => Ce,
	LogoOuiboard: () => we,
	LogoOuiboardIcon: () => we,
	LogoSmasara: () => Te,
	LogoSmasaraIcon: () => Te,
	Luggage: () => Ee,
	LuggageFilled: () => De,
	LuggageFilledIcon: () => De,
	LuggageIcon: () => Ee,
	Mail: () => Oe,
	MailIcon: () => Oe,
	Map: () => ke,
	MapIcon: () => ke,
	MeetingPoint: () => Ae,
	MeetingPointFilled: () => je,
	MeetingPointFilledIcon: () => je,
	MeetingPointIcon: () => Ae,
	MessageDouble: () => Me,
	MessageDoubleFilled: () => Ne,
	MessageDoubleFilledIcon: () => Ne,
	MessageDoubleIcon: () => Me,
	Minus: () => Pe,
	MinusCircle: () => Fe,
	MinusCircleIcon: () => Fe,
	MinusIcon: () => Pe,
	More: () => Ie,
	MoreIcon: () => Ie,
	NewFolder: () => Le,
	NewFolderIcon: () => Le,
	NotLiveIndicator: () => Re,
	NotLiveIndicatorIcon: () => Re,
	Offline: () => ze,
	OfflineIcon: () => ze,
	OpenInNew: () => Be,
	OpenInNewIcon: () => Be,
	OutboundConnection: () => Ve,
	OutboundConnectionIcon: () => Ve,
	Passenger: () => He,
	PassengerIcon: () => He,
	Person: () => Ue,
	PersonCheck: () => We,
	PersonCheckIcon: () => We,
	PersonCross: () => Ge,
	PersonCrossIcon: () => Ge,
	PersonFilled: () => Ke,
	PersonFilledIcon: () => Ke,
	PersonIcon: () => Ue,
	PersonIncome: () => qe,
	PersonIncomeIcon: () => qe,
	PersonOutcome: () => Je,
	PersonOutcomeIcon: () => Je,
	PersonQuestion: () => Ye,
	PersonQuestionIcon: () => Ye,
	Phone: () => Xe,
	PhoneFilled: () => Ze,
	PhoneFilledIcon: () => Ze,
	PhoneIcon: () => Xe,
	Pin: () => Qe,
	PinIcon: () => Qe,
	Plus: () => $e,
	PlusCircle: () => et,
	PlusCircleIcon: () => et,
	PlusIcon: () => $e,
	Print: () => tt,
	PrintIcon: () => tt,
	PriorityService: () => nt,
	PriorityServiceIcon: () => nt,
	Profile: () => rt,
	ProfileFilled: () => it,
	ProfileFilledIcon: () => it,
	ProfileIcon: () => rt,
	Public: () => at,
	PublicIcon: () => at,
	Qr: () => ot,
	QrIcon: () => ot,
	QuestionCircle: () => st,
	QuestionCircleIcon: () => st,
	Queue: () => ct,
	QueueIcon: () => ct,
	RadioButtonFalse: () => lt,
	RadioButtonFalseIcon: () => lt,
	RadioButtonTrue: () => ut,
	RadioButtonTrueIcon: () => ut,
	Reload: () => dt,
	ReloadIcon: () => dt,
	Search: () => ft,
	SearchIcon: () => ft,
	Seat: () => pt,
	SeatCheckFilled: () => mt,
	SeatCheckFilledIcon: () => mt,
	SeatComfort: () => ht,
	SeatComfortFilled: () => gt,
	SeatComfortFilledIcon: () => gt,
	SeatComfortIcon: () => ht,
	SeatIcon: () => pt,
	Send: () => _t,
	SendIcon: () => _t,
	Settings: () => vt,
	SettingsIcon: () => vt,
	Sort: () => yt,
	SortIcon: () => yt,
	Split: () => bt,
	SplitIcon: () => bt,
	Star: () => xt,
	StarFilled: () => St,
	StarFilledIcon: () => St,
	StarIcon: () => xt,
	Support: () => Ct,
	SupportIcon: () => Ct,
	Ticket: () => wt,
	TicketIcon: () => wt,
	Time: () => Tt,
	TimeIcon: () => Tt,
	Timer: () => Et,
	TimerIcon: () => Et,
	Tracking: () => Dt,
	TrackingIcon: () => Dt,
	Trash: () => Ot,
	TrashIcon: () => Ot,
	Under12: () => kt,
	Under12Icon: () => kt,
	Under16: () => At,
	Under16Icon: () => At,
	Under18: () => jt,
	Under18Icon: () => jt,
	Under3: () => Mt,
	Under3Icon: () => Mt,
	Upload: () => Nt,
	UploadIcon: () => Nt,
	Visibility: () => Pt,
	VisibilityIcon: () => Pt,
	VisibilityOff: () => Ft,
	VisibilityOffIcon: () => Ft,
	Warning: () => It,
	WarningIcon: () => It,
	Wifi: () => Lt,
	WifiIcon: () => Lt
});
//#endregion
export { l as AddLocation, l as AddLocationIcon, u as Albatross, u as AlbatrossIcon, d as AltRoute, d as AltRouteIcon, f as ArrowBottom, f as ArrowBottomIcon, p as ArrowLeft, p as ArrowLeftIcon, m as ArrowRight, m as ArrowRightIcon, h as ArrowTop, h as ArrowTopIcon, g as Ban, g as BanIcon, Qt as BbcBusDesktop, Qt as BbcBusDesktopIllustration, $t as BbcBusInvertedDesktop, $t as BbcBusInvertedDesktopIllustration, en as BbcBusMobile, en as BbcBusMobileIllustration, tn as BbcDesktop, tn as BbcDesktopIllustration, nn as BbcMobile, nn as BbcMobileIllustration, _ as Bell, _ as BellIcon, v as Bill, v as BillIcon, y as BlurLinear, y as BlurLinearIcon, b as Boost, b as BoostIcon, x as Bug, x as BugIcon, S as Bus, S as BusIcon, C as BusFilled, C as BusFilledIcon, rn as BusRideBranded, rn as BusRideBrandedIllustration, w as Calendar, w as CalendarIcon, T as CalendarTime, T as CalendarTimeIcon, E as Campaign, E as CampaignIcon, D as CardMember, D as CardMemberIcon, O as Charter, O as CharterIcon, k as Check, k as CheckIcon, A as CheckCircle, A as CheckCircleIcon, j as CheckCircleFilled, j as CheckCircleFilledIcon, M as CheckboxFalse, M as CheckboxFalseIcon, N as CheckboxTrue, N as CheckboxTrueIcon, P as ChevronBottom, P as ChevronBottomIcon, F as ChevronLeft, F as ChevronLeftIcon, I as ChevronRight, I as ChevronRightIcon, L as ChevronTop, L as ChevronTopIcon, R as Child, R as ChildIcon, ee as Close, ee as CloseIcon, z as CloseCircle, z as CloseCircleIcon, te as Cloud, te as CloudIcon, ne as Company, ne as CompanyIcon, re as Connection, re as ConnectionIcon, ie as ConnectionFilled, ie as ConnectionFilledIcon, B as ContactList, B as ContactListIcon, V as Copy, V as CopyIcon, ae as Crew, ae as CrewIcon, oe as Departure, oe as DepartureIcon, H as Dialpad, H as DialpadIcon, U as Disability, U as DisabilityIcon, W as Download, W as DownloadIcon, G as Edit, G as EditIcon, an as EmptyBusStation, an as EmptyBusStationIllustration, on as EmptyState, on as EmptyStateIllustration, sn as Error404, sn as Error404Illustration, cn as Error500, cn as Error500Illustration, K as Euro, K as EuroIcon, se as ExclamationCircle, se as ExclamationCircleIcon, ce as Export, ce as ExportIcon, q as FaceId, q as FaceIdIcon, J as Ferry, J as FerryIcon, le as FerryFilled, le as FerryFilledIcon, ue as Filter, ue as FilterIcon, de as Fingerprint, de as FingerprintIcon, Rt as FlagCs, Rt as FlagCsIllustrationIcon, zt as FlagDe, zt as FlagDeIllustrationIcon, Bt as FlagEn, Bt as FlagEnIllustrationIcon, Vt as FlagEs, Vt as FlagEsIllustrationIcon, Ht as FlagFr, Ht as FlagFrIllustrationIcon, Ut as FlagHr, Ut as FlagHrIllustrationIcon, Wt as FlagHu, Wt as FlagHuIllustrationIcon, Gt as FlagIt, Gt as FlagItIllustrationIcon, Kt as FlagNl, Kt as FlagNlIllustrationIcon, qt as FlagPl, qt as FlagPlIllustrationIcon, Jt as FlagPt, Jt as FlagPtIllustrationIcon, Yt as FlagSk, Yt as FlagSkIllustrationIcon, fe as FlashlightOff, fe as FlashlightOffIcon, pe as FlashlightOn, pe as FlashlightOnIcon, me as Hand, me as HandIcon, he as History, he as HistoryIcon, ge as Home, ge as HomeIcon, _e as HomeFilled, _e as HomeFilledIcon, ve as Hourglass, ve as HourglassIcon, un as Icons, Zt as IllustrationIcons, ln as Illustrations, Y as InboundConnection, Y as InboundConnectionIcon, X as InfoCircle, X as InfoCircleIcon, Z as InstantApproval, Z as InstantApprovalIcon, Q as Insurance, Q as InsuranceIcon, ye as IosAddBox, ye as IosAddBoxIcon, $ as IosShare, $ as IosShareIcon, be as LiveIndicator, be as LiveIndicatorIcon, xe as Locale, xe as LocaleIcon, Se as Lock, Se as LockIcon, Ce as LogoAlfred, Ce as LogoAlfredIcon, Xt as LogoBbb, Xt as LogoBbbIllustrationIcon, we as LogoOuiboard, we as LogoOuiboardIcon, Te as LogoSmasara, Te as LogoSmasaraIcon, Ee as Luggage, Ee as LuggageIcon, De as LuggageFilled, De as LuggageFilledIcon, Oe as Mail, Oe as MailIcon, ke as Map, ke as MapIcon, Ae as MeetingPoint, Ae as MeetingPointIcon, je as MeetingPointFilled, je as MeetingPointFilledIcon, Me as MessageDouble, Me as MessageDoubleIcon, Ne as MessageDoubleFilled, Ne as MessageDoubleFilledIcon, Pe as Minus, Pe as MinusIcon, Fe as MinusCircle, Fe as MinusCircleIcon, Ie as More, Ie as MoreIcon, Le as NewFolder, Le as NewFolderIcon, Re as NotLiveIndicator, Re as NotLiveIndicatorIcon, ze as Offline, ze as OfflineIcon, Be as OpenInNew, Be as OpenInNewIcon, Ve as OutboundConnection, Ve as OutboundConnectionIcon, He as Passenger, He as PassengerIcon, Ue as Person, Ue as PersonIcon, We as PersonCheck, We as PersonCheckIcon, Ge as PersonCross, Ge as PersonCrossIcon, Ke as PersonFilled, Ke as PersonFilledIcon, qe as PersonIncome, qe as PersonIncomeIcon, Je as PersonOutcome, Je as PersonOutcomeIcon, Ye as PersonQuestion, Ye as PersonQuestionIcon, Xe as Phone, Xe as PhoneIcon, Ze as PhoneFilled, Ze as PhoneFilledIcon, Qe as Pin, Qe as PinIcon, $e as Plus, $e as PlusIcon, et as PlusCircle, et as PlusCircleIcon, tt as Print, tt as PrintIcon, nt as PriorityService, nt as PriorityServiceIcon, rt as Profile, rt as ProfileIcon, it as ProfileFilled, it as ProfileFilledIcon, at as Public, at as PublicIcon, ot as Qr, ot as QrIcon, st as QuestionCircle, st as QuestionCircleIcon, ct as Queue, ct as QueueIcon, lt as RadioButtonFalse, lt as RadioButtonFalseIcon, ut as RadioButtonTrue, ut as RadioButtonTrueIcon, dt as Reload, dt as ReloadIcon, ft as Search, ft as SearchIcon, pt as Seat, pt as SeatIcon, mt as SeatCheckFilled, mt as SeatCheckFilledIcon, ht as SeatComfort, ht as SeatComfortIcon, gt as SeatComfortFilled, gt as SeatComfortFilledIcon, _t as Send, _t as SendIcon, vt as Settings, vt as SettingsIcon, yt as Sort, yt as SortIcon, bt as Split, bt as SplitIcon, xt as Star, xt as StarIcon, St as StarFilled, St as StarFilledIcon, Ct as Support, Ct as SupportIcon, wt as Ticket, wt as TicketIcon, Tt as Time, Tt as TimeIcon, Et as Timer, Et as TimerIcon, Dt as Tracking, Dt as TrackingIcon, Ot as Trash, Ot as TrashIcon, kt as Under12, kt as Under12Icon, At as Under16, At as Under16Icon, jt as Under18, jt as Under18Icon, Mt as Under3, Mt as Under3Icon, Nt as Upload, Nt as UploadIcon, Pt as Visibility, Pt as VisibilityIcon, Ft as VisibilityOff, Ft as VisibilityOffIcon, It as Warning, It as WarningIcon, Lt as Wifi, Lt as WifiIcon };
